/* =========================================================
   iG-KUN WORLD RUN  —  本編（6都市 → INFOLENS GEEK SHOP に帰還）
   置き方: <div data-igrun data-sprite="..." data-shop-url="..."></div>

   ゲーム仕様
   ・6都市 × 380m ＋ 帰還区間 220m ＝ 全 2,500m。完走およそ3分20秒
   ・ライフ3。ぶつかっても同じ場所から再開。0になった都市の頭からやり直せる
   ・ゴールは店。iGくんが扉に入ると完走証が出る

   描画の構造（奥→手前の6層）
   0 空       グラデーション＋太陽／月＋雲・星・オーロラ
   1 遠景     山や高層の稜線。空の色に強く溶かす（空気遠近）
   2 中景     その都市のランドマーク。夜の街は窓に灯りが入る
   3 近景     街灯・木・屋台などの小物
   4 地面     路面＋縁石のアクセントライン＋タイル
   5 手前     プレイヤーより前を横切る影。奥行きはこの層で決まる
   ========================================================= */
(function () {
  'use strict';

  var VH = 360;
  var GROUND_Y = VH - 64;
  var P_W = 64, P_H = 72;                              // iGくんは大きめに（認知が目的のため）
  var HIT_X = 26, HIT_Y = 17, HIT_W = 36, HIT_H = 55;
  var GRAVITY = 0.68, HOLD_GRAVITY = 0.30, HOLD_MAX = 15;
  var JUMP_V = -10.6, DOUBLE_V = -8.8;
  /* スライディングと急降下（TODO 5）
     SLIDE_H       スライド中の判定の高さ（HIT_H に対する倍率）。上端を足元から測る
     SLIDE_MIN_F   最低持続フレーム。離した直後に立ち上がって bar の出口で頭をぶつけるのを防ぐ
     DIVE_MUL      急降下の落下加速の倍率
     SWIPE_DY      下スワイプと認める縦の移動量（CSS px）
     JUMP_CANCEL_F タップ直後の下スワイプなら、跳んだばかりのジャンプを取り消してスライドに移す猶予。
                   タップ＝ジャンプは押した瞬間に出す（遅らせない）ので、
                   触る操作でスライドを出すにはこの取り消しが要る */
  var SLIDE_H = 0.5, SLIDE_MIN_F = 20, DIVE_MUL = 2, SWIPE_DY = 16, JUMP_CANCEL_F = 10;
  /* bar の下端の高さ（px。20px = 1m）。
     判定は 3px 内側に詰めてあるので、成立条件は
       立ち姿勢が必ず当たる ： HIT_H(55) > BAR_GAP+3  →  BAR_GAP < 52
       スライドで必ずくぐれる： HIT_H*SLIDE_H(27.5) <= BAR_GAP+3  →  BAR_GAP >= 24.5
     その中間を取る。1.8m は docs/patterns.md の low 系（1.7〜1.8m）とも揃う */
  var BAR_GAP = 36;
  /* 1都市230m（東京だけ 340m）。**2026-09-10 に 320／480 から詰めた。**
     3分は同じことの繰り返しには長すぎる、という実機の指摘
     （BGM が要るという声の本当の原因は単調さのほう）。
     **7都市で完走 約2分20秒**（無傷。導出は docs/qa/README.md「完走時間」）。
     data/patterns/*.json の legLength と必ず揃えること
     （食い違うと tools/build.py が警告を出す）。 */
  var LEG_M = 230, GOAL_M = 220, LIVES = 3;
  /* スコア（TODO 7）。小包は基礎 10点 × コンボ倍率、倍率は COMBO_STEP 個ごとに 1つ上がる。
     NEAR_PX は「ニアミス」と認める隙間（判定の外側の縦の隙間）。
     上限：bar をスライドでくぐるときの隙間は BAR_GAP(36) − 判定の内側の詰め(3)
     − スライド中の判定の高さ(27.5) = 11.5px。**これ以上にすると、くぐるたびに
     NEAR! が出る**（スライドは避けようがないので、狙う遊びにならない）。
     実測（docs/qa/README.md）：普通に跳ぶと low 35〜115px、tall 35px、fly 34px。
     stack は全力で跳んでも 11.0px、bar はスライドで 11.5px しか空かない。
     意識して低く・遅く踏み切ったときだけ 5.5〜6.2px まで詰まる。
     その 6px 台を拾い、11px 台を拾わない **8px** にした */
  var PAR_PT = 10, NEAR_PT = 50, ND_PT = 500, COMBO_STEP = 5, COMBO_MAX = 5, NEAR_PX = 8;
  /* フォント。同梱の M PLUS Rounded 1c（サブセット）が来るまでは等幅で描き、
     読み込めたら差し替える。
     **2026-09-17：ローディング画面でフォントも待つ**（fontDone。上限 2.5 秒）。
     素材だけ待ってタイトルを出すと、最初の数フレームが等幅で描かれて
     フォントが切り替わる瞬間が見える。待てなければ（失敗・遅延）等幅のまま進む。
     なお 9/16 の実機で「タイトルだけフォントが違う」と見えた本当の原因は
     **サブセットの欠字**（9/3 に作ったあとに足した文字が入っていなかった）。
     tools/subset_font.py を作り直して直した。文字を足したら再生成すること。 */
  var FONT_SYS = 'ui-monospace, Menlo, Consolas, "Hiragino Kaku Gothic ProN", "Yu Gothic", monospace';
  var FONT = FONT_SYS;
  var fontDone = false;                    // 読めた／失敗した／無い、のどれかで true
  var digitW = {};                         // サイズ → 0〜9 の最大幅。フォント差し替えで捨てる
  function loadFont(url){
    if(!url || !window.FontFace || !document.fonts){ fontDone = true; return; }
    try{
      var ff = new FontFace('IGRun Rounded', 'url("' + url + '")');
      ff.load().then(function(f){
        document.fonts.add(f);
        FONT = '"IGRun Rounded", ' + FONT_SYS;
        digitW = {};
        fontDone = true;
      })['catch'](function(){ fontDone = true; });
    }catch(e){ fontDone = true; }
  }

  /* 都市ごとの色。sky は上→地平の3段。accent は灯り・看板・縁石に使う差し色 */
  var BASE_CITIES = [
    { id:'tokyo', en:'TOKYO', name:'東京', night:true, ridge:'blocky', legM:340,
      sky:['#0d1430','#28345f','#5b5f86'], sun:'#f2f0e2', sunR:26, sunX:0.16, sunY:0.18,
      far:'#2a3055', mid:'#1b2140', near:'#12162b', ink:'#0b0e1c',
      ground:'#141830', ground2:'#1c2140', accent:'#ff7a4d', weather:null },
    { id:'cairo', en:'CAIRO', name:'カイロ', night:false, ridge:'dunes',
      sky:['#f0c777','#efb463','#f2d9a4'], sun:'#fff6d8', sunR:48, sunX:0.74, sunY:0.24,
      far:'#c99a5e', mid:'#a97a42', near:'#7d5227', ink:'#4a2f16',
      ground:'#c79753', ground2:'#b5843f', accent:'#2f8f9c', weather:'sand' },
    { id:'paris', en:'PARIS', name:'パリ', night:false, ridge:'blocky',
      sky:['#4e3f6b','#a8657a','#e5a184'], sun:'#ffd9ae', sunR:58, sunX:0.68, sunY:0.34,
      far:'#7a5a72', mid:'#4f3b55', near:'#33273c', ink:'#221929',
      ground:'#2e2438', ground2:'#3a2d46', accent:'#ffcf6b', weather:null },
    { id:'ny', en:'NEW YORK', name:'ニューヨーク', night:true, ridge:'blocky',
      sky:['#0a1320','#182a3f','#2e4a63'], sun:'#f6e9b0', sunR:17, sunX:0.84, sunY:0.13,
      far:'#22384c', mid:'#152535', near:'#0d1722', ink:'#070d14',
      ground:'#101a24', ground2:'#16232f', accent:'#f2c531', weather:null },
    { id:'pole', en:'ANTARCTICA', name:'南極', night:false, ridge:'bergs',
      sky:['#9fd4e8','#cfe8f2','#eef6fa'], sun:'#fff3cf', sunR:34, sunX:0.26, sunY:0.28,
      far:'#8fb9cd', mid:'#a8ccdb', near:'#7ba3b8', ink:'#41627a',
      ground:'#e9f4f9', ground2:'#d3e7f0', accent:'#41caec', weather:'snow' },
    { id:'hk', en:'HONG KONG', name:'香港', night:true, ridge:'blocky',
      sky:['#241442','#6b2f5e','#d9686a'], sun:'#ffd7a8', sunR:40, sunX:0.22, sunY:0.32,
      far:'#4a2b52', mid:'#2f1b38', near:'#1d1024', ink:'#140a1a',
      ground:'#1b1024', ground2:'#241631', accent:'#ff4f8b', weather:null },
    { id:'igs', en:'HOMEWARD', name:'帰り道', night:false, ridge:'blocky',
      sky:['#2bb4dc','#7fd9ef','#c8eef8'], sun:'#ffffff', sunR:30, sunX:0.8, sunY:0.18,
      far:'#4a97b4', mid:'#2f7590', near:'#1d5670', ink:'#123243',
      ground:'#17414f', ground2:'#1e4e5f', accent:'#fc930a', weather:null }
  ];
  /* 店頭QR（?from=parco）から入った人だけ通る隠し区間。IGS の直前に差し込む */
  var IKEBUKURO = { id:'ikebukuro', en:'IKEBUKURO', name:'池袋', night:true, ridge:'blocky',
      sky:['#101a33','#2c3563','#6a5d8a'], sun:'#f3efe0', sunR:20, sunX:0.12, sunY:0.16,
      far:'#2f3660', mid:'#1f2546', near:'#151a30', ink:'#0c0f1e',
      ground:'#171c34', ground2:'#1f2544', accent:'#41caec', weather:null };
  var CKEYS = ['sun','far','mid','near','ink','ground','ground2','accent'];

  /* 公開ルート（docs/plan-a.md 3章、docs/visual-spec.md 1-3）。
     キーは公開日。実行時の日付以下でいちばん新しいキーを使う。
     BASE_CITIES は7都市のまま残し、ここで並びだけを切り替える。
     並びは夜の都市が3つ続かないようにしてある。

     **【2026-09-09 変更】9/17 から全都市を出す**（石川さんの方針変更）。
     元は 9/17 が東京だけで、9/21 に NY、9/25 にパリを足す段階公開だった。
     全都市を最初から出すので、**その段階公開のキーは消した。**
     残したままだと 9/21 に ['tokyo','ny','igs'] が選ばれ、
     **都市が7つから3つへ減ってしまう**（新しい日付のキーが勝つため）。
     'full' は同じ並びの別名。docs と tools が名前で参照しているので残す。 */
  var ROUTES = {
    '2026-09-17': ['tokyo','cairo','paris','ny','pole','hk','igs'],
    'full':       ['tokyo','cairo','paris','ny','pole','hk','igs']
  };
  var ROUTE_DEFAULT = '2026-09-17';           // 9/17 より前（開発中）はこれ

  var CITY_BY_ID = {};
  (function(){
    var i;
    for(i=0;i<BASE_CITIES.length;i++) CITY_BY_ID[BASE_CITIES[i].id]=BASE_CITIES[i];
    CITY_BY_ID[IKEBUKURO.id]=IKEBUKURO;
  })();

  function today(){
    var d=new Date(), m=d.getMonth()+1, a=d.getDate();
    return d.getFullYear()+'-'+(m<10?'0':'')+m+'-'+(a<10?'0':'')+a;
  }
  /* key に指定できるもの
       ・ROUTES のキー（'2026-09-21' や 'full'）
       ・都市 id のカンマ区切り（'tokyo,hk,igs'）＝ 確認用
       ・空 → 日付から決める */
  function resolveRoute(key){
    var ids=null, k, best=null;
    if(key && ROUTES[key]) ids = ROUTES[key];
    else if(key && key.indexOf(',')>=0) ids = key.split(',');
    if(!ids){
      var t=today();
      for(k in ROUTES) if(ROUTES.hasOwnProperty(k) && k.charAt(0)==='2'){
        if(k<=t && (!best || k>best)) best=k;
      }
      ids = ROUTES[best || ROUTE_DEFAULT];
    }
    ids = ids.filter(function(id){ return !!CITY_BY_ID[id]; });
    if(ids[ids.length-1] !== 'igs') ids = ids.concat(['igs']);   // 最後は必ず店
    if(ids.length<2) ids = ROUTES[ROUTE_DEFAULT];
    return ids;
  }

  function hex(h){ return [parseInt(h.slice(1,3),16), parseInt(h.slice(3,5),16), parseInt(h.slice(5,7),16)]; }
  function mixv(a,b,t){ return [a[0]+(b[0]-a[0])*t, a[1]+(b[1]-a[1])*t, a[2]+(b[2]-a[2])*t]; }
  function rgb(c,a){
    return 'rgba(' + (c[0]|0) + ',' + (c[1]|0) + ',' + (c[2]|0) + ',' + (a===undefined?1:a) + ')';
  }
  function lum(c){ return (c[0]*0.299 + c[1]*0.587 + c[2]*0.114)/255; }
  function mmss(f){
    var s=Math.floor(f/60);
    return Math.floor(s/60) + ':' + (s%60<10?'0':'') + (s%60);
  }
  // 1,590 のように3桁ごとに区切る（完走証のスコア）
  function comma(n){ return String(n).replace(/\B(?=(\d{3})+$)/g, ','); }
  function track(n,p){
    try{
      if(typeof window.gtag==='function') window.gtag('event', n, p||{});
      else if(window.dataLayer && window.dataLayer.push){
        var o={event:n},k; if(p) for(k in p) if(p.hasOwnProperty(k)) o[k]=p[k];
        window.dataLayer.push(o);
      }
    }catch(e){}
  }
  // 都市ごとに変わらない疑似乱数（同じ建物が毎回同じ形になる）
  function rnd(seed){ var x = Math.sin(seed*127.1)*43758.5453; return x - Math.floor(x); }

  /* 素材マニフェスト（素材名 → URL）を読む。
     Liquid が data-igrun の中に <script type="application/json" data-igrun-manifest> で出す。
     単体版（tools/build.py）は同じ形で data URL を埋め込む。
     見つからなければ空のまま返し、ゲームは素材なしで動く。 */
  function readManifest(root){
    var el = root.querySelector('[data-igrun-manifest]');
    if(!el) return {};
    try{ return JSON.parse(el.textContent || '{}') || {}; }
    catch(e){ return {}; }
  }

  /* 配置パターン（都市id → data/patterns/<city>.json の中身）。
     Liquid は snippets/igrun-patterns.liquid を、単体版は同じ JSON を埋め込む。
     どちらも tools/build.py が data/patterns/ から作るので、内容がずれない。
     読めなければ空で返し、その都市は spawnObs の保険（ランダム）で走る。 */
  function readPatterns(root){
    var el = root.querySelector('[data-igrun-patterns]');
    if(!el) return {};
    try{ return JSON.parse(el.textContent || '{}') || {}; }
    catch(e){ return {}; }
  }

  /* ===================================================== */
  function init(root){
    var spriteURL = root.getAttribute('data-sprite') || '';
    var shopURL   = root.getAttribute('data-shop-url') || '/collections/all';
    /* 完走証の主導線（2026-09-17）。クーポン表示をやめ、6周年ガチャへ誘導する。
       URL はセクション設定 data-gacha-url。無ければ既定のガチャページ */
    var GACHA_DEFAULT = 'https://geekshop.infolens.com/pages/igs6-gacha';
    var gachaURL  = root.getAttribute('data-gacha-url') || GACHA_DEFAULT;
    var storeKey  = root.getAttribute('data-storage-key') || 'igrun';
    var heading   = root.getAttribute('data-heading') || '';
    var coupon    = root.getAttribute('data-coupon-code') || '';
    var couponNote= root.getAttribute('data-coupon-note') || '';

    // マニフェスト（素材名 → URL）。root.innerHTML を書き換える前に読む
    var MANIFEST = readManifest(root);
    var PATTERNS = readPatterns(root);
    if(spriteURL) MANIFEST.sprite = spriteURL;
    loadFont(MANIFEST['font-rounded']);

    /* ルート決定。
       ・並びは data-route（無ければ ?igrun_route=、それも無ければ日付）で決める
       ・店頭QR（?from=parco または data-route="parco"）なら IGS の直前に池袋を差し込む */
    /* 動作確認用の入口は、セクションが data-debug="1" を出しているときだけ開ける。
       **本番テーマで開けたままにすると、ゴールだけ見てクーポンを取れてしまい、
       使用回数の上限（300回）が意味を失う。**テストテーマだけ ON にする。
       単体版（tools/build.py が作る dist）は確認用なので常に ON。 */
    var debugOn = root.getAttribute('data-debug') === '1';
    /* 性能表示（右下の数字と LITE の札）は **?igrun_perf=1 のときだけ**。
       **data-debug では出さない。**（2026-09-10 に変更）
       単体版 dist は data-debug="1" を常に出すので、それに連動させていたら
       実機で配った1ファイル版に既定で数字が出ていた。**遊ぶ人の画面には出さない。**
       数字を出すだけの表示なので、クエリを本番で誰かが付けても不正には使えない。 */
    var perfOn = false;

    var parco = false, routeKey = root.getAttribute('data-route') || '';
    try{
      var qs = new URLSearchParams(window.location.search);
      if(qs.get('from')==='parco') parco = true;               // 店頭QR。本番でも使う
      if(qs.get('igrun_perf')==='1') perfOn = true;            // 性能表示。誰が付けても害がない
      var qroute = qs.get('igrun_route');
      /* ROUTES のキー（full や 2026-09-21）は本番でも許す。どれも既定より短くならない。
         **都市をカンマで直接並べる書き方だけは debug のときに限る。**
         `?igrun_route=igs,igs` のように区間を減らして走れてしまうため */
      if(qroute && (qroute.indexOf(',') < 0 || debugOn)) routeKey = qroute;
    }catch(e){}
    if(routeKey==='parco'){ parco = true; routeKey=''; }     // 旧来の書き方
    var ROUTE_IDS = resolveRoute(routeKey);
    if(parco && ROUTE_IDS.indexOf('ikebukuro')<0){
      ROUTE_IDS = ROUTE_IDS.slice();
      ROUTE_IDS.splice(ROUTE_IDS.length-1, 0, 'ikebukuro');
    }
    /* =============== モード（TODO 17） ===============
       ~~本編を完走するまでモード選択は出さない~~ → **【2026-09-17 変更・石川さんの判断】
       最初から3つの札を出す。**初期選択はワールドツアーで、何もせずタップ／スペースなら本編が始まる。
       左右キーか札そのものを押した人だけが他のモードに入る。エキスパートの札には
       「上級者向け・2段封印・ワンミス」を添える（初見の人が選んで序盤で死ぬのを防ぐ。完走率 50% が主 KPI）。
       localStorage の <key>.cleared による解放判定は残す（PICKER_ALWAYS を false に戻せば以前の挙動）。

       | key | 中身 |
       |---|---|
       | tour    | 本編。7都市（店頭QRなら8）を走って IGS へ。ライフ3 |
       | endless | 都市をループ。ライフ1、速度に上限なし。**距離を競う** |
       | expert  | 本編と同じ道。**2段ジャンプ封印・初速が本編終盤・ワンミス終了** |

       endless は「区間の配列を伸ばすだけ」で作る。leg の進行・パターン・
       焼き込みの捨て方（procTrim は3都市しか残さない）は本編のまま動く。
       **走行中のコードに if(endless) を撒かないための選択。** */
    /* n＝札の名前、s＝札の中の小さな一行（選んでいなくても読める）、d＝選んでいる札の説明 */
    var MODES = [
      { k:'tour',    n:'ワールドツアー', s:'はじめての方はこちら',
        d:'すべての都市を走って IGS へ ／ 空中でもう一度タップすると2段ジャンプ' },
      { k:'endless', n:'エンドレス',     s:'ライフ1・距離を競う',
        d:'都市をループ・ライフ1・速度に上限なし。走れた距離を競う' },
      { k:'expert',  n:'エキスパート',   s:'上級者向け・2段封印・ワンミス',
        d:'上級者向け。2段ジャンプ封印・初速が本編終盤・ワンミスで終了' }
    ];
    var ENDLESS_LOOPS = 40;          // 6都市×40周＝76km。速度が上がるので誰も走り切れない
    var runMode = 'tour', modeSel = 0, cleared = false;
    try{ cleared = window.localStorage.getItem(storeKey+'.cleared') === '1'; }catch(e){}
    var PICKER_ALWAYS = true;        // 完走前でも札を出す（2026-09-17）。false なら cleared のときだけ
    function pickerOn(){ return cleared || PICKER_ALWAYS; }

    var CITIES, GOAL_IDX, LEG_START, LEG_LEN, TOTAL_M, VISITED;
    /* 走る道を組み立てる。モードを選び直すたびに呼ぶ。
       **ここで作る配列がゲームの「道」そのもの。**これ以外に道の定義は無い */
    function buildRoute(mk){
      var ids = ROUTE_IDS, i, macc = 0;
      if(mk==='endless'){
        // IGS（ゴール）を外した並びを繰り返す。ゴールが来ないので走り続けられる
        var loop = ROUTE_IDS.filter(function(id){ return id!=='igs'; }), r = [];
        for(i=0;i<ENDLESS_LOOPS;i++) r = r.concat(loop);
        r.push('igs');                       // 万一たどり着いたときのために店は残す
        ids = r;
      }
      CITIES = ids.map(function(id){ return CITY_BY_ID[id]; });
      GOAL_IDX = CITIES.length-1;                       // 最後は必ず IGS
      // 区間の長さは都市ごと（東京だけ 480m。data/patterns/tokyo.json の legLength と揃える）
      LEG_START = []; LEG_LEN = [];
      for(i=0;i<CITIES.length;i++){
        LEG_START.push(macc);
        LEG_LEN.push(i===GOAL_IDX ? GOAL_M : (CITIES[i].legM || LEG_M));
        macc += LEG_LEN[i];
      }
      TOTAL_M = macc;
      VISITED = CITIES.slice(0, GOAL_IDX).map(function(c){ return c.name; });
    }
    buildRoute('tour');
    function legOf(m){ for(var i=LEG_START.length-1;i>=0;i--) if(m>=LEG_START[i]) return i; return 0; }

    /* 動作確認用：?igrun_leg=N でその区間から始める（都市ごとの絵を撮るのに使う）。
       **区間を飛ばしてゴールできるので、data-debug="1" のときだけ効く。** */
    var startLeg = 0;
    /* 動作確認用：?debug=goal でゴールの 60m 手前から始まる（TODO 10）。
       ゴール演出は1回の走りで1度しか見られないので、これが無いと確認に3分かかる。
       **完走証のクーポンをすぐ出せてしまうので、こちらも data-debug="1" のときだけ。** */
    var debugGoal = false, foeDebug = '', zooN = 0;
    if(debugOn){
      try{
        var qd = new URLSearchParams(window.location.search);
        var qleg = parseInt(qd.get('igrun_leg'), 10);
        if(qleg>0 && qleg<CITIES.length) startLeg = qleg;
        debugGoal = qd.get('debug') === 'goal';
        /* モードの確認用（TODO 17）。**data-debug のときだけ。**
           ?igrun_cleared=1 で「本編を完走した人」の画に、
           ?igrun_mode=endless|expert でそのモードを選んだ状態にする。
           完走していない人にモードを見せない決まりは本番では変わらない */
        if(qd.get('igrun_cleared')==='1') cleared = true;
        /* 敵の確認用（enemy-spec 8章1「各敵種を単体で通す」）。
           ?igrun_foe=walker|hopper|flyer でその種類だけを一定間隔で出す。
           **data-debug のときだけ。**本番では配置パターンからしか出ない */
        var qfoe = qd.get('igrun_foe');
        if(qfoe==='walker' || qfoe==='hopper' || qfoe==='flyer') foeDebug = qfoe;
        /* ?igrun_foe=zoo：**絵と動きを見るためのモード。**walker → hopper → flyer を
           200px おきに出し続け、障害物とパターンを止め、被弾もしない。
           置き場所の検査も通さない（並べて見比べるのが目的で、公平性は見ない）。
           3フレーム連続のスクリーンショットで動きを証明するのに使う（2026-09-16 の指摘）。 */
        if(qfoe==='zoo') foeDebug = 'zoo';
        /* ?igrun_seed=N で配置を毎回同じにする（**data-debug のときだけ**）。
           人が触って確かめるとき、同じコースを繰り返せないと
           「いまのは配置のせいか、自分の操作のせいか」が切り分けられない。
           式は tools/shot.py の --seed と同じ mulberry32。**同じ数字なら同じ並びになる**ので、
           記録に残した確認（シード 7・21・99）をそのまま手で追体験できる。 */
        var qseed = parseInt(qd.get('igrun_seed'), 10);
        if(qseed >= 0){
          var _s = qseed >>> 0;
          Math.random = function(){
            _s = (_s + 0x6D2B79F5) >>> 0;
            var t = Math.imul(_s ^ (_s >>> 15), 1 | _s);
            t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
            return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
          };
        }
        var qmode = qd.get('igrun_mode');
        for(var qi=0; qmode && qi<MODES.length; qi++) if(MODES[qi].k===qmode){
          cleared = true; modeSel = qi; runMode = qmode; buildRoute(qmode);
        }
      }catch(e){}
    }

    root.classList.add('igrun');
    root.innerHTML =
      (heading ? '<h2 class="igrun-heading">' + heading + '</h2>' : '') +
      '<div class="igrun-stage" tabindex="0" role="application" ' +
        'aria-label="iGくんを走らせるゲーム。タップまたはスペースでジャンプ">' +
        '<canvas></canvas>' +
        '<div class="igrun-actions" data-ig="actions">' +
          '<button type="button" class="igrun-btn" data-ig="retry">この都市から再開</button>' +
          '<button type="button" class="igrun-btn igrun-btn--ghost" data-ig="restart">最初から</button>' +
          '<button type="button" class="igrun-btn igrun-btn--gacha" data-ig="gacha">6周年ガチャを引く</button>' +
          '<button type="button" class="igrun-btn igrun-btn--shop" data-ig="shop">ショップを見る</button>' +
          '<button type="button" class="igrun-btn" data-ig="share">シェア</button>' +
          '<button type="button" class="igrun-btn igrun-btn--save" data-ig="save">画像を保存</button>' +
        '</div>' +
      '</div>';

    var stage=root.querySelector('.igrun-stage'), canvas=root.querySelector('canvas');
    var ctx=canvas.getContext('2d');
    var q=function(n){ return root.querySelector('[data-ig="'+n+'"]'); };
    var actions=q('actions');
    var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* ================= 音（TODO 9） =================
       **音源ファイルは持たず、Web Audio で作る。** 理由は3つ:
       ・この環境には ffmpeg も sox も無く、落とした音源を切ったり軽くしたりできない
       ・そもそも音を聴いて確かめられないので、中身の分からないファイルは載せられない。
         生成なら周波数・長さ・音量が数値でそのまま読める
       ・Shopify のテーマに置く容量も、単体版の base64 も増えない

       **初期はミュート。** 商品ページに埋まる可能性があるので、勝手に鳴らさない。
       AudioContext は最初のユーザー操作でだけ作る（iOS の自動再生制限）。

       音量は visual-spec 3章の指定どおり、バスを3本に分けて持つ。
       効果音は BGM よりはっきり大きい（操作した手応えが最優先）。 */
    var VOL_BGM = 0.25, VOL_SFX = 0.6, VOL_HIT = 0.75;
    var au = { ctx:null, mas:null, bgm:null, sfx:null, hit:null, on:false };

    // ミュートの記憶。既定は「音を出さない」
    try{ au.on = window.localStorage.getItem(storeKey+'.sound') === '1'; }catch(e){ au.on = false; }

    /* 最初のユーザー操作で呼ぶ。2回目以降は resume だけ。
       ここで作らないと iOS は無音のまま「鳴っているつもり」になる */
    function audioBoot(){
      if(au.ctx){
        if(au.ctx.state === 'suspended'){ try{ au.ctx.resume(); }catch(e){} }
        return;
      }
      var AC = window.AudioContext || window.webkitAudioContext;
      if(!AC) return;
      try{ au.ctx = new AC(); }catch(e){ au.ctx = null; return; }
      au.mas = au.ctx.createGain(); au.mas.gain.value = 1; au.mas.connect(au.ctx.destination);
      // BGM は都市ごとにローパスの開き具合を変える（visual-spec 3章）
      au.lp = au.ctx.createBiquadFilter(); au.lp.type='lowpass';
      au.lp.frequency.value = 1200; au.lp.connect(au.mas);
      au.bgm = au.ctx.createGain(); au.bgm.gain.value = VOL_BGM; au.bgm.connect(au.lp);
      au.sfx = au.ctx.createGain(); au.sfx.gain.value = VOL_SFX; au.sfx.connect(au.mas);
      au.hit = au.ctx.createGain(); au.hit.gain.value = VOL_HIT; au.hit.connect(au.mas);
    }
    function soundOn(v){
      au.on = !!v;
      try{ window.localStorage.setItem(storeKey+'.sound', au.on ? '1' : '0'); }catch(e){}
      if(au.on) audioBoot();
      // 予約済みの音まで即座に止める（ミュートは押した瞬間に静かになってほしい）
      if(au.mas) au.mas.gain.value = au.on ? 1 : 0;
      if(!au.on){ bgmAt = 0; bgmHalt(); }
      else bgmLoad();                    // **音を出すと決めたときだけ MP3 を取りに行く**
    }
    /* 1音。f0→f1 に滑らせる。立ち上がりは 8ms（操作の手応えが遅れないように）。
       bus は 'sfx'（既定）か 'hit' か 'bgm' */
    function tone(f0, f1, dur, type, vol, delay, bus){
      if(!au.ctx || !au.on) return;
      var t = au.ctx.currentTime + (delay || 0);
      var o = au.ctx.createOscillator(), g = au.ctx.createGain();
      o.type = type || 'square';
      o.frequency.setValueAtTime(f0, t);
      if(f1 && f1 !== f0) o.frequency.exponentialRampToValueAtTime(Math.max(20, f1), t + dur);
      g.gain.setValueAtTime(0.0001, t);
      g.gain.linearRampToValueAtTime(vol, t + 0.008);
      g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
      o.connect(g); g.connect(au[bus || 'sfx']);
      o.start(t); o.stop(t + dur + 0.03);
    }
    /* ざらつき（スライド・被弾）。ホワイトノイズをローパスに通す。
       **雑音の種に Math.random を使わない。** ゲームの配置も Math.random で決めているので、
       音を出すかどうかで乱数の消費が変わり、**ミュートの有無でコースが変わってしまう**。
       専用の xorshift で作り、バッファは1本だけ作って使い回す（長さは再生時間で切る） */
    var nzSeed = 22801763489 % 4294967296;
    function nzRand(){
      nzSeed ^= nzSeed << 13; nzSeed ^= nzSeed >>> 17; nzSeed ^= nzSeed << 5;
      return (nzSeed >>> 0) / 2147483648 - 1;
    }
    function nzBuf(){
      if(au.nz) return au.nz;
      var n = Math.floor(au.ctx.sampleRate * 0.5);
      var buf = au.ctx.createBuffer(1, n, au.ctx.sampleRate), d = buf.getChannelData(0), i;
      for(i=0;i<n;i++) d[i] = nzRand();
      au.nz = buf;
      return buf;
    }
    function noise(dur, vol, cut, delay, bus){
      if(!au.ctx || !au.on) return;
      var t = au.ctx.currentTime + (delay || 0);
      var src = au.ctx.createBufferSource(); src.buffer = nzBuf();
      var f = au.ctx.createBiquadFilter(); f.type='lowpass'; f.frequency.value = cut || 1200;
      var g = au.ctx.createGain();
      g.gain.setValueAtTime(vol, t);
      g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
      src.connect(f); f.connect(g); g.connect(au[bus || 'sfx']);
      src.start(t, 0, Math.min(0.5, dur)); src.stop(t + dur);
    }

    var C5 = 523.25;
    function sfxJump(){ tone(330, 660, 0.11, 'square', 0.5); }
    function sfxDouble(){ tone(560, 1040, 0.10, 'square', 0.45); }
    /* 小包。**コンボで音程が上がる（visual-spec 3章の唯一の数値連動）。
       ×1 = C5、×5 = E5。5段なので半音ずつ上げる**（C・C#・D・D#・E） */
    function sfxParcel(m){
      var f = C5 * Math.pow(2, (m-1)/12);
      tone(f, f, 0.09, 'triangle', 0.55);
      tone(f*2, f*2, 0.06, 'sine', 0.22, 0.012);      // 倍音を薄く重ねて硬さを取る
    }
    function sfxHit(){
      tone(200, 55, 0.30, 'sawtooth', 0.5, 0, 'hit');
      noise(0.24, 0.4, 800, 0, 'hit');
    }
    /* 敵を踏んだ（enemy-spec 6章）。**軽い打撃音＋跳ね上がりの音**を重ねる。
       跳ね上がりは**小包より高い音程**から始める（小包は C5。ここは G5=784）。
       連続踏みで音程が上がる：2体目 +2半音、3体目以降 +4半音。
       小包（半音刻み）と混ざらないように、こちらは全音刻みにした。 */
    function sfxStomp(n){
      var f = 784.0 * Math.pow(2, Math.min(2, n-1)*2/12);
      noise(0.07, 0.34, 2400);                                       // 打撃（短く硬い）
      tone(f, f*1.5, 0.12, 'triangle', 0.5, 0.01);                   // 跳ね上がり
    }
    function sfxSlide(){ noise(0.30, 0.30, 1600); tone(240, 150, 0.22, 'triangle', 0.18); }
    function sfxNear(){ tone(1500, 2000, 0.05, 'sine', 0.30); }      // ひやりとした短い音
    function sfxClear(){                                             // 区間クリア（上行3音）
      tone(523.25, 523.25, 0.10, 'triangle', 0.42, 0);
      tone(659.25, 659.25, 0.10, 'triangle', 0.42, 0.09);
      tone(784.00, 784.00, 0.18, 'triangle', 0.42, 0.18);
    }
    function sfxGoal(){                                              // ゴール（5音のファンファーレ）
      var n=[523.25, 659.25, 784.00, 1046.5, 1318.5], i;
      for(i=0;i<n.length;i++) tone(n[i], n[i], i===4?0.5:0.12, 'triangle', 0.45, i*0.11);
    }
    /* 踏切の警報。**腕木が下り始めた瞬間に鳴らし、3往復で止める**（ループさせない）。
       本物の踏切と同じく2つの音を交互に打つ */
    function sfxAlarm(){
      var i, d=0.19;
      for(i=0;i<6;i++) tone(i%2 ? 784 : 659, i%2 ? 784 : 659, 0.16, 'square', 0.34, i*d);
    }

    /* BGM。1ループを組み立てて先の分だけ予約する（visual-spec 3章）。
       都市ごとにテンポとローパスを変える。**環境なので効果音より明確に小さい**（バスで 0.25）。
       予約は 0.25 秒先まで。ゲームが止まれば予約も止まる */
    var BGM_BASS = [0, 0, 7, 0, -3, -3, 5, 7];       // I I V I / VI VI V V
    var bgmStep = 0, bgmAt = 0;

    /* ---- 音源ファイルの BGM（2026-09-10。TODO 6） ----
       AI 生成の MP3 に差し替える方針になった。**Web Audio の生成はフォールバックとして残す**
       （音源が無い環境・読み込みに失敗した環境でも無音にしない）。

       ・マニフェストの `bgm-loop` を fetch → decodeAudioData → loop=true で流す。
         **ループの継ぎ目は Web Audio が持つので、隙間は原理的に開かない**
         （予約でつなぐ生成版と違い、サンプル単位で繋がる）
       ・都市ごとのローパスは au.lp をそのまま通すので今までどおり効く
       ・テンポは playbackRate。**生成版と同じ比（最大 1.49倍）は音程が上がりすぎる**ので、
         区間ごと 3% ずつ・上限 1.18倍に抑えた
       ・**読み込むのは「音を出す」に切り替えたときだけ。**ミュートのまま遊ぶ人に
         1.5MB を落とさせない（初期ミュートの方針と揃える）
       ・失敗したら bgmBuf は null のままで、下の生成版がそのまま鳴る */
    var bgmBuf=null, bgmSrc=null, bgmTried=false;
    /* **2026-09-17：BGM は実装しない（石川さんの判断）。効果音だけで公開する。**
       音源ファイルの用意を取りやめた。生成版も鳴らさない。
       仕組み（bgmLoad / bgmTick / bgmOpen / bgmCity）はこのフラグの下でそのまま残す。
       マニフェストの `bgm-loop` は Liquid から外した（無いファイルの URL を出すと 404 になる）。
       ミュートの札は効果音の ON/OFF として働く */
    var BGM_ENABLED = false;
    function bgmRate(){ return 1 + Math.min(legIdx, 6) * 0.03; }
    function bgmLoad(){
      if(!BGM_ENABLED) return;                           // 音源を取りに行かない（404 も出ない）
      if(bgmTried || !au.ctx) return;
      bgmTried = true;                                   // 失敗しても二度は取りに行かない
      var url = MANIFEST['bgm-loop'];
      if(!url || !window.fetch) return;
      try{
        window.fetch(url).then(function(r){
          if(!r.ok) throw new Error('bgm ' + r.status);
          return r.arrayBuffer();
        }).then(function(ab){
          return new Promise(function(res, rej){
            // 古い Safari は Promise を返さない版しか持たない。両対応で書く
            var pr = au.ctx.decodeAudioData(ab, res, rej);
            if(pr && pr.then) pr.then(res, rej);
          });
        }).then(function(buf){
          bgmBuf = buf; bgmPlay();
        })['catch'](function(){ bgmBuf = null; });        // 生成版に落ちる
      }catch(e){}
    }
    function bgmPlay(){
      if(!bgmBuf || !au.ctx || !au.on || bgmSrc) return;
      try{
        bgmSrc = au.ctx.createBufferSource();
        bgmSrc.buffer = bgmBuf; bgmSrc.loop = true;
        bgmSrc.playbackRate.value = bgmRate();
        bgmSrc.connect(au.bgm);                           // 生成版と同じバス（音量も同じ）
        bgmSrc.start();
      }catch(e){ bgmSrc = null; }
    }
    function bgmHalt(){
      if(!bgmSrc) return;
      try{ bgmSrc.stop(); }catch(e){}
      try{ bgmSrc.disconnect(); }catch(e){}
      bgmSrc = null;
    }
    function bgmTick(){
      if(!BGM_ENABLED){ bgmAt = 0; return; }             // 生成版も予約しない
      // 音源があるときは、鳴らす／止めるとテンポだけ見て、生成版は動かさない
      if(bgmBuf){
        var live = au.ctx && au.on && (mode==='run' || mode==='enter');
        if(live && !bgmSrc) bgmPlay();
        if(!live && bgmSrc) bgmHalt();
        if(bgmSrc){
          try{ bgmSrc.playbackRate.setTargetAtTime(bgmRate(), au.ctx.currentTime, 0.5); }catch(e){}
        }
        return;
      }
      if(!au.ctx || !au.on || (mode!=='run' && mode!=='enter')) { bgmAt = 0; return; }
      var t = au.ctx.currentTime;
      if(!bgmAt) bgmAt = t + 0.08;
      // 8分音符の長さ。先の都市ほど速い。**エンドレスは区間が240まで伸びるので頭打ちにする**
      var sp = 60 / (86 + Math.min(legIdx, 12)*7) / 2;
      while(bgmAt < t + 0.25){
        var n = bgmStep % 8, f = 110 * Math.pow(2, BGM_BASS[n]/12);
        tone(f, f, sp*0.85, 'triangle', 0.55, bgmAt - t, 'bgm');
        if(n % 2 === 1) tone(f*4, f*4, sp*0.5, 'sine', 0.16, bgmAt - t, 'bgm');
        bgmAt += sp; bgmStep++;
      }
    }
    /* ゴール前で BGM のローパスを開く（visual-spec 2-6：音が明るくなる）。
       t は 0→1。都市の値から 5000Hz まで持ち上げる */
    function bgmOpen(t){
      if(!au.ctx || !au.on) return;
      var base = city.night ? 900 : 2100;
      try{ au.lp.frequency.setTargetAtTime(base + (5000-base)*Math.max(0,Math.min(1,t)),
                                           au.ctx.currentTime, 0.15); }catch(e){}
    }
    // 夜の都市はこもらせ、昼は開ける。区間が変わるたびに呼ぶ
    function bgmCity(){
      if(!au.ctx) return;
      try{ au.lp.frequency.setTargetAtTime(city.night ? 900 : 2100, au.ctx.currentTime, 0.4); }catch(e){}
    }

    /* ---------------- 素材の読み込み ----------------
       マニフェストの素材名は「<都市id>-<部品名>」か「common-<部品名>」。
       都市の絵を先読みするタイミングを名前だけで決められるようにしてある。
       素材が無い環境（マニフェスト未設置）でも、読み込みを丸ごと飛ばして動く。 */
    var igImg=null, igReady=false, canExport=true;
    var imgs={}, loadState={}, loadDone=0, loadTotal=0;

    function namesFor(prefix){
      var out=[], k;
      for(k in MANIFEST) if(MANIFEST.hasOwnProperty(k) && k.indexOf(prefix)===0) out.push(k);
      return out;
    }
    /* その都市の素材を読むべきか。**procedural で描く都市は1枚も使わない**ので、
       読みに行かない（初回読み込みが 3秒を超えないことが TODO 11 の条件）。
       マニフェストにも読み込みのコードにも手を付けていないので、
       PROC_PAL から外せばそのまま元の見た目に戻る。 */
    function cityNames(id){ return PROC_PAL[id] ? [] : namesFor(id + '-'); }
    function loadOne(name, url, withCORS){
      var im=new Image(), isData=url.indexOf('data:')===0;
      if(withCORS && !isData) im.crossOrigin='anonymous';
      im.onload=function(){
        imgs[name]=im; loadState[name]='ok'; loadDone++;
        if(name==='sprite'){ igImg=im; igReady=true; canExport=withCORS||isData; }
      };
      im.onerror=function(){
        // Shopify CDN が CORS ヘッダを返さない場合に備えて、付けずに1回だけやり直す
        if(withCORS && !isData){ loadOne(name, url, false); return; }
        loadState[name]='err'; loadDone++;
      };
      im.src=url;
    }
    // 未着手のものだけ読み込みに出す。何度呼んでも二重に読まない
    function request(names){
      for(var i=0;i<names.length;i++){
        var n=names[i];
        if(loadState[n] || !MANIFEST[n]) continue;
        loadState[n]='load'; loadTotal++;
        loadOne(n, MANIFEST[n], true);
      }
    }
    function settled(names){
      for(var i=0;i<names.length;i++){
        var st=loadState[names[i]];
        if(st==='load') return false;
      }
      return true;
    }
    // 描画側はこれで素材を取る。無ければ null（呼び出し側がコード描画に落とす）
    function asset(name){ return imgs[name] || null; }

    /* 起動時に要るもの：共通素材＋最初の都市＋iGくん。
       **中身を決めるのは boot の直前**（PROC_PAL と、それを切る逃げ道が
       この位置より下で決まるため。ここで確定させると読む枚数を間違える） */
    var bootNames = [];

    /* ---------------- 状態 ---------------- */
    var VW=640;
    var mode='load';
    var worldX=0, dist=0, parcels=0, spd=3.4, tick=0, shake=0, hitStop=0;
    var lives=LIVES, retries=0, clock=0, enterT=0, nameShow=0, blend=1;
    var legIdx=0, prev=CITIES[0], city=CITIES[0];
    var l1=[], lm=[], l2=[], l3=[], l5=[], obs=[], boxes=[], flakes=[], bits=[], shop=null;
    /* =============== 都市ごとのギミック（2026-09-10。TODO 3） ===============
       東京の踏切・池袋の人波と同じ枠組み（パターンの items に type:"gimmick"）で、
       残り5都市に1つずつ。**どれも当たって死ぬものは作らない。**
       理不尽で離脱されるくらいなら、遊びが1つ増えないほうがまし。

       | 都市 | ギミック | 中身 |
       |---|---|---|
       | カイロ | sand   | 砂嵐。視界が狭まる。**障害物は減らして見えにくさだけで緊張を作る** |
       | パリ   | rain / puddle | 雨。水たまりを踏むとスライドが 1.6 倍伸びる |
       | NY     | taxi   | タクシーの屋根に**乗れる**。乗ると3秒加速。避けてもよい |
       | 南極   | ice    | 氷面。上にいる間すべって前に流される（着地位置の計画が要る） |
       | 香港   | neon   | 点滅する看板の足場。**光っている間だけ乗れる**。落ちても地面に戻るだけ |

       plats  乗れる足場（taxi・neon）。**上から降りてきたときだけ乗る。**
              下から突き上げても素通り＝当たらないので、障害物にはならない
       pads   地面の装飾（puddle・ice）。判定は無く、上を通ると状態が立つ
       trigs  通過した瞬間に効果が始まる目印（sand・rain）。絵は持たない */
    var plats=[], pads=[], trigs=[], gim={sand:0, rain:0, boost:0, ice:0, wet:0};
    var nextObsX=0, nextBoxX=0, nextFoeX=0, lifeHit=0, parcelPop=0;
    /* 一時停止（2026-09-10。TODO 5）。**タイマーも世界も止める。**
       再開は 3・2・1 のカウントダウン。**いきなり動き出すと、止めた意味が無い**
       （手を離していた1秒で障害物に当たる）。タブを離れたときも自動で止める。 */
    var paused=false, countT=0;
    /* スコア（TODO 7）。内訳は完走証に出すので、合計だけでなく3つに分けて持つ。
       combo＝連続で取った小包の数、mult＝いまの倍率（5個ごとに上がる。上限5）、
       comboPop＝上昇のバウンド、comboBreak＝途切れたときの点滅、breakM＝点滅中に見せる倍率、
       legClean＝この区間をまだ無傷で走っているか、ndShow＝NO DAMAGE の表示残り */
    var sPar=0, sNear=0, sND=0, sFoe=0;      // sFoe は敵を踏んだぶん（enemy-spec 5章）
    /* 踏んだ数（2026-09-17・石川さんの指示）。点は入るのに「何体退けたか」がどこにも出ず、
       避ける／踏むの選択の手応えが返っていなかった。言葉は**「撃退」**（仕入れの邪魔をするものを退けた）。
       やり直しても仕入れと同じく残す（区間の頭からの取り直しは combo だけ）。 */
    var stomps=0, stompPop=0;
    var combo=0, mult=1, comboMax=1, comboPop=0, comboBreak=0, breakM=1;
    var legClean=true, ndShow=0, nearGhost=0;
    /* ゴール演出（visual-spec 2-6）。phase は hop → wait → walk → conf → fade。
       hopN はここまでに跳んだ回数、fadeT は完走証へのクロスフェードの経過 */
    var goalPhase='', hopN=0, waitT=0, walkT=0, confT=0, fadeT=0;
    function score(){ return sPar + sNear + sND + sFoe; }
    /* iGくんの状態。squash＝着地のつぶれ、stretch＝踏み切りの伸び、spin＝2段ジャンプの回転、
       hopT＝区間クリアのホップ、hitFlash＝被弾の着色、slide＝スライディング姿勢、
       slideT＝スライドの最低持続の残り、slideHold＝入力を押し続けているか、dive＝急降下中 */
    var pl={ x:100, offX:0, y:GROUND_Y-P_H, vy:0, ground:true, jumps:0, hold:false, holdN:0,
             phase:0, rot:0, inv:0, alpha:1, scale:1, jumpF:-99,
             squash:0, stretch:0, spin:0, hopT:0, hitFlash:0,
             slide:false, slideT:0, slideHold:false, dive:false };
    var ghosts=[];                               // 残像（最大2枚。plan-a 2章）
    var SPIN_F=24, HOP_F=54;        // HOP_F は区間クリアのホップ。3回ぶんに伸ばした（2026-09-10）
    var C={};                                    // 現在の色（都市間で補間したもの）

    /* 区間ごとの速度（px/frame。60fps・20px=1m なので m/s は ×3）。
       expert は「初速が本編終盤」＝ 本編の最後の走行区間（香港 5.10）から始める。
       endless は本編と同じ増え方をそのまま延長する（上限を置かない）。 */
    var EXPERT_BASE = 5.10;
    function speedOfLeg(i){
      if(runMode==='expert') return (i>=GOAL_IDX ? EXPERT_BASE+0.5 : EXPERT_BASE + i*0.34);
      return i>=GOAL_IDX ? 4.0 : 3.4 + i*0.34;
    }
    // ライフ。**エンドレスとエキスパートはワンミス**（TODO 17 の指定）
    function livesFor(){ return runMode==='tour' ? LIVES : 1; }

    function seedScene(){
      l1=[]; lm=[]; l2=[]; l3=[]; l5=[];
      var i;
      for(i=0;i<5;i++) l1.push({ x:i*260, s:i*3.7 });
      lm.push({ x:180, s:2.4 });                 // ランドマークは常に1本だけ持つ
      for(i=0;i<4;i++) l2.push({ x:VW*0.2+i*300, s:i*7.3 });
      for(i=0;i<6;i++) l3.push({ x:i*185, s:i*11.1 });
      for(i=0;i<3;i++) l5.push({ x:i*420, s:i*5.5 });
    }
    function clearField(){
      obs=[]; boxes=[]; flakes=[]; bits=[]; shop=null; cross=null;
      plats=[]; pads=[]; trigs=[]; gim={sand:0, rain:0, boost:0, ice:0, wet:0};
      foes=[]; foeGrace=0; foeChain=0;                    // 敵（enemy-spec）
      pl.footPrev=GROUND_Y;                               // 踏み判定が見る「前フレームの足元」
      pl.y=GROUND_Y-P_H; pl.vy=0; pl.ground=true; pl.jumps=0; pl.rot=0;
      pl.inv=0; pl.alpha=1; pl.scale=1; pl.offX=0; pl.squash=0;
      pl.stretch=0; pl.spin=0; pl.hopT=0; pl.hitFlash=0;
      pl.slide=false; pl.slideT=0; pl.slideHold=false; pl.dive=false; pl.jumpF=-99;
      ghosts=[];
      seedScene();
    }
    function startAt(leg){
      // その区間の素材をまだ持っていないことがある（リトライ、QA の区間指定など）。
      // 読み込み済みなら何も起きない
      if(debugGoal) leg = GOAL_IDX;                 // ?debug=goal はゴール区間から
      request(cityNames(CITIES[leg].id));
      legIdx=leg; prev=city=CITIES[leg]; blend=1;
      dist=LEG_START[leg]; worldX=dist*20; spd=speedOfLeg(leg);
      if(debugGoal){
        dist = TOTAL_M-60; worldX = dist*20;                 // 店が出る 60m 手前
        clock = 192*60;                                      // 完走証の桁を確かめるため 3:12 から
      }
      lives=livesFor(); nextObsX=worldX+460; nextBoxX=worldX+280; nextFoeX=worldX+460;
      procTrim();                                   // やり直しでも、通り過ぎた都市は抱えない
      initPatterns(leg);
      nameShow=NAME_SHOW; shake=0; hitStop=0; lifeHit=0; parcelPop=0;
      // やり直しても小包とスコアは残す（リタイア画面でそう案内している）。
      // コンボは区間の頭から取り直し。無傷ボーナスもその区間の走り直しぶんで判定する
      combo=0; mult=1; comboPop=0; comboBreak=0; legClean=true; ndShow=0;
      clearField(); hideActions(); mode='run';
    }
    function newRun(){
      parcels=0; retries=0; clock=0;
      sPar=0; sNear=0; sND=0; sFoe=0; comboMax=1; stomps=0; stompPop=0;
      slideSent=false;                                 // 走りが変わればまた1回だけ送る
      startAt(startLeg); track('igrun_start',{mode:runMode});
    }

    /* =============== 素材の描画（共通） ===============
       素材名は「<都市id>-<部品名>」。都市の切り替え中（blend<1）は
       前の都市の絵の上に新しい都市の絵を alpha=blend で重ねてクロスフェードする。 */
    function drawAssetOf(cityId, name, x, y, w, h){
      var im = asset(cityId + '-' + name);
      if(!im) return false;
      ctx.drawImage(im, x, y, w, h);
      return true;
    }
    function drawCityAsset(name, x, y, w, h){
      var ok = false;
      if(blend < 1) ok = drawAssetOf(prev.id, name, x, y, w, h);
      if(blend < 1) ctx.globalAlpha = blend;
      ok = drawAssetOf(city.id, name, x, y, w, h) || ok;
      ctx.globalAlpha = 1;
      return ok;
    }

    /* =========================================================
       procedural 描画（art-direction-final.md で確定した方式）

       **コードで直接描く。外部の画像素材（Kenney）は読み込んだまま使わない。**
       4版を作って分かったのは「平面的に描くことが安っぽさの原因ではなく、
       光と大気の情報量が足りないことが原因」だった、ということ。
       禁止していたグラデーションを主役にしたのが転換点（同 1章）。

       効かせる技法（同 2章）:
       ・空を5〜7色のグラデーションにし、地平に向けて色相を動かす
       ・月／太陽に多層の radial gradient で光暈をつける
       ・建物を far / mid / near の3層に分け、遠いほど空の色に溶かす
       ・窓の灯りを暖色と青白で混ぜ、点灯をばらつかせる
       ・ネオン看板は sin 波でゆっくり明滅させる（単純な点滅にしない）
       ・航空障害灯は pow(sin,6) の鋭い波形
       ・地平に大気の靄、画面周囲にビネット
       ・高架下（floor 帯）にもう一層見せて奥行きを作る

       **性能**：グラデーションを毎フレーム作ると重い。建物・光暈・靄・地面・
       障害物は、いちど別 canvas に焼き込んで使い回す。焼き込みは都市ごとに1回。
       画面幅に依存するもの（空・靄・ビネット）だけ VW が変わったら焼き直す。

       いまは**東京と IGS（帰り道）だけ**。PROC_PAL にその都市が無ければ
       1行も通らず、従来の素材描画がそのまま動く。 */
    var BAKE = 2;                 // 焼き込みの解像度倍率（等倍だと高dpiで甘くなる）
    var HORIZON = 244;            // 遠景の街が空に接する高さ

    /* k を渡すと焼き込みの倍率を変えられる。
       **全画面ぶんの滑らかなグラデーション（空・ビネット・靄・高架下）は k=1 で焼く。**
       2倍で焼くと 1枚 4MB 級になり、中位 Android のメモリを無駄に食う。
       拡大しても階調しか無いので、等倍でも見た目は変わらない */
    function mkc(w, h, k){
      k = k || BAKE;
      var c = document.createElement('canvas');
      c.width  = Math.max(1, Math.ceil(w*k));
      c.height = Math.max(1, Math.ceil(h*k));
      var g = c.getContext('2d');
      g.scale(k, k);
      return { c:c, g:g, w:w, h:h };
    }
    function blit(o, x, y){ if(o) ctx.drawImage(o.c, x, y, o.w, o.h); }
    function into(g, o, x, y){ if(o) g.drawImage(o.c, x, y, o.w, o.h); }
    var blurOK = (function(){
      try{ var t=mkc(4,4).g; t.filter='blur(2px)'; return t.filter!=='none'; }catch(e){ return false; }
    })();
    /* 焼き込み用の乱数。同じ種なら毎回同じ絵になる（毎回違う街だと確認が出来ない） */
    function seq(s){
      var i=0;
      return function(a,b){
        var r = rnd(s*3.11 + (++i)*1.37);
        return (a===undefined) ? r : a + r*(b-a);
      };
    }
    function rr(g,x,y,w,h,r){
      r = Math.min(r, w/2, h/2);
      g.beginPath();
      g.moveTo(x+r,y); g.arcTo(x+w,y,x+w,y+h,r); g.arcTo(x+w,y+h,x,y+h,r);
      g.arcTo(x,y+h,x,y,r); g.arcTo(x,y,x+w,y,r); g.closePath();
    }
    function stops(g, gr, list){
      for(var i=0;i<list.length;i++) gr.addColorStop(list[i][0], list[i][1]);
      return gr;
    }

    /* ---- 全都市で使い回すもの（光の粒・接地影・仕入れの箱） ---- */
    function bakeGlow(c){
      var S=64, o=mkc(S,S), g=o.g;
      var gr=g.createRadialGradient(S/2,S/2,0,S/2,S/2,S/2);
      gr.addColorStop(0,'rgba('+c+',1)');
      gr.addColorStop(0.25,'rgba('+c+',.55)');
      gr.addColorStop(1,'rgba('+c+',0)');
      g.fillStyle=gr; g.fillRect(0,0,S,S);
      return o;
    }
    function bakeAO(c){
      c = c || '0,0,0';
      var o=mkc(128,40), g=o.g;
      var gr=g.createRadialGradient(64,20,0,64,20,64);
      gr.addColorStop(0,'rgba('+c+',.80)');
      gr.addColorStop(0.5,'rgba('+c+',.32)');
      gr.addColorStop(1,'rgba('+c+',0)');
      g.save(); g.translate(64,20); g.scale(1,0.30); g.translate(-64,-20);
      g.fillStyle=gr; g.beginPath(); g.arc(64,20,64,0,7); g.fill(); g.restore();
      return o;
    }
    /* =============== 仕入れ品＝玩具（2026-09-10。TODO 4） ===============
       段ボール箱をやめた。**「取るもの／避けるもの」の区別がつかない**という実機の指摘。
       障害物も箱・柱・棒なので、同じ茶色い箱では見分けようがない。

       判別のための決め（全種類に共通で守る）:
         形  障害物には無い**丸みのある不定形**。四角い輪郭で終わらせない
         色  **ピンク・黄・白・水色。**障害物のパレット（茶・石・氷・紺）と重ならない
         光  淡い光暈をまとう。**障害物は光らない**（popObs の縁取りとは別物）
         判定 種類が変わっても当たり判定は同じ（drawBox は見た目だけ）

       **他社IPのキャラクター・ロゴ・固有デザインは1つも入れない。**
       ぬいぐるみは種類の分からない丸い生きもの、フィギュアの箱は窓付きの箱、
       という**一般名詞の範囲**にとどめる。 */
    var TOY_N = 6;
    function bakeToy(k){
      var S=24, p=7, o=mkc(S+p*2,S+p*2), g=o.g, c=p+S/2;   // c＝中心
      function ell(x,y,rx,ry,col){ g.fillStyle=col; g.beginPath(); g.ellipse(x,y,rx,ry,0,0,7); g.fill(); }
      function line(x1,y1,x2,y2,col,w){ g.strokeStyle=col; g.lineWidth=w||1; g.beginPath(); g.moveTo(x1,y1); g.lineTo(x2,y2); g.stroke(); }
      if(k===0){                                   // ぬいぐるみ（丸い生きもの。特定の作品のものにしない）
        ell(c-6.5,c-6,4,4,'#FF9EC4'); ell(c+6.5,c-6,4,4,'#FF9EC4');   // 耳
        ell(c,c+1,9.5,8.5,'#FFB3D1');                                  // 体
        ell(c-3.2,c-1,1.5,1.8,'#3A2A33'); ell(c+3.2,c-1,1.5,1.8,'#3A2A33');
        ell(c,c+2.6,1.6,1.2,'#3A2A33');
        ell(c-5.5,c-3.5,2.6,2,'rgba(255,255,255,.55)');                // つや
      } else if(k===1){                            // フィギュアの箱（窓付き）
        g.fillStyle='#FFD34D'; rr(g,c-8,c-10,16,20,2); g.fill();
        g.fillStyle='rgba(255,255,255,.85)'; rr(g,c-5.5,c-7,11,12,1.5); g.fill();
        ell(c,c-2.5,3,4.2,'#8FD3F4');                                   // 中の人形（顔は描かない）
        g.fillStyle='#E86A9B'; g.fillRect(c-8,c+6,16,3.4);
        g.fillStyle='rgba(255,255,255,.5)'; g.fillRect(c-8,c-10,16,1.4);
      } else if(k===2){                            // 携帯ゲーム機
        g.fillStyle='#FFFFFF'; rr(g,c-7,c-10,14,20,3.5); g.fill();
        g.fillStyle='#2E3A46'; rr(g,c-4.6,c-8,9.2,8,1); g.fill();
        ell(c-4,c+4.5,2.2,2.2,'#9AA6B4'); ell(c+4,c+4.5,1.5,1.5,'#FF7BA6');
        ell(c+4,c+8,1.5,1.5,'#7BD1FF');
        g.fillStyle='rgba(140,220,255,.7)'; g.fillRect(c-3.6,c-6.8,7.2,1.6);
      } else if(k===3){                            // コントローラー
        ell(c-6,c+1,6,5.5,'#F2F4F8'); ell(c+6,c+1,6,5.5,'#F2F4F8');
        g.fillStyle='#F2F4F8'; rr(g,c-7,c-4,14,8,3); g.fill();
        ell(c-5.5,c-0.5,2.4,2.4,'#2E3A46');                             // スティック
        ell(c+5.5,c-0.5,1.4,1.4,'#FF7BA6'); ell(c+8,c-2.4,1.4,1.4,'#FFD34D');
        g.fillStyle='rgba(255,255,255,.6)'; g.fillRect(c-3,c-3.4,6,1.4);
      } else if(k===4){                            // カプセルトイ
        g.fillStyle='#FFE27A'; g.beginPath(); g.arc(c,c,10,Math.PI,0); g.fill();
        g.fillStyle='rgba(255,255,255,.85)'; g.beginPath(); g.arc(c,c,10,0,Math.PI); g.fill();
        line(c-10,c,c+10,c,'rgba(120,100,60,.5)',1.2);
        ell(c-4,c-4.5,3,2.2,'rgba(255,255,255,.7)');
        ell(c+1,c+4,2.4,2,'#7BD1FF');                                   // 中身が透けている
      } else {                                     // 缶バッジ
        ell(c,c,10,10,'#FFFFFF');
        ell(c,c,8.2,8.2,'#7BD1FF');
        ell(c,c,4.6,4.6,'#FF7BA6');
        ell(c-3.4,c-3.8,2.6,1.9,'rgba(255,255,255,.75)');
        g.strokeStyle='rgba(120,150,175,.6)'; g.lineWidth=1;
        g.beginPath(); g.arc(c,c,9.2,0,7); g.stroke();
      }
      return o;
    }
    /* 仕入れの箱。**HUD と完走証はこれのまま**（小さいので玩具だと読めない） */
    function bakeParcel(){
      var S=22, p=6, o=mkc(S+p*2,S+p*2), g=o.g, x=p;
      var gr=g.createLinearGradient(x,x,x+S,x+S);
      gr.addColorStop(0,'#E8BC80'); gr.addColorStop(0.45,'#C89257'); gr.addColorStop(1,'#8A5C2E');
      g.fillStyle=gr; rr(g,x,x,S,S,2.5); g.fill();
      var lg=g.createLinearGradient(0,x,0,x+7);
      lg.addColorStop(0,'#F5D6A4'); lg.addColorStop(1,'#D3A468');
      g.fillStyle=lg; rr(g,x,x,S,7,2.5); g.fill();
      g.strokeStyle='rgba(90,56,22,.45)'; g.lineWidth=0.8;
      g.beginPath(); g.moveTo(x,x+7); g.lineTo(x+S,x+7); g.stroke();
      g.fillStyle='rgba(250,248,240,.72)'; g.fillRect(x+S/2-2.4,x,4.8,S);
      g.fillStyle='rgba(250,248,240,.5)';  g.fillRect(x,x+4,S,3.2);
      g.fillStyle='#45C6EC'; rr(g,x+4,x+12,8,6,1); g.fill();     // iG のラベル
      g.fillStyle='rgba(255,255,255,.9)'; g.fillRect(x+5,x+13.4,2,3.2); g.fillRect(x+8.2,x+13.4,2.6,3.2);
      g.fillStyle='rgba(255,236,200,.55)'; g.fillRect(x,x,1.1,S);
      var sg=g.createLinearGradient(0,x+S-6,0,x+S);
      sg.addColorStop(0,'rgba(0,0,0,0)'); sg.addColorStop(1,'rgba(30,14,0,.35)');
      g.fillStyle=sg; rr(g,x,x,S,S,2.5); g.fill();
      return o;
    }
    var GX=null;
    function gx(){
      if(!GX) GX = {
        warm: bakeGlow('255,190,110'), cyan: bakeGlow('120,232,255'),
        cold: bakeGlow('190,215,255'), star: bakeGlow('226,238,255'),
        red:  bakeGlow('255,110,80'),  ao: bakeAO(), parcel: bakeParcel(),
        toys: (function(){ var a=[],i; for(i=0;i<TOY_N;i++) a.push(bakeToy(i)); return a; })(),
        aoBlue: bakeAO('40,74,120'),   // 雪・氷の上の影（黒だと穴に見える）
        aoWarm: bakeAO('72,44,18')     // 砂・石畳の上の影
      };
      return GX;
    }

    /* ---- 看板の文字。**実在する語だけ**（art-direction-final.md 3章）。
       日本のお客さんが見るので、「麺湯」のような並びはすぐ気づかれる ---- */
    var SIGN_WORDS = ['居酒屋','ラーメン','焼鳥','定食','喫茶','カラオケ','牛丼','餃子','寿司','銭湯'];
    var SIGN_PAIRS = ['酒場','焼肉','珈琲','古書','洋品','花屋','薬局','中華'];
    var NEON = ['#FF4D8D','#45E0FF','#FFD166','#7CE38B','#FF7A45'];
    /* 都市ごとの看板。**その街の言葉で、実在する一般名詞だけ。**
       他社IPの名前・ロゴ・固有の意匠は入れない（風景として描くに留める）。
       縦書きは漢字・かなの街だけ。ラテン文字を縦に積むと読めない */
    var SIGN_SET = {
      tokyo:     { w:SIGN_WORDS, p:SIGN_PAIRS, vert:.62 },
      ikebukuro: { w:['ラーメン','カラオケ','古書店','喫茶','餃子','中華','劇場','洋品',
                       '定食','焼鳥','甘味','写真'],
                   p:['書店','画材','模型','珈琲','雑貨','食堂','薬局','酒場',
                      '古着','文具','時計','眼鏡'], vert:.62 },
      cairo:     { w:['BAZAR','SOUK','CAFE','SPICES','CARPETS','TEA','DATES','COTTON',
                       'PAPYRUS','LAMPS','BRASS','MARKET'],
                   p:['SOUK','CAFE','TEA','SPICE','GOLD','SILK','OIL','FIGS','MINT','RUGS'],
                   vert:0 },
      paris:     { w:['CAFE','HOTEL','FLEURS','LIBRAIRIE','BISTROT','TABAC','FROMAGE',
                       'CHOCOLAT','ANTIQUITES','PATISSERIE','PHARMACIE','THEATRE'],
                   p:['CAFE','PAIN','VINS','FLEURS','LIVRES','TABAC','THE','MIEL',
                      'GLACES','JOURNAUX'], vert:0 },
      ny:        { w:['DINER','DELI','LAUNDRY','BOOKS','PIZZA','HOTEL','BAGELS','BARBER',
                       'RECORDS','HARDWARE','PHARMACY','THEATER'],
                   p:['DELI','BAR','24H','PIZZA','BOOKS','COFFEE','TACOS','DONUTS',
                      'KEYS','NEWS'], vert:0 },
      pole:      { w:[], p:[], vert:0 },
      hk:        { w:['海鮮','飲茶','点心','金行','麺家','茶楼','薬','酒',
                       '雲呑','焼味','涼茶','食堂'],
                   p:['海鮮','飲茶','点心','金行','茶楼','麺家','雲呑','焼味',
                      '涼茶','粥麺'], vert:.78 },
      igs:       { w:SIGN_WORDS, p:SIGN_PAIRS, vert:.62 }
    };

    /* ---- 都市ごとの procedural パレット ----
       near（キャラのすぐ後ろの層）は **mid より1段明るく** してある。
       ここが地面と同じ明度だと iGくんが暗い塊に埋もれる（同 3章の指摘）。 */
    var PROC_PAL = {
      tokyo: {
        id:'tokyo', night:true,
        sky:[[0,'#060819'],[.24,'#101540'],[.48,'#22245C'],[.68,'#3E2C63'],
             [.85,'#6E3A62'],[.95,'#A9525A'],[1,'#C97A55']],
        dome:{x:.58,y:HORIZON+22,r:300,c:'255,178,110',a:.42},
        cool:{x:.18,y:.20,r:250,c:'120,170,255',a:.16},
        orb:{x:.14,y:.13,r:18,moon:true},
        cloud:[['206,220,255',.16,.035,58,5],['230,190,210',.13,.07,108,9],['255,190,160',.10,.11,162,14]],
        haze:['196,124,116','150,96,120'],
        far: {base:HORIZON+4,  body:['#333C6C','#282F5A'], rim:'rgba(160,185,245,.16)',
              win:'198,214,255', winA:.16, dens:.18, glow:.10, wmin:16, wmax:44, hmin:28, hmax:80, signs:0},
        mid: {base:HORIZON+22, body:['#18204A','#0D1230'], rim:'rgba(168,192,255,.40)',
              win:'255,206,140', winA:.72, dens:.38, glow:.5, wmin:28, wmax:74, hmin:52, hmax:126, signs:.34},
        near:{base:GROUND_Y+2, body:['#2A3D72','#16224E'], rim:'rgba(180,208,255,.55)',
              win:'255,208,146', winA:1, dens:.5, glow:.75, wmin:44, wmax:104, hmin:40, hmax:118,
              signs:.55, lamp:true, shopfront:true, shopP:0.6,
              tints:['#3A3060','#243A6A','#402A46','#1E3A58','#3A2A2A']},
        floor:['rgba(26,30,66,0)','rgba(17,22,52,.70)','rgba(9,12,32,.94)','#05081A'],
        ground:{top:['#5A6BAA','#333D71','#1D2349'], lip:'196,220,255', curb:'#141B40',
                wall:['#111845','#0A0F2C','#05081A'], wet:['255,77,141','69,224,255']},
        rail:'#03050E', vign:.52, tower:'tokyo', crossing:true,
        grade:{ tint:'rgba(20,26,58,0.22)', rim:'rgba(190,215,255,1)', rimA:0.5,
                shA:[0.42,0.12] },
        /* 既定値でも同じ絵になるが、**書いておかないと既定を変えたときに
           東京が黙って変わる。**実際、パラメータ化のときに提灯の「祭」と
           バリケードの回転灯が既定値の穴から落ちていた */
        obs:{
          low:  {shape:'box', body:['#8B6136','#6B4726','#3B2612']},
          tall: {shape:'vending', headText:'つめたい', head:['#FF6B6B','#C4243F']},
          stack:{orb:'lantern', char:'祭', lantern:['#FFD9A0','#F26B4A','#93231C']},
          bar:  {shape:'stripe', body:['#F5D14A','#B98A17'], lamp:true},
          fly:  {body:['#3A4468','#1A2140','#0A0E22']}
        },
        /* 敵（enemy-spec 3章）。段ボールお化け／提灯お化け／カラス */
        foe:{
          walker:{shape:'carton', body:['#7A5330','#57381C','#2C1A0A'], tape:'rgba(228,214,180,.8)'},
          hopper:{shape:'lantern', body:['#E4643C','#B8342A','#5E1410'], mark:'rgba(250,240,220,.9)'},
          flyer: {shape:'bird', body:['#2E3550','#171C30','#080B16'], beak:'#E8A23A'}
        }
      },
      /* 池袋（夜）。東京より明るく、若い街。サイネージが多く、
         キーカラーはシアン。塔は高層の板（サンシャイン60 のあたり）。 */
      ikebukuro: {
        id:'ikebukuro', night:true,
        sky:[[0,'#070A1E'],[.24,'#111A44'],[.48,'#232C60'],[.68,'#3A2F66'],
             [.85,'#63386A'],[.95,'#93476A'],[1,'#BE7070']],
        dome:{x:.50,y:HORIZON+18,r:330,c:'255,196,140',a:.50},
        cool:{x:.16,y:.18,r:250,c:'130,190,255',a:.20},
        orb:{x:.12,y:.12,r:17,moon:true},
        cloud:[['206,220,255',.16,.035,56,5],['226,196,220',.13,.07,106,9],['255,196,170',.10,.11,160,14]],
        haze:['200,140,132','150,100,130'],
        far: {base:HORIZON+4,  body:['#3A4478','#2C3462'], rim:'rgba(170,195,250,.18)',
              win:'198,214,255', winA:.20, dens:.22, glow:.12, wmin:16, wmax:44, hmin:28, hmax:80, signs:0},
        mid: {base:HORIZON+22, body:['#1C2554','#0F1436'], rim:'rgba(176,200,255,.42)',
              win:'255,214,152', winA:.80, dens:.46, glow:.55, wmin:26, wmax:70, hmin:56, hmax:132, signs:.42},
        near:{base:GROUND_Y+2, body:['#2E4380','#182658'], rim:'rgba(190,216,255,.58)',
              win:'255,214,158', winA:1, dens:.56, glow:.8, wmin:42, wmax:100, hmin:40, hmax:120,
              signs:.66, lamp:true, shopfront:true, shopP:0.7,
              tints:['#2C3A72','#1E4470','#40305E','#1E3A58','#3A2A44']},
        floor:['rgba(30,36,76,0)','rgba(20,26,60,.70)','rgba(10,14,36,.94)','#06091E'],
        ground:{top:['#5F72B4','#36407A','#1F254E'], lip:'200,224,255', curb:'#161D46',
                wall:['#131A4C','#0B1030','#05081A'], wet:['65,202,236','255,110,170']},
        rail:'#04060F', vign:.50, tower:'slab',
        towerC:['#33447E','#1B2856','#0C1436'], towerSign:'#41caec',
        grade:{ tint:'rgba(22,28,62,0.22)', rim:'rgba(190,215,255,1)', rimA:0.5, shA:[0.42,0.12] },
        obs:{
          low:  {shape:'carton', body:['#8B6136','#6B4726','#3B2612'], tape:'rgba(228,214,180,.85)'},
          tall: {shape:'vending', headText:'あたたかい', head:['#F2603C','#A8281E']},
          stack:{orb:'lantern', char:'福', lantern:['#FFE0B0','#F2704A','#8E2018']},
          bar:  {shape:'stripe', lamp:true},
          fly:  {body:['#3A4468','#1A2140','#0A0E22']},
          // TODO 8 で後回しにした池袋の crowd。**bar の見た目だけ差し替え、判定は同じ**
          skins:{ crowd:{ as:'bar', shape:'crowd', body:['#1C2444','#0E1428'],
                          glow:null, lamp:false, posts:false } }
        },
        /* 敵。段ボールお化け／ガチャカプセル／ドローン */
        foe:{
          walker:{shape:'carton', body:['#7A5330','#57381C','#2C1A0A'], tape:'rgba(228,214,180,.8)'},
          hopper:{shape:'ball', body:['#E05A8E','#B0306A','#5E1638'], seam:'rgba(255,240,248,.7)'},
          flyer: {shape:'drone', body:['#3A4260','#242A44','#10141F'], lens:'#E4453A'}
        }
      },
      /* カイロ（昼）。**光が強く、影が濃く、空気が砂で濁る。**
         夜の都市と正反対なので、補正は tint を外して照り返しを足す。
         遠景は砂丘、中景と近景は日干し煉瓦の街。塔はピラミッド。 */
      cairo: {
        id:'cairo', night:false,
        sky:[[0,'#3E93C4'],[.24,'#75B8D4'],[.50,'#B7CDBE'],[.72,'#E4C892'],
             [.88,'#F0D19A'],[1,'#E8BE7E']],
        dome:{x:.74,y:70,r:340,c:'255,238,178',a:.58},
        cool:{x:.20,y:.30,r:230,c:'130,190,225',a:.10},
        orb:{x:.74,y:.17,r:27,moon:false},
        cloud:[['255,252,242',.22,.035,44,4],['246,232,200',.18,.07,96,8],['238,214,168',.16,.11,150,12]],
        haze:['236,212,164','216,186,136'],
        far: {base:HORIZON+6,  body:['#EBD5AA','#E0C692'], rim:'rgba(255,250,228,.45)',
              form:'dune', wmin:120, wmax:230, hmin:22, hmax:52, signs:0, painted:true,
              win:'255,255,255', winA:0, dens:0, glow:0},
        mid: {base:HORIZON+22, body:['#DCB88C','#C29A64'], rim:'rgba(255,244,208,.5)',
              win:'110,80,42', winA:.5, dens:.14, glow:.05, wmin:30, wmax:78, hmin:34, hmax:78,
              signs:.10, painted:true, noBeacon:true, board:'#E8D6AE', paint:['#3A2A14','#8A3A22']},
        near:{base:GROUND_Y+2, body:['#C68E4C','#8A5C28'], rim:'rgba(255,250,224,.85)',
              win:'96,66,30', winA:.55, dens:.2, glow:.08, wmin:46, wmax:104, hmin:40, hmax:92,
              signs:.34, lamp:true, shopfront:true, shopP:0.55, painted:true, noBeacon:true,
              board:'#EFE0BE', paint:['#3A2A14','#8A3A22','#2E5A62'],
              awn:['#B4543C','#C98A3A','#4E7A72'],
              tints:['#E8C9A0','#D8A870','#C8B48A','#E0B98A','#CDA268']},
        floor:['rgba(214,178,124,0)','rgba(190,152,100,.34)','rgba(158,120,72,.55)','#8A6B44'],
        ground:{top:['#F0DCAE','#D6B47C','#B4914E'], lip:'255,248,220', curb:'#A88349',
                wall:['#A88349','#87673A','#63492A'], wet:null,
                tactile:false, edge:'rgba(120,88,44,.22)'},
        rail:'#4E3B22', vign:.30, tower:'pyramid', lampC:'#6E5228', lampH:'#FFF4D0',
        /* 昼の順光。**tint は入れない。**代わりに右からの強いリムと、
           砂からの照り返しを足す。影は濃く、色は砂に寄せる */
        grade:{ tint:null, rim:'rgba(255,244,206,1)', rimA:0.42,
                bounce:'rgba(236,206,150,1)', bounceA:0.14,
                shA:[0.50,0.15], shC:'aoWarm' },
        obs:{
          low:  {shape:'basket', body:['#C99A5E','#A87A42','#6E4E22']},
          tall: {shape:'pillar', body:['#EADCB4','#D2BE8E','#A98F5E']},
          stack:{orb:'pot', post:['#B08A50','#8A6838','#5C441E'], glow:null},
          bar:  {shape:'cloth', body:['#E0C48E','#A98553'], alt:'#B4543C',
                 glow:null, postC:'#C9A96E'},
          fly:  {body:['#B08A50','#8A6838','#5C441E'], beak:'#F2C94C',
                 rim:'rgba(255,246,214,.6)'}
        },
        /* 敵。スカラベ／壺お化け／ハゲタカ */
        foe:{
          walker:{shape:'beetle', body:['#6A5A2E','#44381A','#221B0A']},
          hopper:{shape:'jar', body:['#C08A50','#96663A','#54381A']},
          flyer: {shape:'bird', body:['#6E5A3E','#48381F','#241B0E'], beak:'#F2C94C'}
        }
      },
      /* パリ（夕）。**低い夕日が右にあり、石が金色に焼ける。**
         同じ高さの箱が並ぶだけではパリに見えないので、
         中景と近景にマンサード屋根を付けた。塔はエッフェル。 */
      paris: {
        id:'paris', night:false, dusk:true,
        sky:[[0,'#241C4E'],[.20,'#42305F'],[.42,'#7A4A6E'],[.62,'#B0637A'],
             [.80,'#DE8C7C'],[.92,'#F0B187'],[1,'#F8D6A4']],
        dome:{x:.68,y:HORIZON-14,r:330,c:'255,186,124',a:.52},
        cool:{x:.14,y:.16,r:250,c:'120,150,225',a:.16},
        orb:{x:.68,y:.32,r:27,moon:false,
             c:['#FFF6DA','#FFD08A','#F2903E'], halo:'255,190,120'},
        cloud:[['236,200,226',.20,.035,50,5],['246,186,180',.17,.07,100,9],['255,196,150',.14,.11,156,13]],
        haze:['226,158,136','186,120,132'],
        far: {base:HORIZON+4,  body:['#8A6A86','#7A5E7C'], rim:'rgba(255,214,180,.28)',
              win:'255,226,190', winA:.20, dens:.16, glow:.10, wmin:16, wmax:44, hmin:26, hmax:72,
              signs:0, painted:true, noBeacon:true},
        mid: {base:HORIZON+22, body:['#C9A184','#9C7566'], rim:'rgba(255,228,190,.5)',
              win:'255,224,168', winA:.5, dens:.26, glow:.2, wmin:34, wmax:78, hmin:52, hmax:112,
              signs:.16, painted:true, noBeacon:true, roof:'mansard', roofC:'#4A4256',
              board:'#F2E6CE', paint:['#2E2436','#8A2A2E']},
        near:{base:GROUND_Y+2, body:['#E8CDAE','#B08E72'], rim:'rgba(255,240,214,.85)',
              win:'255,222,160', winA:.72, dens:.34, glow:.34, wmin:50, wmax:106, hmin:52, hmax:112,
              signs:.32, lamp:true, shopfront:true, shopP:0.8, painted:true, noBeacon:true,
              roof:'mansard', roofC:'#413A4E',
              board:'#F6EDD8', paint:['#2E2436','#8A2A2E','#2A4A46'],
              awn:['#C0392B','#2A5B4E','#1E3A6E'],
              tints:['#E4CEB0','#D8C0A4','#E0C8B8','#D2C4B0','#E8D2B4']},
        floor:['rgba(120,90,110,0)','rgba(96,70,92,.34)','rgba(70,50,70,.56)','#3E2E40'],
        ground:{top:['#B6A8B4','#8C7E90','#5E5468'], lip:'255,232,206', curb:'#4E4658',
                wall:['#4E4658','#3A3444','#26222E'], wet:['255,196,130','160,140,220'],
                tactile:false, edge:'rgba(40,32,44,.28)'},
        rail:'#241C2C', vign:.40, tower:'eiffel', lampC:'#3A3448', lampH:'#FFEFC8',
        /* 夕方の逆光。tint は弱く（石の暖かさを殺さない）、
           リムは右から金色。影は石畳なので暖色寄り */
        grade:{ tint:'rgba(64,36,58,0.14)', rim:'rgba(255,214,160,1)', rimA:0.44,
                shA:[0.40,0.12], shC:'aoWarm' },
        obs:{
          low:  {shape:'bottle', body:['#8A6A44','#6A4E2E','#3E2A16']},
          tall: {shape:'column', body:['#3E4A56','#2C3640','#1A222A'], finial:'#C9A24A'},
          stack:{orb:'barrel', post:['#7A5E42','#5A422A','#2E2016'], glow:null},
          bar:  {shape:'awning', body:['#C0392B','#F4F0E4'], glow:null, postC:'#8E8AA0'},
          fly:  {body:['#7E8798','#5A6272','#343A46'], beak:'#D8A24A',
                 rim:'rgba(255,220,180,.6)'}
        },
        /* 敵。ネズミ／風船／ハト */
        foe:{
          walker:{shape:'rat', body:['#6E6472','#4C4452','#282230'], ear:'#B07A86'},
          hopper:{shape:'balloon', body:['#D2444E','#A02832','#54121A']},
          flyer: {shape:'bird', body:['#6C7286','#4A4F60','#252935'], beak:'#D8A24A'}
        }
      },
      /* ニューヨーク（夜）。**東京と同じ夜だが、光の質が違う。**
         東京はネオンの暖色、NY は事務所の蛍光灯の青白。
         看板を減らし、窓を増やし、空の光暈を街全体に広げる。 */
      ny: {
        id:'ny', night:true,
        sky:[[0,'#04070E'],[.24,'#0B1524'],[.48,'#16293D'],[.70,'#274257'],
             [.86,'#3D5E72'],[1,'#5C7E8C']],
        dome:{x:.46,y:HORIZON+16,r:360,c:'255,208,146',a:.50},
        cool:{x:.84,y:.13,r:230,c:'190,215,255',a:.16},
        orb:{x:.84,y:.12,r:15,moon:true},
        cloud:[['186,204,224',.14,.035,54,5],['170,186,206',.12,.07,104,9],['200,190,180',.10,.11,158,13]],
        haze:['150,172,192','118,140,166'],
        far: {base:HORIZON+4,  body:['#2E3A50','#232E42'], rim:'rgba(170,196,236,.16)',
              win:'214,230,255', winA:.20, dens:.26, glow:.12, wmin:14, wmax:38, hmin:34, hmax:94, signs:0},
        mid: {base:HORIZON+22, body:['#1A2436','#101823'], rim:'rgba(176,204,244,.38)',
              win:'226,238,255', winA:.62, dens:.52, glow:.4, wmin:24, wmax:62, hmin:64, hmax:150, signs:.14,
              neon:['#F2C531','#45E0FF','#FF4D8D']},
        near:{base:GROUND_Y+2, body:['#28374F','#151F30'], rim:'rgba(190,216,255,.5)',
              win:'236,244,255', winA:.9, dens:.6, glow:.6, wmin:40, wmax:96, hmin:44, hmax:126,
              signs:.30, lamp:true, shopfront:true, shopP:0.55,
              neon:['#F2C531','#FF4D8D','#7CE38B'],
              awn:['#1E3A6E','#8A1E2E','#2E5A3A'],
              tints:['#2C3A54','#24303F','#33384A','#1E3448','#3A3244']},
        floor:['rgba(28,36,54,0)','rgba(18,26,42,.70)','rgba(9,14,26,.94)','#05080F'],
        ground:{top:['#54627A','#333F52','#1D2634'], lip:'206,224,248', curb:'#161E2C',
                wall:['#131A26','#0B1018','#05080F'], wet:['242,197,49','69,224,255'],
                tactile:false, edge:'rgba(6,10,18,.35)'},
        rail:'#03050B', vign:.52, tower:'deco',
        grade:{ tint:'rgba(16,24,44,0.24)', rim:'rgba(206,226,255,1)', rimA:0.5, shA:[0.44,0.12] },
        obs:{
          low:  {shape:'bag', body:['#3A4152','#242A38','#12161E']},
          tall: {shape:'stand', body:['#2E3A50','#1E2836','#10161F'], awn:'#D8494E'},
          stack:{orb:'scaffold', post:['#5A6472','#3E4652','#232932'], glow:null},
          bar:  {shape:'stripe', body:['#F2603C','#A8341E'], stripe:'rgba(250,250,245,.9)', lamp:true},
          fly:  {body:['#E8EEF6','#B4C0CE','#6A7684'], beak:'#F2A93C',
                 rim:'rgba(255,255,255,.7)'}
        },
        /* 敵。ゴミ袋モンスター／ピザ／ドローン */
        foe:{
          walker:{shape:'bag', body:['#2E3440','#1E2430','#0C1018']},
          hopper:{shape:'slice', body:['#E0A63C','#C07E22','#7A4A10'],
                  crust:'#C98A3E', topping:'#A82A22'},
          flyer: {shape:'drone', body:['#39404F','#242A36','#10141C'], lens:'#E4453A'}
        }
      },
      /* 南極（昼）。**明度が反転する。**地面も空も白く、いちばん明るいのが
         キャラの足元。ほかの都市と同じ値で描くと、
         ・黒い接地影が雪に開いた穴に見える
         ・上からの光だけだと足元が不自然に暗い
         ・水色の iGくんが白い背景に溶ける
         の3つが起きる。grade と near 層でそれぞれ手当てしてある。 */
      pole: {
        id:'pole', night:false,
        sky:[[0,'#2E7FB8'],[.26,'#63AED6'],[.54,'#9ED2E8'],[.78,'#CEE9F4'],
             [.92,'#E8F5FA'],[1,'#F6FCFE']],
        dome:{x:.26,y:92,r:320,c:'255,250,224',a:.50},
        cool:{x:.72,y:.28,r:250,c:'150,214,255',a:.14},
        orb:{x:.26,y:.21,r:29,moon:false},
        cloud:[['255,255,255',.34,.035,46,4],['246,252,255',.28,.07,98,8],['226,242,250',.22,.11,152,12]],
        haze:['222,240,248','198,226,240'],
        far: {base:HORIZON+6,  body:['#CFE6F2','#B8D8EA'], rim:'rgba(255,255,255,.75)',
              form:'ridge', wmin:90, wmax:190, hmin:30, hmax:76, signs:0,
              win:'255,255,255', winA:0, dens:0, glow:0},
        mid: {base:HORIZON+24, body:['#B2D6EA','#8FBDD8'], rim:'rgba(255,255,255,.85)',
              form:'ridge', wmin:80, wmax:170, hmin:44, hmax:104, signs:0,
              win:'255,255,255', winA:0, dens:0, glow:0},
        /* 近景だけ「色のあるもの」を置く。**南極で唯一の彩度**で、
           これが無いと iGくんが白と白のあいだで消える */
        near:{base:GROUND_Y+2, body:['#D8E8F0','#A8C4D4'], rim:'rgba(255,255,255,.9)',
              form:'hut', roofC:'#C0392B', legC:'#4E6272',
              win:'255,236,178', winA:.9, dens:.4, glow:.5,
              wmin:52, wmax:92, hmin:40, hmax:70, signs:0, lamp:true},
        floor:['rgba(180,212,230,0)','rgba(150,190,214,.30)','rgba(122,166,196,.5)','#6E97B4'],
        ground:{top:['#FFFFFF','#E2F0F8','#BCD8E8'], lip:'255,255,255', curb:'#A8C8DC',
                wall:['#BCD8E8','#96BAD2','#6E97B4'], wet:null,
                tactile:false, edge:'rgba(110,150,180,.20)'},
        rail:'#5C7E96', vign:.26, tower:'berg',
        lampC:'#3E5666', lampH:'#FFFFFF',
        /* **雪の上の手当て。**
           ・影は青（黒だと雪に開いた穴に見える）。地面が明るいぶん濃くする
           ・雪からの照り返しを下から強めに入れる（.22。ほかの都市の1.5倍）
           ・tint は入れない。代わりに左からの強い白いリムで輪郭を切る */
        grade:{ tint:null, rim:'rgba(226,244,255,1)', rimA:0.55,
                bounce:'rgba(198,228,246,1)', bounceA:0.22,
                shA:[0.34,0.10], shC:'aoBlue' },
        obs:{
          low:  {shape:'ice', body:['#DCEFF8','#B6D8EA','#8FBAD2']},
          tall: {shape:'serac', body:['#E4F2FA','#BEDCEE','#93BED8']},
          stack:{orb:'iceblock', post:['#5A7A90','#3E5A6E','#26404E'], glow:null},
          bar:  {shape:'ice', glow:null, postC:'#C6DCEA'},
          fly:  {body:['#F2F8FC','#C8D8E4','#8A9AA8'], beak:'#E8A23A',
                 rim:'rgba(120,170,210,.7)'}
        },
        /* 敵。ペンギン／雪だま／ユキドリ */
        foe:{
          walker:{shape:'penguin', body:['#3A4254','#242B3A','#111620'],
                  belly:'#F2F6FA', beak:'#E8A23A'},
          hopper:{shape:'ball', body:['#E8F0F8','#C2D2E2','#8CA0B4'], seam:'rgba(120,150,180,.5)'},
          flyer: {shape:'bird', body:['#C8D4E0','#9FAEC0','#6A7A8C'], beak:'#D8863A'}
        }
      },
      /* 香港（夕→夜）。**縦の街。**看板が道の上に張り出し、
         塔は密集して立つ。夕日が左に沈みかけ、右上はもう夜。
         赤と金のネオンで、東京（暖色）NY（青白）池袋（シアン）と分ける。 */
      hk: {
        id:'hk', night:true, dusk:true,
        sky:[[0,'#120A28'],[.20,'#291247'],[.42,'#552258'],[.62,'#8A3360'],
             [.80,'#BE4E62'],[.92,'#DE7566'],[1,'#F0A177']],
        dome:{x:.34,y:HORIZON+14,r:330,c:'255,130,150',a:.44},
        cool:{x:.78,y:.16,r:250,c:'110,150,235',a:.20},
        orb:{x:.22,y:.30,r:25,moon:false,
             c:['#FFF0D2','#FFB870','#E85A44'], halo:'255,150,110'},
        cloud:[['246,180,206',.18,.035,52,5],['240,150,160',.15,.07,102,9],['255,178,140',.12,.11,158,13]],
        haze:['214,110,120','160,80,120'],
        far: {base:HORIZON+4,  body:['#4A2A58','#3A2148'], rim:'rgba(255,180,200,.18)',
              win:'255,214,190', winA:.22, dens:.30, glow:.12, wmin:12, wmax:32, hmin:40, hmax:104, signs:0},
        mid: {base:HORIZON+22, body:['#2E1440','#1C0C2A'], rim:'rgba(255,170,200,.36)',
              win:'255,206,150', winA:.78, dens:.56, glow:.5, wmin:20, wmax:52, hmin:70, hmax:158,
              signs:.5, neon:['#FF3B6E','#FFD166','#45E0FF','#7CE38B']},
        near:{base:GROUND_Y+2, body:['#4A2454','#2A1030'], rim:'rgba(255,190,210,.5)',
              win:'255,214,158', winA:1, dens:.6, glow:.8, wmin:36, wmax:88, hmin:44, hmax:126,
              signs:.8, lamp:true, shopfront:true, shopP:0.7,
              neon:['#FF3B6E','#FFD166','#45E0FF','#7CE38B','#FF7A45'],
              awn:['#C8102E','#E8C23A','#1E6E5A'],
              tints:['#4A2454','#5A2038','#3A2A5E','#5A3420','#402048']},
        floor:['rgba(52,24,58,0)','rgba(38,16,44,.70)','rgba(20,8,26,.94)','#0E0616'],
        ground:{top:['#7A5A86','#4A2E56','#2A1832'], lip:'255,206,220', curb:'#241028',
                wall:['#26122C','#180A1C','#0E0616'], wet:['255,59,110','69,224,255'],
                tactile:false, edge:'rgba(14,6,22,.35)'},
        rail:'#0A0412', vign:.50, tower:'slab', towerN:3,
        towerC:['#4A2A5E','#2E1440','#180A22'], towerSign:'#FF3B6E',
        lampC:'#2A1030', lampH:'#FFE7B8',
        grade:{ tint:'rgba(46,20,52,0.20)', rim:'rgba(255,196,164,1)', rimA:0.46,
                shA:[0.42,0.12] },
        obs:{
          low:  {shape:'carton', body:['#8A6136','#6A4726','#3A2612'], tape:'rgba(230,60,80,.85)'},
          tall: {shape:'steamer', body:['#C9A36A','#A17B44','#6B4E22']},
          stack:{orb:'lantern', char:'福', post:['#7A2A2A','#5A1C1C','#2E0E0E'],
                 lantern:['#FFE0A0','#F23C4A','#8E1018'], glowC:'rgba(255,90,90,1)', glowA:.5},
          bar:  {shape:'banner', body:['#C8102E','#8A0A1E'], text:'海鮮', glow:null, postC:'#9A7A8E'},
          fly:  {body:['#3A2444','#241030','#120818'], beak:'#E8A23A',
                 rim:'rgba(255,180,190,.6)'}
        },
        /* 敵。提灯お化け（赤）／肉まん／コウモリ */
        foe:{
          walker:{shape:'carton', body:['#8A4A2A','#61301A','#31180C'], tape:'rgba(240,220,180,.7)'},
          hopper:{shape:'ball', body:['#F2EADC','#D8C8B0','#9A8468'], seam:'rgba(150,120,90,.5)'},
          flyer: {shape:'bat', body:['#3A2A44','#241830','#100A18']}
        }
      },
      igs: {
        id:'igs', night:false,
        sky:[[0,'#1478B8'],[.30,'#3FAEDA'],[.58,'#7FCFEA'],[.80,'#BDE7F6'],
             [.93,'#E8F3EE'],[1,'#F6E3BE']],
        dome:{x:.80,y:74,r:300,c:'255,244,205',a:.46},
        cool:{x:.30,y:.24,r:230,c:'255,255,255',a:.10},
        orb:{x:.80,y:.15,r:22,moon:false},
        cloud:[['255,255,255',.42,.035,52,5],['255,252,242',.34,.07,102,9],['255,238,214',.26,.11,152,14]],
        haze:['186,220,235','170,206,224'],
        far: {base:HORIZON+4,  body:['#9CCBE0','#B4DAEA'], rim:'rgba(255,255,255,.3)',
              win:'255,255,255', winA:.14, dens:.12, glow:.06, wmin:16, wmax:44, hmin:26, hmax:74, signs:0},
        mid: {base:HORIZON+22, body:['#79B6D0','#9BCBDE'], rim:'rgba(255,255,255,.5)',
              win:'255,246,214', winA:.26, dens:.16, glow:.10, wmin:28, wmax:74, hmin:48, hmax:118,
              signs:.12, painted:true, noBeacon:true,
              board:'#F4EFE2', paint:['#2B2B2B','#B03A2E']},
        near:{base:GROUND_Y+2, body:['#CFE0E9','#7EA1B5'], rim:'rgba(255,255,255,.85)',
              win:'255,236,178', winA:.55, dens:.32, glow:.3, wmin:46, wmax:104, hmin:52, hmax:112,
              signs:.4, lamp:true, shopfront:true, shopP:0.85, painted:true, noBeacon:true,
              board:'#F4EFE2', paint:['#2B2B2B','#B03A2E','#2E6EC4'],
              awn:['#D8232A','#2E6EC4','#3E8A5A'],
              tints:['#E8C9A0','#C9DCE0','#E0B9B4','#D6CFE4','#CFE0C4','#EFD9A8']},
        floor:['rgba(150,196,216,0)','rgba(126,176,200,.30)','rgba(100,152,180,.5)','#5E8FA8'],
        ground:{top:['#E7F0F4','#B4CBD7','#87A5B5'], lip:'255,255,255', curb:'#8FAAB8',
                wall:['#7E9BAB','#5E7C8D','#42606F'], wet:null},
        rail:'#31505F', vign:.38, tower:null,
        // 朝の順光。補正はほぼ不要だが、太陽が右にあるので右の縁だけ白く飛ばす
        grade:{ tint:null, rim:'rgba(255,250,236,1)', rimA:0.28, shA:[0.34,0.10] }
      }
    };

    /* ---- 建物1棟。窓・屋上・ネオン看板まで焼き込む ----
       cfg.form で「形」を変える。**ビル一辺倒だと南極とカイロが成立しない。**
         block  … 箱（既定。東京・池袋・パリ・NY・香港・IGS）
         ridge  … 氷の稜線（南極）。窓も屋上設備も看板も付けない
         dune   … 砂丘（カイロの遠景）
         hut    … 切妻屋根の小屋（南極の近景の観測小屋）。白い雪の上で色が立つ
       cfg.roof:'mansard' で屋根だけマンサード（パリ） */
    function bakeBuilding(cfg, bw, bh, kind, r, pal){
      var pad=16, o=mkc(bw+pad*2, bh+pad), g=o.g, ox=pad, oy=pad, i, q;
      var form = cfg.form || 'block';

      if(form==='ridge' || form==='dune'){
        var fg2=g.createLinearGradient(0,oy,0,oy+bh);
        fg2.addColorStop(0,cfg.body[0]); fg2.addColorStop(1,cfg.body[1]);
        g.fillStyle=fg2;
        g.beginPath(); g.moveTo(ox, oy+bh);
        if(form==='dune'){
          for(i=0;i<=8;i++){
            var t2=i/8;
            g.lineTo(ox+t2*bw, oy+bh - bh*(0.45+0.55*Math.sin(t2*Math.PI))*(0.8+r()*0.4));
          }
        } else {
          var n2 = 2 + ((r()*2)|0);
          g.lineTo(ox+bw*0.08, oy+bh*0.42);
          for(i=0;i<n2;i++){
            g.lineTo(ox+bw*(0.2+i*0.3), oy + bh*(0.06+r()*0.3));
            g.lineTo(ox+bw*(0.34+i*0.3), oy + bh*(0.42+r()*0.3));
          }
          g.lineTo(ox+bw*0.94, oy+bh*0.3);
        }
        g.lineTo(ox+bw, oy+bh); g.closePath(); g.fill();
        g.strokeStyle=cfg.rim; g.lineWidth=1.2; g.stroke();    // 稜線に光が乗る
        o.pad=pad; o.bw=bw; o.bh=bh; o.sign=null; o.beacon=false;
        return o;
      }

      var bg=g.createLinearGradient(0,oy,0,oy+bh);
      bg.addColorStop(0,cfg.body[0]); bg.addColorStop(1,cfg.body[1]);
      if(form==='hut'){
        /* 観測小屋。切妻屋根と高床。**南極で唯一の彩度**なので、
           iGくんが白い地面と白い空のあいだで沈まない */
        var rh=Math.min(18, bh*0.34), by2=oy+rh;
        g.fillStyle=bg; g.fillRect(ox, by2, bw, bh-rh);
        g.fillStyle=cfg.roofC||'#B03A2E';
        g.beginPath(); g.moveTo(ox-3, by2+1); g.lineTo(ox+bw/2, oy); g.lineTo(ox+bw+3, by2+1); g.closePath(); g.fill();
        g.fillStyle='rgba(255,255,255,.35)';
        g.beginPath(); g.moveTo(ox-3, by2+1); g.lineTo(ox+bw/2, oy); g.lineTo(ox+bw/2, oy+3); g.lineTo(ox, by2+1); g.closePath(); g.fill();
        g.fillStyle='rgba(255,255,255,.85)'; g.fillRect(ox, by2, bw, 1.4);   // 屋根に積もった雪
        g.fillStyle=cfg.legC||'#5A6B7A';                                     // 高床の脚
        g.fillRect(ox+5, oy+bh-8, 3.4, 10); g.fillRect(ox+bw-9, oy+bh-8, 3.4, 10);
        for(i=0;i<Math.max(1,Math.round(bw/22));i++){                        // 窓
          g.fillStyle='rgba(255,226,164,.92)';
          rr(g, ox+8+i*22, by2+7, 11, 9, 1.5); g.fill();
          g.fillStyle='rgba(40,60,80,.5)'; g.fillRect(ox+8+i*22, by2+11, 11, 1);
        }
        if(blurOK){
          g.save(); g.globalCompositeOperation='lighter'; g.filter='blur(6px)'; g.globalAlpha=.35;
          g.fillStyle='rgba(255,206,140,1)'; g.fillRect(ox+6, by2+6, bw-12, 11); g.restore();
        }
        o.pad=pad; o.bw=bw; o.bh=bh; o.sign=null; o.beacon=false;
        return o;
      }
      g.fillStyle=bg; g.fillRect(ox,oy,bw,bh);
      if(cfg.tints){                                  // 外壁の色を1棟ずつずらす
        g.save(); g.globalAlpha=r(0.12,0.34);
        g.fillStyle=cfg.tints[(r()*cfg.tints.length)|0];
        g.fillRect(ox,oy,bw,bh); g.restore();
      }

      var crown = (kind==='step' && bh>100), sw=bw*0.58, sh=22;
      if(crown){ g.fillStyle=cfg.body[0]; g.fillRect(ox+(bw-sw)/2, oy-sh, sw, sh+2); }

      // 月光の当たる左の縁と、屋上のパラペット
      var rg=g.createLinearGradient(ox,0,ox+5,0);
      rg.addColorStop(0,cfg.rim); rg.addColorStop(1,'rgba(0,0,0,0)');
      g.fillStyle=rg; g.fillRect(ox, oy-(crown?sh:0), 5, bh+(crown?sh:0));
      g.fillStyle=cfg.rim; g.fillRect(ox, oy-1, bw, 1);
      if(crown) g.fillStyle=cfg.rim, g.fillRect(ox+(bw-sw)/2, oy-sh-1, sw, 1);

      // 窓は別の面に描いてから、ぼかした光を下に敷いて重ねる（滲みが出る）
      var wo=mkc(bw+pad*2, bh+pad), wg=wo.g;
      var cw=5, chh=6, gxp=4, gyp=5;
      var cols=Math.max(1, Math.floor((bw-8)/(cw+gxp)));
      var rows=Math.max(1, Math.floor((bh-11)/(chh+gyp)));
      var sx0=ox+(bw-(cols*cw+(cols-1)*gxp))/2;
      for(i=0;i<rows;i++){
        for(q=0;q<cols;q++){
          if(r() > cfg.dens) continue;
          var wx=sx0+q*(cw+gxp), wy=oy+8+i*(chh+gyp), a=cfg.winA*r(0.45,1);
          var lg=wg.createLinearGradient(0,wy,0,wy+chh);
          lg.addColorStop(0,'rgba('+cfg.win+','+a.toFixed(3)+')');
          lg.addColorStop(1,'rgba('+cfg.win+','+(a*0.35).toFixed(3)+')');
          wg.fillStyle=lg; wg.fillRect(wx,wy,cw,chh);
          if(r()<0.18){                                   // 蛍光灯の office を混ぜる
            wg.fillStyle='rgba(180,225,255,'+(a*0.8).toFixed(3)+')';
            wg.fillRect(wx,wy,cw,chh);
          }
        }
      }
      if(blurOK){
        g.save(); g.filter='blur(3px)'; g.globalAlpha=cfg.glow;
        into(g, wo, 0, 0); g.restore();
      }
      into(g, wo, 0, 0);

      /* 1階の店先（near 層だけ）。**キャラのすぐ後ろに灯りの帯を作るのが目的。**
         art-direction-final.md 3章「iGくんの背後が暗すぎて沈む」への直接の対処。 */
      if(cfg.shopfront && bh>40 && r()<(cfg.shopP||0.6)){
        var fh=Math.min(24, bh*0.34), fy=oy+bh-fh;
        var sg2=g.createLinearGradient(0,fy,0,oy+bh);
        sg2.addColorStop(0,'rgba(255,214,150,.72)'); sg2.addColorStop(1,'rgba(226,140,72,.60)');
        g.fillStyle=sg2; g.fillRect(ox+2, fy, bw-4, fh);
        g.fillStyle='rgba(30,40,80,.55)';               // 窓割りと入口
        for(i=1;i<Math.max(2,Math.round(bw/26));i++) g.fillRect(ox+2+i*(bw-4)/Math.max(2,Math.round(bw/26))-1, fy, 2, fh);
        g.fillStyle='rgba(24,32,66,.75)'; g.fillRect(ox+bw*0.5-7, fy+fh*0.35, 14, fh*0.65);
        var aw2=cfg.awn||['#D8232A','#2E6EC4'];
        g.fillStyle=aw2[(r()*aw2.length)|0];             // 庇
        g.fillRect(ox, fy-4, bw, 5);
        g.fillStyle='rgba(255,255,255,.25)'; g.fillRect(ox, fy-4, bw, 1);
        if(blurOK){
          g.save(); g.globalCompositeOperation='lighter'; g.filter='blur(7px)'; g.globalAlpha=.34;
          g.fillStyle='rgba(255,190,120,1)'; g.fillRect(ox+2, fy, bw-4, fh); g.restore();
        }
      }

      if(cfg.roof==='mansard' && bh>50){
        /* マンサード屋根（パリ）。**同じ高さの箱が並ぶだけだとパリに見えない。**
           上端を暗い台形で切り、屋根窓を並べる */
        var mh=Math.min(20, bh*0.22);
        g.fillStyle=cfg.roofC||'#4A4E5C';
        g.beginPath(); g.moveTo(ox-1, oy+mh); g.lineTo(ox+bw*0.10, oy);
        g.lineTo(ox+bw*0.90, oy); g.lineTo(ox+bw+1, oy+mh); g.closePath(); g.fill();
        g.fillStyle='rgba(200,214,240,.28)'; g.fillRect(ox+bw*0.10, oy, bw*0.80, 1.2);
        for(i=0;i<Math.max(1,Math.round(bw/26));i++){         // 屋根窓
          g.fillStyle='rgba(255,226,170,.75)';
          rr(g, ox+9+i*26, oy+mh*0.42, 7, mh*0.5, 1); g.fill();
        }
        g.fillStyle=cfg.rim; g.fillRect(ox-1, oy+mh-1, bw+2, 1.2);
      }
      // 屋上の設備（アンテナと貯水槽）。輪郭に変化が出る
      if(!crown && cfg.roof!=='mansard'){
        g.strokeStyle='rgba(140,165,225,.5)'; g.lineWidth=1;
        var ax=ox+bw*r(0.2,0.8);
        g.beginPath(); g.moveTo(ax,oy); g.lineTo(ax,oy-r(7,20)); g.stroke();
        if(bw>44){
          var tw=11, tx=ox+bw*0.68;
          g.fillStyle=cfg.body[0]; g.fillRect(tx,oy-9,tw,7);
          g.fillStyle='rgba(150,175,240,.22)'; g.fillRect(tx,oy-9,tw,1);
        }
      }

      // ネオン看板。焼き込むのは板と文字。明滅は描画時に光暈を重ねてつくる
      var sign=null;
      var SS = (pal && SIGN_SET[pal.id]) || SIGN_SET.tokyo;
      /* 昼の都市はネオンにしない（cfg.painted）。**昼にネオンが光っていると嘘になる。**
         板に塗った文字にして、描画側の明滅も出さない（sign を返さない） */
      var painted = !!cfg.painted;
      if(r()<cfg.signs && bh>62 && SS.w.length){
        var neon=(cfg.neon||NEON)[(r()*(cfg.neon||NEON).length)|0], vertical=r()<SS.vert;
        if(painted) neon=(cfg.paint||['#3A2A14'])[(r()*(cfg.paint||['#3A2A14']).length)|0];
        if(vertical){
          var word=SS.w[(r()*SS.w.length)|0], n=word.length;
          var fs=9, sw2=fs+5, shh=n*(fs+2)+5;
          /* **札は建物の縁から 8px 内側に置く。**
             建物の canvas は左右に 16px の余白を持ち、隣とは最小 14px しか
             空けないので、縁ぎりぎりの札はあとから描かれる隣の建物に
             6px ほど食われて途中で切れる（実際に切れていた） */
          var sx=(r()<0.5) ? ox+8 : ox+bw-sw2-8;
          /* **下は余白が無い**（canvas の高さは bh+pad で、pad は上だけ）。
             札が建物の下端を越えると途中で切れるので、置ける範囲に丸める */
          var syMax = Math.max(oy+4, oy+bh-shh-2);
          var sy=Math.min(syMax, oy+r(12, Math.max(14, bh*0.45)));
          g.fillStyle=painted?(cfg.board||'#EFE0BE'):'rgba(8,10,24,.92)';
          rr(g,sx,sy,sw2,shh,1.5); g.fill();
          g.strokeStyle=neon; g.globalAlpha=painted?.8:.55; g.lineWidth=0.8; g.stroke(); g.globalAlpha=1;
          g.font='700 '+fs+'px '+FONT; g.textAlign='center'; g.textBaseline='top';
          g.shadowColor=neon; g.shadowBlur=painted?0:8; g.fillStyle=neon;
          for(i=0;i<n;i++) g.fillText(word.charAt(i), sx+sw2/2, sy+3+i*(fs+2));
          g.shadowBlur=0; g.textBaseline='alphabetic'; g.textAlign='left';
          sign={ x:sx+sw2/2-pad, y:sy+shh/2-pad, r:Math.max(sw2,shh)*0.9, col:neon };
        } else {
          var pair=SS.p[(r()*SS.p.length)|0];
          var bwid=Math.max(30, Math.min(bw-8, pair.length*7+12)), bhh=14;
          var bx=ox+r(4, Math.max(5, bw-bwid-4)), by=oy+r(11, Math.max(13, bh*0.5));
          g.fillStyle=painted?(cfg.board||'#EFE0BE'):'rgba(8,10,24,.9)';
          rr(g,bx,by,bwid,bhh,1.5); g.fill();
          g.strokeStyle=neon; g.globalAlpha=painted?.8:.5; g.lineWidth=0.8; g.stroke(); g.globalAlpha=1;
          g.font='700 9px '+FONT; g.textAlign='center'; g.textBaseline='middle';
          g.shadowColor=neon; g.shadowBlur=painted?0:8; g.fillStyle=neon;
          while(bwid>18 && g.measureText(pair).width > bwid-6){ bwid-=2; }
          g.fillText(pair, bx+bwid/2, by+bhh/2+0.5);
          g.shadowBlur=0; g.textBaseline='alphabetic'; g.textAlign='left';
          sign={ x:bx+bwid/2-pad, y:by+bhh/2-pad, r:bwid*0.9, col:neon };
        }
      }
      o.pad=pad; o.bw=bw; o.bh=bh; o.sign=painted?null:sign;   // 塗りの看板は明滅させない
      o.beacon = (bh>120 && r()<0.55 && !cfg.noBeacon);         // 航空障害灯
      return o;
    }

    /* ---- 街灯。near 層に立てて、キャラの背後を1段明るくする ----
       art-direction-final.md 3章「iGくんの背後が暗すぎて沈む」への対処。 */
    function bakeLamp(pal){
      var w=54, h=112, pad=8, o=mkc(w+pad*2, h+pad*2), g=o.g, cx=pad+w/2;
      if(pal.night){                          // 光の円錐（下に開く）
        var cone=g.createLinearGradient(0,pad+16,0,pad+h);
        cone.addColorStop(0,'rgba(255,206,140,.34)');
        cone.addColorStop(0.55,'rgba(255,190,120,.13)');
        cone.addColorStop(1,'rgba(255,180,110,0)');
        g.fillStyle=cone;
        g.beginPath(); g.moveTo(cx-7,pad+16); g.lineTo(cx+7,pad+16);
        g.lineTo(cx+26,pad+h); g.lineTo(cx-26,pad+h); g.closePath(); g.fill();
      }
      g.fillStyle = pal.lampC || (pal.night ? '#1B2450' : '#4E6E7E');
      g.fillRect(cx-1.6, pad+12, 3.2, h-12);
      g.fillRect(cx-9, pad+10, 18, 3);
      var hg=g.createLinearGradient(0,pad+6,0,pad+14);
      hg.addColorStop(0, pal.night?'#FFE7B8':(pal.lampH||'#FFFFFF'));
      hg.addColorStop(1, pal.night?'#FFB25E':(pal.lampC||'#9FB8C4'));
      g.fillStyle=hg; rr(g,cx-8,pad+6,16,7,2.5); g.fill();
      if(pal.night && blurOK){
        g.save(); g.globalCompositeOperation='lighter'; g.filter='blur(6px)'; g.globalAlpha=.75;
        g.fillStyle='rgba(255,196,120,1)'; g.fillRect(cx-9,pad+5,18,10); g.restore();
      }
      g.fillStyle = pal.night ? 'rgba(190,215,255,.35)' : 'rgba(255,255,255,.6)';
      g.fillRect(cx-1.6, pad+12, 1, h-12);
      o.pad=pad; o.bw=w; o.bh=h;
      return o;
    }


    /* ---- ランドマーク（都市の名札）。**1枚に焼いて1回置く。**
       建築そのものは風景として描いてよいが、**他社IPのキャラクター・ロゴ・
       固有の意匠は入れない。**看板は実在の一般名詞だけ、意匠は建築の形だけに留める。

       焼いた canvas は次を持つ:
         halo   … 背後に重ねる光の色（'warm'／'cold'／null）
         beacon … 頂部の航空障害灯を出すか
         lift   … 基準線からの持ち上げ（山や氷山は地平に食い込ませる） */
    function bakeLandmark(pal){
      var k = pal.tower;
      if(!k) return null;
      if(k==='tokyo')   return bakeTower();
      if(k==='eiffel')  return bakeEiffel(pal);
      if(k==='pyramid') return bakePyramids(pal);
      if(k==='deco')    return bakeDeco(pal);
      if(k==='berg')    return bakeBerg(pal);
      if(k==='slab')    return bakeSlab(pal);
      return null;
    }

    /* パリ：曲がった4本脚と2段の展望台。夜はライトアップで金色に浮く */
    function bakeEiffel(pal){
      var TW=88, TH=236, pad=22, o=mkc(TW+pad*2, TH+pad*2), g=o.g;
      var cx=pad+TW/2, baseY=pad+TH, topY=pad+10, i, t;
      var warm = pal.night || pal.dusk;
      var c0 = warm ? '#F2C979' : '#B9976A', c1 = warm ? '#C08A3C' : '#8A6C46',
          c2 = warm ? '#6B4518' : '#5A452C';

      function halfW(t){ return (TW/2)*Math.pow(1-t, 2.1)*0.98 + 3; }
      var mastTop = topY+26, span = baseY-mastTop;

      // 本体。帯に分けて、左を明るく右を落とす（月／夕日が左にある都市）
      for(i=0;i<26;i++){
        var t0=i/26, t1=(i+1)/26;
        var y0=baseY-span*t0, y1=baseY-span*t1, w0=halfW(t0), w1=halfW(t1);
        var bg=g.createLinearGradient(cx-w0,0,cx+w0,0);
        bg.addColorStop(0,c0); bg.addColorStop(.42,c1); bg.addColorStop(1,c2);
        g.fillStyle=bg;
        g.beginPath(); g.moveTo(cx-w0,y0); g.lineTo(cx+w0,y0);
        g.lineTo(cx+w1,y1); g.lineTo(cx-w1,y1); g.closePath(); g.fill();
      }
      // 鉄骨に見せるため、塗りを筋交いの形にくり抜く
      g.save(); g.globalCompositeOperation='destination-out';
      g.lineWidth=1.6; g.strokeStyle='rgba(0,0,0,1)';
      for(i=0;i<24;i++){
        var ta=i/24, tb=(i+1)/24;
        var ya=baseY-span*ta, yb=baseY-span*tb, wa=halfW(ta), wb=halfW(tb);
        g.beginPath();
        g.moveTo(cx-wa*.94,ya); g.lineTo(cx+wb*.94,yb);
        g.moveTo(cx+wa*.94,ya); g.lineTo(cx-wb*.94,yb);
        g.stroke();
      }
      g.lineWidth=2.6;                                  // 4本脚のあいだの抜け
      for(i=-1;i<=1;i+=2){
        g.beginPath();
        for(t=0;t<=0.62;t+=0.04){
          var yy=baseY-span*t, ww=halfW(t), px=cx+i*ww*0.5;
          if(t===0) g.moveTo(px,yy); else g.lineTo(px,yy);
        }
        g.stroke();
      }
      // 脚のあいだのアーチ（この形が「あの塔」と読ませる決め手）
      g.lineWidth=1; g.beginPath();
      g.moveTo(cx-halfW(0)*0.92, baseY);
      g.quadraticCurveTo(cx, baseY-span*0.20, cx+halfW(0)*0.92, baseY);
      g.lineTo(cx+halfW(0)*0.92, baseY-1); g.closePath();
      g.globalCompositeOperation='destination-out';
      g.fillStyle='#000';
      g.beginPath();
      g.moveTo(cx-halfW(0)*0.66, baseY);
      g.quadraticCurveTo(cx, baseY-span*0.155, cx+halfW(0)*0.66, baseY);
      g.closePath(); g.fill();
      g.restore();

      // 横の梁と2段の展望台
      g.strokeStyle='rgba(60,38,12,.5)'; g.lineWidth=0.9;
      for(i=0;i<=24;i++){
        var tt=i/24, y2=baseY-span*tt, w2=halfW(tt);
        g.beginPath(); g.moveTo(cx-w2,y2); g.lineTo(cx+w2,y2); g.stroke();
      }
      function deck(y,w,h){
        var dg=g.createLinearGradient(cx-w,0,cx+w,0);
        dg.addColorStop(0,'#FFE2B4'); dg.addColorStop(.42,c1); dg.addColorStop(1,c2);
        g.fillStyle=dg; g.fillRect(cx-w, y, w*2, h);
        g.fillStyle = warm ? 'rgba(255,226,158,.9)' : 'rgba(255,255,255,.35)';
        g.fillRect(cx-w*0.92, y+h*0.3, w*1.84, h*0.34);
      }
      deck(baseY-span*0.30, 21, 8);
      deck(baseY-span*0.63, 13, 6);
      // 尖塔
      var ag=g.createLinearGradient(0,topY,0,mastTop);
      ag.addColorStop(0,'#FFD9A4'); ag.addColorStop(1,c1);
      g.fillStyle=ag;
      g.beginPath(); g.moveTo(cx-2.4,mastTop); g.lineTo(cx+2.4,mastTop);
      g.lineTo(cx+0.7,topY+4); g.lineTo(cx-0.7,topY+4); g.closePath(); g.fill();
      g.fillStyle='#E0B276'; g.fillRect(cx-0.5, topY-6, 1, 10);

      o.pad=pad; o.bw=TW; o.bh=TH; o.halo='warm'; o.beacon=true;
      return o;
    }

    /* カイロ：3基のピラミッド。太陽が右にあるので右面を明るく、左面を落とす */
    function bakePyramids(pal){
      var W2=300, H2=176, pad=16, o=mkc(W2+pad*2, H2+pad*2), g=o.g, i;
      var baseY=pad+H2;
      var spec=[[0,176,104],[132,232,146],[196,150,84]];   // x, 底辺, 高さ
      for(i=0;i<spec.length;i++){
        var bx=pad+spec[i][0], bw=spec[i][1], bh=spec[i][2];
        var apex=bx+bw*0.5;
        g.fillStyle = ['#8A6534','#9C7440','#7E5B2E'][i];   // 影の面（左）
        g.beginPath(); g.moveTo(bx,baseY); g.lineTo(apex,baseY-bh); g.lineTo(apex,baseY); g.closePath(); g.fill();
        var lg=g.createLinearGradient(apex,baseY-bh,bx+bw,baseY);
        lg.addColorStop(0,'#F2D49A'); lg.addColorStop(.5,'#D8B270'); lg.addColorStop(1,'#B08A4A');
        g.fillStyle=lg;                                    // 光の面（右）
        g.beginPath(); g.moveTo(apex,baseY-bh); g.lineTo(bx+bw,baseY); g.lineTo(apex,baseY); g.closePath(); g.fill();
        g.strokeStyle='rgba(255,240,200,.5)'; g.lineWidth=1;
        g.beginPath(); g.moveTo(apex,baseY-bh); g.lineTo(apex,baseY); g.stroke();
        // 石積みの段。近くで見ると平面に見えないように
        g.strokeStyle='rgba(120,88,40,.22)'; g.lineWidth=0.7;
        var s2; for(s2=1;s2<7;s2++){
          var ty=baseY-bh*s2/7, hw=bw*0.5*(1-s2/7);
          g.beginPath(); g.moveTo(apex-hw,ty); g.lineTo(apex+hw,ty); g.stroke();
        }
      }
      o.pad=pad; o.bw=W2; o.bh=H2; o.halo=null; o.beacon=false;
      return o;
    }

    /* ニューヨーク：段を後退させて積む高層ビルと尖塔。窓は縦の帯で見せる */
    function bakeDeco(pal){
      var TW=92, TH=248, pad=18, o=mkc(TW+pad*2, TH+pad*2), g=o.g, i, q;
      var cx=pad+TW/2, baseY=pad+TH;
      var seg=[[1.00,0.42],[0.78,0.20],[0.58,0.14],[0.40,0.10]];   // 幅比, 高さ比
      var yy=baseY;
      var bodyA=pal.night?'#2C3A55':'#8FA6BE', bodyB=pal.night?'#141C2E':'#5A7288';
      for(i=0;i<seg.length;i++){
        var sw=TW*seg[i][0], shh=TH*seg[i][1];
        var bg=g.createLinearGradient(cx-sw/2,0,cx+sw/2,0);
        bg.addColorStop(0,bodyA); bg.addColorStop(.45,bodyB); bg.addColorStop(1,pal.night?'#0A1120':'#41586C');
        g.fillStyle=bg; g.fillRect(cx-sw/2, yy-shh, sw, shh);
        g.fillStyle='rgba(200,222,255,.28)'; g.fillRect(cx-sw/2, yy-shh, sw, 1.4);
        g.fillStyle='rgba(200,222,255,.20)'; g.fillRect(cx-sw/2, yy-shh, 2.2, shh);
        // 縦の窓帯
        g.fillStyle = pal.night ? 'rgba(255,214,150,.55)' : 'rgba(255,255,255,.30)';
        for(q=0;q<Math.max(2,Math.round(sw/9));q++){
          g.fillRect(cx-sw/2+4+q*9, yy-shh+4, 3.4, shh-8);
        }
        yy -= shh;
      }
      // 王冠（放射状のアーチ）
      var crownY=yy, cr=TW*0.20;
      for(i=0;i<4;i++){
        g.strokeStyle = pal.night ? 'rgba(255,226,164,'+(0.75-i*0.14)+')' : 'rgba(255,255,255,'+(0.6-i*0.12)+')';
        g.lineWidth=1.6;
        g.beginPath(); g.arc(cx, crownY+2, cr-i*3.6, Math.PI, 0); g.stroke();
      }
      g.fillStyle = pal.night ? '#1A2438' : '#7B92A8';
      g.beginPath(); g.moveTo(cx-cr,crownY+3); g.lineTo(cx+cr,crownY+3);
      g.lineTo(cx+cr*0.5,crownY-cr*0.7); g.lineTo(cx-cr*0.5,crownY-cr*0.7); g.closePath(); g.fill();
      // 尖塔
      var mg=g.createLinearGradient(0,crownY-cr*0.7-30,0,crownY);
      mg.addColorStop(0,'#DCE6F2'); mg.addColorStop(1, pal.night?'#3A4A66':'#8FA6BE');
      g.fillStyle=mg;
      g.beginPath(); g.moveTo(cx-2.6,crownY-cr*0.7); g.lineTo(cx+2.6,crownY-cr*0.7);
      g.lineTo(cx+0.7,crownY-cr*0.7-26); g.lineTo(cx-0.7,crownY-cr*0.7-26); g.closePath(); g.fill();
      g.fillStyle='#C8D6E8'; g.fillRect(cx-0.5, crownY-cr*0.7-34, 1, 10);

      o.pad=pad; o.bw=TW; o.bh=TH; o.halo=pal.night?'cold':null; o.beacon=true;
      return o;
    }

    /* 南極：氷山。面で割り、水際に薄い緑青を敷く。灯りは点けない */
    function bakeBerg(pal){
      var W2=270, H2=136, pad=14, o=mkc(W2+pad*2, H2+pad*2), g=o.g, i;
      var baseY=pad+H2, x=pad;
      // 頂点は [x, 上端からの深さ]。深さ 136 が地平、0 が最高点
      var pts=[[0,136],[26,66],[62,88],[96,22],[138,74],[178,38],[214,92],[248,58],[270,136]];
      g.beginPath();
      g.moveTo(x, baseY);
      for(i=0;i<pts.length;i++) g.lineTo(x+pts[i][0], baseY - (H2 - pts[i][1]));
      g.lineTo(x+W2, baseY); g.closePath();
      var bg=g.createLinearGradient(0,baseY-H2,0,baseY);
      bg.addColorStop(0,'#F4FAFD'); bg.addColorStop(.55,'#C8E2F0'); bg.addColorStop(1,'#8FB8D2');
      g.fillStyle=bg; g.fill();
      // 面を割る。1色の塊だと「白い山」で終わる
      g.save(); g.clip();
      for(i=0;i<pts.length-1;i++){
        if(i%2) continue;
        g.fillStyle = 'rgba(150,196,224,'+(0.18+((i*13)%4)*0.06)+')';
        g.beginPath();
        g.moveTo(x+pts[i][0], baseY-(H2-pts[i][1]));
        g.lineTo(x+pts[i+1][0], baseY-(H2-pts[i+1][1]));
        g.lineTo(x+pts[i+1][0]-16, baseY);
        g.lineTo(x+pts[i][0]-8, baseY);
        g.closePath(); g.fill();
      }
      g.fillStyle='rgba(120,200,210,.35)'; g.fillRect(x, baseY-14, W2, 14);   // 水際の緑青
      g.restore();
      g.strokeStyle='rgba(255,255,255,.85)'; g.lineWidth=1.4;   // 稜線に日が当たる
      g.beginPath();
      g.moveTo(x, baseY);
      for(i=0;i<pts.length;i++) g.lineTo(x+pts[i][0], baseY-(H2-pts[i][1]));
      g.stroke();
      o.pad=pad; o.bw=W2; o.bh=H2; o.halo=null; o.beacon=false;
      return o;
    }

    /* 池袋・香港：高層の板。頂部にサイネージの帯とアンテナ。
       香港は3枚を重ねて「密集した塔」にする（pal.towerN） */
    function bakeSlab(pal){
      var n = pal.towerN || 1;
      var TW = n>1 ? 108 : 64, TH = 232, pad=16;
      var o=mkc(TW+pad*2, TH+pad*2), g=o.g, i, q;
      var cols = pal.towerC || ['#2A3A66','#16224A','#0A1230'];
      var slabs = (n>1) ? [[0,0.80,44],[34,1.00,40],[70,0.72,38]] : [[0,1.00,64]];
      for(i=0;i<slabs.length;i++){
        var sx=pad+slabs[i][0], sh2=TH*slabs[i][1], sw=slabs[i][2], sy=pad+TH-sh2;
        var bg=g.createLinearGradient(sx,0,sx+sw,0);
        bg.addColorStop(0,cols[0]); bg.addColorStop(.4,cols[1]); bg.addColorStop(1,cols[2]);
        g.fillStyle=bg; g.fillRect(sx, sy, sw, sh2);
        g.fillStyle='rgba(200,222,255,.30)'; g.fillRect(sx, sy, sw, 1.4);
        g.fillStyle='rgba(200,222,255,.22)'; g.fillRect(sx, sy, 2, sh2);
        // 窓。**塔にも灯りを入れないと、街と別の素材に見える**
        var r=seq(i*9+3);
        for(q=0;q<Math.floor(sh2/11);q++){
          var wy=sy+6+q*11, c2;
          for(c2=0;c2<Math.floor(sw/9);c2++){
            if(r()>0.42) continue;
            g.fillStyle='rgba(255,214,150,'+(0.35+r()*0.5).toFixed(2)+')';
            g.fillRect(sx+4+c2*9, wy, 4, 5);
          }
        }
        if(i===(n>1?1:0)){                                  // いちばん高い板だけ
          g.fillStyle=pal.towerSign||'#F2603C';             // 頂部のサイネージ帯
          g.fillRect(sx, sy+5, sw, 7);
          g.fillStyle='rgba(255,240,200,.5)'; g.fillRect(sx, sy+5, sw, 1.2);
          g.fillStyle=cols[2];                              // アンテナ
          g.fillRect(sx+sw/2-1, sy-24, 2, 24);
          g.fillRect(sx+sw/2-4, sy-14, 8, 1.6);
        }
      }
      o.pad=pad; o.bw=TW; o.bh=TH; o.halo=pal.night?'warm':null; o.beacon=true;
      return o;
    }

    /* ---- 東京タワー。**1本の塔として通して焼き込む。**
       上部と下部を別々に描いていたので「2つに見える」と指摘された（同 3章）。
       基部から尖塔まで、色も筋交いも1枚の canvas で作れば分かれようがない。 ---- */
    function bakeTower(){
      var TW=86, TH=238, pad=22, o=mkc(TW+pad*2, TH+pad*2), g=o.g;
      var cx=pad+TW/2, baseY=pad+TH, topY=pad+14, i, s, t;

      var hg=g.createRadialGradient(cx, pad+TH*0.6, 6, cx, pad+TH*0.6, 120);
      hg.addColorStop(0,'rgba(255,140,80,.20)'); hg.addColorStop(1,'rgba(255,140,80,0)');
      g.fillStyle=hg; g.fillRect(0,0,o.w,o.h);

      function halfW(t){ return (TW/2)*Math.pow(1-t,1.75)*0.95 + 4; }
      var latticeTop=topY+34, span=baseY-latticeTop, bands=20;
      for(i=0;i<bands;i++){
        var t0=i/bands, t1=(i+1)/bands;
        var y0=baseY-span*t0, y1=baseY-span*t1, w0=halfW(t0), w1=halfW(t1);
        var bg=g.createLinearGradient(cx-w0,0,cx+w0,0);
        if(i%2===0){ bg.addColorStop(0,'#FF9A5C'); bg.addColorStop(.4,'#F2612E'); bg.addColorStop(1,'#8E2C18'); }
        else       { bg.addColorStop(0,'#FFF0DC'); bg.addColorStop(.45,'#E8CFAE'); bg.addColorStop(1,'#8A6A52'); }
        g.fillStyle=bg;
        g.beginPath(); g.moveTo(cx-w0,y0); g.lineTo(cx+w0,y0);
        g.lineTo(cx+w1,y1); g.lineTo(cx-w1,y1); g.closePath(); g.fill();
      }
      // 帯を筋交いの形にくり抜く。塗りつぶしのままだと円錐に見えて鉄骨に見えない
      g.save(); g.globalCompositeOperation='destination-out';
      g.lineWidth=1.5; g.strokeStyle='rgba(0,0,0,1)';
      var steps=22;
      for(s=0;s<steps;s++){
        var ta=s/steps, tb=(s+1)/steps;
        var ya=baseY-span*ta, yb=baseY-span*tb, wa=halfW(ta), wb=halfW(tb);
        g.beginPath();
        g.moveTo(cx-wa*.96,ya); g.lineTo(cx+wb*.96,yb);
        g.moveTo(cx+wa*.96,ya); g.lineTo(cx-wb*.96,yb);
        g.stroke();
      }
      g.lineWidth=2.2;
      for(i=0;i<3;i++){
        var f=(i-1)*0.42;
        g.beginPath();
        for(t=0;t<=1.001;t+=0.05){
          var yy=baseY-span*t, ww=halfW(t), px=cx+f*ww*1.6;
          if(t===0) g.moveTo(px,yy); else g.lineTo(px,yy);
        }
        g.stroke();
      }
      g.restore();
      g.strokeStyle='rgba(28,14,10,.55)'; g.lineWidth=0.8;
      for(s=0;s<=steps;s++){
        var tt=s/steps, y2=baseY-span*tt, w2=halfW(tt);
        g.beginPath(); g.moveTo(cx-w2,y2); g.lineTo(cx+w2,y2); g.stroke();
      }
      function deck(y,w,h){
        var dg=g.createLinearGradient(cx-w,0,cx+w,0);
        dg.addColorStop(0,'#FFE6C8'); dg.addColorStop(.42,'#E2A472'); dg.addColorStop(1,'#7A4530');
        g.fillStyle=dg;
        g.beginPath(); g.moveTo(cx-w,y+h); g.lineTo(cx-w*.74,y);
        g.lineTo(cx+w*.74,y); g.lineTo(cx+w,y+h); g.closePath(); g.fill();
        var wg2=g.createLinearGradient(0,y+1,0,y+h-1);
        wg2.addColorStop(0,'rgba(255,222,150,.95)'); wg2.addColorStop(1,'rgba(255,170,90,.45)');
        g.fillStyle=wg2; g.fillRect(cx-w*.82, y+h*0.3, w*1.64, h*0.34);
      }
      deck(baseY-span*0.46, 19, 9);
      deck(baseY-span*0.84, 10, 6);
      var ag=g.createLinearGradient(0,topY,0,latticeTop);
      ag.addColorStop(0,'#FFC9A0'); ag.addColorStop(1,'#C4552B');
      g.fillStyle=ag;
      g.beginPath(); g.moveTo(cx-2.2,latticeTop); g.lineTo(cx+2.2,latticeTop);
      g.lineTo(cx+0.7,topY+3); g.lineTo(cx-0.7,topY+3); g.closePath(); g.fill();
      g.fillStyle='#E0A276'; g.fillRect(cx-0.5, topY-7, 1, 11);

      o.pad=pad; o.bw=TW; o.bh=TH;
      o.lightY = -(TH) - 4;                 // 障害灯の位置（基準線からの相対）
      return o;
    }

    /* ---- 地面タイル ---- */
    var TILE_W=160, GH=VH-GROUND_Y;
    function bakeTile(pal, v){
      var o=mkc(TILE_W, GH+8), g=o.g, gp=pal.ground, topH=15, i;
      var tg=g.createLinearGradient(0,0,0,topH);
      tg.addColorStop(0,gp.top[0]); tg.addColorStop(0.30,gp.top[1]); tg.addColorStop(1,gp.top[2]);
      g.fillStyle=tg; g.fillRect(0,0,TILE_W,topH);
      g.fillStyle='rgba('+gp.lip+',.72)'; g.fillRect(0,0,TILE_W,1);
      g.fillStyle='rgba('+gp.lip+',.22)'; g.fillRect(0,1,TILE_W,0.8);
      g.strokeStyle='rgba(10,14,34,.35)'; g.lineWidth=0.8;
      for(i=0;i<=4;i++){
        var jx=i*(TILE_W/4)+v*8;
        g.beginPath(); g.moveTo(jx,0); g.lineTo(jx-3,topH); g.stroke();
      }
      /* 点字ブロック。日本の歩道であることが一目で伝わる。
         **日本以外の都市には出さない**（gp.tactile が false）。
         代わりに縁石寄りの帯（側溝・排水の見切り）を敷いて、
         歩道の奥行きが消えないようにする */
      if(gp.tactile===false){
        g.fillStyle=gp.edge||'rgba(0,0,0,.10)'; g.fillRect(0,topH-5,TILE_W,4);
        g.fillStyle='rgba(255,255,255,.10)'; g.fillRect(0,topH-5,TILE_W,1);
      } else {
        var yg=g.createLinearGradient(0,topH-6,0,topH-1);
        yg.addColorStop(0,'rgba(228,168,74,.46)'); yg.addColorStop(1,'rgba(150,102,32,.28)');
        g.fillStyle=yg; g.fillRect(0,topH-6,TILE_W,5);
        g.fillStyle='rgba(255,214,132,.36)';
        for(i=0;i<22;i++) g.fillRect(i*7+2, topH-5, 3.2, 1.8);
      }
      g.fillStyle=gp.curb; g.fillRect(0,topH,TILE_W,5);
      g.fillStyle='rgba(130,165,245,.20)'; g.fillRect(0,topH,TILE_W,1);
      g.fillStyle='rgba(4,6,16,.5)'; g.fillRect(0,topH+4,TILE_W,1.5);
      var wt=topH+5;
      var fg=g.createLinearGradient(0,wt,0,GH+8);
      fg.addColorStop(0,gp.wall[0]); fg.addColorStop(0.3,gp.wall[1]); fg.addColorStop(1,gp.wall[2]);
      g.fillStyle=fg; g.fillRect(0,wt,TILE_W,GH+8-wt);
      if(gp.wet){                     // 濡れたアスファルトが頭上のネオンを飲む
        var ng=g.createLinearGradient(0,wt,0,GH+8);
        ng.addColorStop(0,'rgba('+(v===1?gp.wet[0]:gp.wet[1])+',.28)');
        ng.addColorStop(0.45,'rgba(150,70,160,.10)');
        ng.addColorStop(1,'rgba(255,170,90,.07)');
        g.fillStyle=ng; g.fillRect(0,wt,TILE_W,GH+8-wt);
        var r=seq(v+7), s2;
        for(s2=0;s2<5;s2++){
          var sx=r(0,TILE_W), sw=r(4,18), sh=r(14,GH-wt+6);
          var sg=g.createLinearGradient(0,wt,0,wt+sh);
          sg.addColorStop(0, r()<0.6?'rgba(255,196,120,.20)':'rgba(120,215,255,.16)');
          sg.addColorStop(1,'rgba(255,255,255,0)');
          g.fillStyle=sg; g.fillRect(sx,wt,sw,sh);
        }
      }
      g.strokeStyle='rgba(150,180,250,.08)'; g.lineWidth=0.8;
      for(i=1;i<3;i++){ var ry2=wt+i*12; g.beginPath(); g.moveTo(0,ry2); g.lineTo(TILE_W,ry2); g.stroke(); }
      g.strokeStyle='rgba(4,6,16,.45)';
      for(i=0;i<3;i++){ var vx=i*54+v*11+14; g.beginPath(); g.moveTo(vx,wt); g.lineTo(vx-4,GH+8); g.stroke(); }
      if(v===2){                      // 側溝のグレーチング
        g.fillStyle='rgba(4,6,16,.9)'; rr(g,100,wt+4,30,9,1.5); g.fill();
        g.strokeStyle='rgba(130,165,235,.24)'; g.lineWidth=0.8;
        for(i=0;i<5;i++){ g.beginPath(); g.moveTo(103+i*6,wt+5); g.lineTo(103+i*6,wt+12); g.stroke(); }
      }
      if(v===1){                      // マンホール（ほぼ真横から見える）
        g.fillStyle='rgba(70,90,150,.3)';
        g.beginPath(); g.ellipse(48,topH-9,15,2.8,0,0,7); g.fill();
      }
      return o;
    }

    /* ---- 画面幅に依存するもの（VW が変わったら焼き直す） ---- */
    function bakeSky(pal){
      var o=mkc(VW+40, VH+40, 1), g=o.g, i;
      var sg=g.createLinearGradient(0,0,0,GROUND_Y+30);
      for(i=0;i<pal.sky.length;i++) sg.addColorStop(pal.sky[i][0], pal.sky[i][1]);
      g.fillStyle=sg; g.fillRect(0,0,o.w,GROUND_Y+34);
      var d=pal.dome;
      var dg=g.createRadialGradient(d.x*o.w, d.y+20, 6, d.x*o.w, d.y+20, d.r);
      dg.addColorStop(0,'rgba('+d.c+','+d.a+')');
      dg.addColorStop(0.42,'rgba('+d.c+','+(d.a*0.38).toFixed(3)+')');
      dg.addColorStop(1,'rgba('+d.c+',0)');
      g.fillStyle=dg; g.fillRect(0,0,o.w,GROUND_Y+34);
      var c2=pal.cool;
      var cg=g.createRadialGradient(c2.x*o.w, c2.y*VH+20, 10, c2.x*o.w, c2.y*VH+20, c2.r);
      cg.addColorStop(0,'rgba('+c2.c+','+c2.a+')'); cg.addColorStop(1,'rgba('+c2.c+',0)');
      g.fillStyle=cg; g.fillRect(0,0,o.w,GROUND_Y+20);
      return o;
    }
    function bakeHaze(pal){
      var o=mkc(VW+40,120,1), g=o.g;
      var hg=g.createLinearGradient(0,0,0,120);
      hg.addColorStop(0,'rgba('+pal.haze[0]+',0)');
      hg.addColorStop(0.55,'rgba('+pal.haze[0]+',.30)');
      hg.addColorStop(0.86,'rgba('+pal.haze[1]+',.20)');
      hg.addColorStop(1,'rgba('+pal.haze[1]+',0)');
      g.fillStyle=hg; g.fillRect(0,0,o.w,120);
      return o;
    }
    /* ビネット。**形は全都市で同じで、濃さが違うだけ。**
       画面いっぱいの canvas を都市ごとに持つと 1都市あたり 1.1MB 無駄になるので、
       濃さ 1 で1枚だけ焼き、描くときに globalAlpha を掛ける
       （2つの stop の比が保たれるので、都市ごとに焼いたのと同じ絵になる） */
    var VIGN=null, VIGN_W=-1;
    function vignette(){
      if(!VIGN || VIGN_W!==VW){
        var o=mkc(VW+40,VH+40,1), g=o.g;
        var vg=g.createRadialGradient(o.w/2, VH*0.48, VH*0.30, o.w/2, VH*0.5, VH*0.98);
        vg.addColorStop(0,'rgba(0,0,0,0)');
        vg.addColorStop(0.65,'rgba(2,3,10,0.35)');
        vg.addColorStop(1,'rgba(2,3,10,1)');
        g.fillStyle=vg; g.fillRect(0,0,o.w,o.h);
        VIGN=o; VIGN_W=VW;
      }
      return VIGN;
    }
    /* 中景の下から地面までの暗い帯。ここに遠い街灯を散らすと奥行きが出る */
    function bakeFloor(pal){
      var top=HORIZON+8, bh=GROUND_Y+6-top;
      var o=mkc(VW+40,bh,1), g=o.g, i, r=seq(3);
      var fg=g.createLinearGradient(0,0,0,bh);
      fg.addColorStop(0,pal.floor[0]); fg.addColorStop(0.30,pal.floor[1]);
      fg.addColorStop(0.70,pal.floor[2]); fg.addColorStop(1,pal.floor[3]);
      g.fillStyle=fg; g.fillRect(0,0,o.w,bh);
      if(pal.night) for(i=0;i<Math.round(o.w/14);i++){
        g.fillStyle='rgba(255,196,128,'+r(0.10,0.40).toFixed(3)+')';
        g.fillRect(r(0,o.w), r(bh*0.25,bh*0.8), r(1,3), 1);
      }
      o.top=top;
      return o;
    }
    /* 手前を流れる、ピントの外れた手すり。奥行きはこの層で決まる */
    function bakeRail(pal){
      var FW=310, FH=52, o=mkc(FW,FH), g=o.g;
      var s=mkc(FW,FH), sg=s.g, i;
      sg.fillStyle=pal.rail;
      sg.fillRect(0,11,FW,4); sg.fillRect(0,25,FW,2.5);
      for(i=0;i<9;i++){ sg.fillRect(i*35+6,8,5,FH-8); sg.fillRect(i*35+3,4,11,5); }
      if(blurOK) g.filter='blur(2.4px)';
      g.globalAlpha=0.92; into(g,s,0,0); g.filter='none'; g.globalAlpha=1;
      var dg=g.createLinearGradient(0,FH*0.45,0,FH);
      dg.addColorStop(0,'rgba(2,4,12,0)'); dg.addColorStop(1,'rgba(2,4,12,.8)');
      g.fillStyle=dg; g.fillRect(0,0,FW,FH);
      return o;
    }
    function bakeCloud(pal, idx){
      var CW=520, CH=84, o=mkc(CW,CH,1), g=o.g, i;
      var spec=pal.cloud[idx], tint=spec[0], alpha=spec[1], r=seq(idx*5+2);
      for(i=0;i<20;i++){
        var cx=r(0,CW), cy=r(CH*0.25,CH*0.8), rw=r(40,110), rh=r(6,15);
        var cg=g.createRadialGradient(cx,cy,0,cx,cy,rw);
        cg.addColorStop(0,'rgba('+tint+','+(alpha*r(0.7,1)).toFixed(3)+')');
        cg.addColorStop(0.55,'rgba('+tint+','+(alpha*0.35).toFixed(3)+')');
        cg.addColorStop(1,'rgba('+tint+',0)');
        g.save(); g.translate(cx,cy); g.scale(1,rh/rw); g.translate(-cx,-cy);
        g.fillStyle=cg; g.beginPath(); g.arc(cx,cy,rw,0,7); g.fill(); g.restore();
      }
      return o;
    }
    /* 月／太陽。多層の光暈をつける。これが無いと空が「塗り」に見える */
    function bakeOrb(pal){
      var R=pal.orb.r, S=Math.round(R*11), o=mkc(S,S), g=o.g, cx=S/2, cy=S/2, i;
      var halos = pal.orb.moon ? [[R*5.2,.10],[R*3.2,.13],[R*1.8,.20],[R*1.1,.30]]
                               : [[R*5.6,.16],[R*3.4,.20],[R*2.0,.26],[R*1.2,.34]];
      /* **夕方の太陽が白いと月に見える。**光暈と本体の色を都市ごとに変える */
      var hc = pal.orb.halo || (pal.orb.moon ? '232,240,255' : '255,240,190');
      var oc = pal.orb.c || (pal.orb.moon ? null : ['#FFFFFF','#FFF6D6','#FFE29A']);
      for(i=0;i<halos.length;i++){
        var hg=g.createRadialGradient(cx,cy,R*0.5,cx,cy,halos[i][0]);
        hg.addColorStop(0,'rgba('+hc+','+halos[i][1]+')');
        hg.addColorStop(0.45,'rgba('+hc+','+(halos[i][1]*0.35).toFixed(3)+')');
        hg.addColorStop(1,'rgba('+hc+',0)');
        g.fillStyle=hg; g.beginPath(); g.arc(cx,cy,halos[i][0],0,7); g.fill();
      }
      var mg=g.createRadialGradient(cx-R*0.33,cy-R*0.4,1,cx,cy,R*1.16);
      if(pal.orb.moon && !oc){ mg.addColorStop(0,'#FFFDF6'); mg.addColorStop(.6,'#F2F0E4'); mg.addColorStop(1,'#D9DCD4'); }
      else { mg.addColorStop(0,oc[0]); mg.addColorStop(.6,oc[1]); mg.addColorStop(1,oc[2]); }
      g.fillStyle=mg; g.beginPath(); g.arc(cx,cy,R,0,7); g.fill();
      if(pal.orb.moon){
        g.globalAlpha=.075; g.fillStyle='#6E7488';
        var cr=[[-.33,-.26,.22],[.19,.19,.28],[-.07,.44,.13],[.41,-.3,.11],[.48,.33,.17]];
        for(i=0;i<cr.length;i++){ g.beginPath(); g.arc(cx+cr[i][0]*R, cy+cr[i][1]*R, cr[i][2]*R, 0, 7); g.fill(); }
        g.globalAlpha=1;
        var tg2=g.createLinearGradient(cx-R,cy-R,cx+R,cy+R);
        tg2.addColorStop(0,'rgba(255,255,255,0)'); tg2.addColorStop(1,'rgba(60,70,110,.30)');
        g.fillStyle=tg2; g.beginPath(); g.arc(cx,cy,R,0,7); g.fill();
      }
      return o;
    }

    /* ---- 障害物（art-direction-final.md 3章の構成案を全都市へ） ----
       low / tall / stack / bar / fly の5種は**当たり判定の大きさが決まっている**
       （addObs の w,h）。都市ごとに変えられるのは見た目だけ。

       種類ごとに「形」を数種持ち、都市は PROC_PAL の obs で形と色を選ぶ。
       1都市ぶん書き下ろすと 6都市で 30 個の関数になり、直すときに全部触ることになる。

       | 判定 | 形（shape）の候補 |
       |---|---|
       | low   | box 木箱／basket 籠／bottle 酒箱／bag ごみ袋／ice 氷塊／carton 段ボール |
       | tall  | vending 自販機／column 広告塔／stand 屋台／pillar 石柱／serac 氷柱／steamer 蒸籠 |
       | stack | lantern 提灯／pot 壺／barrel 樽／scaffold 足場／iceblock 氷塊 |
       | bar   | stripe バリケード／cloth 日よけ／awning 天幕／banner 横断幕／crowd 人の列 |
       | fly   | 鳥。色だけ変える |
    */
    function obsCanvas(w,h,pad){ var o=mkc(w+pad*2,h+pad*2); o.pad=pad; o.bw=w; o.bh=h; return o; }

    /* 障害物を背景から引き剥がす後処理（2026-09-10。実機で「障害物が背景に埋もれる」）。
       **原因は絵の質ではなく、procedural 化で背景の情報量が障害物に追いついたこと。**
       近景のビルは窓・看板・光暈を持ち、障害物と同じ密度で同じ明度帯に並ぶ。
       背景を削ると 9/9 に承認された絵が壊れるので、**障害物の側だけを立たせる。**

       焼き上がった1枚に対して3つ足す。**毎フレームの処理は1つも増やさない**
       （全部この場で焼き込む。drawObsProc は今までどおり blit するだけ）。

         1. 暗幕（scrim）  … シルエットを半径5pxまで広げて薄く敷く。背景と縁の間に
                             1段の隙間を作る。背景が明るい都市では白い暈にする
         2. リムライト     … シルエットを 2px 広げて縁取る。**背景と逆の明度で。**
                             夜の都市は明るい縁、昼の都市は暗い縁
         3. 明度の押し上げ … 夜は自分自身を lighter で薄く重ねる（＝彩度と明度が上がる）。
                             昼は source-atop で軽く沈める（白背景に白い物を置かない）

       明暗の判定は `pal.near.body[0]`＝**障害物のすぐ後ろに立つビルの色**で決める。
       空でも地面でもなく、実際に背後に来る層で測らないと南極と香港を間違える。 */
    /* 障害物の主色。形ごとに色の入れ物が違うので1か所にまとめる（obsSep が使う） */
    function obsMainColor(cfg){
      if(!cfg) return null;
      if(cfg.body) return cfg.body[0];
      if(cfg.lantern) return cfg.lantern[1] || cfg.lantern[0];
      if(cfg.head) return cfg.head[0];
      return null;
    }
    /* 2つの色がどれだけ離れて見えるか（redmean。0〜およそ765）。
       **明度差だけでは足りない。**東京の茶色い木箱は青いビルの上で読めるが、
       同じ明度差でもカイロの砂色の籠は砂色のビルの上で読めない。差は色相。
       CIELAB まで持ち込まずに済む近似で、焼き込みのときに1度だけ走る。 */
    function colDist(a, b){
      var A = hex(a), B = hex(b), r = (A[0]+B[0])/2;
      var dr = A[0]-B[0], dg = A[1]-B[1], db = A[2]-B[2];
      return Math.sqrt((2+r/256)*dr*dr + 4*dg*dg + (2+(255-r)/256)*db*db);
    }
    var SEP_OK = 90;          // これ以上離れていれば手を入れない（9/9 に承認した絵のまま）

    function popObs(o, pal, cfg){
      if(!o || !o.c) return o;
      var nb = (pal.near && pal.near.body && pal.near.body[0]) || '#333333';
      var dark = lum(hex(nb)) < 0.5;                 // 背後が暗い＝夜側
      /* 2026-09-15。実機で「まだ読みにくい都市がある」との指摘。
         全都市を測ったところ（tools/contrast.js）、**近景ビルと同じ色の帯に
         いる障害物は5組だけ**だった。距離（redmean）は

           カイロ low 36 ／ NY low 34・tall 11 ／ 南極 low 19・tall 32
           次に近いのは カイロ bar の 152。**あいだが大きく空いている。**

         そこで「危ない組み合わせだけ」縁と暗幕を強める。
         **一律には強めない。**東京・池袋・パリ・香港は boost=0 で 9/9 の絵のまま。 */
      var sep   = colDist(obsMainColor(cfg) || nb, nb);
      var boost = cfg ? Math.max(0, (SEP_OK - sep) / SEP_OK) : 0;
      /* 暗幕は**背景ではなく「障害物自身の明るさ」の逆**を敷く。
         背景だけで決めると、明るい背景に明るい障害物（南極）に白い暈を敷いてしまう。
         boost が 0 のときは今までと同じ値になるようにしてある。 */
      var objL  = lum(hex(obsMainColor(cfg) || nb));
      var rim   = dark ? 'rgba(255,247,232,'+(0.92+0.08*boost).toFixed(3)+')'
                       : 'rgba(14,20,30,'  +(0.85+0.15*boost).toFixed(3)+')';
      var scr;
      if(boost > 0){
        scr = (objL < 0.5) ? 'rgba(255,250,240,'+(0.30+0.30*boost).toFixed(3)+')'
                           : 'rgba(6,9,18,'    +(0.28+0.26*boost).toFixed(3)+')';
      } else {
        scr = dark ? 'rgba(6,9,18,.34)' : 'rgba(255,255,255,.42)';
      }
      var RIM_W = 1.6 + 1.5*boost;                   // 縁の太さ。近い組み合わせほど太く
      var PAD  = 5, k, i, a;
      // シルエット（source-in で1色に潰す）。リムと暗幕の両方に使い回す
      function sil(col){
        var t = mkc(o.w, o.h);
        t.g.drawImage(o.c, 0, 0, o.w, o.h);
        t.g.globalCompositeOperation = 'source-in';
        t.g.fillStyle = col;
        t.g.fillRect(0, 0, o.w, o.h);
        return t;
      }
      var out = mkc(o.w + PAD*2, o.h + PAD*2), g = out.g;
      // 1. 暗幕。半径を変えて2周ぶん重ねると、輪郭がぼけた暈になる
      var S1 = sil(scr);
      for(k=0;k<2;k++){
        a = k ? 5 : 2.6;
        g.globalAlpha = k ? 0.5 : 0.8;
        for(i=0;i<8;i++){
          g.drawImage(S1.c, PAD + Math.cos(i*0.7854)*a, PAD + Math.sin(i*0.7854)*a, o.w, o.h);
        }
      }
      g.globalAlpha = 1;
      // 2. リムライト。RIM_W ぶん8方向へずらす＝均一な縁取り
      var S2 = sil(rim);
      for(i=0;i<8;i++){
        g.drawImage(S2.c, PAD + Math.cos(i*0.7854)*RIM_W, PAD + Math.sin(i*0.7854)*RIM_W, o.w, o.h);
      }
      // 3. 本体。夜は自分を薄く足して起こし、昼は薄く沈める
      g.drawImage(o.c, PAD, PAD, o.w, o.h);
      if(dark){
        g.save(); g.globalCompositeOperation='lighter'; g.globalAlpha=0.16;
        g.drawImage(o.c, PAD, PAD, o.w, o.h);
        g.restore();
      } else {
        g.save(); g.globalCompositeOperation='source-atop';
        g.fillStyle='rgba(18,26,36,.14)'; g.fillRect(0,0,out.w,out.h);
        g.restore();
      }
      // 余計なものを持ち帰らない。pad だけ広がり、他の性質はそのまま引き継ぐ
      out.pad = (o.pad||0) + PAD; out.bw = o.bw; out.bh = o.bh;
      out.glow = o.glow; out.gr = o.gr; out.lamp = o.lamp;
      out.posts = o.posts; out.postC = o.postC; out.postD = o.postD;
      if(o.eyes){                                   // 敵の目の位置（瞳を毎フレーム描くため）
        out.eyes = [];
        for(i=0;i<o.eyes.length;i++) out.eyes.push({ x:o.eyes[i].x+PAD, y:o.eyes[i].y+PAD, r:o.eyes[i].r });
      }
      return out;
    }

    /* ---- low（36×34） ---- */
    function bakeObsLow(pal, c){
      c = c || {};
      var w=36,h=34,o=obsCanvas(w,h,10),g=o.g,x=10,y=10,i;
      var sh=c.shape||'box', b=c.body||['#8B6136','#6B4726','#3B2612'];
      var bg=g.createLinearGradient(x,0,x+w,0);
      bg.addColorStop(0,b[0]); bg.addColorStop(.3,b[1]); bg.addColorStop(1,b[2]);

      if(sh==='bag'){                                   // ごみ袋（NY）。丸い塊を3つ
        for(i=0;i<3;i++){
          var bx=x+6+i*11, by=y+h-4, br=9+ (i===1?3:0);
          g.fillStyle=bg;
          g.beginPath(); g.ellipse(bx, by-br*0.7, br*0.85, br, 0, 0, 7); g.fill();
          g.fillStyle='rgba(255,255,255,.10)';
          g.beginPath(); g.ellipse(bx-br*0.3, by-br*1.1, br*0.28, br*0.4, -0.4, 0, 7); g.fill();
          g.fillStyle=b[2];                              // 口を縛った結び目
          g.beginPath(); g.ellipse(bx, by-br*1.55, 2.6, 2, 0, 0, 7); g.fill();
        }
      } else if(sh==='basket'){                          // 籠（カイロ）。編み目と果実
        g.fillStyle=bg;
        g.beginPath();
        g.moveTo(x+3,y+10); g.lineTo(x+w-3,y+10);
        g.lineTo(x+w-7,y+h); g.lineTo(x+7,y+h); g.closePath(); g.fill();
        g.strokeStyle='rgba(60,40,16,.45)'; g.lineWidth=0.9;
        for(i=1;i<5;i++){ g.beginPath(); g.moveTo(x+3+i*0.8,y+10+i*5); g.lineTo(x+w-3-i*0.8,y+10+i*5); g.stroke(); }
        for(i=0;i<6;i++){ g.beginPath(); g.moveTo(x+4+i*5.5,y+10); g.lineTo(x+7+i*4.6,y+h); g.stroke(); }
        g.fillStyle=b[0]; g.fillRect(x+2,y+8,w-4,3.5);   // 縁
        var fr=['#D8632E','#E0A93C','#8FA83A'];
        for(i=0;i<4;i++){                                 // 盛った果実
          g.fillStyle=fr[i%3];
          g.beginPath(); g.arc(x+9+i*6, y+7-(i%2)*2.5, 4, 0, 7); g.fill();
          g.fillStyle='rgba(255,255,255,.28)';
          g.beginPath(); g.arc(x+8+i*6, y+5.6-(i%2)*2.5, 1.3, 0, 7); g.fill();
        }
      } else if(sh==='bottle'){                           // 酒箱（パリ）。首が3本出る
        g.fillStyle=bg; g.fillRect(x,y+10,w,h-10);
        g.strokeStyle='rgba(230,200,160,.24)'; g.lineWidth=1;
        for(i=1;i<3;i++){ g.beginPath(); g.moveTo(x,y+10+i*(h-10)/3); g.lineTo(x+w,y+10+i*(h-10)/3); g.stroke(); }
        for(i=0;i<3;i++){
          var nx=x+7+i*11;
          g.fillStyle='#2E4A2A'; g.fillRect(nx-2, y, 4, 12);
          g.fillStyle='#1E3320'; g.fillRect(nx-3, y+9, 6, 4);
          g.fillStyle='#C9A24A'; g.fillRect(nx-2, y+1, 4, 2.5);
        }
        g.fillStyle='rgba(248,244,232,.85)'; g.fillRect(x+8,y+18,20,8);
        g.fillStyle='rgba(60,44,24,.45)'; g.fillRect(x+10,y+20,16,1); g.fillRect(x+10,y+23,10,1);
      } else if(sh==='ice'){                              // 氷塊（南極）。面で割る
        g.fillStyle=bg;
        g.beginPath();
        g.moveTo(x+2,y+h); g.lineTo(x+5,y+7); g.lineTo(x+18,y+2);
        g.lineTo(x+w-3,y+9); g.lineTo(x+w-1,y+h); g.closePath(); g.fill();
        g.fillStyle='rgba(255,255,255,.42)';
        g.beginPath(); g.moveTo(x+5,y+7); g.lineTo(x+18,y+2); g.lineTo(x+20,y+15); g.lineTo(x+8,y+18); g.closePath(); g.fill();
        g.fillStyle='rgba(255,255,255,.18)';
        g.beginPath(); g.moveTo(x+20,y+15); g.lineTo(x+w-3,y+9); g.lineTo(x+w-1,y+h); g.lineTo(x+22,y+h); g.closePath(); g.fill();
        g.strokeStyle='rgba(255,255,255,.6)'; g.lineWidth=1;
        g.beginPath(); g.moveTo(x+5,y+7); g.lineTo(x+18,y+2); g.lineTo(x+w-3,y+9); g.stroke();
      } else {                                            // box / carton
        g.fillStyle=bg; g.fillRect(x,y,w,h);
        g.fillStyle='rgba(210,180,140,.32)'; g.fillRect(x,y,w,1.2); g.fillRect(x,y,1.2,h);
        if(sh==='carton'){                                // 段ボール。テープが十字に走る
          g.fillStyle=c.tape||'rgba(228,214,180,.85)';
          g.fillRect(x+w/2-3, y, 6, h); g.fillRect(x, y+5, w, 4);
          g.strokeStyle='rgba(40,26,12,.3)'; g.lineWidth=1;
          g.beginPath(); g.moveTo(x,y+5); g.lineTo(x+w,y+5); g.stroke();
        } else {
          g.strokeStyle='rgba(40,26,12,.6)'; g.lineWidth=1.4;
          g.beginPath(); g.moveTo(x+2,y+2); g.lineTo(x+w-2,y+h-2);
          g.moveTo(x+w-2,y+2); g.lineTo(x+2,y+h-2); g.stroke();
          g.strokeStyle='rgba(230,200,160,.22)'; g.lineWidth=1;
          for(i=1;i<3;i++){ g.beginPath(); g.moveTo(x,y+i*h/3); g.lineTo(x+w,y+i*h/3); g.stroke(); }
        }
        // 送り状。仕入れた荷物だと分かる
        g.fillStyle='rgba(248,244,232,.9)'; g.fillRect(x+7,y+12,13,9);
        g.fillStyle='rgba(60,44,24,.5)'; g.fillRect(x+8.5,y+14,10,1); g.fillRect(x+8.5,y+17,7,1);
      }
      o.glow=c.glow||null; o.gr=c.gr||24;
      return o;
    }

    /* ---- tall（36×62）。**その都市らしさが遊びに直結する枠**
       （東京の自販機がそうだったように、跳ぶたびに見える） ---- */
    function bakeObsTall(pal, c){
      c = c || {};
      var w=36,h=62,o=obsCanvas(w,h,14),g=o.g,x=14,y=14,i,q;
      var sh=c.shape||'vending', b=c.body||['#2B3866','#182046','#0A0E26'];
      var bg=g.createLinearGradient(x,0,x+w,0);
      bg.addColorStop(0,b[0]); bg.addColorStop(.22,b[1]); bg.addColorStop(1,b[2]);
      var rim=c.rim||'190,215,255';

      function lightPanel(px,py,pw,ph,warm){              // 光る面。どの形でも使う
        var pg=g.createLinearGradient(0,py,0,py+ph);
        pg.addColorStop(0,'rgba('+warm[0]+',.95)');
        pg.addColorStop(.55,'rgba('+warm[1]+',.85)');
        pg.addColorStop(1,'rgba('+warm[2]+',.7)');
        g.fillStyle=pg; rr(g,px,py,pw,ph,1.5); g.fill();
      }
      function spill(px,py,pw,ph,col,a){
        if(!blurOK) return;
        g.save(); g.globalCompositeOperation='lighter'; g.filter='blur(5px)'; g.globalAlpha=a;
        g.fillStyle=col; g.fillRect(px,py,pw,ph); g.restore();
      }

      if(sh==='column'){                                  // 広告塔（パリ）。円柱＋ドーム
        g.fillStyle=bg; rr(g,x+3,y+8,w-6,h-8,2); g.fill();
        var dg=g.createLinearGradient(x,y,x+w,y);
        dg.addColorStop(0,b[0]); dg.addColorStop(.4,b[1]); dg.addColorStop(1,b[2]);
        g.fillStyle=dg;
        g.beginPath(); g.ellipse(x+w/2, y+8, w/2-3, 6, 0, Math.PI, 0); g.fill();
        g.fillStyle=c.finial||'#C9A24A';
        g.beginPath(); g.arc(x+w/2, y+2.5, 3, 0, 7); g.fill();
        g.fillRect(x+w/2-0.8, y+3, 1.6, 6);
        // 貼られた広告（文字は入れない。他社の意匠に見せない）
        var ads=[['#D8494E','#F2E4C8'],['#2E6EC4','#F6EFD8'],['#3E7A4A','#F2E8CE']];
        for(i=0;i<3;i++){
          var ax=x+5, ay=y+16+i*15, aw=w-10, ah=12;
          g.fillStyle=ads[i][1]; rr(g,ax,ay,aw,ah,1); g.fill();
          g.fillStyle=ads[i][0]; g.fillRect(ax+2, ay+2, aw-4, 3.4);
          g.fillStyle='rgba(60,44,24,.35)';
          g.fillRect(ax+2, ay+7, aw-8, 1.2); g.fillRect(ax+2, ay+9.4, aw-12, 1.2);
        }
        var cg=g.createLinearGradient(x+3,0,x+w-3,0);     // 円柱の丸み
        cg.addColorStop(0,'rgba(255,255,255,.22)'); cg.addColorStop(.35,'rgba(255,255,255,0)');
        cg.addColorStop(1,'rgba(0,0,0,.28)');
        g.fillStyle=cg; rr(g,x+3,y+8,w-6,h-8,2); g.fill();
        o.glow=null;
      } else if(sh==='stand'){                            // 屋台（NY）。庇と湯気の出る鍋
        g.fillStyle=bg; rr(g,x+2,y+22,w-4,h-22,2); g.fill();
        g.fillStyle='rgba('+rim+',.45)'; g.fillRect(x+2,y+22,2.4,h-22);
        for(i=0;i<4;i++){                                  // 庇の縞
          g.fillStyle = (i%2) ? (c.awn||'#D8494E') : '#F4F0E4';
          g.fillRect(x+i*(w/4), y+8, w/4, 8);
        }
        g.fillStyle='rgba(0,0,0,.28)'; g.fillRect(x, y+16, w, 2);
        g.fillStyle='#8794AA'; g.fillRect(x+3, y+16, 2, 8); g.fillRect(x+w-5, y+16, 2, 8);
        var pw2=w-10, ph2=14, px2=x+5, py2=y+26;
        lightPanel(px2,py2,pw2,ph2, c.warm||['255,246,214','255,214,150','255,180,110']);
        g.fillStyle='rgba(40,30,20,.55)';                  // 鍋
        rr(g,px2+4,py2+3,pw2-8,ph2-6,1.5); g.fill();
        g.fillStyle='rgba(255,255,255,.22)';               // 湯気
        for(i=0;i<3;i++){ g.beginPath(); g.ellipse(px2+8+i*6, py2-4-i*2, 3.5, 2, 0, 0, 7); g.fill(); }
        g.fillStyle='rgba(0,0,0,.5)'; g.fillRect(x+4, y+h-8, w-8, 6);
        spill(px2,py2,pw2,ph2,'rgba(255,196,120,1)',.45);
        o.glow='warm'; o.gr=30;
      } else if(sh==='pillar'){                            // 石柱（カイロ）。溝と帯
        var pg2=g.createLinearGradient(x+4,0,x+w-4,0);
        pg2.addColorStop(0,b[0]); pg2.addColorStop(.35,b[1]); pg2.addColorStop(1,b[2]);
        g.fillStyle=pg2; g.fillRect(x+5,y+6,w-10,h-10);
        g.fillStyle=b[0]; g.fillRect(x+1,y,w-2,7); g.fillRect(x+2,y+h-5,w-4,5);   // 柱頭と基部
        g.fillStyle='rgba(255,255,255,.25)'; g.fillRect(x+1,y,w-2,1.4); g.fillRect(x+5,y+6,1.4,h-10);
        g.strokeStyle='rgba(70,48,20,.35)'; g.lineWidth=1;   // 縦の溝
        for(i=1;i<5;i++){ g.beginPath(); g.moveTo(x+5+i*(w-10)/5, y+7); g.lineTo(x+5+i*(w-10)/5, y+h-6); g.stroke(); }
        for(i=0;i<3;i++){                                    // 彫りの帯（実在の文字は入れない）
          var by2=y+14+i*15;
          g.fillStyle='rgba(70,48,20,.28)'; g.fillRect(x+6, by2, w-12, 8);
          g.fillStyle='rgba(240,220,170,.5)';
          g.fillRect(x+8, by2+2, 3, 4); g.fillRect(x+13, by2+2, 2, 4);
          g.fillRect(x+17, by2+2, 4, 4); g.fillRect(x+23, by2+2, 2, 4);
        }
        o.glow=null;
      } else if(sh==='serac'){                             // 氷柱（南極）。上が細く尖る
        g.fillStyle=bg;
        g.beginPath();
        g.moveTo(x+w*0.42,y); g.lineTo(x+w-6,y+18); g.lineTo(x+w-2,y+h);
        g.lineTo(x+3,y+h); g.lineTo(x+7,y+16); g.closePath(); g.fill();
        g.fillStyle='rgba(255,255,255,.5)';
        g.beginPath(); g.moveTo(x+w*0.42,y); g.lineTo(x+7,y+16); g.lineTo(x+13,y+h); g.lineTo(x+16,y+h); g.closePath(); g.fill();
        g.fillStyle='rgba(120,170,215,.35)';
        g.beginPath(); g.moveTo(x+w*0.42,y); g.lineTo(x+w-6,y+18); g.lineTo(x+w-2,y+h); g.lineTo(x+22,y+h); g.closePath(); g.fill();
        g.strokeStyle='rgba(255,255,255,.75)'; g.lineWidth=1.2;
        g.beginPath(); g.moveTo(x+w*0.42,y); g.lineTo(x+7,y+16); g.stroke();
        o.glow=null;
      } else if(sh==='steamer'){                           // 蒸籠の塔（香港）。湯気が上がる
        for(i=0;i<5;i++){
          var sy2=y+h-12-i*11, sw2=w-4-i*0.6;
          var sg2=g.createLinearGradient(x,0,x+w,0);
          sg2.addColorStop(0,b[0]); sg2.addColorStop(.35,b[1]); sg2.addColorStop(1,b[2]);
          g.fillStyle=sg2; rr(g,x+(w-sw2)/2, sy2, sw2, 12, 2); g.fill();
          g.fillStyle='rgba(255,236,190,.3)'; g.fillRect(x+(w-sw2)/2, sy2, sw2, 1.2);
          g.strokeStyle='rgba(60,40,18,.4)'; g.lineWidth=0.8;
          g.beginPath(); g.moveTo(x+(w-sw2)/2, sy2+8); g.lineTo(x+(w-sw2)/2+sw2, sy2+8); g.stroke();
        }
        g.fillStyle='rgba(255,255,255,.26)';               // 湯気
        for(i=0;i<4;i++){ g.beginPath(); g.ellipse(x+10+i*5, y+2+((i%2)*3), 5, 2.6, 0, 0, 7); g.fill(); }
        spill(x+4,y+h-24,w-8,20,'rgba(255,214,150,1)',.35);
        o.glow='warm'; o.gr=26;
      } else {                                             // vending（東京・池袋）
        g.fillStyle=bg; rr(g,x,y,w,h,2); g.fill();
        var rg=g.createLinearGradient(x,0,x+3,0);
        rg.addColorStop(0,'rgba('+rim+',.55)'); rg.addColorStop(1,'rgba('+rim+',0)');
        g.fillStyle=rg; g.fillRect(x,y+1,3,h-2);
        g.fillStyle='rgba(200,222,255,.35)'; g.fillRect(x+1.5,y,w-3,1);
        var hg2=g.createLinearGradient(0,y+3,0,y+13);
        hg2.addColorStop(0,(c.head&&c.head[0])||'#FF6B6B'); hg2.addColorStop(1,(c.head&&c.head[1])||'#C4243F');
        g.fillStyle=hg2; rr(g,x+2,y+3,w-4,10,1.5); g.fill();
        g.font='700 7px '+FONT; g.textAlign='center'; g.textBaseline='middle';
        g.fillStyle='rgba(255,240,230,.95)'; g.fillText(c.headText||'つめたい', x+w/2, y+8.5);
        g.textAlign='left'; g.textBaseline='alphabetic';
        var pw=w-8, ph=28, px=x+4, py=y+16;
        lightPanel(px,py,pw,ph, c.warm||['255,246,214','255,214,150','255,180,110']);
        var cols=c.cans||['#3E6FD0','#D0453E','#4FA84A','#E0A93C','#8B5AC8','#2FA8B8'], r=seq(11);
        for(i=0;i<3;i++) for(q=0;q<4;q++){
          var cx2=px+2.5+q*((pw-5)/4), cy2=py+2+i*((ph-4)/3);
          g.fillStyle=cols[(r()*cols.length)|0];
          rr(g,cx2,cy2,(pw-5)/4-1.5,(ph-4)/3-2,0.8); g.fill();
          g.fillStyle='rgba(255,255,255,.35)'; g.fillRect(cx2+0.6,cy2+0.6,1,(ph-4)/3-3);
        }
        var glr=g.createLinearGradient(px,py,px+pw,py+ph);
        glr.addColorStop(0,'rgba(255,255,255,.30)'); glr.addColorStop(.4,'rgba(255,255,255,.04)');
        glr.addColorStop(1,'rgba(255,255,255,.16)');
        g.fillStyle=glr; rr(g,px,py,pw,ph,1.5); g.fill();
        for(i=0;i<4;i++){
          g.fillStyle='rgba(255,206,120,.9)';
          rr(g,px+2+i*((pw-4)/4), py+ph+3, (pw-4)/4-3, 2.4, 1); g.fill();
        }
        g.fillStyle='rgba(6,9,22,.85)'; rr(g,x+4,y+h-12,w-8,8,1.5); g.fill();
        spill(px,py,pw,ph,'rgba(255,196,120,1)',.5);
        o.glow='warm'; o.gr=34;
      }
      if(c.glow===null) o.glow=null;
      return o;
    }

    /* ---- stack（40×86）。**長押しか2段ジャンプが要る高さ** ---- */
    function bakeObsStack(pal, c){
      c = c || {};
      var w=40,h=86,o=obsCanvas(w,h,14),g=o.g,x=14,y=14,i,rib;
      var kind=c.orb||'lantern', p=c.post||['#6B4B33','#4A3222','#241708'];
      var fg=g.createLinearGradient(x,0,x+w,0);
      fg.addColorStop(0,p[0]); fg.addColorStop(.3,p[1]); fg.addColorStop(1,p[2]);
      g.fillStyle=fg;
      g.fillRect(x+2,y,5,h); g.fillRect(x+w-7,y,5,h);        // 柱2本
      for(i=0;i<3;i++) g.fillRect(x+2,y+8+i*26,w-4,4);       // 貫
      g.fillStyle='rgba(210,180,140,.28)'; g.fillRect(x+2,y,5,1.2); g.fillRect(x+w-7,y,5,1.2);

      for(i=0;i<3;i++){
        var ly=y+16+i*26, cx3=x+w/2;
        if(kind==='pot'){                                    // 壺（カイロ）
          var og=g.createLinearGradient(cx3-11,0,cx3+11,0);
          og.addColorStop(0,'#D8A566'); og.addColorStop(.35,'#B47B3C'); og.addColorStop(1,'#6B4520');
          g.fillStyle=og;
          g.beginPath(); g.ellipse(cx3, ly+1, 10, 9, 0, 0, 7); g.fill();
          g.fillRect(cx3-4, ly-11, 8, 5);                     // 首
          g.fillStyle='#8A5C2C'; g.fillRect(cx3-6, ly-12, 12, 3);
          g.strokeStyle='rgba(90,58,24,.45)'; g.lineWidth=0.8;
          g.beginPath(); g.ellipse(cx3, ly+1, 7, 6.4, 0, 0, 7); g.stroke();
          g.fillStyle='rgba(255,240,200,.3)';
          g.beginPath(); g.ellipse(cx3-3.5, ly-2, 2.2, 3.4, -0.3, 0, 7); g.fill();
        } else if(kind==='barrel'){                           // 樽（パリ）
          var bg3=g.createLinearGradient(cx3-11,0,cx3+11,0);
          bg3.addColorStop(0,'#A0703E'); bg3.addColorStop(.35,'#7A5228'); bg3.addColorStop(1,'#442A10');
          g.fillStyle=bg3; rr(g,cx3-11, ly-9, 22, 18, 5); g.fill();
          g.fillStyle='#5B6070';                              // たが
          g.fillRect(cx3-11, ly-6, 22, 2.4); g.fillRect(cx3-11, ly+3.6, 22, 2.4);
          g.strokeStyle='rgba(50,30,10,.4)'; g.lineWidth=0.7;
          for(rib=-1;rib<=1;rib++){ g.beginPath(); g.moveTo(cx3+rib*5, ly-9); g.lineTo(cx3+rib*5, ly+9); g.stroke(); }
          g.fillStyle='rgba(255,236,200,.25)'; g.fillRect(cx3-11, ly-9, 22, 1.2);
        } else if(kind==='iceblock'){                         // 氷塊（南極）
          g.fillStyle='rgba(196,228,244,.92)';
          g.beginPath(); g.moveTo(cx3-11,ly+8); g.lineTo(cx3-8,ly-8); g.lineTo(cx3+9,ly-9);
          g.lineTo(cx3+11,ly+8); g.closePath(); g.fill();
          g.fillStyle='rgba(255,255,255,.65)';
          g.beginPath(); g.moveTo(cx3-8,ly-8); g.lineTo(cx3+9,ly-9); g.lineTo(cx3+2,ly+2); g.lineTo(cx3-6,ly+1); g.closePath(); g.fill();
          g.strokeStyle='rgba(110,165,205,.55)'; g.lineWidth=0.9;
          g.beginPath(); g.moveTo(cx3-6,ly+1); g.lineTo(cx3+11,ly+8); g.stroke();
        } else if(kind==='scaffold'){                         // 足場の灯り（NY）
          g.fillStyle='#4A5468'; g.fillRect(cx3-13, ly-3, 26, 5);
          g.fillStyle='#F2C94C';
          g.beginPath(); g.arc(cx3, ly+6, 4.5, 0, 7); g.fill();
          g.fillStyle='#2A3040';
          g.beginPath(); g.moveTo(cx3-6, ly+2); g.lineTo(cx3+6, ly+2); g.lineTo(cx3+4, ly+5); g.lineTo(cx3-4, ly+5); g.closePath(); g.fill();
          g.fillStyle='rgba(255,240,190,.35)';
          g.beginPath(); g.ellipse(cx3, ly+9, 8, 4, 0, 0, 7); g.fill();
        } else {                                              // 提灯（東京・池袋・香港）
          var lg=g.createLinearGradient(x+8,0,x+w-8,0);
          var lc=c.lantern||['#FFD9A0','#F26B4A','#93231C'];
          lg.addColorStop(0,lc[0]); lg.addColorStop(.35,lc[1]); lg.addColorStop(1,lc[2]);
          g.fillStyle=lg; g.beginPath(); g.ellipse(cx3, ly, 11, 8.5, 0, 0, 7); g.fill();
          g.strokeStyle='rgba(120,32,22,.5)'; g.lineWidth=0.7;
          for(rib=-2;rib<=2;rib++){
            g.beginPath(); g.ellipse(cx3, ly, 11*Math.cos(rib*0.34), 8.5, 0, 0, 7); g.stroke();
          }
          g.fillStyle='#2A1B10'; g.fillRect(cx3-3.5, ly-9.5, 7, 2); g.fillRect(cx3-3, ly+7.5, 6, 2);
          if(c.char){
            g.font='700 9px '+FONT; g.textAlign='center'; g.textBaseline='middle';
            g.fillStyle='rgba(60,20,12,.85)'; g.fillText(c.char, cx3, ly+0.5);
            g.textAlign='left'; g.textBaseline='alphabetic';
          }
        }
      }
      if(blurOK && c.glow!==null){
        g.save(); g.globalCompositeOperation='lighter'; g.filter='blur(6px)'; g.globalAlpha=c.glowA||.42;
        g.fillStyle=c.glowC||'rgba(255,150,90,1)'; g.fillRect(x+6,y+8,w-12,h-14); g.restore();
      }
      o.glow=(c.glow===null)?null:'warm'; o.gr=40;
      return o;
    }

    /* ---- bar（34×24）。**スライディングでくぐる。支柱は drawObsProc が接地面まで描く** ---- */
    function bakeObsBar(pal, c){
      c = c || {};
      var w=34,h=24,o=obsCanvas(w,h,12),g=o.g,x=12,y=12,i;
      var sh=c.shape||'stripe';

      if(sh==='cloth'){                                     // 日よけの布（カイロ）。縦縞が垂れる
        var cl=c.body||['#D8B87A','#9C7B44'];
        g.fillStyle=cl[1]; g.fillRect(x,y,w,3);
        for(i=0;i<7;i++){
          g.fillStyle = (i%2) ? cl[0] : (c.alt||'#B4543C');
          g.beginPath();
          g.moveTo(x+i*(w/7), y+2); g.lineTo(x+(i+1)*(w/7), y+2);
          g.lineTo(x+(i+1)*(w/7), y+9); g.lineTo(x+i*(w/7)+w/14, y+12);
          g.lineTo(x+i*(w/7), y+9); g.closePath(); g.fill();
        }
        g.fillStyle='rgba(255,240,200,.3)'; g.fillRect(x,y,w,1);
      } else if(sh==='awning'){                              // 天幕（パリ）。扇形に垂れる
        var aw=c.body||['#C0392B','#F4F0E4'];
        for(i=0;i<6;i++){
          g.fillStyle = (i%2) ? aw[1] : aw[0];
          g.beginPath();
          g.moveTo(x+i*(w/6), y); g.lineTo(x+(i+1)*(w/6), y);
          g.lineTo(x+(i+1)*(w/6), y+8);
          g.arc(x+(i+0.5)*(w/6), y+8, w/12, 0, Math.PI);
          g.lineTo(x+i*(w/6), y+8); g.closePath(); g.fill();
        }
        g.fillStyle='rgba(0,0,0,.22)'; g.fillRect(x,y+7.5,w,1.2);
        g.fillStyle='rgba(255,255,255,.28)'; g.fillRect(x,y,w,1);
      } else if(sh==='banner'){                              // 横断幕（香港）。縦書きの札が下がる
        var bn=c.body||['#C8102E','#8A0A1E'];
        var bg4=g.createLinearGradient(0,y,0,y+12);
        bg4.addColorStop(0,bn[0]); bg4.addColorStop(1,bn[1]);
        g.fillStyle=bg4; g.fillRect(x,y,w,12);
        g.fillStyle='#E8C23A'; g.fillRect(x,y,w,1.4); g.fillRect(x,y+10.6,w,1.4);
        if(c.text){
          g.font='700 8px '+FONT; g.textAlign='center'; g.textBaseline='middle';
          g.fillStyle='#FFE9A8'; g.fillText(c.text, x+w/2, y+6.2);
          g.textAlign='left'; g.textBaseline='alphabetic';
        }
        for(i=0;i<4;i++){                                    // 下がる房
          g.fillStyle='#E8C23A'; g.fillRect(x+4+i*8, y+12, 1.6, 5);
        }
      } else if(sh==='crowd'){
        /* 人だかり（池袋）。**bar はくぐる障害物なので、下に抜けが
           見えないと理不尽になる。**手すりの向こうに人が並ぶ形にして、
           人は箱の上（pad の側）へ出し、箱の下半分は手すりだけにした。
           顔は描かない。**シルエットだけ**にして、誰にも見えないようにする */
        var pc=c.body||['#1C2444','#0E1428'];
        for(i=0;i<5;i++){
          var hx=x+4+i*6.6, sc=0.9+((i*37)%5)*0.05, hy=y-6;
          g.fillStyle = (i%2) ? pc[0] : pc[1];
          g.beginPath(); g.arc(hx, hy, 3.2*sc, 0, 7); g.fill();          // 頭
          g.beginPath();                                                  // 肩から胸まで
          g.moveTo(hx-5.2*sc, y+11); g.lineTo(hx-3.6*sc, hy+5*sc);
          g.quadraticCurveTo(hx, hy+3*sc, hx+3.6*sc, hy+5*sc);
          g.lineTo(hx+5.2*sc, y+11); g.closePath(); g.fill();
        }
        var hg3=g.createLinearGradient(0,y+8,0,y+14);                     // 手すり
        hg3.addColorStop(0,'#8FA2C4'); hg3.addColorStop(1,'#3B4870');
        g.fillStyle=hg3; rr(g,x,y+8,w,6,2); g.fill();
        g.fillStyle='rgba(220,236,255,.5)'; g.fillRect(x,y+8,w,1.2);
        g.fillStyle='#2A3358';                                            // 手すりの子柱
        for(i=0;i<5;i++) g.fillRect(x+4+i*6.6, y+14, 1.8, 6);
      } else if(sh==='ice'){                                 // 氷のアーチ（南極）
        g.fillStyle='rgba(206,234,246,.95)'; rr(g,x,y,w,10,2); g.fill();
        g.fillStyle='rgba(255,255,255,.7)'; g.fillRect(x,y,w,2.4);
        g.fillStyle='rgba(120,170,215,.35)';
        for(i=0;i<5;i++){                                    // 下がるつらら
          g.beginPath();
          g.moveTo(x+3+i*7, y+10); g.lineTo(x+6+i*7, y+10); g.lineTo(x+4.5+i*7, y+10+4+((i*29)%5)); g.closePath(); g.fill();
        }
      } else {                                               // stripe（東京・NY）
        var st=c.body||['#F5D14A','#B98A17'];
        var sg3=g.createLinearGradient(0,y,0,y+11);
        sg3.addColorStop(0,st[0]); sg3.addColorStop(1,st[1]);
        g.fillStyle=sg3; rr(g,x,y,w,11,1.2); g.fill();
        g.save(); rr(g,x,y,w,11,1.2); g.clip();
        g.fillStyle=c.stripe||'rgba(24,20,10,.85)';
        for(i=-1;i<7;i++){
          g.beginPath();
          g.moveTo(x+i*8, y+11); g.lineTo(x+4+i*8, y+11);
          g.lineTo(x+11+i*8, y); g.lineTo(x+7+i*8, y);
          g.closePath(); g.fill();
        }
        g.restore();
        g.fillStyle='rgba(255,240,190,.35)'; g.fillRect(x,y,w,0.9);
      }
      o.glow=(c.glow===undefined)?'warm':c.glow; o.gr=22;
      o.lamp=!!c.lamp; o.posts=(c.posts!==false);
      o.postC=c.postC||'#2A3358';
      return o;
    }

    /* ---- fly（34×28）。色だけ都市で変える ---- */
    function bakeObsFly(pal, c, frame){
      c = c || {};
      var w=34,h=28,o=obsCanvas(w,h,10),g=o.g,x=10,y=10;
      var b=c.body||['#3A4468','#1A2140','#0A0E22'];
      var bg=g.createLinearGradient(x,y,x+w,y+h);
      bg.addColorStop(0,b[0]); bg.addColorStop(.5,b[1]); bg.addColorStop(1,b[2]);
      g.fillStyle=bg;
      g.beginPath(); g.ellipse(x+w*0.52, y+h*0.6, w*0.28, h*0.26, 0, 0, 7); g.fill();
      g.beginPath(); g.ellipse(x+w*0.26, y+h*0.44, w*0.15, h*0.17, 0, 0, 7); g.fill();
      g.fillStyle=c.beak||'#E8A23A';
      g.beginPath(); g.moveTo(x+w*0.11,y+h*0.44); g.lineTo(x+w*0.02,y+h*0.5);
      g.lineTo(x+w*0.13,y+h*0.55); g.closePath(); g.fill();
      g.fillStyle='rgba(240,246,255,.9)';
      g.beginPath(); g.arc(x+w*0.24, y+h*0.4, 1.5, 0, 7); g.fill();
      g.fillStyle='#0A0E22';
      g.beginPath(); g.arc(x+w*0.24, y+h*0.4, 0.8, 0, 7); g.fill();
      g.fillStyle=c.wing || bg;                                // 翼（2コマ）
      g.beginPath();
      if(frame===0){
        g.moveTo(x+w*0.42,y+h*0.5); g.quadraticCurveTo(x+w*0.6,y-h*0.1,x+w*0.9,y+h*0.12);
        g.quadraticCurveTo(x+w*0.72,y+h*0.48,x+w*0.48,y+h*0.62);
      } else {
        g.moveTo(x+w*0.42,y+h*0.55); g.quadraticCurveTo(x+w*0.66,y+h*0.7,x+w*0.98,y+h*0.9);
        g.quadraticCurveTo(x+w*0.7,y+h*0.72,x+w*0.48,y+h*0.66);
      }
      g.closePath(); g.fill();
      // 光源側の縁。**背景と同じ明度だと鳥が消える**（東京の夜で実際に消えた）
      g.strokeStyle=c.rim||'rgba(180,205,255,.55)'; g.lineWidth=1.2;
      g.beginPath(); g.ellipse(x+w*0.52, y+h*0.6, w*0.28, h*0.26, 0, 3.6, 5.6); g.stroke();
      g.beginPath(); g.ellipse(x+w*0.26, y+h*0.44, w*0.15, h*0.17, 0, 2.9, 5.2); g.stroke();
      g.fillStyle=b[0];
      g.beginPath(); g.moveTo(x+w*0.76,y+h*0.66); g.lineTo(x+w*0.96,y+h*0.84);
      g.lineTo(x+w*0.78,y+h*0.74); g.closePath(); g.fill();
      o.glow=null;
      return o;
    }

    /* =============== 敵の絵（enemy-spec 3章） ===============
       **3つの要件（3章「絵の要件」）をこの3関数で守る。**
         1. 障害物・仕入れ品のどちらとも違うシルエット。**目を持たせる**のが最も効く
         2. 敵だと一目で分かる色（暗めの彩度、または赤系の差し色）
         3. 仕入れ品の光暈とは違う表現。**敵は光らない**（o.glow は必ず null）

       都市ごとの姿は PROC_PAL の foe:{walker,hopper,flyer} で shape と色を渡す。
       障害物と同じく popObs() に通して縁と暗幕を付ける（背景に埋もれさせない）。 */
    /* 目。**これが敵の記号。**白目＋怒り眉を焼き、**瞳は焼かない。**
       瞳は drawFoe が毎フレーム描き、プレイヤーの方を見る（2026-09-16 の指摘3
       「目を大きくし、瞳を動かす」）。位置は rec に残して焼き込みに持たせる。
       目の大きさは以前の 1.45 倍。 */
    function foeEyes(g, cx, cy, r, look, rec){
      var i; r = r*1.45;
      for(i=0;i<2;i++){
        var ex = cx + (i ? r*1.25 : -r*1.25);
        g.fillStyle='rgba(248,250,255,.97)';
        g.beginPath(); g.ellipse(ex, cy, r, r*1.12, 0, 0, 7); g.fill();
        g.strokeStyle='rgba(20,16,26,.55)'; g.lineWidth=0.8;
        g.beginPath(); g.ellipse(ex, cy, r, r*1.12, 0, 0, 7); g.stroke();
        if(rec) rec.push({ x:ex, y:cy, r:r });
      }
      g.strokeStyle='rgba(20,16,26,.8)'; g.lineWidth=Math.max(1.2, r*0.42);
      g.beginPath();
      g.moveTo(cx - r*2.3, cy - r*1.7); g.lineTo(cx - r*0.4, cy - r*1.0);
      g.moveTo(cx + r*2.3, cy - r*1.7); g.lineTo(cx + r*0.4, cy - r*1.0);
      g.stroke();
    }
    /* 踏める上面の帯（指摘3「踏む場所の示唆」）。体の輪郭の内側だけ、上端 6px を明るくする */
    function foeTopBand(g, o, x, y, w){
      g.save(); g.globalCompositeOperation='source-atop';
      var tb=g.createLinearGradient(0, y-1, 0, y+7);
      tb.addColorStop(0,'rgba(255,255,255,.70)'); tb.addColorStop(1,'rgba(255,255,255,0)');
      g.fillStyle=tb; g.fillRect(x-4, y-2, w+8, 9);
      g.restore();
    }
    /* 歩く足（2コマ）。どの形にも同じ足を付け、コマで前後を入れ替える */
    function foeLegs(g, x, y, w, h, frame, col){
      var lx = x+w*0.30, rx = x+w*0.62, ly = frame ? -1.5 : 1.5;
      g.fillStyle = col || '#1A1410';
      rr(g, lx-3 + (frame?2:-2), y+h-6+ly, 6, 6.5, 1.5); g.fill();
      rr(g, rx-3 - (frame?2:-2), y+h-6-ly, 6, 6.5, 1.5); g.fill();
    }
    /* **敵だけ明るい縁取り**（指摘3）。障害物には付けないので、一目で区別がつく。
       シルエットを黄白で 1.6px ずらして8方向に置き、その上に本体を戻す。
       popObs より前に掛ける（popObs の縁と暗幕はこの外側に付く） */
    function foeOutline(o){
      /* **必ず論理サイズ（o.w, o.h）を渡して描く。**焼き込み canvas は BAKE 倍の
         画素を持つので、サイズ無しで drawImage すると2倍に膨らむ
         （実際に膨らんで、瞳が体の上に浮いて見えた） */
      var t = mkc(o.w, o.h), i;
      t.g.drawImage(o.c, 0, 0, o.w, o.h);
      t.g.globalCompositeOperation='source-in';
      t.g.fillStyle='#FFE98A'; t.g.fillRect(0,0,o.w,o.h);
      var out = mkc(o.w, o.h), g = out.g;
      for(i=0;i<8;i++) g.drawImage(t.c, Math.cos(i*0.7854)*1.6, Math.sin(i*0.7854)*1.6, o.w, o.h);
      g.drawImage(o.c, 0, 0, o.w, o.h);
      out.pad=o.pad; out.bw=o.bw; out.bh=o.bh; out.glow=null; out.eyes=o.eyes;
      return out;
    }
    /* ---- walker（32×32。地面を歩いて来る） ---- */
    function bakeFoeWalk(pal, c, frame){
      c = c || {}; frame = frame || 0;
      var w=32,h=32,o=obsCanvas(w,h,10),g=o.g,x=10,y=10,i,rec=[];
      var sh=c.shape||'carton', b=c.body||['#6B4A2A','#4E351C','#2A1B0C'];
      var bg=g.createLinearGradient(x,y,x+w,y+h);
      bg.addColorStop(0,b[0]); bg.addColorStop(.5,b[1]); bg.addColorStop(1,b[2]);
      g.fillStyle=bg;
      if(sh==='beetle'){                                  // スカラベ（カイロ）
        g.beginPath(); g.ellipse(x+w*0.5, y+h*0.6, w*0.42, h*0.34, 0, 0, 7); g.fill();
        g.strokeStyle='rgba(20,16,10,.5)'; g.lineWidth=1.2;
        g.beginPath(); g.moveTo(x+w*0.5,y+h*0.27); g.lineTo(x+w*0.5,y+h*0.93); g.stroke();
        g.fillStyle=b[2];                                  // 角と脚
        g.beginPath(); g.moveTo(x+w*0.34,y+h*0.3); g.lineTo(x+w*0.5,y+h*0.1);
        g.lineTo(x+w*0.66,y+h*0.3); g.closePath(); g.fill();
        for(i=0;i<3;i++){
          g.fillRect(x+w*0.16+i*w*0.24, y+h*0.86, 3, h*0.14);
        }
        foeEyes(g, x+w*0.5, y+h*0.46, 2.4, undefined, rec);
      } else if(sh==='rat'){                               // ネズミ（パリ）
        g.beginPath(); g.ellipse(x+w*0.46, y+h*0.66, w*0.36, h*0.26, 0, 0, 7); g.fill();
        g.beginPath(); g.ellipse(x+w*0.2, y+h*0.5, w*0.2, h*0.19, 0, 0, 7); g.fill();
        g.fillStyle=c.ear||'#B07A86';                      // 耳
        g.beginPath(); g.arc(x+w*0.26, y+h*0.3, w*0.12, 0, 7); g.fill();
        g.strokeStyle=b[1]; g.lineWidth=2;                 // しっぽ
        g.beginPath(); g.moveTo(x+w*0.8,y+h*0.72);
        g.quadraticCurveTo(x+w*1.0,y+h*0.5,x+w*0.86,y+h*0.32); g.stroke();
        g.fillStyle='#F0E4D0';                             // 前歯
        g.fillRect(x+w*0.05, y+h*0.56, 3.4, 3);
        foeEyes(g, x+w*0.2, y+h*0.46, 2.1, 0.5, rec);
      } else if(sh==='bag'){                               // ごみ袋モンスター（NY）
        for(i=0;i<3;i++){
          g.fillStyle=bg;
          g.beginPath(); g.ellipse(x+w*0.28+i*w*0.22, y+h*0.72-(i===1?h*0.1:0),
                                   w*0.22, h*0.26, 0, 0, 7); g.fill();
        }
        g.fillStyle=b[2];
        g.beginPath(); g.ellipse(x+w*0.5, y+h*0.24, w*0.1, h*0.08, 0, 0, 7); g.fill();
        g.fillStyle='rgba(255,255,255,.12)';
        g.beginPath(); g.ellipse(x+w*0.34, y+h*0.5, w*0.08, h*0.12, -0.4, 0, 7); g.fill();
        foeEyes(g, x+w*0.5, y+h*0.6, 2.6, undefined, rec);
      } else if(sh==='penguin'){                           // ペンギン（南極）
        g.beginPath(); g.ellipse(x+w*0.5, y+h*0.62, w*0.32, h*0.36, 0, 0, 7); g.fill();
        g.fillStyle=c.belly||'#F2F6FA';
        g.beginPath(); g.ellipse(x+w*0.52, y+h*0.68, w*0.2, h*0.28, 0, 0, 7); g.fill();
        g.fillStyle=c.beak||'#E8A23A';                     // くちばしと足
        g.beginPath(); g.moveTo(x+w*0.2,y+h*0.44); g.lineTo(x+w*0.04,y+h*0.52);
        g.lineTo(x+w*0.2,y+h*0.56); g.closePath(); g.fill();
        g.fillRect(x+w*0.3, y+h*0.94, 6, 2.6); g.fillRect(x+w*0.56, y+h*0.94, 6, 2.6);
        foeEyes(g, x+w*0.42, y+h*0.36, 2.2, 0.4, rec);
      } else {                                             // 段ボールお化け（東京・池袋）
        g.fillRect(x+w*0.08, y+h*0.18, w*0.84, h*0.7);
        g.fillStyle=c.tape||'rgba(228,214,180,.8)';        // テープ
        g.fillRect(x+w*0.46, y+h*0.18, w*0.1, h*0.7);
        g.fillRect(x+w*0.08, y+h*0.3, w*0.84, h*0.1);
        g.fillStyle=b[2];                                  // 開いたフタ（角のように立てる）
        g.beginPath(); g.moveTo(x+w*0.08,y+h*0.18); g.lineTo(x+w*0.0,y+h*0.02);
        g.lineTo(x+w*0.3,y+h*0.16); g.closePath(); g.fill();
        g.beginPath(); g.moveTo(x+w*0.92,y+h*0.18); g.lineTo(x+w*1.0,y+h*0.02);
        g.lineTo(x+w*0.7,y+h*0.16); g.closePath(); g.fill();
        g.fillRect(x+w*0.22, y+h*0.88, 5, h*0.12); g.fillRect(x+w*0.64, y+h*0.88, 5, h*0.12);
        foeEyes(g, x+w*0.5, y+h*0.58, 2.7, undefined, rec);
      }
      foeLegs(g, x, y, w, h, frame, b[2]);                 // 歩く足（2コマ）
      foeTopBand(g, o, x, y+h*0.12, w);                    // 踏める上面の帯
      o.glow=null;                                         // **敵は光らない**（3章）
      o.eyes=rec;
      return o;
    }
    /* ---- hopper（30×30。その場で跳ねる） ---- */
    function bakeFoeHop(pal, c){
      c = c || {};
      var w=30,h=30,o=obsCanvas(w,h,10),g=o.g,x=10,y=10,i,rec=[];
      var sh=c.shape||'lantern', b=c.body||['#E4643C','#C03A28','#6E1C14'];
      var bg=g.createLinearGradient(x,y,x+w,y+h);
      bg.addColorStop(0,b[0]); bg.addColorStop(.55,b[1]); bg.addColorStop(1,b[2]);
      g.fillStyle=bg;
      if(sh==='jar'){                                      // 壺お化け（カイロ）
        g.beginPath();
        g.moveTo(x+w*0.34,y+h*0.12); g.lineTo(x+w*0.66,y+h*0.12);
        g.quadraticCurveTo(x+w*1.02,y+h*0.6,x+w*0.5,y+h*0.98);
        g.quadraticCurveTo(x-w*0.02,y+h*0.6,x+w*0.34,y+h*0.12);
        g.closePath(); g.fill();
        g.fillStyle=b[2]; g.fillRect(x+w*0.3, y+h*0.06, w*0.4, h*0.09);
        g.strokeStyle='rgba(20,14,8,.35)'; g.lineWidth=1;
        g.beginPath(); g.moveTo(x+w*0.16,y+h*0.56); g.lineTo(x+w*0.84,y+h*0.56); g.stroke();
        foeEyes(g, x+w*0.5, y+h*0.42, 2.4, undefined, rec);
      } else if(sh==='balloon'){                           // 風船（パリ）
        g.beginPath(); g.ellipse(x+w*0.5, y+h*0.44, w*0.36, h*0.4, 0, 0, 7); g.fill();
        g.fillStyle=b[2];
        g.beginPath(); g.moveTo(x+w*0.44,y+h*0.84); g.lineTo(x+w*0.56,y+h*0.84);
        g.lineTo(x+w*0.5,y+h*0.94); g.closePath(); g.fill();
        g.strokeStyle='rgba(30,24,20,.5)'; g.lineWidth=1;
        g.beginPath(); g.moveTo(x+w*0.5,y+h*0.94);
        g.quadraticCurveTo(x+w*0.62,y+h*1.0,x+w*0.54,y+h); g.stroke();
        g.fillStyle='rgba(255,255,255,.22)';
        g.beginPath(); g.ellipse(x+w*0.36, y+h*0.3, w*0.1, h*0.14, -0.5, 0, 7); g.fill();
        foeEyes(g, x+w*0.5, y+h*0.44, 2.3, undefined, rec);
      } else if(sh==='slice'){                             // ピザ（NY）
        g.beginPath();
        g.moveTo(x+w*0.5,y+h*0.9); g.lineTo(x+w*0.1,y+h*0.16);
        g.lineTo(x+w*0.9,y+h*0.16); g.closePath(); g.fill();
        g.fillStyle=c.crust||'#C98A3E';
        g.fillRect(x+w*0.08, y+h*0.08, w*0.84, h*0.11);
        g.fillStyle=c.topping||'#A82A22';                  // 具
        for(i=0;i<3;i++){
          g.beginPath(); g.arc(x+w*(0.34+i*0.16), y+h*(0.38+(i%2)*0.16), 2.4, 0, 7); g.fill();
        }
        foeEyes(g, x+w*0.5, y+h*0.5, 2.2, undefined, rec);
      } else if(sh==='ball'){                              // 雪だま／肉まん／ガチャ
        g.beginPath(); g.arc(x+w*0.5, y+h*0.52, w*0.4, 0, 7); g.fill();
        if(c.seam){                                        // ガチャは合わせ目、肉まんは襞
          g.strokeStyle=c.seam; g.lineWidth=1.4;
          g.beginPath(); g.moveTo(x+w*0.1,y+h*0.52); g.lineTo(x+w*0.9,y+h*0.52); g.stroke();
        }
        g.fillStyle='rgba(255,255,255,.2)';
        g.beginPath(); g.ellipse(x+w*0.36, y+h*0.36, w*0.12, h*0.1, -0.5, 0, 7); g.fill();
        foeEyes(g, x+w*0.5, y+h*0.5, 2.5, undefined, rec);
      } else {                                             // 提灯お化け（東京・香港）
        g.beginPath(); g.ellipse(x+w*0.5, y+h*0.52, w*0.36, h*0.42, 0, 0, 7); g.fill();
        g.strokeStyle='rgba(30,14,10,.35)'; g.lineWidth=0.9;
        for(i=1;i<4;i++){
          g.beginPath(); g.ellipse(x+w*0.5, y+h*0.52, w*0.36*(1-i*0.02), h*0.42, 0,
                                   -0.6+i*0.5, -0.2+i*0.5); g.stroke();
        }
        g.fillStyle=b[2];                                  // 上下の口輪
        g.fillRect(x+w*0.34, y+h*0.06, w*0.32, h*0.09);
        g.fillRect(x+w*0.34, y+h*0.88, w*0.32, h*0.08);
        g.fillStyle=c.mark||'rgba(250,240,220,.9)';        // 赤提灯の白い帯
        g.fillRect(x+w*0.18, y+h*0.46, w*0.64, h*0.1);
        foeEyes(g, x+w*0.5, y+h*0.34, 2.3, undefined, rec);
        g.fillStyle='#8E1B18';                             // 舌
        g.beginPath(); g.moveTo(x+w*0.44,y+h*0.66); g.lineTo(x+w*0.56,y+h*0.66);
        g.lineTo(x+w*0.5,y+h*0.8); g.closePath(); g.fill();
      }
      foeTopBand(g, o, x, y+h*0.08, w);
      o.glow=null;
      o.eyes=rec;
      return o;
    }
    /* ---- flyer（30×26。2コマで羽ばたく） ---- */
    function bakeFoeFly(pal, c, frame){
      c = c || {};
      var w=30,h=26,o=obsCanvas(w,h,10),g=o.g,x=10,y=10,i,rec=[];
      var sh=c.shape||'bird', b=c.body||['#2E3550','#1C2138','#0C0F1C'];
      var bg=g.createLinearGradient(x,y,x+w,y+h);
      bg.addColorStop(0,b[0]); bg.addColorStop(.5,b[1]); bg.addColorStop(1,b[2]);
      g.fillStyle=bg;
      if(sh==='drone'){                                    // ドローン（NY・池袋）
        g.fillRect(x+w*0.3, y+h*0.42, w*0.4, h*0.3);
        g.strokeStyle=b[1]; g.lineWidth=2;
        for(i=0;i<2;i++){
          var ax = i ? x+w*0.7 : x+w*0.3;
          g.beginPath(); g.moveTo(ax, y+h*0.5); g.lineTo(ax+(i?w*0.2:-w*0.2), y+h*0.26); g.stroke();
          g.fillStyle='rgba(200,215,240,'+(frame?0.5:0.22)+')';   // 回転翼（2コマ）
          g.beginPath(); g.ellipse(ax+(i?w*0.2:-w*0.2), y+h*0.24, w*0.16, h*0.05, 0, 0, 7); g.fill();
          g.fillStyle=bg;
        }
        // ドローンは目の代わりに大きな1つ目のレンズ。瞳は drawFoe が動かす
        g.fillStyle=c.lens||'#E4453A';
        g.beginPath(); g.arc(x+w*0.5, y+h*0.6, 4.6, 0, 7); g.fill();
        g.fillStyle='rgba(248,250,255,.97)';
        g.beginPath(); g.arc(x+w*0.5, y+h*0.6, 3.2, 0, 7); g.fill();
        rec.push({ x:x+w*0.5, y:y+h*0.6, r:3.0 });
      } else if(sh==='bat'){                               // コウモリ（香港）
        g.beginPath(); g.ellipse(x+w*0.5, y+h*0.56, w*0.18, h*0.26, 0, 0, 7); g.fill();
        for(i=0;i<2;i++){                                   // 翼（2コマで上下）
          var s = i ? 1 : -1, wy = frame ? h*0.18 : -h*0.06;
          g.beginPath();
          g.moveTo(x+w*0.5, y+h*0.5);
          g.quadraticCurveTo(x+w*(0.5+s*0.34), y+h*0.3+wy, x+w*(0.5+s*0.5), y+h*0.56+wy);
          g.quadraticCurveTo(x+w*(0.5+s*0.3), y+h*0.6, x+w*0.5, y+h*0.72);
          g.closePath(); g.fill();
        }
        g.fillStyle=b[2];                                   // 耳
        g.beginPath(); g.moveTo(x+w*0.42,y+h*0.34); g.lineTo(x+w*0.38,y+h*0.16);
        g.lineTo(x+w*0.5,y+h*0.3); g.closePath(); g.fill();
        g.beginPath(); g.moveTo(x+w*0.58,y+h*0.34); g.lineTo(x+w*0.62,y+h*0.16);
        g.lineTo(x+w*0.5,y+h*0.3); g.closePath(); g.fill();
        foeEyes(g, x+w*0.5, y+h*0.5, 1.9, undefined, rec);
      } else {                                              // 鳥（カラス・ハゲタカ・ハト・ユキドリ）
        g.beginPath(); g.ellipse(x+w*0.54, y+h*0.6, w*0.3, h*0.28, 0, 0, 7); g.fill();
        g.beginPath(); g.ellipse(x+w*0.26, y+h*0.44, w*0.16, h*0.19, 0, 0, 7); g.fill();
        g.fillStyle=c.beak||'#E8A23A';
        g.beginPath(); g.moveTo(x+w*0.12,y+h*0.44); g.lineTo(x+w*0.0,y+h*0.5);
        g.lineTo(x+w*0.13,y+h*0.56); g.closePath(); g.fill();
        g.fillStyle=c.wing||bg;                             // 翼（2コマ）
        g.beginPath();
        if(frame===0){
          g.moveTo(x+w*0.44,y+h*0.5); g.quadraticCurveTo(x+w*0.62,y-h*0.08,x+w*0.92,y+h*0.14);
          g.quadraticCurveTo(x+w*0.74,y+h*0.48,x+w*0.5,y+h*0.62);
        } else {
          g.moveTo(x+w*0.44,y+h*0.55); g.quadraticCurveTo(x+w*0.68,y+h*0.72,x+w*0.98,y+h*0.9);
          g.quadraticCurveTo(x+w*0.72,y+h*0.72,x+w*0.5,y+h*0.66);
        }
        g.closePath(); g.fill();
        foeEyes(g, x+w*0.26, y+h*0.4, 1.8, 0.5, rec);
      }
      foeTopBand(g, o, x, y+h*0.1, w);
      o.glow=null;
      o.eyes=rec;
      return o;
    }

    /* 踏切（東京のフィナーレ tk12）。判定は遮断機だけ、電車は演出 */
    function bakeGate(pal){
      var w=36,h=34,o=obsCanvas(w,h,10),g=o.g,x=10,y=10,i;
      g.fillStyle='#F2F2EA'; g.fillRect(x+3,y,7,h);            // 柱（黄と黒の斜め帯）
      g.save(); g.beginPath(); g.rect(x+3,y,7,h); g.clip();
      g.fillStyle='#191B22';
      for(i=-1;i<7;i++){
        g.beginPath(); g.moveTo(x+3+i*7,y+h); g.lineTo(x+6+i*7,y+h);
        g.lineTo(x+13+i*7,y); g.lineTo(x+10+i*7,y); g.closePath(); g.fill();
      }
      g.restore();
      g.strokeStyle='#3A4460'; g.lineWidth=2;                  // 筋交い（下をくぐれそうに見せない）
      g.beginPath(); g.moveTo(x+9,y+4); g.lineTo(x+w-2,y+h);
      g.moveTo(x+w-2,y+10); g.lineTo(x+14,y+h); g.stroke();
      g.fillStyle='#3A4460'; g.fillRect(x+3,y+h-3,w-4,3);
      g.fillStyle='rgba(190,215,255,.35)'; g.fillRect(x+3,y,1.2,h);
      o.glow=null;
      return o;
    }
    function bakeArm(pal){
      var w=58,h=10,o=obsCanvas(w,h,4),g=o.g,x=4,y=4,i;
      g.fillStyle='#F2F2EA'; rr(g,x,y,w,h,1.5); g.fill();
      g.save(); rr(g,x,y,w,h,1.5); g.clip();
      g.fillStyle='#D8232A';
      for(i=0;i<5;i++) g.fillRect(x+4+i*12, y, 6, h);
      g.restore();
      g.fillStyle='rgba(255,255,255,.4)'; g.fillRect(x,y,w,1);
      o.glow=null;
      return o;
    }
    function bakeSignal(pal){
      var w=26,h=84,o=obsCanvas(w,h,8),g=o.g,x=8,y=8;
      /* 柱。夜の街を背景にすると細い濃色は消えるので、
         実物どおり黄と黒の斜め帯にして明るい側を残す */
      var px3=x+w/2-3, i3;
      g.fillStyle='#E8C23A'; g.fillRect(px3, y+22, 6, h-22);
      g.save(); g.beginPath(); g.rect(px3, y+22, 6, h-22); g.clip();
      g.fillStyle='#1A1E2C';
      for(i3=0;i3<9;i3++){
        g.beginPath();
        g.moveTo(px3, y+22+i3*8); g.lineTo(px3+3, y+22+i3*8);
        g.lineTo(px3+9, y+18+i3*8); g.lineTo(px3+6, y+18+i3*8);
        g.closePath(); g.fill();
      }
      g.restore();
      g.fillStyle='rgba(255,255,255,.35)'; g.fillRect(px3, y+22, 1.2, h-22);
      g.fillStyle='#1A2140'; rr(g, x, y, w, 24, 3); g.fill();  // 頭
      g.fillStyle='#F2F2EA';                                   // ×印
      g.save(); g.translate(x+w/2, y+12); g.rotate(Math.PI/4);
      g.fillRect(-11,-1.6,22,3.2); g.fillRect(-1.6,-11,3.2,22); g.restore();
      o.pad=8; o.bw=w; o.bh=h;
      return o;
    }
    function bakeTrainCar(pal, head){
      var w=120,h=68,o=mkc(w,h),g=o.g,i;
      var bg=g.createLinearGradient(0,0,0,h);
      bg.addColorStop(0,'#D8DEE8'); bg.addColorStop(.5,'#9AA6BC'); bg.addColorStop(1,'#3C4560');
      g.fillStyle=bg; rr(g, 2, 4, w-4, h-14, head?7:3); g.fill();
      g.fillStyle='#7FC441'; g.fillRect(2, 26, w-4, 7);        // 帯（山手線を思わせる緑）
      g.fillStyle='rgba(255,255,255,.4)'; g.fillRect(2,5,w-4,1.4);
      g.fillStyle='#141A2C';                                    // 窓
      for(i=0;i<3;i++) rr(g, (head?20:14)+i*33, 10, 26, 14, 2), g.fill();
      if(head){ rr(g, 6, 12, 12, 12, 2); g.fill(); }
      g.fillStyle='#1A2140'; g.fillRect(6, h-12, w-12, 8);      // 台車
      g.fillStyle='#0A0E22';
      for(i=0;i<2;i++){ g.beginPath(); g.arc(24+i*(w-48), h-6, 6, 0, 7); g.fill(); }
      if(head){                                                 // 前照灯
        g.fillStyle='rgba(255,244,200,.95)';
        g.beginPath(); g.arc(9, h-20, 3.2, 0, 7); g.fill();
      }
      return o;
    }
    /* 店（ゴール）。ブランド色の庇と看板。窓に灯りを入れて「開いている」ことを見せる */
    function bakeShop(){
      var w=150,h=150,pad=16,o=mkc(w+pad*2,h+pad*2),g=o.g,x=pad,y=pad,i;
      var bg=g.createLinearGradient(0,y,0,y+h);
      bg.addColorStop(0,'#FFFFFF'); bg.addColorStop(.55,'#E7F3F8'); bg.addColorStop(1,'#BFD9E4');
      g.fillStyle=bg; g.fillRect(x,y,w,h);
      g.fillStyle='rgba(255,255,255,.9)'; g.fillRect(x,y,2,h);
      g.fillStyle='rgba(20,50,66,.14)'; g.fillRect(x+w-3,y,3,h);
      // ショーウィンドウ（暖色の灯り）
      var ww=w-30, wh=52, wx=x+15, wy=y+64;
      var wg=g.createLinearGradient(0,wy,0,wy+wh);
      wg.addColorStop(0,'rgba(255,248,222,.98)'); wg.addColorStop(1,'rgba(255,214,150,.9)');
      g.fillStyle=wg; g.fillRect(wx,wy,ww,wh);
      g.fillStyle='rgba(30,70,90,.5)';
      for(i=1;i<3;i++) g.fillRect(wx+i*ww/3-1, wy, 2, wh);
      g.fillStyle='rgba(40,80,100,.28)'; g.fillRect(wx, wy+wh-16, ww, 2);
      for(i=0;i<5;i++){                                        // 棚に並ぶ商品（仕入れたもの）
        g.fillStyle=['#45C6EC','#FC930A','#B7D029','#FF6B6B','#8B5AC8'][i];
        g.fillRect(wx+8+i*22, wy+wh-30, 13, 14);
      }
      // 扉
      g.fillStyle='rgba(20,50,66,.85)'; g.fillRect(x+w/2-17, y+h-46, 34, 46);
      g.fillStyle='rgba(255,240,200,.5)'; g.fillRect(x+w/2-13, y+h-42, 26, 34);
      g.fillStyle='#41caec'; g.fillRect(x-8, y-12, w+16, 14);  // 庇
      g.fillStyle='#2ba9cd'; g.fillRect(x-8, y+2, w+16, 3);
      g.fillStyle='#0e2530'; g.fillRect(x+8, y+20, w-16, 26);  // 看板
      g.fillStyle='#b7d029'; g.fillRect(x+8, y+46, w-16, 3);
      var label='INFOLENS GEEK SHOP', fsz=12;
      g.textAlign='center';
      g.font='700 '+fsz+'px '+FONT;
      while(fsz>7 && g.measureText(label).width > w-24){ fsz--; g.font='700 '+fsz+'px '+FONT; }
      g.fillStyle='#eef7fa'; g.fillText(label, x+w/2, y+38);
      g.textAlign='left';
      if(blurOK){
        g.save(); g.globalCompositeOperation='lighter'; g.filter='blur(9px)'; g.globalAlpha=.55;
        g.fillStyle='rgba(255,214,150,1)'; g.fillRect(wx,wy,ww,wh); g.restore();
      }
      o.pad=pad; o.bw=w; o.bh=h;
      return o;
    }

    /* ---- 都市ぶんの焼き込み一式 ---- */
    var PROC={}, PROC_MS={}, bakeLastMS=0, bakeLastId='';
    /* 焼き込みの実測。**7都市に広げると canvas が数百枚になる**ので、
       枚数・画素・所要時間を数えられるようにしておく（data-debug のときだけ公開）。
       走査は PROC を舐めるだけで、ゲーム中は誰も呼ばない */
    /* 1都市ぶんの canvas の枚数と画素を数える。**焼いた直後に1回だけ呼ぶ。**
       毎フレーム数えると、測るために遅くなって本末転倒になる */
    function procCount(P){
      var n={n:0,px:0};
      (function walk(v){
        if(!v) return;
        if(v.c && v.c.width){ n.n++; n.px += v.c.width*v.c.height; return; }
        if(Object.prototype.toString.call(v)==='[object Array]'){
          for(var i=0;i<v.length;i++) walk(v[i]);
          return;
        }
        if(typeof v==='object'){
          for(var k in v) if(v.hasOwnProperty(k) && k!=='pal') walk(v[k]);
        }
      })(P);
      return n;
    }
    // いま抱えている都市の合計（キャッシュ済みの数を足すだけ）
    function procLoad(){
      var id, n=0, px=0, c=0;
      for(id in PROC) if(PROC.hasOwnProperty(id)){
        c++; n += (PROC[id].cn||0); px += (PROC[id].cpx||0);
      }
      return { cities:c, sheets:n, mb:px*4/1048576 };
    }
    function procStats(){
      var out=[], id, L;
      for(id in PROC) if(PROC.hasOwnProperty(id)){
        out.push(id+': '+PROC[id].cn+'枚 '+(PROC[id].cpx*4/1048576).toFixed(1)+'MB '+
                 Math.round(PROC_MS[id]||0)+'ms');
      }
      L = procLoad();
      out.push('合計 '+L.sheets+'枚 '+L.mb.toFixed(1)+'MB（'+L.cities+'都市）');
      out.push('frame '+frameMS.toFixed(1)+'ms lite='+lite+' 最悪'+Math.round(worstMS)+'ms');
      return out.join('\n');
    }
    function bakeCity(pal){
      var P={ pal:pal, far:[], mid:[], near:[], tile:[], cloud:[], obs:{}, vw:-1 }, i, r;
      var LK=['far','mid','near'], NN={far:8, mid:12, near:10};
      for(var li=0; li<LK.length; li++){
        var key=LK[li], cfg=pal[key];
        for(i=0;i<NN[key];i++){
          r=seq(i*7.7 + li*31.3 + 5);
          var bw=Math.round(r(cfg.wmin,cfg.wmax)), bh=Math.round(r(cfg.hmin,cfg.hmax));
          P[key].push(bakeBuilding(cfg, bw, bh, r()<0.22?'step':'flat', r, pal));
        }
      }
      for(i=0;i<3;i++) P.tile.push(bakeTile(pal,i));
      for(i=0;i<3;i++) P.cloud.push(bakeCloud(pal,i));
      P.rail=bakeRail(pal); P.orb=bakeOrb(pal); P.lamp=bakeLamp(pal);
      P.tower = bakeLandmark(pal);
      var oc = pal.obs || {}, sk;
      /* 第3引数は「その障害物の色の設定」。popObs が近景ビルとの色の距離を測り、
         **同じ色の帯にいる組み合わせだけ**縁と暗幕を強める（2026-09-15）。
         fly は空の前を飛ぶので近景ビルと比べても意味が無い。**渡さない＝強めない** */
      P.obs.low   = popObs(bakeObsLow  (pal, oc.low),   pal, oc.low);
      P.obs.tall  = popObs(bakeObsTall (pal, oc.tall),  pal, oc.tall);
      P.obs.stack = popObs(bakeObsStack(pal, oc.stack), pal, oc.stack);
      P.obs.bar   = popObs(bakeObsBar  (pal, oc.bar),   pal, oc.bar);
      P.obs.fly   = [popObs(bakeObsFly(pal, oc.fly, 0), pal),
                     popObs(bakeObsFly(pal, oc.fly, 1), pal)];
      // skin（見た目の差し替え。池袋の crowd など）。**判定は type のまま変えない**
      if(oc.skins) for(sk in oc.skins) if(oc.skins.hasOwnProperty(sk)){
        var sc = oc.skins[sk];
        P.obs[sk] = popObs((sc.as==='low')   ? bakeObsLow(pal, sc)
                  : (sc.as==='tall')  ? bakeObsTall(pal, sc)
                  : (sc.as==='stack') ? bakeObsStack(pal, sc)
                  : bakeObsBar(pal, sc), pal, sc);
      }
      /* 敵（enemy-spec 3章）。**IGS には foe を書かないので焼かれない**＝凱旋区間には出ない。
         障害物と同じく popObs に通す（背景に埋もれさせない。実機報告4と同じ理由） */
      if(pal.foe){
        var fo = pal.foe;
        // 明るい縁取り（foeOutline）→ 障害物と同じ縁と暗幕（popObs）の順。walker と flyer は2コマ
        P.foe = {
          walker: [popObs(foeOutline(bakeFoeWalk(pal, fo.walker, 0)), pal, fo.walker),
                   popObs(foeOutline(bakeFoeWalk(pal, fo.walker, 1)), pal, fo.walker)],
          hopper:  popObs(foeOutline(bakeFoeHop (pal, fo.hopper)), pal, fo.hopper),
          flyer:  [popObs(foeOutline(bakeFoeFly(pal, fo.flyer, 0)), pal),
                   popObs(foeOutline(bakeFoeFly(pal, fo.flyer, 1)), pal)]
        };
      }
      if(pal.crossing){                       // 踏切は東京のフィナーレだけ
        P.obs.crossing=popObs(bakeGate(pal), pal);
        P.arm=bakeArm(pal); P.signal=bakeSignal(pal);
        P.train=[bakeTrainCar(pal,true), bakeTrainCar(pal,false)];
      }
      P.stars=[];
      for(i=0;i<120;i++) P.stars.push({ x:rnd(i*1.7), y:rnd(i*2.9)*(HORIZON-20),
                                        s:1+rnd(i*3.3)*1.6, a:0.25+rnd(i*4.1)*0.7,
                                        tw:0.25+rnd(i*5.7)*1.3, ph:rnd(i*6.1)*7,
                                        big:rnd(i*7.3)<0.10 });
      return P;
    }
    function procOf(cy){
      var pal = cy && PROC_PAL[cy.id];
      if(!pal) return null;
      var P = PROC[cy.id];
      if(!P){
        var t0 = (window.performance && performance.now) ? performance.now() : 0;
        P = PROC[cy.id] = bakeCity(pal);
        PROC_MS[cy.id] = ((window.performance && performance.now) ? performance.now() : 0) - t0;
        var cnt = procCount(P);
        P.cn = cnt.n; P.cpx = cnt.px;          // 枚数と画素は焼いた直後に1回だけ数える
        bakeLastMS = PROC_MS[cy.id]; bakeLastId = cy.id;
      }
      if(P.vw !== VW){                       // 画面幅に依存するものだけ焼き直す
        P.sky=bakeSky(pal); P.haze=bakeHaze(pal); P.floor=bakeFloor(pal);
        P.vw=VW;
      }
      return P;
    }
    /* 使わなくなった都市の焼き込みを捨てる。
       **1都市 60枚・10MB。8都市ぶん抱えると 80MB になり、
       中位 Android では確実に効いてくる。**
       ルートは一方通行で戻らないので、
       いま・ひとつ前（クロスフェード用）・次（先読み用）の3つだけ残せばよい。
       やり直しは同じ都市の頭からなので、捨てたものを焼き直すことにはならない。 */
    function procTrim(){
      var keep={}, id;
      keep[city.id]=1; keep[prev.id]=1;
      if(legIdx+1<CITIES.length) keep[CITIES[legIdx+1].id]=1;
      for(id in PROC) if(PROC.hasOwnProperty(id) && !keep[id]){
        delete PROC[id]; delete PROC_MS[id];
      }
    }
    function procActive(){ return !!(PROC_PAL[city.id] || (blend<1 && PROC_PAL[prev.id])); }
    /* procedural を切る逃げ道（art-direction-final.md 4章「マニフェストで切り替えられること」）。
       data-proc="0" または ?igrun_proc=0 で PROC_PAL を空にすると、
       素材（Kenney）の描画がそのまま戻る。素材の読み込み経路は一切消していない。 */
    // 焼き込みの数え上げは確認スクリプト（tools/shot.py --perf）も使う。
    // こちらは data-debug でも開ける。画面には何も描かないので遊びに影響しない
    if(perfOn || debugOn) window.__igrunStats = procStats;
    // 仕入れ品と障害物の重なりの数。tools/shot.py --boxes が毎フレーム読む
    if(perfOn || debugOn) window.__igrunOverlap = boxOverlaps;
    (function(){
      var off = root.getAttribute('data-proc') === '0';
      try{ if(new URLSearchParams(window.location.search).get('igrun_proc')==='0') off = true; }catch(e){}
      if(off) PROC_PAL = {};
    })();
    /* 都市の切り替え中は前の都市を描いてから、新しい都市を alpha=blend で重ねる。
       fn(cityObj) は「その都市として描く」1回ぶん */
    function forCity(fn){
      if(blend<1){ fn(prev); ctx.globalAlpha=blend; }
      fn(city);
      ctx.globalAlpha=1;
    }

    /* ---- 層の並べ方。item ごとに一度だけ決めて持たせる（毎フレーム抽選しない） ---- */
    function layoutOf(it, key, P, wTarget){
      var tag = key+':'+P.pal.id;
      if(it['L'+key] && it['L'+key].tag===tag) return it['L'+key];
      var r=seq(it.s+key.length*13), a=[], x=0, pool=P[key], n=0;
      while(x < wTarget && n < 12){
        var b = pool[(r()*pool.length)|0];
        a.push({ b:b, x:x, ph:r()*7 });
        x += b.bw + (key==='far' ? r(0,8) : key==='mid' ? r(14,44) : r(16,54));
        n++;
      }
      var lay = { tag:tag, a:a, w:x, lampAt: (P.pal[key].lamp && r()<0.8) ? r(0.15,0.75) : -1 };
      it['L'+key] = lay;
      return lay;
    }
    /* 建物1棟を置く。ネオンは sin 波でゆっくり息をする（単純な点滅にしない）。
       航空障害灯は pow(sin,6) の鋭い波形（同 2章） */
    function putBuilding(b, sx, base, key){
      if(sx > VW+50 || sx + b.bw < -50) return;
      blit(b, sx-b.pad, base-b.bh-b.pad);
      if(b.sign){
        var fl = reduce ? 0.8 : 0.55 + 0.45*Math.sin(tick*0.040 + sx*0.01)*0.5 + 0.22;
        ctx.save(); ctx.globalCompositeOperation='lighter';
        ctx.globalAlpha = ctx.globalAlpha * Math.max(0, Math.min(1, fl)) * 0.30;
        var G = (b.sign.col==='#45E0FF') ? gx().cyan : gx().warm;
        ctx.drawImage(G.c, sx+b.sign.x-b.sign.r, base-b.bh+b.sign.y-b.sign.r, b.sign.r*2, b.sign.r*2);
        ctx.restore();
      }
      if(b.beacon && key!=='far'){
        var bl = reduce ? 0.5 : 0.35 + 0.65*Math.pow(Math.max(0, Math.sin(tick*0.028 + sx*0.02)), 6);
        var lx = sx+b.bw*0.5, ly = base-b.bh-2;
        ctx.save(); ctx.globalAlpha *= bl;
        ctx.drawImage(gx().red.c, lx-10, ly-10, 20, 20);
        ctx.fillStyle='#FF6A55'; ctx.beginPath(); ctx.arc(lx, ly, 1.4, 0, 7); ctx.fill();
        ctx.restore();
      }
    }
    function drawLayerProc(it, key, cy, wTarget){
      var P=procOf(cy); if(!P) return;
      var lay=layoutOf(it, key, P, wTarget), base=P.pal[key].base, i;
      for(i=0;i<lay.a.length;i++) putBuilding(lay.a[i].b, it.x+lay.a[i].x, base, key);
      if(lay.lampAt>=0){
        var L=P.lamp, lx=it.x+lay.w*lay.lampAt;
        if(lx>-60 && lx<VW+60) blit(L, lx-L.pad, GROUND_Y+2-L.bh-L.pad);
      }
    }

    /* =============== 層1：遠景 ===============
       proc の都市は焼き込んだ建物を並べる。それ以外は従来の稜線（下）。
       この4行の並びが、以降の各層でも同じ「前の都市 → 今の都市」の重ね方。 */
    function drawL1(it){
      if(blend<1 && PROC_PAL[prev.id]){ drawLayerProc(it,'far',prev,300); ctx.globalAlpha=blend; }
      if(PROC_PAL[city.id]){ drawLayerProc(it,'far',city,300); ctx.globalAlpha=1; return; }
      drawL1Ridge(it);
      ctx.globalAlpha=1;
    }
    function drawL1Ridge(it){
      var base=GROUND_Y+6, x=it.x, i, w, h;
      ctx.fillStyle = rgb(C.l1);
      if(city.ridge==='dunes'){
        ctx.beginPath(); ctx.moveTo(x, base);
        for(i=0;i<=8;i++){
          var t=i/8;
          ctx.lineTo(x+t*300, base - 40 - Math.sin(t*3.1+it.s)*26 - Math.sin(t*7.7)*10);
        }
        ctx.lineTo(x+300, base); ctx.closePath(); ctx.fill();
      } else if(city.ridge==='bergs'){
        ctx.beginPath(); ctx.moveTo(x, base);
        ctx.lineTo(x+52, base-72); ctx.lineTo(x+96, base-30);
        ctx.lineTo(x+150, base-96); ctx.lineTo(x+210, base-24);
        ctx.lineTo(x+260, base); ctx.closePath(); ctx.fill();
      } else {
        var bx=x;
        for(i=0;i<7;i++){
          w = 24 + rnd(it.s+i)*40;
          h = 44 + rnd(it.s+i*2.3)*86;
          ctx.fillRect(bx, base-h, w, h);
          bx += w + 5;
        }
      }
    }

    /* =============== 層1b：ランドマーク（コード描画） ===============
       遠景は霞んで輪郭だけになるので、ここはコードで描いてよい（docs/plan-a.md 1-1）。
       稜線より視差を遅くし、都市に1本だけ立てる。 */
    function drawLandmark(it){
      if(blend<1 && PROC_PAL[prev.id]){ drawTowerProc(it,prev); ctx.globalAlpha=blend; }
      if(PROC_PAL[city.id]){ drawTowerProc(it,city); ctx.globalAlpha=1; return; }
      drawLandmarkFlat(it);
      ctx.globalAlpha=1;
    }
    /* 東京タワー。**1枚に焼いた canvas を1回置くだけ。**
       上部と下部を別々に描いていたので「2つに見える」と指摘された（art-direction 3章）。
       基部は中景のビルに隠れるが、隠れるのは奥行きとして正しい。
       塔そのものが分割されないことが直したかった点。 */
    function drawTowerProc(it, cy){
      var P=procOf(cy); if(!P || !P.tower) return;
      var T=P.tower, base=HORIZON+34, sx=it.x;
      if(sx > VW+160 || sx + T.bw < -160) return;
      // 塔の背後の空気。輪郭が空から浮く。ピラミッドや氷山には要らない
      if(T.halo){
        ctx.save(); ctx.globalCompositeOperation='lighter'; ctx.globalAlpha*=0.16;
        ctx.drawImage(gx()[T.halo].c, sx+T.bw/2-110, base-T.bh*0.55-110, 220, 220);
        ctx.restore();
      }
      blit(T, sx-T.pad, base-T.bh-T.pad);
      if(!T.beacon) return;
      // 尖塔の航空障害灯（pow(sin,6) の鋭い波形）
      var bl = reduce ? 0.6 : 0.45 + 0.55*Math.pow(Math.max(0, Math.sin(tick*0.028)), 6);
      var lx = sx+T.bw/2, ly = base-T.bh-6;
      ctx.save(); ctx.globalAlpha*=bl;
      ctx.drawImage(gx().red.c, lx-13, ly-13, 26, 26);
      ctx.fillStyle='#FF5A4A'; ctx.beginPath(); ctx.arc(lx, ly, 1.4, 0, 7); ctx.fill();
      ctx.restore();
    }
    function drawLandmarkFlat(it){
      var x=it.x, base=GROUND_Y+4, i, w, h, bx, bw, bh;
      ctx.fillStyle = rgb(C.l1);

      if(city.id==='tokyo'){                       // 東京タワー
        h=176; w=h*0.42;
        ctx.beginPath();
        ctx.moveTo(x, base);
        ctx.lineTo(x+w*0.30, base-h*0.52); ctx.lineTo(x+w*0.42, base-h*0.52);
        ctx.lineTo(x+w*0.452, base-h);     ctx.lineTo(x+w*0.487, base-h-30);
        ctx.lineTo(x+w*0.513, base-h-30);  ctx.lineTo(x+w*0.548, base-h);
        ctx.lineTo(x+w*0.58, base-h*0.52); ctx.lineTo(x+w*0.70, base-h*0.52);
        ctx.lineTo(x+w, base);
        ctx.closePath(); ctx.fill();
        // 塔の灯り：2秒周期で下から1段ずつ点く
        var step = Math.floor(tick/30) % 5;
        for(i=1;i<5;i++){
          ctx.fillStyle = rgb(C.accent, i<=step ? .85 : .25);
          ctx.fillRect(x+w*(0.34+i*0.06), base-h*0.52-i*24, 3, 3);
        }
      } else if(city.id==='ikebukuro'){            // 高層1本。頂部のサイネージが明滅
        ctx.fillRect(x+40, base-236, 44, 236);
        ctx.fillStyle = rgb(C.accent, 0.45+0.4*(0.5+0.5*Math.sin(tick*0.070)));
        ctx.fillRect(x+40, base-236, 44, 5);
      } else if(city.id==='cairo'){                // ピラミッド
        for(i=0;i<3;i++){
          var ph=90+i*44, pw=ph*1.5, px2=x+i*pw*0.48;
          ctx.beginPath(); ctx.moveTo(px2, base); ctx.lineTo(px2+pw/2, base-ph); ctx.lineTo(px2+pw, base);
          ctx.closePath(); ctx.fill();
        }
      } else if(city.id==='paris'){                // エッフェル塔
        h=190; w=h*0.44;
        ctx.beginPath();
        ctx.moveTo(x, base);
        ctx.quadraticCurveTo(x+w*0.36, base-h*0.46, x+w*0.452, base-h);
        ctx.lineTo(x+w*0.47, base-h-22); ctx.lineTo(x+w*0.53, base-h-22);
        ctx.lineTo(x+w*0.548, base-h);
        ctx.quadraticCurveTo(x+w*0.64, base-h*0.46, x+w, base);
        ctx.closePath(); ctx.fill();
        ctx.fillRect(x+w*0.16, base-h*0.46, w*0.68, 6);
        ctx.fillRect(x+w*0.29, base-h*0.72, w*0.42, 5);
      } else if(city.id==='ny'){                   // 摩天楼のシルエット
        bx = x;
        for(i=0;i<6;i++){
          bw=32+rnd(it.s+i)*30; bh=70+rnd(it.s+i*2.7)*118;
          ctx.fillRect(bx, base-bh, bw, bh);
          if(i===2) ctx.fillRect(bx+bw*0.28, base-bh-16, bw*0.36, 16);
          if(i===4){
            ctx.fillRect(bx+bw*0.46, base-bh-34, 3, 34);
            ctx.fillStyle=rgb(C.accent); ctx.fillRect(bx+bw*0.44, base-bh-38, 7, 5);
            ctx.fillStyle=rgb(C.l1);
          }
          bx += bw+6;
        }
      } else if(city.id==='hk'){                   // 密集ビル
        bx = x;
        for(i=0;i<8;i++){
          bw=20+rnd(it.s+i)*22; bh=64+rnd(it.s+i*1.9)*130;
          ctx.fillRect(bx, base-bh, bw, bh);
          bx += bw+3;
        }
      } else if(city.id==='pole'){                 // 氷山
        ctx.beginPath();
        ctx.moveTo(x, base); ctx.lineTo(x+58, base-96); ctx.lineTo(x+104, base-52);
        ctx.lineTo(x+150, base-132); ctx.lineTo(x+214, base-40); ctx.lineTo(x+266, base);
        ctx.closePath(); ctx.fill();
      } else {                                     // 帰り道：低いビル群（池袋の街を遠くに）
        bx = x;
        for(i=0;i<5;i++){
          bw=46+rnd(it.s+i)*30; bh=48+rnd(it.s+i*2.1)*54;
          ctx.fillRect(bx, base-bh, bw, bh);
          bx += bw+9;
        }
      }
    }

    /* =============== 層2：中景の街並み（素材） ===============
       素材は色替えの時点で空気遠近（彩度0.65・空色30%混合）を焼き込んである。 */
    var MID_KINDS = [ ['mid-house-a',60,100], ['mid-house-b',40,80], ['mid-tower',40,160] ];

    // 夜の街の窓。5秒ごとに一部が点いたり消えたりする
    function midWindows(x, y, w, h, seed){
      if(!city.night) return;
      var rate = (city.id==='ikebukuro') ? 0.45 : 0.34;   // 池袋は東京より明るい街
      var im = asset(city.id+'-mid-window');
      var wx, wy, phase = Math.floor(tick/300);
      for(wy=y+11; wy<y+h-11; wy+=15){
        for(wx=x+7; wx<x+w-10; wx+=13){
          if(rnd(seed + wx*0.37 + wy*0.11) >= rate) continue;
          if(rnd(seed + wx*0.71 + wy*0.29 + phase*3.3) < 0.12) continue;
          if(im) ctx.drawImage(im, wx, wy, 6, 8);
          else { ctx.fillStyle=rgb(C.accent,.75); ctx.fillRect(wx, wy, 4, 5); }
        }
      }
    }
    function drawL2(it){
      if(blend<1 && PROC_PAL[prev.id]){ drawLayerProc(it,'mid',prev,340); ctx.globalAlpha=blend; }
      if(PROC_PAL[city.id]){ drawLayerProc(it,'mid',city,340); ctx.globalAlpha=1; return; }
      drawL2Asset(it);
      ctx.globalAlpha=1;
    }
    function drawL2Asset(it){
      var base=GROUND_Y+3, bx=it.x, i, kind, w, h;
      for(i=0;i<4;i++){
        kind = MID_KINDS[(rnd(it.s+i*1.7)*MID_KINDS.length)|0];
        w = kind[1];
        h = Math.round(kind[2] * (0.8 + rnd(it.s+i*3.1)*0.45));
        if(drawCityAsset(kind[0], bx, base-h, w, h)) midWindows(bx, base-h, w, h, it.s+i);
        bx += w - 6;                                // 少し重ねて街を密に見せる
      }
    }

    /* =============== 層3：近景の小物（素材） =============== */
    var PROPS = [
      ['prop-lamp',  22, 84], ['prop-sign',  32, 32], ['prop-fence', 40, 34],
      ['prop-bush',  36, 22], ['prop-tree',  46, 80], ['prop-rock',  28, 20]
    ];
    /* proc の都市では、この層が **iGくんのすぐ後ろに立つ建物の列**。
       mid より1段明るく塗り、街灯を混ぜてある。
       ここが地面と同じ明度だとキャラが暗い塊に埋もれる（art-direction 3章）。 */
    function drawL3(it){
      if(blend<1 && PROC_PAL[prev.id]){ drawLayerProc(it,'near',prev,340); ctx.globalAlpha=blend; }
      if(PROC_PAL[city.id]){ drawLayerProc(it,'near',city,340); ctx.globalAlpha=1; return; }
      var base=GROUND_Y+1, p=PROPS[(rnd(it.s)*PROPS.length)|0];
      drawCityAsset(p[0], it.x, base-p[2], p[1], p[2]);
      ctx.globalAlpha=1;
    }

    /* =============== 層5：手前のオーバーレイ（素材） ===============
       上端から垂れて風で揺れる（周期2.4秒、3°）。視差1.7で最も速く流れる。
       都市に合うものだけを出す。提灯は夜の街、枝葉は木のある街。
       南極は上から垂れるものが無いので何も描かない（雪と氷山で十分に動いている）。 */
    var OVER_KIND = { tokyo:'lantern', ikebukuro:'lantern', hk:'lantern',
                      igs:'leaves', cairo:'leaves' };
    /* proc の都市の手前層は「ピントの外れた手すり」を継ぎ目なく流す（drawFore）。
       item ごとに置くものではないので、ここでは何もしない */
    function drawL5(it){
      if(PROC_PAL[city.id]) return;
      var kind = OVER_KIND[city.id];
      if(!kind) return;
      var sway = reduce ? 0 : Math.sin((tick + it.s*20)*0.026) * 3 * Math.PI/180;
      var i, lx;
      for(i=0;i<3;i++){
        lx = it.x + i*54;
        if(lx < -60 || lx > VW+60) continue;
        ctx.save();
        ctx.translate(lx, 0);
        ctx.rotate(sway * (1 + i*0.12));
        if(kind==='lantern') drawCityAsset('over-lantern', -13, -4, 26, 48);
        else { ctx.scale(1,-1); drawCityAsset('prop-tree', -46, -44, 92, 118); }  // 上下反転で枝葉
        ctx.restore();
      }
    }

    /* =============== 店（ゴール） ===============
       建物は共通素材。ブランドの庇と看板だけ上に重ねる（都市色替えの対象外）。 */
    var SHOP_W = 150, SHOP_H = 150;
    var SHOP_BAKED = null;
    function drawShop(s){
      if(PROC_PAL[city.id]){
        if(!SHOP_BAKED) SHOP_BAKED = bakeShop();
        var S=SHOP_BAKED, bx=s.x, by=GROUND_Y+1-S.bh;
        // 接地の影と、店から歩道にこぼれる灯り
        ctx.save(); ctx.globalAlpha=0.9;
        ctx.drawImage(gx().ao.c, bx-14, GROUND_Y-6, SHOP_W+28, 16);
        ctx.restore();
        ctx.save(); ctx.globalCompositeOperation='lighter'; ctx.globalAlpha=0.34;
        ctx.drawImage(gx().warm.c, bx+SHOP_W/2-96, GROUND_Y-96, 192, 192);
        ctx.restore();
        blit(S, bx-S.pad, by-S.pad);
        return;
      }
      var x=s.x, base=GROUND_Y+1, w=SHOP_W, h=SHOP_H, im=asset('common-shop');
      ctx.fillStyle='rgba(0,0,0,.18)'; ctx.fillRect(x+8, base-6, w, 6);
      if(im) ctx.drawImage(im, x, base-h, w, h);
      else { ctx.fillStyle='#f4f8fa'; ctx.fillRect(x, base-h, w, h); }
      ctx.fillStyle='#41caec'; ctx.fillRect(x-8, base-h-12, w+16, 14);   // 庇
      ctx.fillStyle='#2ba9cd'; ctx.fillRect(x-8, base-h,    w+16, 3);
      ctx.fillStyle='#0e2530'; ctx.fillRect(x+8, base-h+18, w-16, 26);   // 看板
      ctx.fillStyle='#b7d029'; ctx.fillRect(x+8, base-h+44, w-16, 3);
      text('INFOLENS GEEK SHOP', x+w/2, base-h+36, 12, '#eef7fa', 'center');
    }

    /* =============== 障害物・小包 =============== */
    function addObs(x, type, skin){
      var w,h,y;
      if(type==='low'){ w=36; h=34; }
      else if(type==='tall'){ w=36; h=62; }
      else if(type==='stack'){ w=40; h=86; }
      else if(type==='bar'){ w=34; h=24; }
      else { w=34; h=28; }
      // bar は下端を BAR_GAP の高さに置く。上端ではなく下端で決めるのは、
      // くぐれるかどうかが下端だけで決まるため
      y = (type==='fly') ? GROUND_Y-118 : (type==='bar') ? GROUND_Y-BAR_GAP-h : GROUND_Y-h;
      // skin は見た目の差し替え（池袋の crowd など）。素材が無ければ type の絵に落ちる
      obs.push({ x:x, y:y, w:w, h:h, type:type, skin:skin||'', id:city.id, t:Math.random()*6 });
      /* **障害物の生成は敵の都合で変えない。**代わりに、湧いた場所にいる敵を捨てる。
         障害物が湧くのは必ず画面の右外（VW+40 以降）なので、消える瞬間は見えない。
         これが無いと、あとから湧いた障害物と敵が重なったまま一緒に流れてくる
         （確認用の連続出しで 316 フレームぶん重なった。実測） */
      if(foes.length){
        var nr={ x:x-OBS_RIM, y:y-OBS_RIM, w:w+OBS_RIM*2, h:h+OBS_RIM*2 };
        foes = foes.filter(function(f){
          return !foeAlive(f) || !rectHit(foeSpan(f), nr, 0);
        });
      }
      return w;
    }
    /* =============== PatternPlayer（docs/patterns.md） ===============
       data/patterns/<city>.json を読んで並べる。パターンを持たない都市は
       下の spawnObs（ランダム）が保険として走る。

       選び方
       ・まず tier1 を **書かれた順に** 出す（導入）。ここで死なせない。
         bar の初出をこの導入に置いてあるので（東京は tk04、池袋は ik01）、
         「それより前に bar を出さない」が並びとして保証される
       ・導入のあとは区間の進行度で tier を絞る。0〜40% は 1〜2、40〜100% は 2〜3
       ・同じ id を連続させない
       ・区間の終わりに finale がちょうど入る距離になったら finale を置く
       ・パターン間の空白は 速度×1.2秒（固定値にしない） */
    /* y:0 地面 / 1 低い弧 / 2 高い弧。
       **y:0 は 42 → 18 に下げた（2026-09-10）。** bar の下端は接地面から 36px
       （BAR_GAP）しかなく、42px に置くと玩具の絵が必ず横棒に食い込む。
       18px なら絵の上端が 31px で、くぐる隙間に収まる。
       見た目も「道に落ちている」ほうが仕入れ品らしい。 */
    var PARCEL_Y = [GROUND_Y-18, GROUND_Y-78, GROUND_Y-126];
    var pp = null;

    function patFor(cityId){ return foeDebug==='zoo' ? null : (PATTERNS[cityId] || null); }
    function patHasBar(p){
      for(var i=0;i<p.items.length;i++) if(p.items[i].type==='bar') return true;
      return false;
    }
    // その区間の PatternPlayer を用意する。パターンが無ければ null（保険に落ちる）
    function initPatterns(leg){
      var set = patFor(CITIES[leg].id);
      if(!set || !set.patterns || !set.patterns.length){ pp = null; return; }
      var intro = set.patterns.filter(function(p){ return p.tier===1; });
      pp = { set:set, intro:intro, introI:0, lastId:'', finDone:false, barOK:false, fillerDone:false };
    }
    /* 区間の**本来の**速度。区間クリアの演出とゴールの減速で spd は一時的に下がるが、
       **配置の間隔をそれに追従させてはいけない。**下がった速度で間隔を決めると、
       速度が戻ったときに詰まった配置だけが残る（実測で IGS の保険配置が詰まって被弾した）。 */
    function baseSpd(){ return speedOfLeg(legIdx); }
    function gapPx(){ return baseSpd()*72; }  // 速度×1.2秒（px/frame。60fps・20px=1m）
    /* 置いたものが自分に届くまでの距離（m）。パターンは画面右端の外（VW+40）に置くので、
       区間の境目も tier の切り替えも、このぶん先を見て決める。
       これが無いと、フィナーレを自分の現在地で測ってしまい、実際に出会うのは 26m 先。
       東京のフィナーレ（60m）が 449〜509m に来て、区間の境目 480m をまたいでいた */
    function leadM(){ return (VW + 40 - (pl.x + HIT_X)) / 20; }
    function finaleOf(set){
      for(var i=0;i<set.patterns.length;i++) if(set.patterns[i].id===set.finale) return set.patterns[i];
      return null;
    }
    function pickPattern(){
      var set=pp.set, i, p, fin=finaleOf(set);
      // done は「いま置くものに出会う地点」の区間内進行度。leadM のぶん先を見る
      var legM = LEG_LEN[legIdx], done = dist + leadM() - LEG_START[legIdx];
      var remain = legM - done, gap = gapPx()/20;

      // フィナーレは区間の最後に置く。残りが「フィナーレ＋空白」を切ったらここで置く
      if(fin && !pp.finDone && remain <= fin.len + gap){ pp.finDone=true; return fin; }
      // フィナーレの場所は先に取っておく。普通のパターンはこの残りにしか置かない。
      // これをやらないと、最後の1つがはみ出してフィナーレが次の都市に食い込む
      var room = remain - ((fin && !pp.finDone) ? fin.len + gap : 0);

      // 導入：tier1 を書かれた順に。bar の初出はここに置いてあるので、
      // 選択に移る前に必ず通る（東京 tk04、池袋 ik01）
      if(pp.introI < pp.intro.length){
        p = pp.intro[pp.introI];
        if(p.len + gap <= room){ pp.introI++; return p; }
      }
      // 以降は進行度で tier を絞って選ぶ
      var lo = done/legM < 0.4 ? 1 : 2, hi = done/legM < 0.4 ? 2 : 3;
      var cand=[];
      for(i=0;i<set.patterns.length;i++){
        p=set.patterns[i];
        if(p.id===set.finale) continue;              // finale は終わりまで取っておく
        if(p.tier<lo || p.tier>hi) continue;
        if(p.id===pp.lastId) continue;               // 同じものを続けない
        if(p.len + gap > room) continue;             // フィナーレの場所を潰さない
        if(!pp.barOK && patHasBar(p)) continue;      // bar は導入で初出させる
        cand.push(p);
      }
      /* **余り埋め（`filler:true`）は、通常のパターンが1つも入らないときだけ選ぶ**（2026-09-16）。
         フィナーレの前には 8〜42m の余りが毎回残っていた（南極・香港は 42m）。
         通常のパターン（3拍・32m〜）は入らないが、1〜2拍の短いものなら入る。
         通常のものが入るのに短いものを選ぶと、その都市の3拍のリズムが崩れて敵も増えないので、
         「入るものが無いときの穴埋め」に限る。**選び方はここだけ。** spawnPattern は区別しない */
      var full=[];
      for(i=0;i<cand.length;i++) if(!cand[i].filler) full.push(cand[i]);
      if(full.length) cand = full;
      else if(pp.fillerDone) return null;              // 余り埋めは1区間1枚。2枚続くと拍が詰まる（末尾を詰めてあるため）
      // 入るものが無ければ null。呼び側がフィナーレの直前まで道を空ける。
      // ここで無理にフィナーレを前倒しすると、区間の末尾に長い空白が残る
      if(!cand.length) return null;
      return cand[(Math.random()*cand.length)|0];
    }
    // items の1つを世界に置く。px はパターン先頭の画面x
    function placeItem(px, it){
      /* 連続ブロックの間隔は「跳んで越えられるか」で決まる。東京（spd 3.4px/frame）で
           重なりが続くフレーム数 ＝ (64 + 最後のブロックの位置) / spd
           判定が 31px 以上ある窓 ＝ 長押しひと跳びで約40フレーム、2段を足して約48フレーム
         double（間隔 56px）：(64+56)/3.4 = 35 フレーム < 40 → 長押しひと跳びで越える
         triple：**docs/patterns.md の 7.2m（間隔 54px）は越えられない。**
           (64+108)/3.4 = 51 フレーム > 48。間隔 44px でも 45 フレームで余裕が3しか無い。
           余裕を8フレーム取れる上限が間隔 36px＝隙間なしの3連（幅 5.4m）で 40 フレーム。
           2段ジャンプ必須という設計意図は保ったまま、越えられる幅にした */
      if(it.type==='double'){ addObs(px,'low'); addObs(px+56,'low'); return; }
      if(it.type==='triple'){ addObs(px,'low'); addObs(px+36,'low'); addObs(px+72,'low'); return; }
      if(it.type==='gimmick'){
        var gk = it.gimmick || it.skin;
        if(gk==='crossing'){ addCrossing(px); return; }
        if(gk==='sand' || gk==='rain'){ trigs.push({x:px, k:gk}); return; }
        if(gk==='puddle'){ pads.push({x:px, w:76, k:'puddle'}); return; }
        if(gk==='ice'){    pads.push({x:px, w:96, k:'ice'});    return; }
        if(gk==='taxi'){   plats.push({x:px, y:GROUND_Y-42, w:80, h:42, k:'taxi', t:0, ph:0, on:true}); return; }
        if(gk==='neon'){
          // 点滅の位相は置いた位置から決める。**Math.random を使わない**
          // （乱数の消費が増えるとコースが変わる。音の noise() と同じ理由）
          plats.push({x:px, y:GROUND_Y-64, w:60, h:12, k:'neon', t:0, ph:(px|0)%150, on:true});
          return;
        }
        // 知らないギミックは素の障害物として置く（判定だけは必ず出す）
        addObs(px, 'low', gk); return;
      }
      addObs(px, it.type, it.skin);
    }
    /* 区間の終わりまで何も出さない。区間が切り替われば nextLeg が入れ替える。
       境目を越えた直後に次の都市の1つ目を置く。**そこから出会うまでが leadM()＝26m** で、
       池袋の速度なら約2.3秒。都市名の演出（90f＝1.5秒）が終わってすぐ最初の障害物、という間になる。
       以前は +40m 待っていて、フィナーレの終わりから 67m＝4.6秒 も何も出なかった */
    function holdUntilLegEnd(){
      var legEndM = LEG_START[legIdx] + LEG_LEN[legIdx];
      nextObsX = Math.max(worldX + 4*20, (legEndM + 1)*20);
    }
    function spawnPattern(){
      var i, x0 = VW+40, fin = finaleOf(pp.set);
      // フィナーレを置き終えたら、その区間ではもう何も出さない
      if(pp.finDone){ holdUntilLegEnd(); return; }
      var p = pickPattern();
      if(!p){
        // いま置けるものが無い。フィナーレがちょうど区間の終わりで終わる位置まで道を空ける
        if(!fin){ holdUntilLegEnd(); return; }
        // 置く地点（プレイヤーの距離）＝ 出会わせたい地点 − leadM
        var startM = LEG_START[legIdx] + LEG_LEN[legIdx] - fin.len - leadM();
        nextObsX = Math.max(worldX + 12*20, startM*20);
        return;
      }
      pp.lastId = p.id;
      if(p.filler) pp.fillerDone = true;
      if(patHasBar(p)) pp.barOK = true;              // 初出が済んだので以降は選んでよい
      for(i=0;i<p.items.length;i++)   placeItem(x0 + p.items[i].x*20, p.items[i]);
      spawnFoes(p, x0);                              // 敵は障害物のあとに置く（場所取りを見るため）
      for(i=0;i<(p.parcels||[]).length;i++){
        var b = p.parcels[i];
        var bxw = x0 + b.x*20, byw = PARCEL_Y[b.y] || PARCEL_Y[0];
        // **パターンから置くぶんも検査する。**手で書いたものでも、
        // ギミックや隣のパターンと重なる組み合わせは起こりうる
        if(boxFree(bxw, byw)) boxes.push({ x:bxw, y:byw, t:Math.random()*6,
                                           k:((Math.abs(worldX+bxw)|0)>>3) % TOY_N });
      }
      nextObsX = worldX + p.len*20 + gapPx();
    }

    function spawnObs(){
      if(foeDebug==='zoo'){ nextObsX = worldX + 1e9; return; }   // 見本市モードでは障害物を出さない
      var pool=['low','low','tall'];
      if(legIdx>=1) pool.push('fly','tall');
      if(legIdx>=2) pool.push('double','fly');
      if(legIdx>=3) pool.push('stack','lowfly');
      if(legIdx>=4) pool.push('triple','stack','lowfly');
      if(legIdx>=GOAL_IDX) pool=['low','low','tall'];
      var k=pool[(Math.random()*pool.length)|0], x=VW+40, w=36;
      if(k==='double'){ addObs(x,'low'); addObs(x+56,'low'); w=92; }
      else if(k==='triple'){ addObs(x,'low'); addObs(x+52,'low'); addObs(x+104,'low'); w=140; }
      else if(k==='lowfly'){ addObs(x,'low'); addObs(x+124,'fly'); w=158; }
      else w=addObs(x,k);
      nextObsX = worldX + w + baseSpd()*(42+Math.random()*26);   // 減速中でも間隔は縮めない
    }
    /* =============== 仕入れ品と障害物を重ねない（2026-09-10 の不具合） ===============
       実機で、帰り道の柱（tall）と仕入れ品が1つの塊になっていた。

       **原因は「置く瞬間に既にある障害物しか見ていなかった」こと。**
       仕入れ品は VW+50 から、障害物は VW+40 から置く。仕入れ品を置いた数フレーム後に
       障害物が湧けば、チェックは1度も走らない。**片方向・一度きりの検査**だった。
       ほかに3つ穴があった：
         ・玩具にして絵が 22px → 38px になったのに、判定は ±10px のままだった
         ・パターンから置く仕入れ品は、そもそも検査を通っていなかった
         ・ギミック（足場・タクシー・水たまり・氷）が検査の対象に入っていなかった

       直し方は2段構え。**どちらか片方だけでは順序の穴が残る。**
         (1) 置くとき：boxFree() を**すべての生成経路**で通す
         (2) 毎フレーム：sweepBoxes() が重なっている仕入れ品を捨てる。
             後から障害物が湧いても、必ず次のフレームで解消する

       **判定は「描かれる絵の外周」で行う**（指示3）。当たり判定の矩形ではない。
       見た目が重なっていれば不具合なので、焼き込みの pad まで含めて測る。 */
    /* 玩具の**絵**の半径。焼き込み canvas は 38px だが、周りの 7px は透明な余白で、
       塗られているのは中心の 26px ほど。**canvas の大きさで測ると障害物と同じ間違いをする。**
       光暈（48px）は含めない。柔らかい暈が障害物に掛かるのは「1つの塊」ではない。 */
    var BOX_VR = 13;
    function boxVis(b){ return { x:b.x-BOX_VR, y:b.y-BOX_VR, w:BOX_VR*2, h:BOX_VR*2 }; }
    /* 障害物の**絵**の外周。
       **焼き込み canvas の大きさを使ってはいけない。**obsCanvas は絵の周りに
       10px の透明な余白を持つので、36px の障害物が 66px として当たる
       （実際これで小包が2割落ちた）。絵が塗られている範囲は
       「判定の枠 ＋ popObs のリムと暗幕ぶん（5px）」。 */
    var OBS_RIM = 5;
    function obsVis(o){
      return { x:o.x-OBS_RIM, y:o.y-OBS_RIM, w:o.w+OBS_RIM*2, h:o.h+OBS_RIM*2 };
    }
    /* 仕入れ品を置いてはいけない場所ぜんぶ（障害物・足場・地面の装飾・踏切・**敵**）。
       noFoe を立てると敵を含めない。**敵自身の重なりを数えるとき**に使う
       （自分と自分が重なっていると数えないため） */
    function solidVis(noFoe){
      var a=[], i, o;
      for(i=0;i<obs.length;i++){
        o = obs[i];
        a.push(obsVis(o));
        /* bar の支柱は接地面まで描き足している（焼き込みには入っていない）。
           **横棒の下は「くぐる隙間」なので塞がない。**ここを塞ぐと、
           スライドの正解ラインを示す地面の小包が置けなくなる（設計の意図が消える）。
           支柱2本ぶんだけを別の矩形にする。 */
        if(o.type==='bar'){
          var pb = o.y+o.h-2, ph = GROUND_Y-pb+2;
          a.push({ x:o.x, y:pb, w:9, h:ph });
          a.push({ x:o.x+o.w-9, y:pb, w:9, h:ph });
        }
      }
      for(i=0;i<plats.length;i++){
        o = plats[i];
        // タクシーは地面に立つ。ネオンは宙に浮く（光暈ぶん少し広く見る）
        if(o.k==='taxi') a.push({ x:o.x-5, y:o.y-9, w:o.w+10, h:GROUND_Y-o.y+11 });
        else             a.push({ x:o.x-8, y:o.y-7, w:o.w+16, h:o.h+14 });
      }
      // 水たまり・氷は地面に貼り付いた薄い絵。**y:0 の小包（中心が地面から42px）とは
      // そもそも重ならない**が、念のため対象に入れておく
      for(i=0;i<pads.length;i++) a.push({ x:pads[i].x, y:GROUND_Y-6, w:pads[i].w, h:9 });
      // 踏切。遮断機の箱と、下りてくる腕木の掃く範囲
      if(cross) a.push({ x:cross.x-8, y:GROUND_Y-58, w:cross.w+70, h:62 });
      /* 敵（enemy-spec 4章「重なり防止」）。**動くので、置くときの検査だけでは足りない。**
         毎フレームの sweepBoxes が拾い直すので、歩いてきた敵が仕入れ品に
         重なっても次のフレームで解消する（画面に入る前のものだけ）。 */
      if(!noFoe) for(i=0;i<foes.length;i++) if(foeAlive(foes[i])) a.push(foeSpan(foes[i]));
      return a;
    }
    // その矩形は地面の装飾（水たまり・氷）か。boxOverlaps が敵の判定から外すのに使う
    function padRect(r){
      for(var i=0;i<pads.length;i++) if(r.x===pads[i].x && r.y===GROUND_Y-6) return true;
      return false;
    }
    function rectHit(a, b, gap){
      gap = gap || 0;
      return a.x < b.x+b.w+gap && a.x+a.w+gap > b.x && a.y < b.y+b.h+gap && a.y+a.h+gap > b.y;
    }
    /* ここに置いてよいか。**すべての生成経路がこれを通る。**
       gap 3px は「隣り合って見える」のを避けるための余白（重なりの判定自体は 0 で足りる） */
    function boxFree(bx, by){
      var r = boxVis({x:bx, y:by}), a = solidVis(), i;
      for(i=0;i<a.length;i++) if(rectHit(r, a[i], 3)) return false;
      return true;
    }
    /* 敵にも毎フレームの保険をかける（enemy-spec 4章）。
       **敵は動くので、置くときの検査だけでは足りない。**
       障害物の生成は敵を見ていない（既存の道を敵の都合で変えない、という決め）ので、
       湧いた障害物と重なった敵は、**画面に入る前（x > VW）なら捨てる。**
       目の前で消えると理不尽なので、画面内のものは残す。仕入れ品の sweepBoxes と同じ考え方。 */
    function sweepFoes(){
      if(!foes.length) return;
      var a = solidVis(true), i, j, keep = [];
      for(i=0;i<foes.length;i++){
        var f = foes[i], bad = false;
        if(foeAlive(f)){
          var r = foeSpan(f);
          for(j=0;j<a.length;j++) if(rectHit(r, a[j], 0)){ bad = true; break; }
        }
        if(!bad || f.x <= VW) keep.push(f);
      }
      foes = keep;
    }
    /* 毎フレームの保険。**置いたあとに障害物が湧いた場合はこちらで解消する。**
       画面に入る前（x > VW）のものだけ捨てる。目の前で消えると理不尽なので。 */
    function sweepBoxes(){
      if(!boxes.length) return;
      var a = solidVis(), i, j, keep = [];
      for(i=0;i<boxes.length;i++){
        var r = boxVis(boxes[i]), bad = false;
        for(j=0;j<a.length;j++) if(rectHit(r, a[j], 3)){ bad = true; break; }
        if(!bad || boxes[i].x <= VW) keep.push(boxes[i]);
      }
      boxes = keep;
    }
    /* 重なっている組の数。**確認用**（tools/shot.py --boxes が毎フレーム読む）。
       仕入れ品 × 実体、に加えて **敵 × 実体（敵を除く）** も数える。
       enemy-spec 4章「障害物・仕入れ品・ギミック・敵が互いに重ならないこと」を
       1つの数字で見られるようにするため。**確認スクリプト側は変更不要**
       （--boxes は本体のこの関数を読むだけ、という約束を守る）。 */
    function boxOverlaps(){
      var a = solidVis(), b = solidVis(true), i, j, n = 0;
      for(i=0;i<boxes.length;i++){
        var r = boxVis(boxes[i]);
        for(j=0;j<a.length;j++) if(rectHit(r, a[j], 0)) n++;
      }
      /* 敵 × 実体。**水たまり・氷（pads）は数えない。**
         あれは地面に貼った薄い絵で、その上に立つのは重なりではない
         （数えると、氷の上を歩く敵がずっと「重なり」として出続ける）。
         仕入れ品のほうは従来どおり pads も見る（浮いている絵なので意味が違う） */
      var b2 = [], k;
      for(k=0;k<b.length;k++) if(!padRect(b[k])) b2.push(b[k]);
      for(i=0;i<foes.length;i++){
        if(!foeAlive(foes[i])) continue;
        var fr = foeVis(foes[i]);
        for(j=0;j<b2.length;j++) if(rectHit(fr, b2[j], 0)) n++;
      }
      return n;
    }
    function spawnBoxes(){
      var n=3+((Math.random()*3)|0), i;
      var x0=VW+50, high=Math.random()<0.6;
      for(i=0;i<n;i++){
        var t=n===1?0.5:i/(n-1), bx=x0+i*34;
        var by=high ? GROUND_Y-52-Math.sin(t*Math.PI)*72 : GROUND_Y-42;
        if(boxFree(bx, by)) boxes.push({ x:bx, y:by, t:Math.random()*6, k:((Math.abs(worldX+bx)|0)>>3) % TOY_N });
      }
      nextBoxX = worldX + 280 + Math.random()*430;
    }

    /* =========================================================
       敵（docs/enemy-spec.md）
       =========================================================
       **障害物との違いは「選べる」こと。**避けても進めるし、踏んでもよい。
       踏むと跳ね返って消え、コンボが伸びる。横や下から当たると被弾（ライフ-1）。
       9章の判断3点は石川さんが確定：避けられる／踏んだら消える／ライフ-1。

       踏み成立の3条件（1章）。**3つすべて**を満たしたときだけ踏み。
         1. 落下中（pl.vy > 0）
         2. **前フレームの足元**が敵の上面より上にあった
         3. 横が重なっている
       2 を「前フレーム」で見るのが肝心。いまのフレームだけで見ると、
       横から突っ込んで深くめり込んだ1フレーム目に「足元が上面より下」になり、
       踏めるはずの入り方が被弾になる（逆も起きる）。

       **上昇中は絶対に踏めない。**下から突き上げたら被弾、が直感に合う（仕様 1章）。

       当たり判定の詰め方は障害物（overlaps）と揃える：横4px・縦3px 内側。
       こうすると「見た目が触れた瞬間」と「判定」がずれない。 */
    var foes = [];
    /* 踏んだ直後の無敵（1章）。**敵にだけ効く。**
       障害物の当たりまで消すと、既存の遊び（跳ぶ・くぐる）の手応えが変わる。
       仕様の意図は「踏んで跳ねた上昇中に、次の敵の横に触れて死ぬ」を防ぐことなので、
       敵に限って効かせれば足りる（7章5「既存の遊びを壊さない」）。 */
    var foeGrace = 0;
    /* 連続踏みの段数（5章）。2体目 200点、3体目以降 300点。
       **仕様の「8フレーム以内」は使えない。**踏んだ跳ね返り（-6.5）で元の高さに
       戻るまでに 2*6.5/0.68 ≒ 19 フレームかかるので、8フレームでは2体目が
       物理的に成立せず、200点・300点が死に文言になる。
       **「着地するまで」を連鎖の窓にした**（跳ね続けている限り伸びる）。
       着地＝仕切り直し、は見た目にも分かりやすい。石川さんへの報告事項。 */
    var foeChain = 0;
    var FOE_BOUNCE = -6.5;          // 踏んだ跳ね返り（1章）
    var FOE_GRACE_F = 8;            // 踏んだ直後に敵で被弾しないフレーム数（1章）
    var FOE_PT = [100, 200, 300];   // 1体目・2体目・3体目以降（5章）
    var FOE_RIM = 5;                // 絵の外周。障害物の OBS_RIM と同じ考え方
    var FOE_W = { walker:32, hopper:30, flyer:30 };
    var FOE_H = { walker:32, hopper:30, flyer:26 };

    /* いまの姿勢での上端。hopper は跳ね、flyer は波打つ（移動は手順2で入れる）。
       **描画も判定もこの1か所から取る。**別々に計算すると必ずずれる */
    function foeTop(f){ return f.y - (f.hop || 0); }
    function foeRect(f){
      var t = foeTop(f);
      return { x:f.x+4, y:t+3, w:f.w-8, h:f.h-6 };
    }
    /* 絵の外周（**いまの姿勢**）。重なりを「数える」ときだけ使う */
    function foeVis(f){
      return { x:f.x-FOE_RIM, y:foeTop(f)-FOE_RIM, w:f.w+FOE_RIM*2, h:f.h+FOE_RIM*2 };
    }
    /* 敵が**動く先まで含めた**外周。場所取り（foeFree）・場所の掃き取り（sweepFoes）・
       仕入れ品の置き場所（solidVis）はこちらで見る。
       **いまの姿勢だけで見ると、跳ねた瞬間・波が上がった瞬間にだけ重なる置き方を見逃す。**
       実測：bar の下に hopper を置くと、跳ねた 40px で横棒に食い込んだ。
       flyer は帯の上端（113px）が fly の障害物（90〜118px）と重なった。
       tools/build.py の foe_rects と同じ見立て。**片方だけ直さないこと。** */
    function foeSpan(f){
      var top, bot;
      if(f.kind==='flyer'){ top = GROUND_Y-FOE_FLY_LOW-FOE_FLY_A-f.h; bot = GROUND_Y-FOE_FLY_LOW; }
      else if(f.kind==='hopper'){ top = GROUND_Y-f.h-FOE_HOP_H; bot = GROUND_Y; }
      else { top = GROUND_Y-f.h; bot = GROUND_Y; }
      return { x:f.x-FOE_RIM, y:top-FOE_RIM, w:f.w+FOE_RIM*2, h:(bot-top)+FOE_RIM*2 };
    }
    // 生きている敵だけが判定と場所取りに効く。潰れて消えかけの敵は素通りさせる
    function foeAlive(f){ return !f.dead; }

    /* 踏めるか。hb は hitBox()（スライド中は高さが縮む）。
       **足元は姿勢に関係なく pl.y+P_H**（絵の足の位置）。スライド中に
       判定の上端が下がることと、足元の高さは別の話 */
    function stompOK(f, hb){
      var r = foeRect(f);
      if(pl.vy <= 0) return false;                       // 1. 落下中だけ
      if(pl.footPrev > r.y + 8) return false;            // 2. 前フレームの足元が上面より上
      return hb.x < r.x+r.w && hb.x+hb.w > r.x;          // 3. 横の重なり
    }
    function foeHits(f, hb){
      var r = foeRect(f);
      return hb.x < r.x+r.w && hb.x+hb.w > r.x && hb.y < r.y+r.h && hb.y+hb.h > r.y;
    }
    /* 毎フレームの当たり。**踏みを先に見る。**
       同じフレームで踏みと被弾の両方が成り立つ入り方（上から浅く刺さる）では、
       遊ぶ人の意図はほぼ「踏み」なので、そちらを採る（7章2 理不尽にしない）。 */
    function foeCollide(hb){
      var i, f, stomped = false;
      for(i=0;i<foes.length;i++){
        f = foes[i];
        if(!foeAlive(f)) continue;
        if(stompOK(f, hb) && foeHits(f, hb)){
          stompFoe(f); stomped = true; continue;         // 同フレームに2体踏めてよい
        }
        if(stomped) continue;                            // 踏んだ直後は横の接触を見ない
        if(foeGrace > 0 || pl.inv > 0) continue;
        if(foeHits(f, hb)){ hit(); return; }
      }
    }
    /* =============== 敵を置く・動かす（enemy-spec 2章） ===============
       | 種類   | 動き                                   | 大きさ  | 踏む | 避ける |
       |--------|----------------------------------------|---------|------|--------|
       | walker | 地面を歩いて近づく（相対 +1.2px/frame）| 32×32   | 易   | 跳ぶ   |
       | hopper | その場で 90 フレーム周期に 40px 跳ねる | 30×30   | 中   | 跳ぶ   |
       | flyer  | 上下に波打ちながら近づく（振幅25・周期120）| 30×26 | 難   | 跳ばない |

       **flyer の高さ帯は「立って走れば必ず抜けられる」ように決めた。**
       仕様の「地面から60〜90px」は帯の指定だけで、立ち姿勢との関係が書かれていない。
       立ち姿勢の頭は接地面から 55px（HIT_Y+HIT_H=72、P_H=72 なので 72-17=55）。
       下端が 62px を切ると立って走る人に当たり、「避ける＝低く走る」（2章C）が
       成り立たなくなるので、**下端 62〜87px** を帯にした（最低 7px の余裕）。
       上端は 88〜113px で、ひと跳び（長押しで約155px）で必ず届く＝踏める。

       **flyer の横速度は仕様に数字が無い。**「近づく」とだけあるので、
       walker の半分（+0.6px/frame）にした。walker と同じにすると、
       跳ばずにやり過ごす種類（2章C）なのに追いつかれて避けようがなくなる。 */
    /* 2026-09-16 実機の指摘：**動いて見えない。**画面に映る約2秒で動きが読めなかった。
       walker +1.2 は背景の1割で止まって見え、hopper 90 フレーム周期は通り過ぎる間に
       1回跳ねるかどうか、flyer 振幅25・周期120 はほぼ直線だった。
         walker：+4.0px/frame（背景とほぼ同じ速さで「向かってくる」）
         hopper：35 フレーム周期・高さ 55px（画面内で2〜3回跳ねる）
         flyer ：振幅 45・周期 50（はっきり波打つ） */
    var FOE_WALK_V = 4.0, FOE_FLY_V = 0.6;
    /* 近づける上限（px）。**これが無いと配置が壊れる。**
       画面右端（プレイヤーから 680px）から出会うまでに walker は 148 フレーム歩き、
       1.2px/frame なら 177px＝8.8m も手前に寄る。手で決めた「障害物との間隔」が
       消え、**障害物の真裏に敵が立って、跳び越えた先で避けようがなくなる**。
       3m（60px）までに抑えれば、歩いて来る感じは残したまま配置の意図が保てる。 */
    /* **近づく距離の上限は「出会う地点を変えない」ために使う。**
       walker は置く場所（authored）より FOE_ADV_MAX だけ右に湧き、そこから 4px/frame で
       歩いてきて、ちょうど authored の位置で player に出会う。
       上限が無いと出会う地点が 25m 手前にずれ、手で決めた間隔（bar の直後・stack の前後…）
       が全部崩れる。220px なら 4px/frame で 55 フレーム歩き続け、画面に映っている
       時間（約 66 フレーム）のほとんどを歩いて過ごす。 */
    var FOE_ADV_MAX = 220;
    /* 敵が**プレイヤーと出会うときの x**（walker は authored の位置）。
       walker は湧いた直後 FOE_ADV_MAX だけ右にいるので、**配置の検査を f.x で測ると
       「walker の直後」の間隔を 11m ぶん間違える。**実測（2026-09-16）：walker の 14〜17m 後ろに
       書いた hopper・walker が foeTooTight で全部落ち、authored 3体のパターンが 2体、
       2体のパターンが 1体になっていた（ca02・ca04・ny01・pa06）。
       間隔・混雑・飛ぶ敵との距離は、出会う位置で測る。**重なりと助走路の検査はいまの位置のまま**
       （湧いた瞬間に体が重なれば歩けない） */
    function foeHomeX(f){ return f.kind==='walker' ? f.x - (FOE_ADV_MAX - f.adv) : f.x; }
    var FOE_HOP_T = 35, FOE_HOP_H = 55, FOE_HOP_AIR = 20;   // 周期・高さ・滞空フレーム
    var FOE_HOP_CROUCH = 6;                                 // 跳ぶ前にしゃがむフレーム数
    var FOE_FLY_T = 50, FOE_FLY_A = 45, FOE_FLY_LOW = 62;   // 周期・振幅・下端の最低
    var FOE_WALK_CYCLE = 8, FOE_FLAP_CYCLE = 6;             // 歩き・羽ばたきの周期（フレーム）
    function addFoe(x, kind){
      if(!FOE_W[kind]) kind = 'walker';
      var w = FOE_W[kind], h = FOE_H[kind];
      var y = (kind==='flyer') ? GROUND_Y - FOE_FLY_LOW - h : GROUND_Y - h;
      /* 位相は**置いた位置から決める。Math.random を使わない。**
         乱数を余分に消費すると、敵を出すかどうかでコースが変わる
         （音の noise() と同じ理由。CLAUDE.md「noise() は Math.random を使わない」） */
      // walker は歩いて戻ってくるぶん右に湧く（出会う地点 = x を保つ）
      var sx = (kind==='walker') ? x + FOE_ADV_MAX : x;
      foes.push({ x:sx, y:y, w:w, h:h, kind:kind, id:city.id, adv:0,
                  t:0, ph:(Math.abs(x)|0)%FOE_HOP_T, hop:0, dead:0, fade:0,
                  sx:1, sy:1, bob:0 });                    // sx/sy/bob はアニメーション用
      return w;
    }
    /* そこへ動いてよいか。**障害物と他の敵にめり込ませない**（4章「重なり防止」）。
       歩く敵は障害物に追いついたらそこで足踏みする（見た目も「箱に阻まれた」で通る） */
    function foeBlocked(f, nx){
      var r = foeSpan(f); r.x = nx-FOE_RIM;
      var a = solidVis(true), i;
      for(i=0;i<a.length;i++) if(rectHit(r, a[i], 0)) return true;
      for(i=0;i<foes.length;i++){
        if(foes[i]===f || !foeAlive(foes[i])) continue;
        if(rectHit(r, foeSpan(foes[i]), 0)) return true;
      }
      return false;
    }
    /* =============== 敵を配置してよいか（enemy-spec 4章） ===============
       出現させない場所：tier1／東京の最初の2パターン／IGS 帰還区間／ギミックと同時。
       出現の段階：1都市目は後半から walker のみ、2都市目は walker＋hopper、
                   3都市目以降は3種、エキスパートは最初から3種。

       **解禁されていない種類は「置き換えず、置かない」。**
       flyer を walker に落とすと、空にいる前提で書いた配置が地面に降りてきて、
       手で決めた間隔（障害物との距離）が崩れる。密度が下がるほうが安全（7章2）。 */
    function foeKindOK(kind){
      if(runMode==='expert') return true;
      if(legIdx===0) return kind==='walker';
      if(legIdx===1) return kind!=='flyer';
      return true;
    }
    /* ギミックのあるパターンか。**ここに敵を出すときは条件が付く**（下の foeLimit） */
    function patHasGimmick(p){
      for(var i=0;i<p.items.length;i++) if(p.items[i].type==='gimmick') return true;
      return false;
    }
    /* このパターンに置ける敵の数と種類（enemy-spec 4章＋2026-09-16 の石川さんの判断）。
       **ギミックのフィナーレにも敵を許す。**ただし
         ・walker だけ（砂嵐で視界が狭い・氷で滑る・ネオンで足元が不安定なところに
           跳ねる敵や飛ぶ 敵が同時に来ると理不尽になる）
         ・**1体まで**
       区間長（230m）は変えない。2分17秒の完走時間を作っている値で、
       触ると全都市のバランス検証をやり直すことになるため。 */
    function foeLimit(p){
      if(patHasGimmick(p)) return { n:1, only:'walker' };
      /* tier1（各都市の導入）は walker だけ・2体まで（2026-09-16 の方針変更）。
         2都市目以降は跳ぶ・くぐるを習得済みなので導入にも敵を出してよい、という判断。
         **東京の tier1 だけは従来どおり敵を出さない**（foesAllowed で弾く）。
         種類を増やさないのは、導入の役目（その都市のリズムを見せる）を壊さないため */
      if(p.tier===1) return { n:2, only:'walker' };
      return { n:3, only:'' };                           // 最大2体 → 3体に緩和
    }
    function foesAllowed(p){
      if(legIdx>=GOAL_IDX) return false;                 // IGS 帰還区間（凱旋）には出さない
      // **東京の tier1 だけは敵を出さない。**跳ぶ・くぐるをここで教え切る
      if(p.tier===1 && CITIES[legIdx].id==='tokyo') return false;
      if(runMode==='expert') return true;                // 最初から3種
      if(legIdx===0){                                    // 1都市目は後半から
        var done = dist + leadM() - LEG_START[legIdx];
        if(done / LEG_LEN[legIdx] < 0.5) return false;
      }
      return true;
    }
    /* 画面内の判断対象を3つ以上にしない（4章「密度」）。敵を足すと3つ目になるなら置かない。
       **窓は左右 VW*0.4（片側 12.8m）。**画面は 32m ぶん見えていて、
       プレイヤーは左端にいるので、前方に見えるのはおよそ 25m。
       これより広く取ると（最初は 0.55＝片側 17.6m にしていた）
       **画面に映らない障害物まで数えてしまい、敵がほとんど置けなくなる**
       （全ルートで2体しか出なかった。実測） */
    function foeCrowded(px){
      var n=0, i, R=VW*0.4;
      for(i=0;i<obs.length;i++)  if(Math.abs(obs[i].x-px) < R) n++;
      for(i=0;i<foes.length;i++) if(foeAlive(foes[i]) && Math.abs(foeHomeX(foes[i])-px) < R) n++;
      return n >= 2;
    }
    /* くぐる障害物（bar）の近くには置かない（7章1「敵は避けられること」）。
       **スライドは最低 SLIDE_MIN_F（20フレーム）続き、出口でも立ち上がりを待つ。**
       くぐった直後に地面の敵がいると、立ち上がる前に当たって避けようがない。
       実測：debug の連続出しで、bar の 6〜9m 後ろに置いた walker に必ず当たった
       （paris pa03・pole po03・香港 hk03 のいずれも同じ形）。
       速度 4.4px/frame なら 20フレームで 88px＝4.4m 進むので、
       **14m（280px）空ければ立ち上がってから跳ぶ余裕がある。** */
    var FOE_BAR_CLEAR = 280;
    /* **bar の手前にも置かない**（2026-09-16。踏む側の実測で判明）。
       敵を踏むと跳ね返り（-6.5）で約19フレーム浮く。そのあいだ進む距離は
       速度 4.4px/frame で約 84px。着地してからスライドに入る余裕まで含めて
       **200px（10m）**空ける。これが無いと「踏む → 浮いている間に横棒が来る →
       くぐれずに当たる」が必ず起きる（カイロ ca03 で連続して落ちた）。
       **踏まない人には関係ないが、踏む遊びを選んだ人が理不尽に死ぬ。** */
    var FOE_BAR_BEFORE = 200;
    /* **stack（積み荷。86px）の前後にも地面の敵を置かない。**
       stack は長押しジャンプでしか越えられず、滞空が約45フレームある。
       着地してから次の踏み切りまでの猶予が要るので 240px（12m）空ける。
       8.5m しか空けなかったとき、stack を跳んで着地 → 10フレームで hopper、
       となって避けようがなかった（paris pa05 で実測）。 */
    var FOE_STACK_CLEAR = 240;
    /* **飛ぶ敵は、地面の判断（障害物・地面の敵）から 300px（15m）離す。**
       跳び越える動作の弧はおよそ 45 フレーム＝170〜200px 続き、その間ずっと
       高さ 40〜155px を通る。flyer の帯（62〜113px）はその弧の中にあるので、
       地面のものを跳んだ勢いのまま飛ぶ敵に突っ込む。
       **飛ぶ敵は「跳ばずにやり過ごす」ものなので、跳ぶ場所と重ねない。**
       実測：walker を跳んだ直後に 9m 先の flyer へ上りざまに当たった（paris pa02・NY ny05）。 */
    var FOE_FLY_CLEAR = 300;
    function flyerNearGroundJudgement(px, w){
      var i;
      for(i=0;i<obs.length;i++){
        var o = obs[i];
        if(o.type==='fly') continue;                       // 空のものどうしは構わない
        if(px + w > o.x - FOE_FLY_CLEAR && px < o.x + o.w + FOE_FLY_CLEAR) return true;
      }
      for(i=0;i<foes.length;i++){
        var f = foes[i], hx = foeHomeX(f);
        if(!foeAlive(f) || f.kind==='flyer') continue;
        if(px + w > hx - FOE_FLY_CLEAR && px < hx + f.w + FOE_FLY_CLEAR) return true;
      }
      return false;
    }
    function foeNearStack(px, w){
      for(var i=0;i<obs.length;i++){
        var o = obs[i];
        if(o.type!=='stack') continue;
        if(px > o.x && px - (o.x+o.w) < FOE_STACK_CLEAR) return true;
        if(px < o.x && o.x - (px+(w||32)) < FOE_STACK_CLEAR) return true;
      }
      return false;
    }
    /* 氷面・水たまり（pads）と、乗れる足場（plats）のそば（2026-09-16 の石川さんの条件）。
       ・**氷面の外に置く。**氷の上は前に流されるので、その上や出口すぐの敵は
         止まれずに当たる。氷の幅（96px）の前後 80px（4m）を空ける
       ・**ネオン足場の下・真横に置かない。**「落ちるか」と「踏むか」の判断が重なる。
         足場の幅の前後 60px（3m）を空ける
       どちらも**地面を走る敵（walker）だけの話**。飛ぶ敵は高さが違うので見ない。 */
    var FOE_PAD_CLEAR = 80, FOE_PLAT_CLEAR = 60;
    function foeNearGround(px, w){
      var i, o;
      for(i=0;i<pads.length;i++){
        o = pads[i];
        if(px + w > o.x - FOE_PAD_CLEAR && px < o.x + o.w + FOE_PAD_CLEAR) return true;
      }
      for(i=0;i<plats.length;i++){
        o = plats[i];
        if(px + w > o.x - FOE_PLAT_CLEAR && px < o.x + o.w + FOE_PLAT_CLEAR) return true;
      }
      return false;
    }
    // その位置が「bar の直後」だけに当たるか（flyer は空中なので直後は許す）
    function foeNearBarAfterOnly(px){
      for(var i=0;i<obs.length;i++){
        var o = obs[i];
        if(o.type!=='bar' && o.skin!=='crowd') continue;
        if(px < o.x) return false;                       // 手前に bar がある＝許さない
      }
      return true;
    }
    function foeNearBar(px, w){
      for(var i=0;i<obs.length;i++){
        var o = obs[i];
        if(o.type!=='bar' && o.skin!=='crowd') continue;
        if(px > o.x && px - (o.x+o.w) < FOE_BAR_CLEAR) return true;      // くぐった直後
        if(px < o.x && o.x - (px+(w||32)) < FOE_BAR_BEFORE) return true; // くぐる手前
      }
      return false;
    }
    /* 敵と、手前の判断（障害物・他の敵）との最小の間隔（px）。
       **「重なっていない」では足りない。**跳んで着地し、次の踏み切りに入るまでに
       およそ 200px 進む。ここが足りないと、着地した瞬間にもう間に合わない配置になる
       （カイロ ca05・NY ny02 の hopper で、一度も跳べずに当たった）。 */
    /* **必要な間隔は「直前に何を跳んだか」で変わる。**跳ぶ高さが要るものほど
       滞空が長く、着地が遅れる。低いもの 180px／高いもの 240px／積み荷 300px。
         ・hopper（跳ね上がり 70px）の 11m 後ろに walker を置いたら、
           着地した時点でもう間に合わなかった（NY ny02 で実測）
         ・stack（86px）は長押しの滞空が約45フレームある */
    function foeStepGap(type){
      if(type==='stack') return 300;
      if(type==='tall' || type==='hopper') return 240;
      return 180;
    }
    function foeTooTight(px, w){
      var i;
      for(i=0;i<obs.length;i++){
        var o = obs[i];
        if(o.type==='fly') continue;                     // 跳ばなくてよいものは数えない
        if(px > o.x && px - (o.x+o.w) < foeStepGap(o.type)) return true;
      }
      for(i=0;i<foes.length;i++){
        var f = foes[i], hx = foeHomeX(f);          // walker は出会う位置で測る（上の foeHomeX）
        if(!foeAlive(f) || f.kind==='flyer') continue;
        if(px > hx && px - (hx+f.w) < foeStepGap(f.kind)) return true;
      }
      return false;
    }
    // そこに敵を置けるか（重なり防止。置く瞬間の検査）
    function foeFree(px, kind){
      var r=foeSpan({ x:px, kind:kind, h:FOE_H[kind]||32, w:FOE_W[kind]||32 });
      var a=solidVis(true), i;
      /* くぐる障害物との距離。**手前は種類を問わず空ける**（踏んだ跳ね返りで
         くぐれなくなるのは flyer でも同じ）。直後は地面の敵だけ見る */
      if(foeNearBar(px, FOE_W[kind]||32) &&
         (kind!=='flyer' || !foeNearBarAfterOnly(px))) return false;
      if(kind!=='flyer' && foeNearGround(px, FOE_W[kind]||32)) return false;  // 氷面・足場のそば
      if(kind!=='flyer' && foeNearStack(px, FOE_W[kind]||32)) return false;   // 積み荷の前後
      if(kind==='flyer' && flyerNearGroundJudgement(px, FOE_W[kind]||30)) return false;
      if(kind!=='flyer' && foeTooTight(px, FOE_W[kind]||32)) return false;   // 着地して跳び直す余裕
      /* walker は右に FOE_ADV_MAX 湧いて歩いて戻る。**その助走路に何かあると
         途中で足踏みして authored の位置に着けない**（出会う地点がずれる）。
         助走路（px 〜 px+FOE_ADV_MAX）に他の実体があれば置かない */
      if(kind==='walker'){
        var run = { x:px+(FOE_W.walker), y:GROUND_Y-FOE_H.walker-FOE_RIM, w:FOE_ADV_MAX, h:FOE_H.walker+FOE_RIM*2 };
        var sv = solidVis(true);
        for(i=0;i<sv.length;i++) if(rectHit(run, sv[i], 0)) return false;
        for(i=0;i<foes.length;i++) if(foeAlive(foes[i]) && rectHit(run, foeSpan(foes[i]), 0)) return false;
      }
      for(i=0;i<a.length;i++) if(rectHit(r, a[i], 3)) return false;
      for(i=0;i<foes.length;i++) if(foeAlive(foes[i]) && rectHit(r, foeSpan(foes[i]), 3)) return false;
      return true;
    }
    /* パターンに書かれた敵を置く。**1パターンに最大2体**（4章「密度」）。
       x0 はパターン先頭の画面x（items・parcels と同じ原点） */
    function spawnFoes(p, x0){
      var fl = p.foes || [], i, n = 0, lim = foeLimit(p);
      if(!foesAllowed(p)) return;
      for(i=0;i<fl.length && n<lim.n;i++){
        var k = fl[i].kind || 'walker', fx = x0 + fl[i].x*20;
        if(lim.only && k !== lim.only) continue;         // ギミック中は walker だけ
        if(!foeKindOK(k)) continue;
        if(foeCrowded(fx)) continue;
        if(!foeFree(fx, k)) continue;
        addFoe(fx, k); n++;
      }
    }

    function stepFoes(){
      var i, f, p;
      for(i=0;i<foes.length;i++){
        f = foes[i]; f.t++;
        if(f.dead){ f.fade--; continue; }          // 潰れたものは演出だけ進める
        if(f.kind==='walker'){
          var walking = f.adv < FOE_ADV_MAX && !foeBlocked(f, f.x-FOE_WALK_V);
          if(walking){ f.x -= FOE_WALK_V; f.adv += FOE_WALK_V; }
          // 歩き：8フレーム周期で体が上下に揺れる（足の交互は焼き込みの2コマ）
          f.bob = walking ? Math.abs(Math.sin(Math.PI*f.t/(FOE_WALK_CYCLE/2)))*2.2 : 0;
          f.sx = 1; f.sy = 1;
        } else if(f.kind==='hopper'){
          p = (f.t + f.ph) % FOE_HOP_T;
          f.hop = (p < FOE_HOP_AIR) ? FOE_HOP_H*Math.sin(Math.PI*p/FOE_HOP_AIR) : 0;
          /* 予備動作と伸び：跳ぶ直前の FOE_HOP_CROUCH フレームはしゃがみ（横に広く縦に低く）、
             上昇中は縦に伸び、着地の瞬間はつぶれる。**判定は変えない**（見た目だけ） */
          var toJump = FOE_HOP_T - p;                       // 次の跳躍まで
          if(p >= FOE_HOP_AIR && toJump <= FOE_HOP_CROUCH){
            var c = 1 - toJump/FOE_HOP_CROUCH;              // 0→1 でしゃがみが深くなる
            f.sx = 1 + 0.22*c; f.sy = 1 - 0.28*c;
          } else if(p < FOE_HOP_AIR){
            var up = p < FOE_HOP_AIR/2;
            f.sx = up ? 0.88 : 0.96; f.sy = up ? 1.18 : 1.04;
          } else if(p < FOE_HOP_AIR + 3){
            f.sx = 1.18; f.sy = 0.8;                        // 着地のつぶれ
          } else { f.sx = 1; f.sy = 1; }
        } else {
          if(f.adv < FOE_ADV_MAX && !foeBlocked(f, f.x-FOE_FLY_V)){ f.x -= FOE_FLY_V; f.adv += FOE_FLY_V; }
          // 下端が FOE_FLY_LOW〜FOE_FLY_LOW+振幅 の間を往復する
          var ph2 = 2*Math.PI*(f.t+f.ph)/FOE_FLY_T;
          var lo = FOE_FLY_LOW + FOE_FLY_A*(0.5 - 0.5*Math.cos(ph2));
          f.y = GROUND_Y - lo - f.h;
          f.tilt = Math.sin(ph2)*0.22;                      // 上昇で前傾・下降で後傾（波に乗る）
          f.sx = 1; f.sy = 1;
        }
      }
    }

    /* 踏んだ（1章の報酬・6章の音）。加点は手順6でここに足す。
       **画面全体を光らせない**（CLAUDE.md「画面全体のフラッシュ・強い明滅を入れない」）。
       手応えは 跳ね返り・つぶれ・粒・音 の4つだけで作る。 */
    function stompFoe(f){
      f.dead = 1; f.fade = 14;
      pl.vy = FOE_BOUNCE; pl.ground = false; pl.dive = false;
      pl.jumps = Math.min(pl.jumps, 1);                  // 踏んだら2段ジャンプを1回返す
      pl.squash = 1;                                     // 着地と同じつぶれ（踏んだ感触）
      pl.stretch = 0;
      foeGrace = FOE_GRACE_F;
      foeChain++;
      sfxStomp(foeChain);
      /* 加点（5章）。1体目 100、2体目 200、3体目以降 300。
         **倍率は掛けない。**掛けると ×5 のときに1体で 1500 点入り、
         小包を集める遊び（コンボの線を拾う）より踏むほうが強くなる。
         仕様の表も「敵を踏む＝100点」と倍率に触れていない。
         敵の役目はコンボを**伸ばす**ことで、点そのものではない */
      var gain = FOE_PT[Math.min(foeChain, FOE_PT.length) - 1];
      sFoe += gain;
      stomps++; stompPop = 8;                            // HUD の「撃退」がはねる（小包と同じ 8f）
      bumpCombo();                                       // 仕入れコンボが +1（5章）
      var fx = f.x + f.w/2, fy = foeTop(f) - 6;
      bits.push({ x:fx, y:fy, vx:0, vy:-24/26, life:26, world:true, c:'#b7d029',
                  txt:'+'+gain+(foeChain>1 ? ' 連続'+foeChain : '') });
      if(!reduce){
        /* 潰れた地点から左右に散る粒。**world:true で地面と一緒に流す**
           （その場に置き去りにする。踏んだ位置が残って見える） */
        var cx = f.x + f.w/2, cy = foeTop(f) + 2, i;
        for(i=0;i<9;i++){
          bits.push({ x:cx, y:cy, vx:(Math.random()-.5)*4.6, vy:-Math.random()*2.4,
                      life:18, s:3, world:true,
                      c:['#fc930a','#b7d029','#f2f0e2'][(Math.random()*3)|0] });
        }
        bits.push({ x:cx, y:cy, vx:0, vy:0, life:12, ring:true, world:true, c:'#b7d029' });
      }
      hitStop = reduce ? 0 : 2;                          // 2フレームだけ止める。被弾（5）より軽く
    }

    var OBS_ASSET = { low:'obs-low', tall:'obs-tall', stack:'obs-stack', bar:'obs-bar' };
    /* =============== 踏切（東京のフィナーレ。TODO 8） ===============
       ・当たり判定は遮断機（low）だけ。**電車は演出で、判定を持たない**
       ・音は TODO 9 なので、いまは目だけで「電車が来る」と分かるようにする
         ＝ 腕木が下りる動き＋警報機の灯りの交互点滅
       ・遮断機を跳び越えたら、背後（近景層）を電車が右から左へ横切る

       crossing は1つだけ持つ（フィナーレでしか出ないため）。
       x は世界と一緒に流し、画面外に出たら捨てる。 */
    var cross = null;
    var CROSS_DOWN_X = 0.46, CROSS_WARN_X = 0.95;   // 腕木が下りきる／下り始める画面位置（VW比）
    var TRAIN_V = 22, TRAIN_CARS = 3;               // 電車の速度（px/frame）と中間車の数

    /* =============== ギミックの更新（TODO 3） ===============
       **当たって死ぬものは1つも無い。**足場は乗れなければ素通り、
       水たまりと氷は判定が無く、砂嵐は見えにくくなるだけ。 */
    function updateGim(){
      var i, px = pl.x+HIT_X, pw = HIT_W, q, p2;
      // 目印を踏んだら効果開始
      for(i=0;i<trigs.length;i++) if(trigs[i].x <= px + pw){
        if(trigs[i].k==='sand') gim.sand = 330;      // 5.5秒
        if(trigs[i].k==='rain') gim.rain = 420;      // 7秒（区間の残りを覆う長さ）
        trigs[i].x = -9999;
      }
      if(gim.sand>0)  gim.sand--;
      if(gim.rain>0)  gim.rain--;
      if(gim.wet>0)   gim.wet--;
      if(gim.boost>0) gim.boost--;
      gim.ice = Math.max(0, gim.ice-1);              // 氷は上に居る間だけ立て直す

      // 地面の装飾。接地しているときだけ効く
      for(i=0;i<pads.length;i++){
        p2 = pads[i];
        if(!pl.ground || px+pw < p2.x || px > p2.x+p2.w) continue;
        if(p2.k==='puddle'){
          if(gim.wet<=0){                            // 踏んだ瞬間だけ水しぶき
            for(var j=0;j<7;j++) bits.push({ x:px+pw/2, y:GROUND_Y-2,
              vx:(Math.random()-.5)*2.6, vy:-Math.random()*2.2, life:16, c:'#9fd8ee', s:3, world:true });
          }
          gim.wet = 240;                             // 4秒のあいだ、スライドが伸びる
        } else {
          gim.ice = 4;                               // 氷の上にいる間ずっと（離れれば数フレームで切れる）
        }
      }

      /* 乗れる足場。**上から降りてきたときだけ乗る。**
         横や下から当たっても何も起きない（障害物ではない）。 */
      for(i=0;i<plats.length;i++){
        q = plats[i]; q.t++;
        // ネオンは点滅。150フレーム周期のうち 96 フレームだけ光る＝乗れる
        q.on = (q.k==='neon') ? (((q.t + q.ph) % 150) < 96) : true;
        if(!q.on) continue;
        if(pl.vy >= 0 && px+pw > q.x+5 && px < q.x+q.w-5 &&
           pl.y+P_H >= q.y-3 && pl.y+P_H <= q.y+16){
          if(!pl.ground) pl.squash = 1;
          pl.y = q.y-P_H; pl.vy = 0; pl.ground = true; pl.jumps = 0; pl.dive = false;
          if(q.k==='taxi' && !q.used){                // 屋根に乗ったら3秒加速
            q.used = true; gim.boost = 180; sfxDouble();
            for(var m=0;m<10;m++) bits.push({ x:px+pw/2, y:q.y, vx:(Math.random()-.5)*3.2,
              vy:-Math.random()*2.6, life:22, c:'#f2c531', s:4 });
          }
        }
      }
    }
    /* 地面の装飾（判定なし）。水たまりは映り込み、氷は白い艶。
       **どちらも「踏むと何かが変わる床」だと分かる程度に控えめに描く。**
       濃く描くと障害物と間違える（それがいちばん困る）。 */
    function drawPad(p2){
      var y = GROUND_Y-1;
      ctx.save();
      if(p2.k==='puddle'){
        ctx.globalAlpha = 0.55;
        ctx.fillStyle = 'rgba(120,190,225,.55)';
        ctx.beginPath(); ctx.ellipse(p2.x+p2.w/2, y, p2.w/2, 4.5, 0, 0, 7); ctx.fill();
        ctx.globalAlpha = 0.9;
        ctx.strokeStyle = 'rgba(220,244,255,.7)'; ctx.lineWidth = 1;
        ctx.beginPath(); ctx.ellipse(p2.x+p2.w/2, y, p2.w/2, 4.5, 0, 0, 7); ctx.stroke();
        // 空の映り込み。2本の細い横線で「濡れている」と読ませる
        ctx.fillStyle = 'rgba(255,255,255,.5)';
        ctx.fillRect(p2.x+p2.w*0.22, y-1.5, p2.w*0.24, 1);
        ctx.fillRect(p2.x+p2.w*0.56, y+0.5, p2.w*0.16, 1);
      } else {
        ctx.globalAlpha = 0.85;
        ctx.fillStyle = 'rgba(232,248,255,.75)';
        ctx.fillRect(p2.x, y-4, p2.w, 6);
        ctx.fillStyle = 'rgba(150,200,225,.6)';
        ctx.fillRect(p2.x, y+1, p2.w, 1.5);
        ctx.strokeStyle = 'rgba(255,255,255,.9)'; ctx.lineWidth = 1;
        for(var i=0;i<3;i++){                     // ひび。氷だと分かる印
          var ix = p2.x + p2.w*(0.2+i*0.3);
          ctx.beginPath(); ctx.moveTo(ix, y-4); ctx.lineTo(ix+5, y+1); ctx.stroke();
        }
      }
      ctx.restore();
    }
    /* 乗れる足場。タクシー（NY）とネオン看板（香港）。
       **光っていない看板は half alpha で描く。**乗れないことが見て分かる必要がある。 */
    function drawPlat(q){
      ctx.save();
      if(q.k==='taxi'){
        var x=q.x, y=q.y, w=q.w, h=q.h;
        ctx.fillStyle='#1a1c22';                                   // 影
        ctx.beginPath(); ctx.ellipse(x+w/2, GROUND_Y-1, w*0.46, 4, 0, 0, 7);
        ctx.globalAlpha=0.3; ctx.fill(); ctx.globalAlpha=1;
        ctx.fillStyle='#F2C531'; rr(ctx, x, y+13, w, h-16, 4); ctx.fill();   // 車体
        ctx.fillStyle='#E0AE22'; rr(ctx, x+11, y+2, w-30, 14, 4); ctx.fill();// 屋根
        ctx.fillStyle='#2A3340';                                              // 窓
        rr(ctx, x+15, y+5, 18, 9, 2); ctx.fill();
        rr(ctx, x+37, y+5, 15, 9, 2); ctx.fill();
        ctx.fillStyle='#F8F4E8'; ctx.fillRect(x+8, y+22, w-16, 5);            // 帯
        ctx.fillStyle='#2A3340';
        ctx.beginPath(); ctx.arc(x+17, y+h-3, 6, 0, 7); ctx.fill();           // 車輪
        ctx.beginPath(); ctx.arc(x+w-17, y+h-3, 6, 0, 7); ctx.fill();
        ctx.fillStyle='#F8F4E8'; rr(ctx, x+w/2-9, y-4, 18, 7, 2); ctx.fill(); // 行灯
        ctx.fillStyle='#C4243F'; ctx.font='700 5px '+FONT; ctx.textAlign='center';
        ctx.fillText('TAXI', x+w/2, y+1.5); ctx.textAlign='left';
      } else {
        var on = q.on;
        ctx.globalAlpha = on ? 1 : 0.34;
        if(on){                                    // 光っている間だけ光暈を落とす
          ctx.save(); ctx.globalCompositeOperation='lighter'; ctx.globalAlpha=0.28;
          ctx.drawImage(gx().warm.c, q.x-18, q.y-20, q.w+36, 44);
          ctx.restore();
        }
        ctx.fillStyle = on ? '#C8102E' : '#4A2830';
        rr(ctx, q.x, q.y, q.w, q.h, 2); ctx.fill();
        ctx.fillStyle = on ? '#FFE0A0' : '#6A5A50';
        ctx.fillRect(q.x+3, q.y+2, q.w-6, 2);      // 蛍光管
        ctx.fillStyle = on ? '#FFF6DC' : '#5A4A44';
        ctx.font='700 7px '+FONT; ctx.textAlign='center';
        ctx.fillText('好', q.x+q.w/2, q.y+q.h-2.5); ctx.textAlign='left';
      }
      ctx.restore();
    }
    /* 砂嵐（カイロ）。**画面の周囲を砂で閉じる。**中央だけが見える状態にして、
       障害物を減らしたぶんの緊張をここで作る。フラッシュはしない（明滅禁止）。 */
    function drawSand(){
      if(gim.sand<=0) return;
      var a = Math.min(1, gim.sand/40) * Math.min(1, (330-gim.sand)/30);   // 出入りをなめらかに
      var gr = ctx.createRadialGradient(VW*0.42, VH*0.55, VH*0.22, VW*0.42, VH*0.55, VH*0.95);
      gr.addColorStop(0, 'rgba(214,176,116,0)');
      gr.addColorStop(0.55, 'rgba(212,172,112,.42)');
      gr.addColorStop(1, 'rgba(196,152,96,.88)');
      ctx.save();
      ctx.globalAlpha = a;
      ctx.fillStyle = gr; ctx.fillRect(0,0,VW,VH);
      // 流れる砂の筋。粒を増やさず、細い線を数本だけ
      ctx.strokeStyle = 'rgba(240,214,170,.5)'; ctx.lineWidth = 1;
      for(var i=0;i<9;i++){
        var sy = ((i*47 + tick*7) % (VH+40)) - 20;
        var sx = ((i*173 - tick*13) % (VW+140)) - 70;
        ctx.beginPath(); ctx.moveTo(sx, sy); ctx.lineTo(sx+38, sy+3); ctx.stroke();
      }
      ctx.restore();
    }
    function addCrossing(px){
      var w = addObs(px, 'low', 'crossing');        // 判定はこれだけ
      // 警報機は線路の手前と向こうに1本ずつ。腕木の付け根に合わせて少し手前に置く
      cross = { x:px, w:w, sig:[px-30, px+118], train:null, done:false };
    }
    // 腕木の下り具合（0＝上がりきり、1＝下りきり）。画面の右から近づくにつれて下りる
    function crossDown(){
      if(!cross) return 1;
      var a = VW*CROSS_WARN_X, b = VW*CROSS_DOWN_X;
      return Math.max(0, Math.min(1, (a - cross.x) / (a - b)));
    }
    // 警報中か。遮断機が下り始めてから、電車が通り過ぎるまで
    function crossWarn(){
      if(!cross) return false;
      if(cross.train) return true;
      return !cross.done && crossDown() > 0;
    }
    function updateCrossing(v){
      if(!cross) return;
      cross.x -= v;
      // 腕木が下り始めたら警報。鳴らすのは1回だけ（3往復で止まる）
      if(!cross.warned && crossDown() > 0){ cross.warned = true; sfxAlarm(); }
      cross.sig[0] -= v; cross.sig[1] -= v;
      // 遮断機を跳び越えたら電車を出す。iGくんの背後を横切らせたいので、通過を待つ
      if(!cross.done && !cross.train && cross.x + cross.w < pl.x + HIT_X){
        cross.done = true;
        cross.train = { x: VW + 40 };
      }
      if(cross.train){
        cross.train.x -= TRAIN_V + v;               // 世界の流れに電車自身の速さを足す
        if(cross.train.x + trainW() < -40) cross.train = null;
      }
      if(cross.x < -260 && !cross.train) cross = null;
    }
    var TRAIN_BW = 120, TRAIN_BH = 68;              // 1両の大きさ（6.0×3.4m）
    function trainW(){ return TRAIN_BW*(1+TRAIN_CARS); }

    /* 電車。近景の props より奥に描くので、街灯や木が手前に重なって奥行きが出る。
       窓は mid-window（灯りの素材）を重ねて点灯させる。夜の都市で暗いままだと物体に見えない */
    function drawTrain(t){
      // 線路は描かない。地面から少し浮かせて奥に置き、近景の建物や街灯が
      // 手前に重なることで「奥を走っている」と読ませる
      /* 電車の高さ。近景がビルの列になったので、低いと店先の裏に完全に隠れる。
         38px 上げると屋根の低いビルの上に上半分が出て、高いビルの手前は
         隠れる＝「奥を横切っている」と読める */
      var i, j, bw=TRAIN_BW, bh=TRAIN_BH, y=GROUND_Y-bh-38;
      var P=procOf(CITY_BY_ID.tokyo);
      if(P){
        for(i=0;i<=TRAIN_CARS;i++){
          var tx=t.x+i*bw;
          if(tx > VW+10 || tx < -bw-10) continue;
          blit(P.train[i===0?0:1], tx, y);
          ctx.save(); ctx.globalCompositeOperation='lighter'; ctx.globalAlpha=0.35;
          ctx.drawImage(gx().warm.c, tx+bw/2-58, y+bh/2-58, 116, 116);   // 車内の灯りがこぼれる
          ctx.restore();
        }
        return;
      }
      for(i=0;i<=TRAIN_CARS;i++){
        var x = t.x + i*bw;
        if(x > VW+10 || x < -bw-10) continue;
        drawAssetOf('tokyo', i===0 ? 'over-train-head' : 'over-train-car', x, y, bw, bh);
        // 窓は灯りの素材を 'lighter' で重ねて点灯させる。
        // 暗いままだと背景のビルの窓に紛れて、物が横切ったと分からない
        ctx.save();
        ctx.globalCompositeOperation='lighter';
        for(j=0;j<3;j++) drawAssetOf('tokyo', 'mid-window', x + (i===0?22:17) + j*35, y+16, 18, 23);
        ctx.restore();
      }
    }
    /* 警報機。柱と頭は素材、灯りは accent 素材を 'lighter' で重ねて光らせる。
       8フレームごとに左右が入れ替わる（踏切の交互点滅） */
    function drawSignals(){
      if(!cross) return;
      var i, on = crossWarn(), lit = reduce ? 1 : (Math.floor(tick/8)%2);
      var P=procOf(CITY_BY_ID.tokyo);
      for(i=0;i<2;i++){
        var sx=cross.sig[i];
        if(sx < -50 || sx > VW+50) continue;
        if(P){
          blit(P.signal, sx-P.signal.pad, GROUND_Y-P.signal.bh-P.signal.pad);
          if(!on) continue;
          /* 警報灯。8フレームごとに左右が入れ替わる（踏切の交互点滅）。
             光り物なので lighter で重ねる（1度だと夜空に沈む） */
          ctx.save(); ctx.globalCompositeOperation='lighter';
          var px2=sx+6+(lit?0:12), py2=GROUND_Y-P.signal.bh+16;
          ctx.globalAlpha=0.9; ctx.drawImage(gx().red.c, px2-11, py2-11, 22, 22);
          ctx.globalAlpha=1; ctx.fillStyle='#FF3B2E';
          ctx.beginPath(); ctx.arc(px2, py2, 3, 0, 7); ctx.fill();
          ctx.restore();
          continue;
        }
        drawAssetOf('tokyo', 'prop-signal', sx, GROUND_Y-84, 26, 84);
        if(!on) continue;
        ctx.save();
        ctx.globalCompositeOperation='lighter';
        // 頭は素材の上端 26px ぶん。その中に灯りを2つ並べ、8フレームごとに入れ替える。
        // 光り物なので 'lighter' で2度重ねる（1度だと夜空に沈む）
        var lx = sx+1 + (lit?0:12), ly = GROUND_Y-80;
        drawAssetOf('tokyo', 'prop-signal-lamp', lx, ly, 13, 13);
        drawAssetOf('tokyo', 'prop-signal-lamp', lx, ly, 13, 13);
        ctx.restore();
      }
    }
    /* 遮断機。柱と筋交いは判定の枠に合わせて描き、腕木だけ付け根で回す */
    function drawCrossingGate(o){
      var down = crossDown(), ang = -(1-down)*1.15;
      var P = PROC_PAL[o.id] ? procOf(CITY_BY_ID[o.id]) : null;
      if(P){
        ctx.save(); ctx.globalAlpha=0.85;
        ctx.drawImage(gx().ao.c, o.x-o.w*0.5, GROUND_Y-6, o.w*2, 14);
        ctx.restore();
        blit(P.obs.crossing, o.x-P.obs.crossing.pad, o.y-P.obs.crossing.pad);
        ctx.save();
        ctx.translate(o.x+6, o.y+5);                // 付け根（柱の上）
        ctx.rotate(ang);
        blit(P.arm, -P.arm.pad, -P.arm.bh/2-P.arm.pad);
        ctx.restore();
        return;
      }
      ctx.fillStyle='rgba(0,0,0,.2)';
      ctx.fillRect(o.x-3, GROUND_Y-1, o.w+6, 4);
      drawAssetOf(o.id, 'obs-crossing', o.x-3, o.y-3, o.w+6, o.h+4);
      ctx.save();
      ctx.translate(o.x+3, o.y+4);                  // 付け根（柱の上）
      ctx.rotate(ang);
      if(!drawAssetOf(o.id, 'obs-crossing-arm', 0, -5, o.w+22, 10)){
        ctx.fillStyle=rgb(C.obs); ctx.fillRect(0, -5, o.w+22, 10);  // 素材が来ていないときの保険
      }
      ctx.restore();
    }

    /* proc の障害物（art-direction-final.md 3章の構成案）。
       low=木箱 ／ tall=**自動販売機** ／ stack=提灯やぐら ／ bar=工事用バリケード ／ fly=カラス。
       自販機を背景から障害物に移した。東京らしさが遊びに直結する。
       o.id はその障害物を出した都市。切り替え中に色が飛ばないよう都市で描き分ける */
    function drawObsProc(o){
      var cy = CITY_BY_ID[o.id], P = procOf(cy);
      if(!P) return false;
      var A = (o.skin && P.obs[o.skin]) || P.obs[o.type], y = o.y;
      if(o.skin==='crossing') return false;                 // 遮断機は drawCrossingGate
      if(o.type==='fly'){
        y = o.y + Math.sin((tick+o.t*10)*0.13)*5;
        A = P.obs.fly[Math.floor(tick/6)%2];
      }
      if(!A) return false;
      if(o.type!=='fly'){                                   // 接地の影
        ctx.save(); ctx.globalAlpha*=0.85;
        ctx.drawImage(gx().ao.c, o.x-o.w*0.5, GROUND_Y-6, o.w*2, 14);
        ctx.restore();
      }
      if(A.glow){                                           // 灯りが路面にこぼれる
        ctx.save(); ctx.globalCompositeOperation='lighter'; ctx.globalAlpha*=0.3;
        ctx.drawImage(gx().warm.c, o.x+o.w/2-A.gr, y+o.h/2-A.gr, A.gr*2, A.gr*2);
        ctx.restore();
      }
      if(A.posts){
        /* bar の支柱。**焼き込みの中では地面まで届かない**（判定の箱ぶんしか無い）ので
           ここで接地面まで通す。細い2本にして、くぐる隙間が開いて見えるようにする。

           **濃い1色で描くと、暗い建物の前では消えて barが宙に浮いて見える**
           （実際に消えていた）。濃い縁の内側に明るい芯を入れて、
           明るい背景でも暗い背景でも輪郭が出るようにする。 */
        var py3 = y+o.h-2, ph3 = GROUND_Y-(y+o.h)+2, k3;
        for(k3=0;k3<2;k3++){
          var px3 = k3 ? o.x+o.w-7 : o.x+2;
          ctx.fillStyle = A.postD || 'rgba(10,14,26,.75)';
          ctx.fillRect(px3, py3, 5, ph3);
          ctx.fillStyle = A.postC || '#B6C0D2';
          ctx.fillRect(px3+1, py3, 3, ph3);
        }
      }
      blit(A, o.x-A.pad, y-A.pad);
      if(A.lamp){                                           // バリケードの黄色い回転灯
        var bl = reduce ? 0.6 : (((tick*0.037+o.t)%1.6) < 0.8 ? 1 : 0.15);
        var lx=o.x+o.w/2, ly=y-3;
        ctx.save(); ctx.globalAlpha*=bl;
        ctx.drawImage(gx().warm.c, lx-11, ly-11, 22, 22);
        ctx.fillStyle='#FFC24A'; ctx.beginPath(); ctx.arc(lx,ly,1.8,0,7); ctx.fill();
        ctx.restore();
      }
      return true;
    }
    function drawObs(o){
      var y=o.y, name;
      if(o.skin==='crossing'){ drawCrossingGate(o); return; }
      if(drawObsProc(o)) return;
      if(o.type==='fly'){
        y = o.y + Math.sin((tick+o.t*10)*0.13)*5;
        name = (Math.floor(tick/6)%2) ? 'obs-fly-b' : 'obs-fly-a';   // 羽ばたきの2コマ
      } else {
        // skin があればそちらの素材を先に試す（池袋の crowd など。素材は TODO 8）
        name = (o.skin && asset(o.id+'-obs-'+o.skin)) ? ('obs-'+o.skin) : (OBS_ASSET[o.type] || 'obs-low');
        ctx.fillStyle='rgba(0,0,0,.2)';                              // 接地の影
        ctx.fillRect(o.x-3, GROUND_Y-1, o.w+6, 4);
      }
      // 絵はアウトラインの分だけ判定枠より少し大きく描く。
      // 障害物は「どの都市で出したか」で描く（都市の切り替え中に色が飛ばないように）
      if(drawAssetOf(o.id, name, o.x-3, y-3, o.w+6, o.h+4)) return;
      // 素材が来ていないときの保険。当たるものが見えないと理不尽になるため塗る
      ctx.fillStyle=rgb(C.obs); ctx.fillRect(o.x, y, o.w, o.h);
    }
    /* =============== 敵を描く（enemy-spec 3章） ===============
       焼き込み1枚を blit するだけ。**毎フレームの図形描画はしない**（障害物と同じ作法）。
       踏まれた敵（dead）は縦に潰して薄れる（9章の判断2「潰れる演出→フェード」）。
       焼き込みが無い都市・素材版では、**目を持った濃い矩形**で代用する。
       敵が見えないのは理不尽そのものなので、必ず何かを描く。 */
    function drawFoe(f){
      var cy = CITY_BY_ID[f.id], P = procOf(cy), A = null, top = foeTop(f);
      if(P && P.foe){
        if(f.kind==='walker')      A = P.foe.walker[Math.floor(f.t/(FOE_WALK_CYCLE/2))%2];   // 8フレーム周期の2コマ
        else if(f.kind==='flyer')  A = P.foe.flyer [Math.floor(f.t/(FOE_FLAP_CYCLE/2))%2];   // 6フレーム周期の羽ばたき
        else                       A = P.foe.hopper;
      }
      var a = f.dead ? Math.max(0, f.fade/14) : 1;
      var sy = (f.dead ? 0.35 + 0.65*a : 1) * (f.sy||1);   // 潰れ × アニメーションの伸縮
      var sx = (f.dead ? 1 + (1-a)*0.5 : 1) * (f.sx||1);
      ctx.save();
      ctx.globalAlpha *= a;
      if(f.kind!=='flyer'){                                  // 接地の影（跳ねると薄く小さく）
        var hp = (f.hop||0)/FOE_HOP_H, sc = 1-hp*0.45;
        ctx.save(); ctx.globalAlpha *= 0.8*(1-hp*0.5);
        if(PROC_PAL[f.id]) ctx.drawImage(gx().ao.c, f.x-f.w*0.4*sc, GROUND_Y-6, f.w*1.8*sc, 13);
        else { ctx.fillStyle='rgba(0,0,0,.2)'; ctx.fillRect(f.x-2, GROUND_Y-1, f.w+4, 4); }
        ctx.restore();
      }
      // 足元（flyer は体の中心）を軸に、伸縮・揺れ・傾きを掛ける
      if(f.kind==='flyer'){
        ctx.translate(f.x + f.w/2, top + f.h/2);
        ctx.rotate(f.tilt||0);
        ctx.translate(0, f.h/2);
      } else {
        ctx.translate(f.x + f.w/2, top + f.h - (f.bob||0));
      }
      ctx.scale(sx, sy);
      if(A){
        ctx.drawImage(A.c, -f.w/2 - A.pad, -f.h - A.pad, A.w, A.h);
        /* 瞳。**プレイヤーの方を見る**（指摘3）。焼き込みには白目しか無い。
           目の位置は焼き込みが持っている（A.eyes。popObs の PAD ぶんはずらしてある） */
        if(A.eyes && !f.dead){
          var ox = -f.w/2 - A.pad, oy = -f.h - A.pad, k;
          var tx = (pl.x + HIT_X + HIT_W/2) - (f.x + f.w/2);
          var ty = (pl.y + HIT_Y + HIT_H/2) - (top + f.h/2);
          var L = Math.sqrt(tx*tx + ty*ty) || 1;
          for(k=0;k<A.eyes.length;k++){
            var e = A.eyes[k], px2 = ox + e.x + (tx/L)*e.r*0.42, py2 = oy + e.y + (ty/L)*e.r*0.36;
            ctx.fillStyle='#10131F';
            ctx.beginPath(); ctx.arc(px2, py2, e.r*0.55, 0, 7); ctx.fill();
            ctx.fillStyle='rgba(255,255,255,.75)';
            ctx.beginPath(); ctx.arc(px2 - e.r*0.2, py2 - e.r*0.22, e.r*0.16, 0, 7); ctx.fill();
          }
        }
      } else {
        ctx.fillStyle='#2A2030'; ctx.fillRect(-f.w/2, -f.h, f.w, f.h);
        ctx.strokeStyle='#FFE98A'; ctx.lineWidth=1.5; ctx.strokeRect(-f.w/2, -f.h, f.w, f.h);
        ctx.fillStyle='rgba(245,248,255,.95)';
        ctx.beginPath(); ctx.arc(-f.w*0.18, -f.h*0.6, 4, 0, 7); ctx.fill();
        ctx.beginPath(); ctx.arc(f.w*0.18, -f.h*0.6, 4, 0, 7); ctx.fill();
        ctx.fillStyle='#10131F';
        ctx.beginPath(); ctx.arc(-f.w*0.22, -f.h*0.58, 2, 0, 7); ctx.fill();
        ctx.beginPath(); ctx.arc(f.w*0.14, -f.h*0.58, 2, 0, 7); ctx.fill();
      }
      ctx.restore();
    }

    /* 仕入れの箱。proc の都市では焼き込んだ箱を使い、青白い光暈をまとわせる
       （拾えるものだと分かることが第一。障害物と同じ暖色にはしない） */
    function drawBox(b){
      if(PROC_PAL[city.id]){
        var B=gx().toys[b.k||0];
        ctx.save();
        ctx.globalCompositeOperation='lighter';
        ctx.globalAlpha=0.30+0.12*Math.sin((tick+b.t*9)*0.07);
        ctx.drawImage(gx().cyan.c, b.x-24, b.y-24, 48, 48);   // 淡い光暈。障害物は光らない
        ctx.restore();
        ctx.save();
        ctx.translate(b.x, b.y);
        ctx.rotate(Math.sin((tick+b.t*9)*0.05)*0.16);
        ctx.drawImage(B.c, -B.w/2, -B.h/2, B.w, B.h);
        ctx.restore();
        return;
      }
      var im=asset('common-parcel');
      ctx.save();
      ctx.translate(b.x, b.y);
      ctx.rotate(Math.sin((tick+b.t*9)*0.05)*0.16);
      if(im) ctx.drawImage(im, -11, -11, 22, 22);
      else { ctx.fillStyle='#fc930a'; ctx.fillRect(-11,-11,22,22); }
      ctx.restore();
    }

    /* =============== iGくん（パペットアニメーション。docs/plan-a.md 2章） ===============
       1枚絵を変形させて動かす。変形は poseNow() 1か所で作り、残像も同じ形を取っておいて描く。 */
    function poseNow(){
      var air=!pl.ground, sx=1, sy=1, v;
      if(mode==='dead') return { bob:0, rot:Math.PI/2, sx:1, sy:1 };   // 倒れた姿勢
      var bob = air ? 0 : Math.sin(pl.phase*0.9)*2.4;          // 走りの上下
      var tilt = air ? -0.21 : Math.sin(pl.phase*0.45)*0.05;   // 空中は前傾12°、走りは±3°
      if(pl.slide){
        /* スライディング姿勢。-70° に倒し、そのうえで「画面の縦方向」に潰す。
           潰しを回転前に掛けると、-70° で長辺が縦に立ち上がってしまい寝ない。
           post は回転より前（画面座標）に掛ける倍率。
           倒した絵の高さの半分は (P_W*sin70 + P_H*cos70)/2 ≒ 42px なので、
           post 0.42 で高さ 35px ほど。BAR_GAP(36px) の下をちょうど通る絵になる。
           bob で中心を下げ、足元を接地面に合わせる */
        return { bob:bob+18, rot:-70*Math.PI/180, sx:1, sy:1, post:0.42 };
      } else {
        if(air){                                               // 上昇中は伸び、下降中はやや縮む
          v = Math.max(-1, Math.min(1, -pl.vy/9));
          sy = 1 + v*0.10; sx = 1 - v*0.10;
        }
        if(pl.stretch>0){ sy += pl.stretch*0.15; sx -= pl.stretch*0.15; }  // 踏み切りの伸び
        if(pl.squash>0){ sy -= pl.squash*0.20; sx += pl.squash*0.20; }     // 着地のつぶれ
      }
      // 区間クリアの2回ホップ
      var hop = pl.hopT>0 ? -Math.abs(Math.sin((1-pl.hopT/HOP_F)*Math.PI*3))*16 : 0;   // 3回・16px
      return { bob:bob+hop, rot:pl.rot+tilt, sx:sx, sy:sy };
    }

    /* 被弾の着色。source-atop は下地（背景）まで染めてしまうので、
       iGくんだけのキャンバスを別に作ってそこで塗り、色ごとに使い回す。 */
    var tintCache={};
    function tinted(color){
      if(!igReady) return null;
      if(tintCache[color]) return tintCache[color];
      var c=document.createElement('canvas'), g;
      c.width=P_W; c.height=P_H;
      g=c.getContext('2d');
      g.imageSmoothingEnabled=true;
      g.drawImage(igImg, 0, 0, P_W, P_H);
      g.globalCompositeOperation='source-atop';
      g.fillStyle=color; g.fillRect(0, 0, P_W, P_H);
      tintCache[color]=c;
      return c;
    }

    /* 時間帯の色調補正とリムライト（art-direction-final.md 3-b / 3-c）。
       **これが無いと「昼のキャラが夜の街に立っている」ままになる。**

       都市ごとに `grade` を持つ（PROC_PAL）:
         tint  … 同じ形に重ねる色。source-atop なので背景は染まらない。昼の都市は null
         rim   … 光源側の縁に置く色。lit（下）の向きへずらして先に描く
         rimA  … リムの濃さ。昼の都市は薄く、雪の都市は濃く
         bounce/bounceA … **下からの照り返し。**南極は雪が明度を反転させるので、
                          上からの光だけだと足元が不自然に暗くなる
       色ごとに tinted() が canvas を1枚持つので、作るのは最初の1回だけ。

       `lit` は「キャラから見て光源がどちら側にあるか」（-1 左 / +1 右）。
       PROC_PAL の orb.x から決めるので、都市を足すときに書き忘れられない。 */
    function gradeOf(cy){
      var pal = PROC_PAL[cy && cy.id];
      return pal ? pal.grade : null;
    }
    // 光源の向き。月／太陽が画面の左半分なら -1（左から照らす）
    function litOf(pal){ return (pal && pal.orb && pal.orb.x >= 0.5) ? 1 : -1; }
    /* tint を焼き込んだ iGくん。都市ごとに1枚。tint が無い都市は素の絵を返す */
    function gradedIG(pal){
      if(!igReady || !pal || !pal.grade || !pal.grade.tint) return igImg;
      var k = '__grade_' + pal.id;
      if(tintCache[k]) return tintCache[k];
      var c=document.createElement('canvas'), g;
      c.width=P_W; c.height=P_H;
      g=c.getContext('2d');
      g.imageSmoothingEnabled=true;
      g.drawImage(igImg, 0, 0, P_W, P_H);
      g.globalCompositeOperation='source-atop';
      g.fillStyle=pal.grade.tint; g.fillRect(0,0,P_W,P_H);
      tintCache[k]=c;
      return c;
    }
    function drawIG(x, y, scale, alpha, pose){
      pose = pose || poseNow();
      var im = igReady ? igImg : null;
      /* 補正は「いまいる都市」で決める。切り替え中に前後で混ぜないのは、
         1枚絵を2回描くと縁が二重に見えるため（残像と紛らわしい） */
      var pal = PROC_PAL[city.id], gr = pal && pal.grade;
      if(igReady && gr) im = gradedIG(pal) || im;
      if(igReady && pl.hitFlash>0) im = tinted(pl.hitFlash>9 ? '#ffffff' : '#e05a4a') || igImg;
      ctx.save();
      ctx.globalAlpha=alpha;
      ctx.translate(x+P_W/2, y+P_H/2+pose.bob);
      if(pose.post) ctx.scale(1, pose.post);       // 画面の縦方向の潰し（回転より前に掛ける）
      ctx.rotate(pose.rot);
      ctx.scale(scale*pose.sx, scale*pose.sy);
      if(im){
        ctx.imageSmoothingEnabled=true;
        if(gr && pl.hitFlash<=0){
          var lit = litOf(pal), sh;
          if(gr.bounce){                          // 下からの照り返し（雪・砂）
            sh = tinted(gr.bounce);
            if(sh){
              ctx.globalAlpha = alpha*gr.bounceA;
              ctx.drawImage(sh, -P_W/2, -P_H/2+1.5, P_W, P_H);
            }
          }
          if(gr.rim){
            sh = tinted(gr.rim);
            if(sh){
              ctx.globalAlpha = alpha*gr.rimA;
              ctx.drawImage(sh, -P_W/2 + lit*1.5, -P_H/2-1, P_W, P_H);
            }
          }
          ctx.globalAlpha = alpha;
        }
        ctx.drawImage(im, -P_W/2, -P_H/2, P_W, P_H);
      } else {
        ctx.fillStyle='#41caec';
        ctx.fillRect(-P_W/2+HIT_X, -P_H/2+HIT_Y, HIT_W, HIT_H);
      }
      ctx.restore();
      ctx.globalAlpha=1;
    }
    // 残像。速いほど濃い。prefers-reduced-motion では ghosts が溜まらないので何も出ない
    function drawGhosts(alpha){
      var thick = 0.7 + 0.3*Math.min(1, Math.max(0, (spd-3.2)/1.6));
      for(var i=ghosts.length-1;i>=0;i--){
        var g=ghosts[i];
        drawIG(g.x, g.y, g.scale, alpha*thick*(i===0?0.26:0.13), g.pose);
      }
    }
    function dust(n, x, y){
      if(lite) n = Math.max(1, n>>1);          // 粒の数を半分に（削る順の3番目）
      for(var i=0;i<n;i++){
        bits.push({ x:x+(Math.random()-.5)*20, y:y, vx:-1-Math.random()*2.4,
                    vy:-Math.random()*1.6, life:16+Math.random()*8, c:rgb(C.dust), s:3 });
      }
    }

    /* =============== 空 ===============
       proc の都市は焼き込んだ空（5〜7色のグラデーション＋街の光暈＋逆光）を1枚置く。
       **毎フレーム createLinearGradient しない。**その上に星・月・雲を重ねる。 */
    function drawSkyProc(cy){
      var P=procOf(cy); if(!P) return;
      var pal=P.pal, i, x;
      ctx.drawImage(P.sky.c, -20, -20, P.sky.w, P.sky.h);
      if(pal.night){                                  // 星。ゆっくり瞬き、わずかに流れる
        var base=ctx.globalAlpha;
        for(i=0;i<P.stars.length;i++){
          var st=P.stars[i];
          var a=st.a*(reduce ? 1 : 0.55+0.45*Math.sin(tick*0.016*st.tw+st.ph));
          var sx=((st.x*(VW+40) - worldX*0.02)%(VW+40)); if(sx<-20) sx+=VW+40;
          if(st.big && !lite){
            ctx.globalAlpha=base*a*0.55;
            ctx.drawImage(gx().star.c, sx-6, st.y-6, 12, 12);
          }
          ctx.globalAlpha=base*a;
          ctx.fillStyle='#EAF1FF'; ctx.fillRect(sx, st.y, st.s, st.s);
        }
        ctx.globalAlpha=base;
      }
      for(i=0;i<P.cloud.length;i++){                  // 雲。層ごとに速さが違う
        var cl=P.cloud[i], sp=pal.cloud[i];
        var off=((worldX*sp[2] + tick*sp[4]*0.016) % cl.w + cl.w) % cl.w;
        for(x=-1; x<=Math.ceil(VW/cl.w); x++) ctx.drawImage(cl.c, x*cl.w-off, sp[3], cl.w, cl.h);
      }
    }
    function drawSky(){
      if(blend<1 && PROC_PAL[prev.id]){ drawSkyProc(prev); ctx.globalAlpha=blend; }
      if(PROC_PAL[city.id]){ drawSkyProc(city); ctx.globalAlpha=1; return; }
      drawSkyFlat();
      ctx.globalAlpha=1;
    }
    /* 月／太陽は空とは別に、**両方の都市を通して1つだけ**描く。
       空と一緒にクロスフェードすると、切り替え中に月と太陽が並んで映る */
    function drawOrb(){
      var pp = PROC_PAL[prev.id], pc = PROC_PAL[city.id], b = (blend<1) ? blend : 1;
      if(!pp && !pc) return;
      var ax = pp ? pp.orb.x : pc.orb.x, ay = pp ? pp.orb.y : pc.orb.y;
      var bx = pc ? pc.orb.x : ax,       by = pc ? pc.orb.y : ay;
      var ox = (ax+(bx-ax)*b)*VW, oy = (ay+(by-ay)*b)*VH;
      var base = ctx.globalAlpha;
      if(pp && b<1){
        var A=procOf(prev);
        ctx.globalAlpha = base*(1-b);
        ctx.drawImage(A.orb.c, ox-A.orb.w/2, oy-A.orb.h/2, A.orb.w, A.orb.h);
      }
      if(pc){
        var B=procOf(city);
        ctx.globalAlpha = base*(pp ? b : 1);
        ctx.drawImage(B.orb.c, ox-B.orb.w/2, oy-B.orb.h/2, B.orb.w, B.orb.h);
      }
      ctx.globalAlpha = base;
    }
    function drawSkyFlat(){
      var g=ctx.createLinearGradient(0,-20,0,GROUND_Y+10);
      g.addColorStop(0, rgb(C.sky0)); g.addColorStop(0.55, rgb(C.sky1)); g.addColorStop(1, rgb(C.sky2));
      ctx.fillStyle=g; ctx.fillRect(-30,-30,VW+60,VH+60);

      var sunR = prev.sunR + (city.sunR-prev.sunR)*blend;
      var sx = (prev.sunX + (city.sunX-prev.sunX)*blend)*VW;
      var sy = (prev.sunY + (city.sunY-prev.sunY)*blend)*VH;
      var glow = ctx.createRadialGradient(sx, sy, sunR*0.6, sx, sy, sunR*4.2);
      glow.addColorStop(0, rgb(C.sun, .38)); glow.addColorStop(1, rgb(C.sun, 0));
      ctx.fillStyle=glow;
      ctx.beginPath(); ctx.arc(sx, sy, sunR*4.2, 0, Math.PI*2); ctx.fill();
      ctx.fillStyle=rgb(C.sun);
      ctx.beginPath(); ctx.arc(sx, sy, sunR, 0, Math.PI*2); ctx.fill();

      var i, x;
      if(city.night && blend>0.35){                 // 星
        ctx.fillStyle='rgba(255,255,255,'+(0.55*blend)+')';
        for(i=0;i<34;i++) ctx.fillRect((i*137)%VW, ((i*79)%120)+8, 2, 2);
      }
      if(city.id==='pole'){                         // オーロラ
        for(i=0;i<3;i++){
          var ag=ctx.createLinearGradient(0, 10+i*22, 0, 120+i*22);
          ag.addColorStop(0, i%2 ? 'rgba(183,208,41,'+(.26*blend)+')' : 'rgba(65,202,236,'+(.26*blend)+')');
          ag.addColorStop(1, 'rgba(0,0,0,0)');
          ctx.fillStyle=ag;
          ctx.beginPath(); ctx.moveTo(-20, 34+i*20);
          for(x=-20;x<=VW+20;x+=36) ctx.lineTo(x, 34+i*20+Math.sin(x*0.013+tick*0.009+i)*15);
          ctx.lineTo(VW+20,150); ctx.lineTo(-20,150); ctx.closePath(); ctx.fill();
        }
      }
      if(!city.night && city.id!=='pole'){          // 雲
        ctx.fillStyle=rgb(mixv(C.sky0, C.sun, .5), .3);
        for(i=0;i<4;i++){
          var cx=((i*230 - worldX*0.03)%(VW+340))-70;
          ctx.beginPath(); ctx.ellipse(cx, 44+(i%2)*38, 74, 13, 0, 0, Math.PI*2); ctx.fill();
          ctx.beginPath(); ctx.ellipse(cx+40, 52+(i%2)*38, 46, 10, 0, 0, Math.PI*2); ctx.fill();
        }
      }
    }

    /* =============== 層4：地面（素材タイル） ===============
       表面タイルを1段、その下に下地タイルを敷き、縁石を都市キーカラーで重ねる。
       タイルは 32px 単位。worldX の剰余で継ぎ目なく流す。 */
    var GTILE = 32;
    function drawGround(){
      if(blend<1 && PROC_PAL[prev.id]){ drawGroundProc(prev); ctx.globalAlpha=blend; }
      if(PROC_PAL[city.id]){ drawGroundProc(city); ctx.globalAlpha=1; return; }
      drawGroundAsset();
      ctx.globalAlpha=1;
    }
    /* 焼き込んだ 160px のタイルを3種、worldX の剰余で継ぎ目なく流す。
       タイルには歩道の面・点字ブロック・縁石・その下の壁（濡れたアスファルトが
       頭上のネオンを飲む）まで入っている。 */
    function drawGroundProc(cy){
      var P=procOf(cy); if(!P) return;
      var t0=Math.floor(worldX/TILE_W), gsOff=((worldX % TILE_W)+TILE_W)%TILE_W, i;
      for(i=-1; i<=Math.ceil(VW/TILE_W)+1; i++){
        var T=P.tile[(((t0+i)%3)+3)%3];
        ctx.drawImage(T.c, i*TILE_W-gsOff, GROUND_Y, TILE_W, T.h);
      }
    }
    function drawGroundAsset(){
      var off = -(((worldX % GTILE) + GTILE) % GTILE), x, y;
      if(!asset(city.id+'-ground')){
        // 素材が来ていないときの保険。走れる床が無いと遊べないため塗る
        ctx.fillStyle=rgb(C.ground); ctx.fillRect(-30, GROUND_Y, VW+60, VH-GROUND_Y+30);
        ctx.fillStyle=rgb(C.accent,.85); ctx.fillRect(-30, GROUND_Y, VW+60, 3);
        return;
      }
      for(x=off-GTILE; x<VW+GTILE; x+=GTILE){
        drawCityAsset('ground', x, GROUND_Y, GTILE, GTILE);
        for(y=GROUND_Y+GTILE; y<VH+GTILE; y+=GTILE) drawCityAsset('ground-fill', x, y, GTILE, GTILE);
      }
      for(x=off-GTILE; x<VW+GTILE; x+=GTILE) drawCityAsset('curb', x, GROUND_Y-2, GTILE, 7);
    }

    /* =============== 進行 =============== */
    /* 当たり判定の矩形。スライド中は高さを SLIDE_H 倍にし、上端を足元から測る
       （-70° に倒れて頭が下がる姿勢に合わせる。下端は接地面のまま） */
    function hitBox(){
      var x=pl.x+HIT_X, y=pl.y+HIT_Y, h=HIT_H;
      if(pl.slide){ h=HIT_H*SLIDE_H; y=pl.y+HIT_Y+HIT_H-h; }
      return { x:x, y:y, w:HIT_W, h:h };
    }
    function obsTop(o){                            // fly だけ上下に揺れる
      return o.type==='fly' ? o.y+Math.sin((tick+o.t*10)*0.13)*5 : o.y;
    }
    function overlaps(b, o){
      var oy=obsTop(o);
      return b.x<o.x+o.w-4 && b.x+b.w>o.x+4 && b.y<oy+o.h-3 && b.y+b.h>oy+3;
    }
    /* 立ち上がってよいか。立ち姿勢の矩形が何かに重なるなら、まだ立たない
       （bar の出口で頭をぶつけないための猶予。crowd や fly にも効く）。
       いま重なっているものだけでなく、8フレーム先までに来るものも見る。
       離した直後に立ち上がって、すぐ先の bar にぶつかるのは理不尽なため（完走率を優先） */
    function standBlocked(){
      var st={ x:pl.x+HIT_X, y:pl.y+HIT_Y, w:HIT_W+spd*8, h:HIT_H }, i;
      for(i=0;i<obs.length;i++) if(overlaps(st, obs[i])) return true;
      return false;
    }
    var slideSent = false;                             // igrun_slide は1回の走りで1度だけ
    function startSlide(){
      if(mode!=='run' || !pl.ground || pl.slide) return;
      if(!slideSent){ slideSent = true; track('igrun_slide', { city: city.id }); }
      // 水たまりを踏んだ直後（gim.wet）はスライドが 1.6 倍伸びる（パリのギミック）
      pl.slide=true; pl.slideT = gim.wet>0 ? Math.round(SLIDE_MIN_F*1.6) : SLIDE_MIN_F;
      pl.squash=0; pl.stretch=0; pl.rot=0; pl.spin=0;
      dust(6, pl.x+HIT_X+HIT_W/2, GROUND_Y-2);
      sfxSlide();
    }
    function endSlideHold(){ pl.slideHold=false; }
    /* 下スワイプ／↓キー。接地中はスライド、空中は急降下。
       ただし「タップしてすぐ下へ払った」場合は、出たばかりのジャンプを取り消してスライドにする */
    function down(){
      if(mode!=='run') return;
      pl.slideHold=true;
      if(pl.ground){ startSlide(); return; }
      if(pl.jumps===1 && tick-pl.jumpF<=JUMP_CANCEL_F){
        pl.y=GROUND_Y-P_H; pl.vy=0; pl.ground=true; pl.jumps=0;
        pl.hold=false; pl.stretch=0; pl.squash=0;
        startSlide(); return;
      }
      pl.dive=true; pl.hold=false;                 // 急降下
    }
    function jump(){
      if(mode!=='run') return;
      if(pl.slide){                                // スライド中でも跳べる。姿勢は解除
        pl.slide=false; pl.slideT=0; pl.slideHold=false;
      }
      if(pl.ground){
        pl.vy=JUMP_V; pl.ground=false; pl.jumps=1; pl.hold=true; pl.holdN=0;
        pl.jumpF=tick; pl.dive=false;
        pl.stretch=1;                              // 踏み切りで縦に伸びる
        dust(5, pl.x+HIT_X+HIT_W/2, GROUND_Y-2);
        sfxJump();
      } else if(pl.jumps<2 && runMode!=='expert'){   // エキスパートは2段ジャンプ封印
        pl.vy=DOUBLE_V; pl.jumps=2; pl.hold=true; pl.holdN=HOLD_MAX-6; pl.dive=false;
        pl.spin=SPIN_F;                            // 2段ジャンプはその場で1回転
        if(reduce) pl.spin=0;
        sfxDouble();
        for(var i=0;i<8;i++){
          bits.push({ x:pl.x+HIT_X+HIT_W/2, y:pl.y+P_H-6, vx:(Math.random()-.5)*3.6,
                      vy:Math.random()*1.8, life:16, c:'#b7d029', s:4 });
        }
      }
    }
    /* =============== スコア（TODO 7） ===============
       小包 10点 × コンボ倍率（5個ごとに ×1→×5）／ ニアミス 50点 ／ 無傷の区間 500点。
       走行中の HUD に出すのは倍率と小包の数だけ（visual-spec 2-4）。
       合計と内訳は完走証で見せる。 */
    /* コンボを1つ進める。**小包と敵で同じ段数を使う**（enemy-spec 5章
       「敵を踏むと仕入れコンボが +1 される」）。倍率の上がり方は変えない */
    function bumpCombo(){
      combo++;
      var m = Math.min(COMBO_MAX, 1 + Math.floor(combo/COMBO_STEP));
      if(m>mult){ mult=m; comboPop=10; if(mult>comboMax) comboMax=mult; }
    }
    function takeParcel(b){
      bumpCombo();
      var gain = PAR_PT*mult;
      sPar += gain;
      sfxParcel(mult);
      // ring と「+10」は取った地点（world 座標）に置く。world:true で地面と一緒に流れる
      bits.push({ x:b.x, y:b.y, vx:0, vy:0, life:14, ring:true, world:true, c:'#fc930a' });
      // 取った位置に「+10」（コンボ中は「+10 ×3」）が 24px 浮いて消える
      bits.push({ x:b.x, y:b.y-6, vx:0, vy:-24/26, life:26, world:true, c:'#fc930a',
                  txt:'+'+PAR_PT+(mult>1 ? ' ×'+mult : '') });
    }
    function breakCombo(){
      if(mult>1){ comboBreak=16; breakM=mult; }   // 白く2回点滅して消える
      combo=0; mult=1; comboPop=0;
    }
    /* 判定どうしの縦の隙間。横が重なっていない間は -1（測らない）。
       障害物の矩形は overlaps と同じだけ内側に詰める（横4px・縦3px）。
       こうすると「隙間 0」が「当たる寸前」と一致する */
    function clearance(b, o){
      var ox=o.x+4, ow=o.w-8, oy=obsTop(o)+3, oh=o.h-6;
      if(b.x >= ox+ow || b.x+b.w <= ox) return -1;
      return Math.max(oy-(b.y+b.h), b.y-(oy+oh));
    }
    /* 障害物1つを見張る。横が重なっている間の最小の隙間を覚えておき、
       通り過ぎた時点で NEAR_PX 以内ならニアミス。
       被弾した障害物は hit() が obs から外すので、ここには来ない（二重取りしない）。
       無敵中（pl.inv>0）は隙間が負になるだけなので、o.gap が付かず加点もされない */
    function nearWatch(o, b){
      if(o.done) return;
      var c=clearance(b, o);
      if(c>=0 && (o.gap===undefined || c<o.gap)) o.gap=c;
      if(o.x+o.w-4 > b.x) return;                 // まだ通り過ぎていない
      o.done=1;
      if(o.gap===undefined || o.gap>NEAR_PX) return;
      sNear += NEAR_PT;
      sfxNear();
      nearGhost = 20;                             // 残像が1枚増える（visual-spec 2-5）
      bits.push({ x:o.x+o.w/2, y:obsTop(o)-12, vx:0, vy:-14/20, life:20, world:true,
                  txt:'NEAR!', sz:11, c:'#b7d029' });
    }
    function hit(){
      if(pl.inv>0) return;
      if(foeDebug==='zoo') return;                 // 見本市モードでは死なない（眺めるためのモード）
      lives--;
      // この区間の無傷ボーナスは無くなる。コンボは切らない
      // （リセットは「小包を逃したとき」だけ、という決め）
      legClean=false;
      lifeHit=8; pl.hitFlash=14;                   // 白（4f）→ 赤（10f）。着色は画像だけ
      sfxHit();
      hitStop=reduce?1:5; shake=reduce?0:13;
      for(var i=0;i<16;i++){
        bits.push({ x:pl.x+HIT_X+HIT_W/2, y:pl.y+P_H/2, vx:(Math.random()-.5)*6.5,
          vy:-Math.random()*5, life:30, s:4,
          c:['#41caec','#fc930a','#b7d029'][(Math.random()*3)|0] });
      }
      obs=obs.filter(function(o){ return o.x > pl.x + VW*0.7; });
      // 敵も同じだけ払う。**被弾のあと目の前に敵が残っていると連続で削られる**
      foes=foes.filter(function(f){ return f.x > pl.x + VW*0.7; });
      foeChain=0;
      if(lives<=0){
        mode='dead'; pl.hitFlash=0;
        track('igrun_retry',{city:city.id, run_mode:runMode});
        // エンドレスは距離が記録。**死んだ時点で確定させる**
        if(runMode==='endless'){ saveBest('Dist', Math.floor(dist)); track('igrun_endless',{dist:Math.floor(dist)}); }
        // ワンミスのモードで「この都市から再開」を出すと、ワンミスの意味が無くなる
        showActions(runMode==='tour' ? ['retry','restart'] : ['restart']);
      }
      else { mode='hit'; pl.inv=115; }
    }
    /* 区間を無傷で終えたら 500点。都市名の下に 60f 出す（visual-spec 2-5）。
       区間の走り直し（リトライ）でも legClean は startAt で立て直すので、
       やり直した区間を無傷で走れば取れる。ゴール区間は finish() から呼ぶ */
    function legBonus(show){
      if(!legClean) return;
      sND += ND_PT;
      // ゴールでは出さない。完走証に切り替わる画に走行中の表示が重なる
      if(show) ndShow = 60;
    }
    /* =============== 区間クリアの演出（2026-09-10） ===============
       前は 1.5秒で、都市が変わったことに気づかないまま次の区間に入っていた。
       **3分走って何も起きない**のが「BGM が要る」と言われた本当の原因なので、
       ここで緊張と緩和のリズムを作る。3.8秒（230フレーム）。

         0f    速度が 45% に落ちる（**止めない。**止めると操作が奪われた感じになる）
               iGくんが大きく3回はねる／緑の粒／効果音
         6f    通過した都市の**スタンプが画面に押される**（2.6倍から叩きつける）
         26f   無傷なら NO DAMAGE +500 をスタンプの下に大きく
         150f  スタンプが上へ抜け、172f で完全に消える
         172f  **次の都市名が画面中央に大きく**出る（スタンプと重ねない）
         150f〜 速度が元に戻っていく
         230f  演出終わり。左下の都市名（従来の表示）に引き継ぐ

       走行は止めないので、演出中も跳べる。障害物は nextObsX を押して出さない。 */
    var CLEAR_F = 230, clearT = 0, clearCity = null, clearND = false;
    function nextLeg(){
      var li=legOf(dist);
      if(li===legIdx) return;
      var wasClean = legClean;                                          // legBonus の前に控える
      track('igrun_city_clear',{city:CITIES[legIdx].id, leg:legIdx+1});
      legBonus(true);                                                   // 無傷なら +500
      ndShow = 0;                                                       // 表示は演出側でやる（二重に出さない）
      clearT = CLEAR_F; clearCity = CITIES[legIdx]; clearND = wasClean;
      legIdx=li; prev=city; city=CITIES[li];
      procTrim();                                                       // 通り過ぎた都市の焼き込みを捨てる
      blend=0; nameShow=0; spd=speedOfLeg(li)*0.45; pl.hopT=HOP_F;      // 大きく3回はねる
      initPatterns(li);                                                 // 都市ごとにパターンを入れ替える
      /* 演出のあいだ障害物を出さない。4m 置いてから置き始めるので、出会うのは leadM(26m) を
         足した 30m 先。**2026-09-17 に 14m → 4m**（石川さんの判断）。都市名の演出（1.5秒）が
         終わってから最初の判断まで 2.1秒 → 1.2秒。区間の予算が 10m 増え、フィナーレ前の
         余りに短いパターンが入りやすくなる（docs/qa/README.md「敵の数を増やす」） */
      nextObsX = Math.max(nextObsX, worldX + 4*20);
      legClean=true;                                                    // 次の区間の無傷判定はここから
      sfxClear(); bgmCity();                                            // 音も都市に合わせて変える
      for(var i=0;i<16;i++){
        bits.push({ x:pl.x+HIT_X+HIT_W/2, y:pl.y+10, vx:(Math.random()-.5)*4.2,
                    vy:-Math.random()*4.2, life:34, c:i%2?'#b7d029':'#41caec', s:4 });
      }
    }
    /* =============== ゴール演出（visual-spec 2-6。TODO 10） ===============
       残り60m 店が出る → 30m で減速・BGM が開く → 到達
       → 3回ジャンプ（30/40/50px、着地ごとに砂ぼこり）→ +20f で扉へ歩く
       → scale 1→0.7・alpha 1→0（22f）→ 紙吹雪60個 → +30f で完走証へ 30f のクロスフェード。
       ?debug=goal で 60m 手前から始められる（何度でも見られるように）。 */
    var HOP_H = [30, 40, 50];
    function startGoal(){
      mode='enter'; enterT=0; pl.inv=999;
      goalPhase='hop'; hopN=0; waitT=0; walkT=0; confT=0; fadeT=0;
      pl.slide=false; pl.slideT=0; pl.dive=false; pl.hold=false;
      startHop(0);
    }
    // h px の高さまで上がる初速。着地までの時間も h で決まる
    function startHop(i){
      pl.vy = -Math.sqrt(2*GRAVITY*HOP_H[i]);
      pl.ground=false; pl.jumps=1; pl.stretch=1;
      sfxJump();
    }
    function goalStep(){
      enterT++;
      spd = Math.max(0, spd*0.86); worldX += spd;      // 扉の前で止まる
      if(goalPhase==='hop'){
        pl.vy += GRAVITY; pl.y += pl.vy;
        if(pl.y >= GROUND_Y-P_H){
          pl.y = GROUND_Y-P_H; pl.vy = 0; pl.ground = true;
          pl.squash = 1;
          dust(9, pl.x+HIT_X+HIT_W/2, GROUND_Y-2);     // 着地ごとに砂ぼこり
          hopN++;
          if(hopN < HOP_H.length) startHop(hopN);
          else { goalPhase='wait'; waitT=20; }         // 3回目の着地から 20f
        }
      } else if(goalPhase==='wait'){
        if(--waitT<=0){ goalPhase='walk'; walkT=0; }
      } else if(goalPhase==='walk'){
        walkT++;
        pl.offX += 1.9;                                // 扉へ歩く
        pl.scale = Math.max(0.7, 1 - walkT*(0.3/22));
        pl.alpha = Math.max(0, 1 - walkT/22);
        if(walkT>=22){
          goalPhase='conf'; confT=0; sfxGoal(); confetti();
          legBonus(false);                             // ゴール区間も無傷なら +500。
          // **ここで確定させる。**finish() まで待つと、クロスフェード中の完走証だけ
          // スコアが 0 のまま映り、数字が途中で変わって見える
        }
      } else if(goalPhase==='conf'){
        if(++confT>=30){ goalPhase='fade'; fadeT=0; }  // 紙吹雪のあと 30f で切り替え始める
      } else if(goalPhase==='fade'){
        if(++fadeT>=30) finish();                      // 30f のクロスフェードの終わりで確定
      }
    }
    /* 紙吹雪60個。上から降らせ、90f 残す。素材（common-pt-confetti）を
       4色に染めて使う（iGくんの被弾と同じ source-atop のやり方） */
    var CONF_C = ['#41caec', '#fc930a', '#b7d029', '#ffffff'];
    function confetti(){
      var i;
      for(i=0;i<60;i++){
        bits.push({ x: 20 + Math.random()*(VW-40), y: -12 - Math.random()*90,
                    vx: (Math.random()-0.5)*1.4, vy: 1.1 + Math.random()*1.9,
                    life: 90, conf: true, rot: Math.random()*6.3,
                    s: 9 + Math.random()*5, c: CONF_C[(Math.random()*CONF_C.length)|0] });
      }
    }

    function finish(){
      mode='clear';
      try{
        /* 完走したらモード選択が開く（TODO 17。解放は本編の完走）。
           **エキスパートやエンドレスの完走でも開いてよい**が、そもそも
           この2つは本編を完走しないと選べないので、実質は本編の完走で開く。 */
        window.localStorage.setItem(storeKey+'.cleared','1');
        cleared = true;
        // 自己ベストは**モード別**。エキスパートの記録で本編の記録を上書きしない
        var bk = (runMode==='expert') ? '.bestExpert' : '.bestTime';
        if(runMode!=='endless'){
          var p=parseInt(window.localStorage.getItem(storeKey+bk)||'0',10);
          if(!p || clock<p) window.localStorage.setItem(storeKey+bk, String(clock));
        } else {
          saveBest('Dist', Math.floor(dist));       // まず起きないが、走り切ったら距離を残す
        }
      }catch(e){}
      track('igrun_finish',{ time_sec:Math.floor(clock/60), parcels:parcels, retries:retries, route: parco?'parco':'default', run_mode:runMode,
                             stomps:stomps });   // 踏んだ数（9/17 追加。カスタム指標 #14）
      // 完走時のコンボ最大とスコア。**既存の igrun_finish は触らない**（見ている数字が変わるため）
      track('igrun_combo_max',{ combo_max:comboMax, score:score(), route: parco?'parco':'default' });
      /* igrun_coupon は送らない（2026-09-17。クーポン表示をやめてガチャへ誘導）。
         ガチャは「押した」ときに igrun_to_gacha を送る（表示しただけでは送らない） */
      showActions(canExport ? ['gacha','shop','share','save'] : ['gacha','shop','share']);
    }

    /* =============== ボタン =============== */
    function hideActions(){
      actions.classList.remove('is-on');
      ['retry','restart','gacha','shop','share','save'].forEach(function(n){ q(n).style.display='none'; });
    }
    function showActions(list){
      hideActions();
      list.forEach(function(n){ q(n).style.display=''; });
      actions.classList.add('is-on');
    }
    hideActions();

    q('retry').addEventListener('click', function(){
      retries++; track('igrun_start',{mode:'retry', run_mode:runMode, city:city.id}); startAt(legIdx);
    });
    q('restart').addEventListener('click', newRun);
    q('gacha').addEventListener('click', function(){
      track('igrun_to_gacha',{}); window.location.href=gachaURL;
    });
    q('shop').addEventListener('click', function(){
      track('igrun_to_shop',{}); window.location.href=shopURL;
    });
    q('share').addEventListener('click', function(){
      track('igrun_share',{});
      // 設定は「世界一周」ではなく「世界で仕入れて持ち帰る」（docs/series-concept.md 2章）
      var t='世界で'+parcels+'個仕入れて INFOLENS GEEK SHOP に帰ってきました！ タイム '+
            mmss(clock)+' #iGくんWORLDRUN';
      window.open('https://twitter.com/intent/tweet?text='+encodeURIComponent(t)+
                  '&url='+encodeURIComponent(window.location.href), '_blank', 'noopener');
    });
    q('save').addEventListener('click', function(){
      var b=q('save');
      try{
        var c=buildCertificate(), a=document.createElement('a');
        a.download='igkun-world-run.png'; a.href=c.toDataURL('image/png'); a.click();
        track('igrun_save',{});
      }catch(e){
        /* **黙って消さない。**書き出せない理由（画像の出所が違う＝CORS）は
           プレイヤーには分からないので、消えたボタンは不具合にしか見えない。
           押せなくなったことと、代わりにできること（画面を撮る）を出す。 */
        b.disabled = true;
        b.textContent = '保存できません（画面を撮ってください）';
        track('igrun_save_fail',{});
      }
    });

    function buildCertificate(){
      var c=document.createElement('canvas'); c.width=1200; c.height=630;
      drawCertificate(c.getContext('2d'), 1200, 630, 0, true);
      return c;
    }

    /* =============== 入力 =============== */
    function press(){
      if(mode==='load') return;                 // 読み込み中は無反応
      if(paused){ resumeRun(); return; }        // 止めている間はどこを押しても再開
      if(countT>0) return;                      // カウントダウン中の入力は捨てる
      // 札を出しているときは選んでいる札（初期はワールドツアー）。何もしなければ本編
      if(mode==='idle'){ chooseMode(pickerOn() ? MODES[modeSel].k : 'tour'); return; }
      if(mode==='run'){ jump(); return; }
    }
    function release(){ pl.hold=false; endSlideHold(); }
    /* 下スワイプの追跡。押した瞬間にジャンプを出す方針は変えていない（visual-spec / TODO 5）。
       払い下ろしたときだけ down() が走り、直後のジャンプなら取り消してスライドに移る。
       長押しでスライドは出さない（ジャンプの長押し＝高く跳ぶ、と取り合いになるため）。 */
    var sw={ on:false, y:0, fired:false };
    /* 画面の座標をゲームの仮想座標に直す。
       **canvas の実寸の箱を、そのまま仮想の箱（VW×VH）に写す。**
       以前は高さから倍率 s を出して x にも使っていたが、それだと
       「render が stage.clientWidth/clientHeight から出した VW」と
       「ここが canvas.getBoundingClientRect() から出した倍率」が別物になる。
       親に transform:scale や枠が掛かると両者がずれ、描いた札と当たりが食い違う。
       縦横それぞれ箱どうしを対応させれば、何が掛かっていても必ず一致する。 */
    function toVirtual(e){
      var r = canvas.getBoundingClientRect();
      if(!r.width || !r.height) return { x:-1, y:-1 };
      return { x:(e.clientX-r.left) * (VW/r.width), y:(e.clientY-r.top) * (VH/r.height) };
    }
    /* 指で押せる最小の大きさ（44 CSS px）を仮想 px に直す。
       縦持ちの iPhone では画面 390px に対し高さ 312px ＝ 1 仮想px が 0.87 CSS px。
       札は 30 仮想px ＝ **26 CSS px しかなく、44px の目安を大きく割っていた。**
       描く大きさは 9/9 に承認した画なので変えない。**当たりだけ広げる。** */
    function tapPad(){
      var r = canvas.getBoundingClientRect();
      return r.height ? 44 * (VH/r.height) : 44;
    }
    stage.addEventListener('pointerdown', function(e){
      if(e.target.closest('button')) return;
      e.preventDefault(); stage.focus({preventScroll:true});
      /* AudioContext は最初のユーザー操作でだけ作れる（iOS）。
         ただし**音を出す設定のときだけ作る**。ミュートのまま遊ぶ人の頁に
         音の文脈を作らない（商品ページに埋まる可能性があるため）。
         前回ミュートを解除した人は、この最初のタップで作られる */
      if(au.on){ audioBoot(); bgmLoad(); }  // 前回ミュートを解除した人はここで読む
      // ミュートの札を先に見る。ここを押したときはジャンプしない
      var v = toVirtual(e);
      if(hitQuit(v.x, v.y)){ quitToTitle(); return; }    // 一時停止中の「やめる」。再開より先に見る
      if(hitPause(v.x, v.y)){ togglePause(); return; }   // ミュートより先に見る（隣り合っている）
      if(hitMute(v.x, v.y)){ soundOn(!au.on); return; }
      // タイトルのモード選択。**押した札をそのまま選んで走り出す**（2手にしない）
      var mi = hitMode(v.x, v.y);
      if(mi >= 0){ modeSel = mi; chooseMode(MODES[mi].k); return; }
      sw.on=true; sw.y=e.clientY; sw.fired=false;
      try{ stage.setPointerCapture(e.pointerId); }catch(err){}   // 指が面から出ても払いを拾う
      press();
    });
    stage.addEventListener('pointermove', function(e){
      if(!sw.on || sw.fired) return;
      if(e.clientY - sw.y >= SWIPE_DY){ sw.fired=true; down(); }
    });
    function upEnd(){ sw.on=false; release(); }
    stage.addEventListener('pointerup', upEnd);
    stage.addEventListener('pointercancel', upEnd);
    stage.addEventListener('pointerleave', upEnd);
    stage.addEventListener('keydown', function(e){
      if(au.on){ audioBoot(); bgmLoad(); }  // 前回ミュートを解除した人はここで読む                        // キーもユーザー操作。音を出す設定のときだけ作る
      if(e.code==='Space'||e.code==='ArrowUp'||e.code==='KeyW'||
         e.code==='Enter'||e.code==='NumpadEnter'){
        e.preventDefault(); if(!e.repeat) press();   // Enter も決定（タイトルの札を確定する）
      } else if(e.code==='ArrowDown'||e.code==='KeyS'){
        e.preventDefault(); if(!e.repeat) down();   // PC はこちらが主経路
      } else if(e.code==='KeyM'){
        e.preventDefault(); if(!e.repeat) soundOn(!au.on);   // PC は M でも切り替えられる
      } else if(e.code==='KeyP' || e.code==='Escape'){
        e.preventDefault(); if(!e.repeat) togglePause();     // PC は P と Esc
      } else if((e.code==='ArrowLeft'||e.code==='ArrowRight') && mode==='idle' && pickerOn()){
        // タイトルでだけ効く。走行中は左右キーを使わないので取り合いにならない
        e.preventDefault();
        if(!e.repeat) modeSel = (modeSel + (e.code==='ArrowRight'?1:MODES.length-1)) % MODES.length;
      }
    });
    stage.addEventListener('keyup', function(e){
      if(e.code==='Space'||e.code==='ArrowUp'||e.code==='KeyW') pl.hold=false;
      else if(e.code==='ArrowDown'||e.code==='KeyS') endSlideHold();
    });
    /* タイトルの ← → だけ document でも拾う（2026-09-15。実機報告への対応）。

       **なぜ例外を作るか。**上の keydown はゲーム面（stage）にフォーカスがある
       ときだけ効く。ところが**タイトルでフォーカスを得る手段がタップしかなく、
       そのタップがそのまま走り出してしまう**ので、画面に出している
       「← → で切り替え」に手が届かない（Tab で辿り着いた人だけ使えていた）。

       ゲームのキー（スペース・↓・P・M・Esc）は stage のまま動かさない。
       ここで拾うのは**タイトルの札が出ているときの ← → だけ**で、
       - 走行中は効かない（mode==='idle' かつ cleared のときだけ）
       - 画面に入っていないときは効かない（running＝IntersectionObserver）
       - 入力欄に文字を打っている人からは奪わない（activeElement を見る）
       拾ったらゲーム面にフォーカスを移す。**以降のキーは元どおり stage の担当**。 */
    function editable(el){
      if(!el) return false;
      var t = el.tagName;
      return t==='INPUT' || t==='TEXTAREA' || t==='SELECT' || el.isContentEditable;
    }
    document.addEventListener('keydown', function(e){
      if(e.code!=='ArrowLeft' && e.code!=='ArrowRight') return;
      if(mode!=='idle' || !pickerOn() || !running) return;
      if(document.activeElement === stage) return;     // stage の担当。二重に動かさない
      if(editable(document.activeElement)) return;
      if(e.metaKey || e.ctrlKey || e.altKey) return;
      e.preventDefault();
      if(!e.repeat) modeSel = (modeSel + (e.code==='ArrowRight'?1:MODES.length-1)) % MODES.length;
      try{ stage.focus({preventScroll:true}); }catch(err){}
    });

    /* =============== 更新 =============== */
    function update(){
      /* **tick より前で返す。**tick を進めると鳥の羽ばたきやネオンの点滅だけが
         動いてしまい、「止まっていない」ように見える */
      if(paused) return;
      if(countT>0){ countT--; return; }        // 3・2・1 の間も世界は止めたまま
      tick++;
      if(mode==='load'){
        // 素材が揃い、フォントも来たら（または 2.5 秒＝150f 待ったら）タイトルへ
        if(settled(bootNames) && (fontDone || tick>150)) mode='idle';
        return;
      }
      if(hitStop>0){ hitStop--; if(hitStop===0 && mode==='hit') mode='run'; return; }
      var i,o,b,g,r1,r2,r3,r5;
      var scrollV=0;                            // この frame の地面のスクロール量（world:true の粒子が従う）

      // 次の都市の絵を、到達の約20秒前から読み込んでおく（spd は px/frame、20px=1m）
      if(mode==='run' && tick%30===0 && legIdx+1<CITIES.length &&
         dist >= LEG_START[legIdx+1] - spd*60){
        request(cityNames(CITIES[legIdx+1].id));
        procOf(CITIES[legIdx+1]);      // 焼き込みも先に済ませる（切り替えでの引っかかりを消す）
      }

      if(mode==='run'||mode==='idle'||mode==='enter'){
        if(mode==='run'){
          /* 区間クリアの演出中は 45% に落とし、終盤 35% の時間で元に戻す。
             **spd をそのまま書き換える**（scrollV も gapPx も同じ値を見るので、
             ここだけ直せば絵も配置もついてくる） */
          var sk = 1;
          if(clearT>0){
            clearT--;
            var ck = CLEAR_F*0.35;
            sk *= (clearT>ck ? 0.45 : 0.45 + 0.55*(1-clearT/ck));
            if(clearT===0) nameShow = 90;          // 左下の都市名に引き継ぐ
          }
          if(gim.boost>0) sk *= 1.28;              // タクシーに乗った3秒
          if(gim.ice>0)   sk *= 1.16;              // 氷の上ですべって前に流される
          /* **毎フレーム区間の速度から組み直す。**足し引きで持ち回すと、
             演出と加速が重なったときに元の速度へ戻れなくなる。
             ゴール手前の減速はこのあとで上書きする（そちらが最終） */
          spd = speedOfLeg(legIdx) * sk;
          clock++; worldX+=spd; dist=Math.floor(worldX/20);
          nextLeg();
          if(pl.inv>0) pl.inv--;
          if(foeGrace>0) foeGrace--;               // 踏んだ直後の無敵（敵にだけ効く）
          /* **物理を動かす前の足元**を控える。踏み判定の条件2がこれを見る。
             動かしたあとの値で見ると、深くめり込んだ1フレーム目に上下が入れ替わる */
          pl.footPrev = pl.y + P_H;
          g=GRAVITY;
          if(pl.hold && pl.vy<0 && pl.holdN<HOLD_MAX){ g=HOLD_GRAVITY; pl.holdN++; }
          if(pl.dive) g=GRAVITY*DIVE_MUL;          // 急降下
          pl.vy+=g; pl.y+=pl.vy;
          if(pl.y>=GROUND_Y-P_H){
            if(!pl.ground){ pl.squash=1; dust(pl.dive?11:7, pl.x+HIT_X+HIT_W/2, GROUND_Y-2); }
            pl.y=GROUND_Y-P_H; pl.vy=0; pl.ground=true; pl.jumps=0; pl.dive=false;
            foeChain=0;                            // 着地で連続踏みは仕切り直し（5章の窓）
            // 急降下から着いた直後にまだ下を押しているなら、そのままスライドへ繋ぐ
            if(pl.slideHold) startSlide();
          }
          updateGim();                              // 足場・水たまり・氷・砂嵐（TODO 3）
          stepFoes();                               // 敵の移動（enemy-spec 2章）
          /* スライドの維持と解除。
             ・最低 SLIDE_MIN_F フレームは必ず続ける
             ・入力を離しても、立ち姿勢が障害物に重なる間は立ち上がらない
             ・跳んだ場合は jump() 側で解除済み */
          if(pl.slide){
            if(pl.slideT>0) pl.slideT--;
            if(!pl.ground) { pl.slide=false; pl.slideT=0; }
            else if(!pl.slideHold && pl.slideT<=0 && !standBlocked()) pl.slide=false;
          }
        } else if(mode==='idle'){
          worldX+=3.2;
        } else {
          goalStep();                              // ゴール演出（visual-spec 2-6）
          if(mode==='clear') return;
        }
        // パペットの各値を戻す（着地のつぶれは6フレームで戻る）
        if(pl.squash>0) pl.squash=Math.max(0, pl.squash-0.17);
        if(pl.stretch>0) pl.stretch=Math.max(0, pl.stretch-0.2);
        if(pl.spin>0){ pl.spin--; pl.rot = pl.spin ? (1-pl.spin/SPIN_F)*Math.PI*2 : 0; }
        if(pl.hopT>0) pl.hopT--;
        if(pl.hitFlash>0) pl.hitFlash--;
        pl.phase += pl.ground ? Math.max(spd,2.4)*0.12 : 0.05;

        // スライド中の火花。足元から後ろへ散る。地面に置き去りにするので world:true
        if(pl.slide && !reduce && mode==='run'){
          for(i=0;i<2;i++){
            bits.push({ x:pl.x+HIT_X+2+Math.random()*10, y:GROUND_Y-3-Math.random()*4,
                        vx:-1.4-Math.random()*3.2, vy:-1.1-Math.random()*2.1,
                        life:11+Math.random()*9, world:true,
                        s: Math.random()<0.3 ? 3 : 2,
                        c: Math.random()<0.34 ? '#fff2c4' : '#ffb43c' });
          }
        }

        // 残像。3フレームおきに姿勢を控えて2枚まで持つ
        if(!reduce && mode==='run'){
          if(tick%3===0){
            ghosts.unshift({ x:pl.x+pl.offX, y:pl.y, scale:pl.scale, pose:poseNow() });
            // ニアミスの直後だけ1枚増やす（visual-spec 2-5）
            var gmax = lite ? 1 : (nearGhost>0 ? 3 : 2);
            if(ghosts.length>gmax) ghosts.length=gmax;
          }
        } else if(ghosts.length) ghosts=[];

        var v=(mode==='idle')?3.2:spd;
        scrollV=v;
        // 残像は世界に置き去りにする（iGくんの画面上の x は動かないため、
        // 同じ位置に重ねると見えない）
        for(i=0;i<ghosts.length;i++) ghosts[i].x-=v;
        for(i=0;i<l1.length;i++) l1[i].x-=v*0.10;
        for(i=0;i<lm.length;i++) lm[i].x-=v*0.10;
        lm=lm.filter(function(t){return t.x>-420;});
        /* 次の1本は、前の1本が画面から完全に出てから置く。
           2本が同時に映ると「塔が2つある街」に見えてしまう */
        var rlm=-Infinity;
        for(i=0;i<lm.length;i++) rlm=Math.max(rlm,lm[i].x);
        if(rlm < -300) lm.push({x:VW+500+Math.random()*700, s:Math.random()*99});
        for(i=0;i<l2.length;i++) l2[i].x-=v*0.26;
        for(i=0;i<l3.length;i++) l3[i].x-=v*0.55;
        for(i=0;i<l5.length;i++) l5[i].x-=v*1.7;
        l1=l1.filter(function(t){return t.x>-360;});
        l2=l2.filter(function(t){return t.x>-460;});
        l3=l3.filter(function(t){return t.x>-200;});
        l5=l5.filter(function(t){return t.x>-320;});
        r1=r2=r3=r5=-Infinity;
        for(i=0;i<l1.length;i++) r1=Math.max(r1,l1[i].x);
        for(i=0;i<l2.length;i++) r2=Math.max(r2,l2[i].x);
        for(i=0;i<l3.length;i++) r3=Math.max(r3,l3[i].x);
        for(i=0;i<l5.length;i++) r5=Math.max(r5,l5[i].x);
        if(r1<VW+20) l1.push({x:VW+40+Math.random()*90, s:Math.random()*99});
        if(r2<VW+30) l2.push({x:VW+160+Math.random()*180, s:Math.random()*99});
        if(r3<VW+40) l3.push({x:VW+120+Math.random()*180, s:Math.random()*99});
        if(r5<VW+60) l5.push({x:VW+260+Math.random()*380, s:Math.random()*99});

        if(mode==='run'){
          /* 障害物を出すのを止めるのは**店が出るより 40m 早く**する。
             ゴール前は減速するので、障害物が画面に長く残る。
             **減速中に障害物が来ると、跳ぶ間合いが変わって理不尽**（実測で被弾した）。
             小包は最後まで出してよい（取れて嬉しいだけで、事故にならない） */
          var noSpawn = dist >= TOTAL_M-100;
          var nearGoal = dist >= TOTAL_M-60;                      // 店が出る（visual-spec 2-6）
          if(!noSpawn && worldX>=nextObsX){ if(pp) spawnPattern(); else spawnObs(); }
          if(!noSpawn && !pp && worldX>=nextBoxX) spawnBoxes();   // 小包はパターンに書いてある
          /* 敵の確認用（?igrun_foe=…。data-debug のときだけ）。本番の経路はパターン。
             **ここでも foeFree を通す。**通さずに一定間隔で置いたら、障害物の上に
             重なった敵が湧き、確認スクリプトの --boxes が重なりを報告した（実測）。
             置けないときは 1m 先送りして、空いた場所で置く */
          /* **本番と同じ制約に揃える。**IGS 帰還区間とギミックのある場では出さない
             （4章）。揃えておかないと、確認で出た被弾が本番の配置の話なのか
             確認用の出し方の話なのか分からなくなる */
          var gimHere = plats.length || pads.length || trigs.length || cross;
          if(foeDebug==='zoo'){
            if(worldX>=nextFoeX){
              var ZOO=['walker','hopper','flyer'];
              addFoe(VW+40, ZOO[(zooN++)%3]); nextFoeX = worldX + 200;
            }
          } else if(foeDebug && !noSpawn && legIdx<GOAL_IDX && !gimHere && worldX>=nextFoeX){
            if(foeFree(VW+40, foeDebug) && !foeCrowded(VW+40)){
              addFoe(VW+40, foeDebug); nextFoeX = worldX + 300;
            }
            else nextFoeX = worldX + 20;
          }
          /* **置いたあとに障害物が湧く順序があるので、毎フレーム掃く。**
             置くときの検査（boxFree）だけでは、この順序の穴が埋まらない */
          sweepBoxes();
          sweepFoes();                            // 敵も同じく掃く（enemy-spec 4章）
          if(nearGoal && !shop){
            shop={ x:VW+70 };
            // まだ画面に入っていない障害物は片づける。ゴールまでの道を空ける
            obs = obs.filter(function(o){ return o.x < VW; });
          }
          /* 扉まで 30m を切ったら減速し、BGM のローパスを開く（音が明るくなる）。
             **仕様の 0.9^f をそのまま掛けると 25m 手前で止まって扉に着けない**ので、
             残りの距離で速度を決める（到達が保証される）。1.0倍 → 0.5倍 */
          if(shop){
            var remPx = (shop.x + SHOP_W*0.34) - (pl.x+HIT_X);
            if(remPx < 600){
              spd = speedOfLeg(legIdx) * (0.5 + 0.5*Math.max(0, remPx)/600);
              bgmOpen(1 - Math.max(0, remPx)/600);
            }
          }
        }
        for(i=0;i<obs.length;i++) obs[i].x-=v;
        for(i=0;i<foes.length;i++) foes[i].x-=v;   // 敵も世界と一緒に流す（自前の移動は stepFoes）
        for(i=0;i<boxes.length;i++) boxes[i].x-=v;
        for(i=0;i<plats.length;i++) plats[i].x-=v;
        for(i=0;i<pads.length;i++)  pads[i].x-=v;
        for(i=0;i<trigs.length;i++) trigs[i].x-=v;
        updateCrossing(v);                       // 踏切（警報機と電車）も世界と一緒に流す
        obs=obs.filter(function(o){return o.x>-170;});
        foes=foes.filter(function(f){return f.x>-170 && !(f.dead && f.fade<=0);});
        boxes=boxes.filter(function(b){return b.x>-40;});
        plats=plats.filter(function(o){return o.x>-200;});
        pads=pads.filter(function(o){return o.x>-200;});
        trigs=trigs.filter(function(o){return o.x>-40;});
        if(shop){
          shop.x-=v;
          if(mode==='run' && shop.x+SHOP_W*0.34 <= pl.x+HIT_X){ startGoal(); }
        }

        if(!reduce && gim.rain>0 && tick%2===0){
          // パリの雨。斜めに速く落とす。都市の weather 設定は触らない（一時的なものなので）
          flakes.push({ x:VW+6+Math.random()*80, y:-8, vx:-2.6, vy:5.2, w:1.6, h:9 });
        }
        if(!reduce && city.weather && tick%4===0){
          flakes.push({ x:VW+6, y:Math.random()*GROUND_Y,
            vx: city.weather==='sand'?-5.5:-1.6, vy: city.weather==='sand'?0.05:0.85,
            w: city.weather==='sand'?11:3, h: city.weather==='sand'?1:3 });
        }
        for(i=0;i<flakes.length;i++){ flakes[i].x+=flakes[i].vx-v*0.3; flakes[i].y+=flakes[i].vy; }
        flakes=flakes.filter(function(f){return f.x>-16 && f.y<GROUND_Y+4;});

        if(blend<1) blend=Math.min(1, blend+0.011);
        if(nameShow>0) nameShow--;

        if(mode==='run'){
          var hb=hitBox();                        // スライド中は高さが SLIDE_H 倍になる
          /* 敵を先に見る（enemy-spec 1章）。**踏みが成立したフレームで
             障害物の判定に入らないように**、敵 → 障害物の順にする。
             踏んだ跳ね返りで障害物を抜けることはない（跳ね返りは上向きだけ） */
          foeCollide(hb);
          if(pl.inv<=0){
            for(i=0;i<obs.length;i++){
              if(overlaps(hb, obs[i])){ hit(); break; }
            }
          }
          // 小包の取得は立ち姿勢の矩形のまま。スライドしたせいで小包を逃す
          // （TODO 7 のコンボが切れる）のは理不尽なので、判定を縮めない
          var bx0=pl.x+HIT_X, by0=pl.y+HIT_Y;
          for(i=boxes.length-1;i>=0;i--){
            b=boxes[i];
            if(b.x>bx0-15 && b.x<bx0+HIT_W+15 && b.y>by0-15 && b.y<by0+HIT_H+15){
              boxes.splice(i,1); parcels++; parcelPop=8;
              takeParcel(b);
            } else if(b.x<=bx0-15 && !b.miss){
              // 取得の窓（bx0-15）を過ぎた小包はもう取れない。ここでコンボが切れる
              b.miss=1; breakCombo();
            }
          }
          // ニアミス：通り過ぎた障害物のうち、いちばん近づいた隙間が NEAR_PX 以内なら加点
          for(i=0;i<obs.length;i++) nearWatch(obs[i], hb);
        }
      }

      for(i=0;i<bits.length;i++){
        bits[i].x+=bits[i].vx - (bits[i].world?scrollV:0); bits[i].y+=bits[i].vy;
        if(!bits[i].ring && !bits[i].txt && !bits[i].conf) bits[i].vy+=0.17;
        if(bits[i].conf) bits[i].x += Math.sin((90-bits[i].life)*0.09)*0.7;   // 左右に揺れながら
        bits[i].life--;
      }
      bits=bits.filter(function(p){return p.life>0;});
      if(shake>0) shake*=0.85;
      if(lifeHit>0) lifeHit--;
      if(parcelPop>0) parcelPop--;
      if(stompPop>0) stompPop--;
      bgmTick();                                   // BGM の予約を進める（走行中だけ鳴る）
      if(comboPop>0) comboPop--;
      if(comboBreak>0) comboBreak--;
      if(ndShow>0) ndShow--;
      if(nearGhost>0) nearGhost--;
    }

    /* =============== 色の補間 =============== */
    function mixCity(){
      var k, i;
      C.sky0 = mixv(hex(prev.sky[0]), hex(city.sky[0]), blend);
      C.sky1 = mixv(hex(prev.sky[1]), hex(city.sky[1]), blend);
      C.sky2 = mixv(hex(prev.sky[2]), hex(city.sky[2]), blend);
      for(i=0;i<CKEYS.length;i++){
        k=CKEYS[i];
        C[k] = mixv(hex(prev[k]), hex(city[k]), blend);
      }
      // 空気遠近：遠いものほど地平の空の色に溶かす
      C.l1 = mixv(C.far,  C.sky2, 0.62);
      C.l2 = mixv(C.mid,  C.sky2, 0.30);
      C.l3 = mixv(C.near, C.sky2, 0.10);
      C.obs = mixv(C.near, C.ink, 0.35);
      C.dust = mixv(C.ground2, C.sky2, 0.3);
    }

    /* maxW を渡したときだけ、収まるまで1pxずつ縮める（完走証の certT と同じ考え方）。
       **7都市の並びはタイトルの1行に入らない**（縦持ちでは特に）。渡さなければ従来どおり。 */
    function text(str,x,y,size,color,align,weight,maxW){
      var s=size, w=(weight||700);
      ctx.font=w+' '+s+'px '+FONT;
      if(maxW){
        while(s>7 && ctx.measureText(str).width > maxW){ s--; ctx.font=w+' '+s+'px '+FONT; }
      }
      ctx.fillStyle=color; ctx.textAlign=align||'left';
      ctx.fillText(str,x,y); ctx.textAlign='left';
    }

    /* 数字は1桁ずつ固定幅のスロットに入れて描く。
       値が変わっても左右に揺れない（visual-spec 2-2）。戻り値は描いた幅。 */
    function slotW(size){
      if(digitW[size]) return digitW[size];
      ctx.font='700 '+size+'px '+FONT;
      var w=0, d;
      for(d=0;d<10;d++) w=Math.max(w, ctx.measureText(String(d)).width);
      digitW[size]=w;
      return w;
    }
    function numText(str,x,y,size,color,align){
      str=String(str);
      var dw=slotW(size), i, c, w=0;
      ctx.font='700 '+size+'px '+FONT;
      for(i=0;i<str.length;i++){
        c=str.charAt(i);
        w += (c>='0'&&c<='9') ? dw : ctx.measureText(c).width;
      }
      var cx = (align==='right') ? x-w : (align==='center' ? x-w/2 : x);
      ctx.fillStyle=color;
      for(i=0;i<str.length;i++){
        c=str.charAt(i);
        if(c>='0'&&c<='9'){
          ctx.textAlign='center'; ctx.fillText(c, cx+dw/2, y); ctx.textAlign='left';
          cx+=dw;
        } else {
          ctx.fillText(c, cx, y); cx+=ctx.measureText(c).width;
        }
      }
      return w;
    }

    /* iGくんの顔を記号にしたもの（ライフと進行度で使う）。
       **スプライトから切り出さない。**1枚絵の頭の位置は画像に依存するし、
       15px に縮めると目が潰れる。**記号として描き直したほうが小さくても読める。**

       色はシアン固定（`#41caec`）。都市で変えない。HUD の他の要素は都市の
       明暗に追従するが、**これは「iGくん」という固有のものなので色が変わると別物に見える。**
       生きている＝塗り、失った＝輪郭だけ（uiDim）。

       x,y は左上、s は一辺。取っ手 → 本体 → 目 → 口 の順に描く。 */
    function igFace(x, y, s, solid, dim){
      var col = solid ? '#41caec' : (dim || 'rgba(255,255,255,.35)');
      // 取っ手。ショッパーだと分かる唯一の手がかりなので、顔より先に描いて背面に置く
      ctx.strokeStyle = col;
      ctx.lineWidth = Math.max(1, s*0.085);
      ctx.beginPath(); ctx.arc(x+s*0.37, y+s*0.30, s*0.15, Math.PI*1.05, Math.PI*1.95); ctx.stroke();
      ctx.beginPath(); ctx.arc(x+s*0.63, y+s*0.30, s*0.15, Math.PI*1.05, Math.PI*1.95); ctx.stroke();
      // 本体
      if(solid){
        ctx.fillStyle = col;
        rr(ctx, x+s*0.10, y+s*0.28, s*0.80, s*0.66, s*0.16); ctx.fill();
      } else {
        rr(ctx, x+s*0.10+0.5, y+s*0.28+0.5, s*0.80-1, s*0.66-1, s*0.16); ctx.stroke();
        return;                                   // 失ったぶんに顔は描かない
      }
      // 目。白目に濃い瞳。**この2点があるかどうかで「顔」に見えるかが決まる**
      var ey = y+s*0.52, er = s*0.115;
      ctx.fillStyle = '#ffffff';
      ctx.beginPath(); ctx.arc(x+s*0.36, ey, er, 0, 7); ctx.fill();
      ctx.beginPath(); ctx.arc(x+s*0.64, ey, er, 0, 7); ctx.fill();
      ctx.fillStyle = '#12303c';
      ctx.beginPath(); ctx.arc(x+s*0.37, ey, er*0.5, 0, 7); ctx.fill();
      ctx.beginPath(); ctx.arc(x+s*0.65, ey, er*0.5, 0, 7); ctx.fill();
      // 口。1本の弧
      ctx.strokeStyle = '#12303c';
      ctx.lineWidth = Math.max(1, s*0.055);
      ctx.beginPath(); ctx.arc(x+s*0.50, y+s*0.66, s*0.15, 0.25, Math.PI-0.25); ctx.stroke();
    }

    /* =============== HUD（visual-spec 2-4） ===============
       上端72pxが情報帯。枠・影・光彩は使わない。数字は固定幅スロット。 */
    function drawHUD(uiC, uiDim, light){
      var i;
      // 情報帯の下地：主文字の反対色を alpha .40 → 0 の縦グラデーションで
      var scrim=ctx.createLinearGradient(0,0,0,72);
      scrim.addColorStop(0, light?'rgba(255,255,255,.40)':'rgba(0,0,0,.40)');
      scrim.addColorStop(1, 'rgba(0,0,0,0)');
      ctx.fillStyle=scrim; ctx.fillRect(0,0,VW,72);

      // タイム（M=22）。100分の1秒は出さない
      numText(mmss(clock), 18, 38, 22, uiC);

      /* ライフ ×3。**四角ではなく iGくんの顔**（2026-09-10。実機の指摘）。
         残機が「iGくん自身」だと分かると、減ったときの痛みが伝わる。
         減る時は 1.4倍に膨らんで 8f で消え、あとは輪郭だけ残る。 */
      var lmax = livesFor();                    // エンドレス・エキスパートは1つだけ
      for(i=0;i<lmax;i++){
        var lx=18+i*18, ly=44;
        if(i<lives){
          igFace(lx, ly, 15, 1);
        } else if(i===lives && lifeHit>0){
          var g=1+0.4*(lifeHit/8), s=15*g, o=(s-15)/2;
          ctx.globalAlpha=lifeHit/8;
          igFace(lx-o, ly-o, s, 1);
          ctx.globalAlpha=1;
        } else {
          igFace(lx, ly, 15, 0, uiDim);
        }
      }

      /* 進行：**iGくんが線の上を歩いていく**（2026-09-10。四角の点列からの作り直し）。
         点が並ぶだけでは「旅」に見えない、という実機の指摘。
         狙いは「どこまで来たか」を数字ではなく**絵で**分からせること。

           ・線     … 通った側は太く（2px）濃く、これからの側は細く（1px）薄く
           ・都市   … 通過した都市は塗り、これからの都市は輪郭だけ
           ・現在地 … iGくんの顔。**歩幅に合わせて上下に1pxだけ揺れる**

         都市が2つでも8つでも同じ見え方で通る。 */
      /* エンドレスは終わりが無いので線を出さない。**距離そのものが記録**なので、
         数字を主役にする（241区間ぶんの点を並べても何も読めない）。 */
      if(runMode==='endless'){
        igFace(VW/2-58, 14, 15, 1);
        // 単位は数字のすぐ後ろに置く。**固定の x に置くと桁が増えたときに離れる**
        var dwid = numText(comma(Math.floor(dist)), VW/2-34, 30, 20, uiC);
        ctx.font='400 9px '+FONT; ctx.fillStyle=uiDim; ctx.textAlign='left';
        ctx.fillText('m', VW/2-34+dwid+3, 30);
        var eb = bestOf('Dist');
        if(eb){
          ctx.textAlign='center';
          ctx.fillText('BEST '+comma(eb)+' m', VW/2, 44);
        }
        ctx.textAlign='left';
        return drawHUDTail(uiC, uiDim, light);
      }
      var pw=Math.round(Math.min(230, Math.max(110, VW*0.34)));
      var ox=Math.round(VW/2-pw/2), py=25, t=Math.min(1, dist/TOTAL_M), dx, hx;
      hx = ox + Math.round(pw*t);                          // 現在地
      ctx.fillStyle=uiDim; ctx.fillRect(hx, py, ox+pw-hx, 1);        // これから
      ctx.fillStyle=uiC;   ctx.fillRect(ox, py-0.5, hx-ox, 2);       // 通った道
      for(i=0;i<=CITIES.length;i++){                       // 区間の切れ目＝都市
        dx = ox + Math.round(pw * (i<CITIES.length ? LEG_START[i]/TOTAL_M : 1));
        ctx.beginPath(); ctx.arc(dx, py+0.5, 2.6, 0, 7);
        if(i<=legIdx){ ctx.fillStyle=uiC; ctx.fill(); }
        else { ctx.strokeStyle=uiDim; ctx.lineWidth=1; ctx.stroke(); }
      }
      // ゴール（帰り道の終わり）だけは橙で、目指す先だと分かるようにする
      ctx.fillStyle = (t>=1) ? '#fc930a' : (mode==='idle' ? uiDim : '#fc930a');
      ctx.beginPath(); ctx.arc(ox+pw, py+0.5, 1.3, 0, 7); ctx.fill();
      // 現在地の iGくん。走っている間だけ歩幅で揺れる（止まっていたら静止）
      var bobY = (mode==='run'||mode==='hit') ? Math.round(Math.sin(tick*0.22))*1 : 0;
      igFace(hx-6.5, py-13+bobY, 13, 1);

      drawHUDTail(uiC, uiDim, light);
    }
    /* 情報帯の右側（コンボ倍率と仕入れ）。**本編とエンドレスで共通**なので、
       進行の描き方が分かれても、ここは1つの関数のままにする */
    function drawHUDTail(uiC, uiDim, light){
      /* コンボ倍率（visual-spec 2-4）。×1 では出さない。
         上昇時は 1.5倍 → 1.0 に 10f でバウンド。途切れたら白く2回点滅して消える */
      /* 【2026-09-17 整理・石川さんの指摘】右上は「情報だけ」にする（visual-spec 2-1「情報は上、操作は下」）。
         ・橙の四角（仕入れ品のアイコン）は何の数字か伝わらないので消し、**「仕入れ」の文字ラベル**にした
           （完走証の「仕入れ N 個」と同じ言葉。英字 CARGO より 1 秒で読める）
         ・数字は右端 x=VW−18（左のタイムと同じ余白）、ラベルはその真上
         ・一時停止とミュートは HUD から出し、**画面右下の操作領域**へ（drawCtrls）*/
      var pop = parcelPop>0 ? parcelPop/8 : 0;
      ctx.save();
      ctx.translate(VW-18, 38);
      ctx.scale(1+pop*0.3, 1+pop*0.3);
      var nw = numText(parcels, 0, 0, 22, uiC, 'right');
      ctx.restore();
      ctx.save();
      ctx.font = '400 9px '+FONT;
      ctx.fillStyle = uiDim; ctx.textAlign = 'right';
      ctx.fillText('仕入れ', VW-18, 19);
      ctx.textAlign = 'left';
      ctx.restore();
      /* 撃退（踏んだ数。2026-09-17）。仕入れの数字の下、副行（y=57）に小さく。
         **1体目を踏むまでは出さない**（情報を増やしすぎない。踏まずに進む人には要らない）。
         踏んだ瞬間に 8f はねる（仕入れと同じ手応え）。右下の操作の札とは 30px 以上離れている */
      if(stomps>0){
        var sp = stompPop>0 ? stompPop/8 : 0;
        ctx.save();
        ctx.translate(VW-18, 58);
        ctx.scale(1+sp*0.3, 1+sp*0.3);
        text('撃退 '+stomps, 0, 0, 12, '#fc930a', 'right', 700);
        ctx.restore();
      }

      /* コンボ倍率（visual-spec 2-4）。×1 では出さない。仕入れの数字の左に 14px 空けて置く。
         上昇時は 1.5倍 → 1.0 に 10f でバウンド。途切れたら白く2回点滅して消える */
      if(mult>1 || comboBreak>0){
        var cm = comboBreak>0 ? breakM : mult;
        var blink = comboBreak>0 ? (Math.floor(comboBreak/4)%2)===0 : true;
        if(blink){
          var cs = comboPop>0 ? 1+0.5*(comboPop/10) : 1;
          ctx.save();
          ctx.translate(VW-18-(nw||slotW(22)*2)-14, 38); ctx.scale(cs, cs);
          text('×'+cm, 0, 0, 22, comboBreak>0 ? '#ffffff' : '#fc930a', 'right');
          ctx.restore();
        }
      }

      drawCtrls(uiC, uiDim);           // 一時停止・ミュート（右下の操作領域）
    }

    /* ミュートの切り替え（canvas 内。TODO 9）。
       **指定は「小包アイコンの左 18px」だったが、そこはコンボ倍率と小包の数字が占めている。**
       縦持ち（VW が狭い）では進行バーとも重なるため、小包アイコンの真下（副行）に置いた。
       ライフが左の副行にあるので、左右で釣り合う。
       絵は HUD の他の部品と同じくコード描画（枠・影・光彩は使わない）。
       **タップ領域は見た目より広く 44px 四方**（指で押せないと意味がない）。 */
    /* 【2026-09-17 整理】操作は右下へ（visual-spec 2-1「情報は上、操作は下」）。
       ミュートと一時停止は**同じ大きさの札**（CTRL_S 四方、角丸、薄い下地）に同じ色で描き、
       同じ間隔で横に並べる。情報（数字）とは行も高さも分けるので混ざらない。
       当たりは見た目より広く、**44 CSS px 四方以上**（tapPad）。隣の札と当たりが重なる分は
       中点で分ける（ctrlHit）。 */
    var MUTE_R = 44, CTRL_S = 22, CTRL_GAP = 30;   // 札の見た目の大きさと、札の中心どうしの距離
    function ctrlPad(){ return Math.max(MUTE_R, tapPad()); }
    function muteCenter(){ return { x: VW-8-CTRL_S/2, y: VH-8-CTRL_S/2 }; }
    function pauseCenter(){ var m = muteCenter(); return { x: m.x-CTRL_GAP, y: m.y }; }
    // 札の下地（同じ形を2つとも使う）。枠線は引かない（visual-spec 2-1「装飾しない」）
    function ctrlChip(c, light){
      ctx.fillStyle = light ? 'rgba(255,255,255,.55)' : 'rgba(6,10,16,.55)';
      rr(ctx, c.x-CTRL_S/2, c.y-CTRL_S/2, CTRL_S, CTRL_S, 5); ctx.fill();
    }
    // 札の当たり。pad 四方だが、隣の札の側は中点までにして取り合わない
    function ctrlHit(c, vx, vy, leftNeighbor, rightNeighbor){
      var p = ctrlPad()/2;
      var l = leftNeighbor  ? Math.max(c.x-p, (c.x+leftNeighbor.x)/2)  : c.x-p;
      var r = rightNeighbor ? Math.min(c.x+p, (c.x+rightNeighbor.x)/2) : c.x+p;
      return vx >= l && vx <= r && Math.abs(vy-c.y) <= p;
    }
    function drawCtrls(uiC, uiDim){
      var light = false;
      try{ light = !city.night; }catch(e){}
      drawPause(uiC, uiDim, light);
      drawMute(uiC, uiDim, light);
    }
    function drawMute(uiC, uiDim, light){
      var c = muteCenter(), col = au.on ? uiC : uiDim;
      ctrlChip(c, light);
      ctx.save();
      ctx.translate(c.x, c.y);
      ctx.fillStyle = col;
      ctx.fillRect(-7, -3.5, 4, 7);                    // 本体
      ctx.beginPath();                                  // ラッパ
      ctx.moveTo(-3, -3.5); ctx.lineTo(2, -7.5); ctx.lineTo(2, 7.5); ctx.lineTo(-3, 3.5);
      ctx.closePath(); ctx.fill();
      ctx.strokeStyle = col; ctx.lineWidth = 1.5; ctx.lineCap='round';
      if(au.on){
        ctx.beginPath();                                // 鳴っているときは音波2本
        ctx.arc(3, 0, 3.5, -0.9, 0.9); ctx.stroke();
        ctx.beginPath();
        ctx.arc(3, 0, 6.5, -0.8, 0.8); ctx.stroke();
      } else {
        // 消音はスピーカーごと斜線で消す（短い線だと「消えている」と読めない）
        ctx.beginPath();
        ctx.moveTo(-8, -7.5); ctx.lineTo(8, 7.5); ctx.stroke();
      }
      ctx.restore();
    }
    /* =============== モード選択（TODO 17。canvas の中に描く） ===============
       **HTML の要素は増やさない。**ボタンを足すと、埋め込み先のテーマの CSS に
       見た目を握られる。ミュートの札と同じで、自分で描いて自分で当たりを取る。

       ~~出るのは本編を完走した人だけ（cleared）~~ → 9/17 から最初から出す（pickerOn）。
       札は2行（名前＋小さな一行）にして、選んでいない札でも中身が分かるようにした。
       **エキスパートは札の中に「上級者向け・2段封印・ワンミス」**。 */
    var MODE_W = 118, MODE_H = 40, MODE_GAP = 8;
    function modeRect(i){
      var n = MODES.length, tw = n*MODE_W + (n-1)*MODE_GAP;
      return { x: Math.round(VW/2 - tw/2 + i*(MODE_W+MODE_GAP)), y: VH/2+38, w: MODE_W, h: MODE_H };
    }
    // タイトルの3行目。エンドレスは都市を並べても意味が無いので言い換える
    function idleRouteLine(){
      if(runMode==='endless') return '東京から順に、走れるところまで';
      return VISITED.join(' → ') + ' → INFOLENS GEEK SHOP';
    }
    function bestOf(kind){
      try{
        var v = parseInt(window.localStorage.getItem(storeKey+'.best'+kind)||'0', 10);
        return v>0 ? v : 0;
      }catch(e){ return 0; }
    }
    function saveBest(kind, v){
      try{
        var p = bestOf(kind);
        if(!p || v>p) window.localStorage.setItem(storeKey+'.best'+kind, String(Math.floor(v)));
      }catch(e){}
    }
    function drawModePicker(){
      var i, r, on, b, sub = '';
      for(i=0;i<MODES.length;i++){
        r = modeRect(i); on = (i===modeSel);
        if(on){
          ctx.fillStyle = '#fc930a';
          rr(ctx, r.x, r.y, r.w, r.h, 4); ctx.fill();
        } else {
          ctx.strokeStyle = 'rgba(255,255,255,.42)'; ctx.lineWidth = 1;
          rr(ctx, r.x+0.5, r.y+0.5, r.w-1, r.h-1, 4); ctx.stroke();
        }
        text(MODES[i].n, r.x+r.w/2, r.y+17, 13, on ? '#0e2530' : 'rgba(255,255,255,.85)', 'center', 700, r.w-10);
        // 小さな一行。エキスパートは選んでいなくても橙で「上級者向け」と読める
        text(MODES[i].s, r.x+r.w/2, r.y+31, 8,
             on ? 'rgba(14,37,48,.8)' : (MODES[i].k==='expert' ? '#fc930a' : 'rgba(255,255,255,.55)'),
             'center', 700, r.w-8);
      }
      // 選んでいるモードの説明と自己ベスト。**1行に混ぜない**（説明が読めなくなる）
      sub = MODES[modeSel].d;
      text(sub, VW/2, VH/2+96, 11, 'rgba(255,255,255,.72)', 'center', 400, VW-32);
      b = (MODES[modeSel].k==='endless') ? bestOf('Dist')
        : (MODES[modeSel].k==='expert')  ? bestOf('Expert') : bestOf('Time');
      if(b){
        text(MODES[modeSel].k==='endless' ? ('自己ベスト '+comma(b)+' m')
                                          : ('自己ベスト '+mmss(b)),
             VW/2, VH/2+111, 11, '#fc930a', 'center', 700);
      }
      /* 主導線は「タップして出発」のまま（初見の人はこれだけ読めばよい）。
         他のモードは左右キーか札を押した人だけが入る */
      ctx.globalAlpha = 0.55+0.45*(0.5+0.5*Math.sin(tick*0.055));
      text('タップして出発', VW/2, VH/2+131, 16, '#41caec', 'center');
      ctx.globalAlpha = 1;
      text('札をタップ、または ← → で他のモード', VW/2, VH/2+146, 9, 'rgba(255,255,255,.45)', 'center', 400, VW-32);
    }
    /* タイトルでモードの札を押したか。押していれば その番号、外なら -1。
       **札は 30 仮想px しかない。**縦持ちの実機では 26 CSS px で、指の目標としては
       小さすぎた（実測：20px 下にずれた指はここを外し、press() に落ちて
       本編が始まる＝「選べない」ように見える。これが 9/10 の実機報告の正体）。

       ・縦は 44 CSS px ぶんまで広げる（tapPad）
       ・横は札のあいだの隙間（8px）を半分ずつ分け合う。**隙間に落ちない**
       ・帯の中に入っていれば、いちばん近い札に寄せる（取りこぼしを残さない） */
    function hitMode(vx, vy){
      if(mode!=='idle' || !pickerOn()) return -1;
      /* 札の上下は空いている（上は行き先の行、下は説明文で、どちらも押せない）。
         **空いているぶんは当たりに使う。**縦持ちで 52 CSS px、PC で 60 CSS px になる */
      var r0 = modeRect(0), pad = Math.max(tapPad(), r0.h + 30);
      var top = r0.y + r0.h/2 - pad/2, bot = r0.y + r0.h/2 + pad/2;
      if(vy < top || vy > bot) return -1;
      var half = MODE_GAP/2, best = -1, bd = 1e9, i, r, d;
      for(i=0;i<MODES.length;i++){
        r = modeRect(i);
        if(vx >= r.x-half && vx <= r.x+r.w+half) return i;
        d = Math.min(Math.abs(vx-r.x), Math.abs(vx-(r.x+r.w)));
        if(d < bd){ bd = d; best = i; }
      }
      // 帯の左右の端をわずかに外した指も拾う（44 CSS px ぶんまで）
      return bd <= tapPad()/2 ? best : -1;
    }
    // モードを決めて走り出す。**道を組み直してから走る**（endless は区間の並びが違う）
    function chooseMode(k){
      runMode = k;
      buildRoute(k);
      newRun();
    }

    /* =============== 一時停止（TODO 5） ===============
       ミュートの隣（左）。**canvas の中に描いて自分で当たりを取る。**
       HTML のボタンを足すと埋め込み先のテーマの CSS に見た目を握られる。
       走っている間だけ効く（タイトル・完走証・リタイア画面では出さない）。 */
    function canPause(){ return mode==='run' || mode==='hit'; }
    /* 「やめる」（2026-09-17・石川さんの指示）。一時停止中だけ、右下に小さく出す。
       押し間違い防止のため目立たせない（小さい文字・薄い色・端）。走行中の記録は捨てて
       タイトルへ戻る。**.cleared や自己ベストには触らない。** */
    // 左下。右下は一時停止（再開）とミュートの札があるので、反対側に離す（押し間違い防止）
    function quitCenter(){ return { x: 44, y: VH-19 }; }
    function hitQuit(vx, vy){
      if(!paused) return false;
      var c = quitCenter(), p = ctrlPad()/2;
      return Math.abs(vx-c.x) <= Math.max(p, 34) && Math.abs(vy-c.y) <= p;
    }
    function quitToTitle(){
      paused = false; countT = 0;
      bgmAt = 0; bgmHalt();
      track('igrun_quit', { city: city.id, run_mode: runMode, dist: Math.floor(dist) });
      startAt(startLeg);                          // 区間の頭の状態に戻す（mode は 'run' になる）
      clock = 0; parcels = 0; retries = 0; nameShow = 0;
      sPar = 0; sNear = 0; sND = 0; sFoe = 0; comboMax = 1; stomps = 0; stompPop = 0;
      mode = 'idle';                              // タイトルへ。次のタップで newRun
      hideActions();
    }
    function togglePause(){
      if(paused){ resumeRun(); return; }
      if(!canPause() || countT>0) return;
      paused = true;
      /* BGM は update から予約しているので、止まれば自然に鳴り終わる。
         **bgmAt を戻しておかないと、再開したときに止まっていた時間ぶんの音が
         いっぺんに鳴る**（予約時刻が過去のまま while が回るため） */
      bgmAt = 0; bgmHalt();
    }
    function resumeRun(){
      if(!paused) return;
      paused = false;
      countT = 168;                               // 2.8秒。3→2→1 を各56フレーム
      if(au.on) bgmCity();
    }
    /* タブを離れたら自動で止める（指定どおり）。
       **rAF が止まるので時計は進まないが、戻った瞬間に動き出すと事故になる。** */
    document.addEventListener('visibilitychange', function(){
      if(document.hidden && canPause() && !paused) togglePause();
    });
    function hitPause(vx, vy){
      if(!canPause() && !paused) return false;
      return ctrlHit(pauseCenter(), vx, vy, null, muteCenter());
    }
    function drawPause(uiC, uiDim, light){
      if(!canPause() && !paused) return;
      var c = pauseCenter(), col = paused ? '#fc930a' : uiC;
      ctrlChip(c, light);
      ctx.save();
      ctx.fillStyle = col;
      if(paused){                                  // 再生の三角（押せば戻る、と分かる形）
        ctx.beginPath();
        ctx.moveTo(c.x-4, c.y-6); ctx.lineTo(c.x+6, c.y); ctx.lineTo(c.x-4, c.y+6);
        ctx.closePath(); ctx.fill();
      } else {                                     // 一時停止の2本線
        ctx.fillRect(c.x-5, c.y-6, 3.4, 12);
        ctx.fillRect(c.x+1.6, c.y-6, 3.4, 12);
      }
      ctx.restore();
    }
    /* 止めている間の画と、再開の 3・2・1。**画面全体を暗くしすぎない**
       （何が起きていたか見えなくなると、再開したときに状況が分からない）。 */
    function drawPauseOverlay(){
      if(paused){
        ctx.fillStyle='rgba(6,10,16,.62)'; ctx.fillRect(0,0,VW,VH);
        text('一時停止', VW/2, VH/2-6, 26, '#ffffff', 'center');
        text('画面をタップすると再開します（PC は P か Esc）',
             VW/2, VH/2+20, 11, 'rgba(255,255,255,.7)', 'center', 400, VW-40);
        // 「やめる」は小さく端に（2026-09-17）。押すとタイトルへ。記録は捨てる
        var q = quitCenter();
        ctx.fillStyle = 'rgba(255,255,255,.10)';
        rr(ctx, q.x-30, q.y-11, 60, 22, 4); ctx.fill();
        text('やめる', q.x, q.y+4, 10, 'rgba(255,255,255,.7)', 'center', 700);
        return;
      }
      if(countT>0){
        var n = Math.ceil(countT/56);              // 3 → 2 → 1
        var f = (countT % 56)/56;                  // その数字の中での進み（1→0）
        ctx.save();
        ctx.fillStyle='rgba(6,10,16,'+(0.42*Math.min(1,countT/28))+')';
        ctx.fillRect(0,0,VW,VH);
        ctx.globalAlpha = Math.min(1, f*2.2);      // 出て、消える
        ctx.translate(VW/2, VH/2);
        ctx.scale(1.6-0.6*f, 1.6-0.6*f);           // 大きく出て縮む
        text(String(n), 0, 14, 44, '#ffffff', 'center');
        ctx.restore();
      }
    }
    // 画面のどこを触ったか（仮想座標）。ミュートの札に入っていれば true
    function hitMute(vx, vy){
      if(!(canPause() || paused || mode==='idle')) return false;   // 描いているときだけ押せる
      return ctrlHit(muteCenter(), vx, vy, (canPause()||paused) ? pauseCenter() : null, null);
    }

    /* 実機で性能を読むための表示（TODO 11）。
       **URL に ?igrun_perf=1 が付いたときだけ出す。**それ以外では1行も描かない。
       単体版（dist）でも同じ。**付けなければ遊ぶ人の画面には出ない。**

       ヘッドレスでは 60fps も焼き込みの引っかかりも測れない。
       **実機で人が判断するには、画面に数字が出ていないと分からない。**

         16ms      … 直近の平均フレーム時間（16.7 なら 60fps）
         最悪 21ms … 直近5秒でいちばん遅かった1フレーム。
                     **都市の切り替えの引っかかりはここに出る**（平均には出ない）
         焼 64ms   … 直前に焼いた都市とその所要時間
         3都市 25MB… いま抱えている焼き込み。**増え続けたら破棄が効いていない**
         LITE      … 自動間引きに落ちた（落ちたらその走りの間は戻らない） */
    function drawPerfHUD(uiC, uiDim){
      if(!perfOn) return;
      var L = procLoad();
      var a = Math.round(frameMS) + 'ms  最悪 ' + Math.round(worstMS) + 'ms';
      var b = '焼 ' + (bakeLastId ? bakeLastId + ' ' + Math.round(bakeLastMS) + 'ms' : '-') +
              '   ' + L.cities + '都市 ' + L.mb.toFixed(1) + 'MB';
      ctx.save();
      ctx.font = '400 9px ' + FONT;
      ctx.textAlign = 'right';
      ctx.fillStyle = uiDim;
      ctx.fillText(a, VW-8, VH-20);
      ctx.fillText(b, VW-8, VH-9);
      if(lite){
        // **落ちたことは一目で分かる必要がある。**橙の札で出す
        ctx.textAlign = 'left';
        ctx.fillStyle = '#fc930a';
        ctx.fillRect(VW-8-52, VH-44, 52, 14);
        ctx.fillStyle = '#0e2530';
        ctx.font = '700 9px ' + FONT;
        ctx.fillText('LITE', VW-8-44, VH-34);
      }
      ctx.textAlign = 'left';
      ctx.restore();
    }

    /* 都市名の演出（visual-spec 2-5）。左下に橙の縦線＋都市名＋英字。
       0〜10f 縦線が下から伸びる／14〜28f 名前が左から入る／終盤 40f で消える。 */
    var NAME_SHOW = 150;
    /* 区間クリアの演出の絵（2026-09-10）。**素材は使わない。**
       通過した都市の「スタンプ」を押し、無傷なら +500 を大きく、
       最後に次の都市名を中央に出す。時間割は nextLeg のコメントのとおり。

       スタンプは二重枠＋都市名＋英字。**傾けて、少し透かして押す。**
       まっすぐで不透明だと「印を押した」ではなく「UI が出た」に見える。 */
    function drawClearSeq(){
      if(clearT<=0 || !clearCity) return;
      var t = CLEAR_F - clearT;                 // 経過フレーム
      var cx = VW/2, cy = Math.round(VH*0.34);
      var acc = clearCity.accent || '#fc930a';

      // ---- スタンプ（6f から。150f で抜ける）----
      if(t>=6 && t<172){
        var st = Math.min(1, (t-6)/12), ease = 1-Math.pow(1-st,4);
        var sc = reduce ? 1 : (2.6 - 1.6*ease);              // 叩きつける
        var rot = (reduce ? -0.10 : (-0.24 + 0.14*ease));
        var out = t>150 ? (t-150)/22 : 0;                    // 上へ抜けて消える（172f で完全に消す）
        var w = 168, h = 62;
        ctx.save();
        ctx.globalAlpha = (reduce ? ease : Math.min(1, ease)) * (1-out);
        ctx.translate(cx, cy - out*10);
        ctx.rotate(rot); ctx.scale(sc, sc);
        ctx.strokeStyle = acc; ctx.lineWidth = 3;
        rr(ctx, -w/2, -h/2, w, h, 6); ctx.stroke();
        ctx.lineWidth = 1;
        rr(ctx, -w/2+6, -h/2+6, w-12, h-12, 3); ctx.stroke();
        text(clearCity.name, 0, 4, 26, acc, 'center', 700, w-26);
        ctx.font='400 9px '+FONT; ctx.fillStyle=acc; ctx.textAlign='center';
        ctx.fillText(spaced(clearCity.en), 0, 20);
        ctx.textAlign='left';
        // 「通過」の印。左上の隅に小さく
        text('CLEAR', -w/2+22, -h/2+13, 8, acc, 'center', 700);
        ctx.restore();
      }
      // ---- NO DAMAGE +500（26f から。スタンプの下）----
      if(clearND && t>=26 && t<172){
        var nt = Math.min(1, (t-26)/10), ne = 1-Math.pow(1-nt,3);
        var nout = t>150 ? (t-150)/22 : 0;
        ctx.save();
        ctx.globalAlpha = ne*(1-nout);
        ctx.translate(cx, cy+58);
        ctx.scale(1.4-0.4*ne, 1.4-0.4*ne);
        text('NO DAMAGE +'+ND_PT, 0, 0, 18, '#b7d029', 'center');
        ctx.restore();
      }
      // ---- 次の都市名（150f から。中央に大きく）----
      if(t>=172){
        var vt = Math.min(1, (t-172)/14), ve = 1-Math.pow(1-vt,3);
        var vout = t>212 ? (t-212)/18 : 0;
        ctx.save();
        ctx.globalAlpha = ve*(1-vout);
        ctx.translate(cx, cy+6+(1-ve)*10);
        text(city.name, 0, 0, 34, '#ffffff', 'center', 700, VW-60);
        ctx.font='400 10px '+FONT; ctx.fillStyle='rgba(255,255,255,.6)'; ctx.textAlign='center';
        ctx.fillText(spaced(city.en), 0, 20);
        ctx.textAlign='left';
        ctx.restore();
      }
    }
    // 英字を1文字ずつ空ける（都市名の副題。visual-spec 2-5 と同じ見せ方）
    function spaced(str){ return String(str||'').split('').join(' '); }

    function drawCityName(uiC, uiDim){
      // 無傷ボーナスは都市名の下に 60f（visual-spec 2-5）。都市名より先に消える
      if(ndShow>0){
        ctx.globalAlpha = Math.min(1, ndShow/12);
        text('NO DAMAGE +'+ND_PT, 30, VH-16, 13, '#b7d029', 'left');
        ctx.globalAlpha = 1;
      }
      if(nameShow<=0) return;
      var e = NAME_SHOW - nameShow;                    // 経過フレーム
      var out = Math.max(0, 1 - nameShow/40);          // 終盤のフェード
      var barT = Math.min(1, e/10), ease = 1-Math.pow(1-barT,3);
      var y = VH-40;

      ctx.globalAlpha = 1-Math.pow(out,3);
      ctx.fillStyle='#fc930a';
      ctx.fillRect(18, y-26*ease, 4, 26*ease);

      if(e>=14){
        var st=Math.min(1,(e-14)/14), se=1-Math.pow(1-st,3);
        ctx.globalAlpha *= se;
        text(city.name, 30-12*(1-se), y-8, 26, uiC);
        if(city.en) text(city.en, 30-12*(1-se), y+7, 13, uiDim, 'left', 400);
      }
      ctx.globalAlpha=1;
    }

    /* =============== 描画 =============== */
    function render(){
      var cw=stage.clientWidth, ch=stage.clientHeight;
      if(!cw||!ch) return;
      var dpr=Math.min(2, window.devicePixelRatio||1);
      if(canvas.width!==Math.round(cw*dpr)||canvas.height!==Math.round(ch*dpr)){
        canvas.width=Math.round(cw*dpr); canvas.height=Math.round(ch*dpr);
      }
      var s=ch/VH; VW=Math.round(cw/s);
      if(mode!=='enter'&&mode!=='clear') pl.x=Math.max(80, VW*0.2);
      var drawX=pl.x+pl.offX;

      ctx.setTransform(s*dpr,0,0,s*dpr,0,0);
      /* proc の都市は 2倍で焼いた canvas を等倍に落として描くので、補間を効かせる。
         素材（Kenney）の都市は従来どおり切る */
      ctx.imageSmoothingEnabled = procActive();
      mixCity();
      var light=lum(C.sky2)>0.55;
      var uiC=light?'#12222b':'#f2f6f8';
      var uiDim=light?'rgba(18,34,43,.55)':'rgba(242,246,248,.55)';

      ctx.save();
      if(shake>0.4) ctx.translate((Math.random()-.5)*shake, (Math.random()-.5)*shake);

      var i, PA=procActive(), PC=PA?procOf(city):null, PP=(PA&&blend<1)?procOf(prev):null;
      /* 靄を層と層のあいだに挟む。**これが空気遠近の効き所**で、
         遠い層ほど強く空の色に沈む（art-direction 2章） */
      function hazeBand(y, a){
        var H2 = PC ? PC.haze : (PP ? PP.haze : null);
        if(H2){ ctx.globalAlpha=a; ctx.drawImage(H2.c, -20, y, H2.w, H2.h); ctx.globalAlpha=1; return; }
        var hz=ctx.createLinearGradient(0, GROUND_Y-86, 0, GROUND_Y+4);
        hz.addColorStop(0, rgb(C.sky2, 0)); hz.addColorStop(1, rgb(C.sky2, .55));
        ctx.fillStyle=hz; ctx.fillRect(-30, GROUND_Y-86, VW+60, 92);
      }

      drawSky();
      if(PA) drawOrb();
      for(i=0;i<l1.length;i++) drawL1(l1[i]);
      if(PA) hazeBand(HORIZON-72, 0.95);                 // 遠景の上に厚い靄（空に沈める）
      for(i=0;i<lm.length;i++) drawLandmark(lm[i]);
      for(i=0;i<l2.length;i++) drawL2(l2[i]);
      if(PA){
        hazeBand(HORIZON-30, 0.55);                      // 中景の上に薄い靄
        // 高架下の暗い帯。中景の足元から歩道までをもう一層見せて奥行きを作る
        var F = PC ? PC.floor : (PP ? PP.floor : null);
        if(F) ctx.drawImage(F.c, -20, F.top, F.w, F.h);
      } else {
        hazeBand(0,0);
      }

      if(cross && cross.train) drawTrain(cross.train);   // 電車は近景の props より奥（背後を横切る）
      for(i=0;i<l3.length;i++) drawL3(l3[i]);
      drawSignals();                                     // 警報機は props と同じ面に立てる
      drawGround();
      if(shop) drawShop(shop);

      ctx.fillStyle = light ? rgb(C.ink,.3) : 'rgba(255,255,255,.55)';
      for(i=0;i<flakes.length;i++) ctx.fillRect(flakes[i].x, flakes[i].y, flakes[i].w, flakes[i].h);

      for(i=0;i<pads.length;i++)  drawPad(pads[i]);      // 水たまり・氷（地面の上、荷物の下）
      for(i=0;i<boxes.length;i++) drawBox(boxes[i]);
      for(i=0;i<obs.length;i++)   drawObs(obs[i]);
      for(i=0;i<foes.length;i++)  drawFoe(foes[i]);      // 敵（enemy-spec）。障害物の手前
      for(i=0;i<plats.length;i++) drawPlat(plats[i]);    // タクシー・ネオンの足場

      if(mode!=='clear'){
        /* 接地影（art-direction-final.md 3-a）。**キャラが夜の街に「立つ」ための土台。**
           ジャンプの高さで小さく・薄くなる。
           接地時 横幅=キャラ幅の0.55倍・alpha 0.42／最高到達点 0.30倍・0.12。
           月は左上にあるので、跳ぶほど影は右へ逃げる */
        var alt = Math.max(0, Math.min(1, (GROUND_Y-P_H-pl.y)/150));
        var cxp = drawX+HIT_X+HIT_W/2;
        if(PA){
          /* 影は光源の反対側へ逃げる。lit は「光源がどちら側にあるか」なので符号を反転。
             濃さは都市ごと（grade.shA）。**南極は地面が白いので、黒い影のままだと
             穴に見える。** 青寄りの色を濃いめに置いて「雪に落ちた影」にする */
          var gsh = PROC_PAL[city.id] && PROC_PAL[city.id].grade;
          var a0 = gsh && gsh.shA ? gsh.shA[0] : 0.42;
          var a1 = gsh && gsh.shA ? gsh.shA[1] : 0.12;
          var shW = P_W*(0.55 - 0.25*alt), shA = a0 + (a1-a0)*alt;
          var sao = (gsh && gsh.shC) ? gx()[gsh.shC] : gx().ao;
          ctx.globalAlpha = shA;
          ctx.drawImage(sao.c, cxp-shW*1.6/2 - litOf(PROC_PAL[city.id])*alt*16,
                        GROUND_Y-4, shW*1.6, shW*0.42);
          ctx.globalAlpha = 1;
        } else {
          var sh=Math.max(0.35, 1-(GROUND_Y-P_H-pl.y)/170);
          ctx.fillStyle='rgba(0,0,0,.3)';
          ctx.beginPath();
          ctx.ellipse(cxp, GROUND_Y+2, 22*sh, 5*sh, 0, 0, Math.PI*2);
          ctx.fill();
        }
        var alpha=pl.alpha;
        if(pl.inv>0 && pl.inv<999 && Math.floor(tick/4)%2===0) alpha*=0.35;
        drawGhosts(alpha);
        drawIG(drawX, pl.y, pl.scale, alpha);
      }

      for(i=0;i<bits.length;i++){
        var p=bits[i];
        ctx.globalAlpha=Math.min(1, p.life/14);
        if(p.conf){
          /* 紙吹雪。落ちながら回る。
             **素材（common-pt-confetti）は「粒が散った1枚絵」で、1粒には使えない**
             （7px に縮めると消える）。砂ぼこりや火花と同じく矩形で描く */
          ctx.save();
          ctx.translate(p.x, p.y);
          ctx.rotate(p.rot + (90-p.life)*0.11);
          ctx.fillStyle = p.c;
          ctx.fillRect(-p.s/2, -p.s/4, p.s, p.s/2);
          ctx.restore();
        } else if(p.txt){
          text(p.txt, p.x, p.y, p.sz||13, p.c, 'center');
        } else if(p.ring){
          ctx.strokeStyle=p.c; ctx.lineWidth=2.5;
          var r=(14-p.life)*1.9+7;
          ctx.strokeRect(p.x-r, p.y-r, r*2, r*2);
        } else {
          ctx.fillStyle=p.c; ctx.fillRect(p.x, p.y, p.s||4, p.s||4);
        }
        ctx.globalAlpha=1;
      }

      for(i=0;i<l5.length;i++) drawL5(l5[i]);       // 手前を横切る影
      if(PA){
        /* 手前の手すり。ピントが外れたまま画面下を最も速く流れる。
           奥行きはこの層で決まる（art-direction 2章「高架下にもう一層」の手前版）。
           **重い端末ではここから削る**（lite） */
        var R = lite ? null : (PC ? PC.rail : (PP ? PP.rail : null));
        if(R){
          var ro = ((worldX*1.55) % R.w + R.w) % R.w;
          for(i=-1; i<=Math.ceil(VW/R.w)+1; i++) ctx.drawImage(R.c, i*R.w-ro, VH-R.h+8, R.w, R.h);
        }
        // 画面全体の靄とビネット。**全画面のフラッシュは入れない**（明滅禁止）
        if(!lite) hazeBand(GROUND_Y-96, 0.30);
        var V = vignette(), va = (PC||PP).pal.vign;
        ctx.globalAlpha = va;
        ctx.drawImage(V.c, -20, -20, V.w, V.h);
        ctx.globalAlpha = 1;
      }
      ctx.restore();

      drawSand();                        // 砂嵐は世界の上・HUD の下（カイロのギミック）
      drawPauseOverlay();                // 一時停止と 3・2・1（TODO 5）

      /* ---- 表示 ---- */
      var pulse=0.55+0.45*(0.5+0.5*Math.sin(tick*0.055));

      if(mode==='run'||mode==='hit'||mode==='enter'||mode==='dead'){
        // ゴール演出に入ったら HUD を引く。最後に見る画を邪魔しない
        var hudA = (mode==='enter') ? Math.max(0, 1 - enterT/44) : 1;
        ctx.globalAlpha = hudA;
        if(hudA > 0) drawHUD(uiC, uiDim, light);
        ctx.globalAlpha = 1;
        drawCityName(uiC, uiDim);
        drawClearSeq();                   // 区間クリアの演出（2026-09-10）
        drawPerfHUD(uiC, uiDim);          // ?igrun_perf=1 のときだけ
      }

      if(mode==='load'){
        // 東京の空の上に iGくんが小さく揺れ、下に進捗バー（visual-spec 2-6）
        var lp = loadTotal ? loadDone/loadTotal : 1;
        if(igReady){
          ctx.save();
          ctx.globalAlpha=0.9; ctx.imageSmoothingEnabled=true;
          ctx.drawImage(igImg, VW/2-P_W/2 + Math.sin(tick*0.087)*2, VH/2-P_H-16, P_W, P_H);
          ctx.restore();
        }
        var bw=Math.round(VW*0.3), bx=Math.round(VW/2-bw/2), by=Math.round(VH/2+22);
        ctx.fillStyle=uiDim; ctx.fillRect(bx, by, bw, 3);
        ctx.fillStyle='#41caec'; ctx.fillRect(bx, by, Math.round(bw*lp), 3);
        text('読み込み中 '+Math.round(lp*100)+'%', VW/2, by+22, 13, uiC, 'center', 400);
        if(tick>120) text('もう少しお待ちください', VW/2, by+42, 13, uiDim, 'center', 400);
      }

      if(mode==='idle'){
        ctx.fillStyle='rgba(6,10,16,.46)'; ctx.fillRect(0,0,VW,VH);
        text('iGくん WORLD RUN', VW/2, VH/2-30, 27, '#ffffff', 'center');
        drawMute('#ffffff', 'rgba(255,255,255,.55)', false);   // タイトルでも音を切り替えられる（見えている札だけ押せる）
        ctx.fillStyle='#fc930a'; ctx.fillRect(VW/2-46, VH/2-18, 92, 3);
        // 設定：世界で仕入れて持ち帰る（docs/series-concept.md 2章）。
        // 走る街はルートで変わるので、どこを回るかは副えるだけにする
        text('世界で商品を仕入れて INFOLENS GEEK SHOP へ持ち帰ろう',
             VW/2, VH/2+6, 12, 'rgba(255,255,255,.75)', 'center', 400, VW-32);
        text(idleRouteLine(), VW/2, VH/2+23, 10, 'rgba(255,255,255,.45)', 'center', 400, VW-32);
        if(pickerOn()){
          drawModePicker();                       // 9/17 から最初から出す（cleared の判定は残す）
        } else {
          ctx.globalAlpha=pulse;
          text('タップして出発', VW/2, VH/2+58, 19, '#41caec', 'center');
          ctx.globalAlpha=1;
          text('空中でもう一度タップすると2段ジャンプ', VW/2, VH/2+82, 11, 'rgba(255,255,255,.55)', 'center', 400);
        }
      }

      if(mode==='dead'){
        ctx.fillStyle='rgba(6,10,16,.78)'; ctx.fillRect(0,0,VW,VH);
        if(runMode==='endless'){
          text('記録 '+comma(Math.floor(dist))+' m', VW/2, VH/2-24, 27, '#ffffff', 'center');
          var bd = bestOf('Dist');
          text(bd ? ('自己ベスト '+comma(bd)+' m'+(dist>=bd?'　更新！':'')) : '',
               VW/2, VH/2+6, 12, '#fc930a', 'center', 400);
        } else if(runMode==='expert'){
          text(city.name+'で終了', VW/2, VH/2-24, 27, '#ffffff', 'center');
          text('エキスパートはワンミスで終わります。最初からやり直せます。',
               VW/2, VH/2+6, 12, 'rgba(255,255,255,.7)', 'center', 400);
        } else {
          text(city.name+'でリタイア', VW/2, VH/2-24, 27, '#ffffff', 'center');
          text('この都市の最初からやり直せます。仕入れた商品は残ります。',
               VW/2, VH/2+6, 12, 'rgba(255,255,255,.7)', 'center', 400);
        }
      }

      // ゴール演出の最後。走っている画の上に完走証を 30f で重ねる（visual-spec 2-6）
      if(mode==='enter' && goalPhase==='fade'){
        ctx.globalAlpha = Math.min(1, fadeT/30);
        drawCertificate(ctx, VW, VH, 0);
        ctx.globalAlpha = 1;
      }
      if(mode==='clear'){
        // 保存する PNG と同じ関数で描く。iGくんはゆっくり上下に浮く（±3px・2秒）
        drawCertificate(ctx, VW, VH, Math.sin(tick*0.052)*3);
      }
    }

    /* =============== 完走証（visual-spec 2-6。TODO 10） ===============
       **canvas 版と保存 PNG 版で同じ関数を使う。** 別々に書くと必ずどちらかが崩れ、
       崩れた画像がそのまま SNS に流れる。ここだけは一本にしておく。

       g … 描画先の 2D コンテキスト、W/H … その大きさ、igFloat … iGくんの上下の揺れ（px）。
       - 大きさは H/360 を基準に拡縮する（canvas も 1200×630 も同じ絵になる）
       - 縦の間隔は紙面の高さに合わせて詰める（縦持ちでも下にはみ出さない）
       - 横は文字を測って紙面に収まるまで縮める（certT）。**紙面から文字が出ない** */
    function certT(g, str, x, y, size, color, align, weight, maxW){
      var s = Math.max(9, Math.round(size)), w = (weight||700);
      g.font = w+' '+s+'px '+FONT;
      if(maxW){
        while(s > 9 && g.measureText(str).width > maxW){ s--; g.font = w+' '+s+'px '+FONT; }
      }
      g.fillStyle = color; g.textAlign = align||'left';
      g.fillText(str, x, y); g.textAlign = 'left';
      return s;
    }
    // 数字を固定幅スロットで描く（visual-spec 2-2）。numText の 描画先を選べる版
    function certNum(g, str, x, y, size, color){
      str = String(str);
      g.font = '700 '+size+'px '+FONT;
      var dw = 0, d, i, c, cx = x;
      for(d=0;d<10;d++) dw = Math.max(dw, g.measureText(String(d)).width);
      g.fillStyle = color;
      for(i=0;i<str.length;i++){
        c = str.charAt(i);
        if(c>='0'&&c<='9'){ g.textAlign='center'; g.fillText(c, cx+dw/2, y); cx += dw; }
        else { g.textAlign='left'; g.fillText(c, cx, y); cx += g.measureText(c).width; }
      }
      g.textAlign = 'left';
      return cx - x;
    }

    function certDate(){
      var d = new Date();
      return '完走日 ' + d.getFullYear() + '.' + (d.getMonth()+1) + '.' + d.getDate();
    }

    function drawCertificate(g, W, H, igFloat, forSave){
      var k = H/360;                                  // 360 を基準にした拡縮
      var ink = '#0e2530', dim = 'rgba(14,37,48,.62)';
      var bg = g.createLinearGradient(0, 0, 0, H);
      bg.addColorStop(0, '#2bb4dc'); bg.addColorStop(1, '#eaf7fc');
      g.fillStyle = bg; g.fillRect(0, 0, W, H);
      g.fillStyle = '#fc930a'; g.fillRect(0, 0, W, Math.round(8*k));
      g.fillStyle = '#b7d029'; g.fillRect(0, Math.round(8*k), W, Math.round(3*k));

      /* 紙面。**下端はボタン（bottom:7%、折り返すと2段）の上で止める。**
         いちばん外に出やすいのが最後の1行なので、下からの余白を先に確保する */
      var narrow = (W/H) < 1.55;                      // 縦持ちなど。横に余裕が無い
      var m = Math.round((narrow?12:18)*k);
      var py = Math.round(26*k);
      /* 紙面の下端。画面ではボタン（bottom:7%、折り返すと2段）の上で止める。
         **保存する PNG にはボタンが無いので、そのぶんを空けない**（下が間延びする） */
      // 9/17 にボタンが4つになり、縦持ちでは2段に折れる。折れたぶん（1段≒14）を足して 118
      var pb = H - Math.round((forSave ? 26 : (narrow?118:78))*k);
      var ph = pb - py;
      var igW = narrow ? Math.round(64*k) : Math.round(Math.min(126, W*0.19)*k/k)*1;
      var pw  = narrow ? (W - m*2) : Math.min(Math.round(W*0.62), W - m*2 - igW - Math.round(14*k));
      var px  = m;
      g.fillStyle = 'rgba(255,255,255,.92)';
      g.fillRect(px, py, pw, ph);

      var pad = Math.round(16*k);
      var ix = px + pad;                              // 文字の左端
      var iw = pw - pad*2;                            // 文字が使える幅
      // 縦の間隔は「280 の設計」を紙面の高さに合わせて詰める。文字も一緒に少し縮める
      var u  = Math.min(1.06, ph / (280*k));
      var fu = Math.max(0.74, Math.min(1.08, u));
      function ry(v){ return py + Math.round(v*k*u); }   // 設計上の y → 実際の y
      function fs(v){ return Math.max(9, Math.round(v*k*fu)); }

      // 上の2行は iGくん（縦持ちのときは紙面の中に入る）の幅ぶんだけ狭くする
      var topW = narrow ? (iw - igW - Math.round(8*k)) : iw;

      /* 下から積む値を先に決める。上から積むと、紙面が縮んだときに
         最後の1行が外へ出る（実際に出ていた）。下から置けば計算で保証できる */
      var annY  = py + ph - Math.round(13*k);                       // 6th Anniversary
      var noteY = annY - Math.round(21*k);                          // クーポンの注記／ガチャの URL
      var bandH = coupon ? Math.round(32*k*Math.min(1, u)) : Math.round(20*k*Math.min(1, u));
      var bandY = noteY - Math.round(11*k) - bandH;                 // 黒帯／ガチャの見出し

      certT(g, '完走', ix, ry(34), fs(17), dim, 'left', 400, topW);
      g.font = '700 '+fs(50)+'px '+FONT;               // タイムだけ固定幅スロット
      certNum(g, mmss(clock), ix, ry(88), fs(50), ink);
      // 撃退（踏んだ数）は必ず出す（2026-09-17・石川さんの指示。0 でも出す＝踏めることを知らせる）
      certT(g, '仕入れ '+parcels+' 個　／　撃退 '+stomps+' 体　／　コンボ最大 ×'+comboMax+
               (retries===0?'　／　ノーミス完走':'　／　やり直し '+retries+' 回'),
            ix, ry(116), fs(13), dim, 'left', 400, iw);
      /* 内訳。**敵を踏んだぶんの点（sFoe）は 0 のときだけ省く。**
         踏まずに完走する人（避けるだけで進める＝9章の判断1）の内訳に
         いつも「撃退 0」が出ていると、取り逃したように見える（数のほうは上の行に出ている） */
      certT(g, '仕入れ '+sPar+' ／ ニアミス '+sNear+(sFoe ? ' ／ 撃退 '+sFoe : '')+
               ' ／ ノーダメージ '+sND+' ＝ '+comma(score()),
            ix, ry(138), fs(11), dim, 'left', 400, iw);
      certT(g, VISITED.join(' → ')+' → INFOLENS GEEK SHOP',
            ix, ry(160), fs(11), dim, 'left', 400, iw);
      if(parco) certT(g, '池袋パルコ店 限定ルート', ix, ry(180), fs(11), '#fc930a', 'left', 700, iw);
      // 上のブロックの最後。黒帯に食い込む場合はその手前で止める
      certT(g, certDate(), ix, Math.min(ry(200), bandY - Math.round(10*k)), fs(11), dim, 'left', 400, iw);

      /* クーポン。**黒帯に白文字で、ここだけ強いコントラスト。**
         角も影も付けない（押せそうに見せない。コピーはボタンでする） */
      if(coupon){
        g.fillStyle = ink; g.fillRect(ix, bandY, iw, bandH);
        certT(g, '完走特典  '+coupon, ix + Math.round(10*k), bandY + bandH*0.7,
              fs(15), '#ffffff', 'left', 700, iw - Math.round(20*k));
        if(couponNote) certT(g, couponNote, ix, noteY, fs(10), dim, 'left', 400, iw);
      } else {
        /* ガチャへの誘導（2026-09-17）。クーポンの黒帯の場所に、橙の見出しと URL。
           **保存 PNG は SNS でそのまま流れる**ので、見た人が何をすればいいか
           （どこへ行けばいいか）が画像だけで分かるように URL を入れる。
           帯も枚も付けない（押せそうに見せない。押すのは下のボタン） */
        certT(g, '完走おめでとう！  6周年ガチャに挑戦しよう', ix, bandY + bandH*0.78,
              fs(14), '#fc930a', 'left', 700, iw);
        certT(g, gachaURL.replace(/^https?:\/\//, ''), ix, noteY, fs(10), dim, 'left', 400, iw);
      }
      certT(g, 'INFOLENS GEEK SHOP  6th Anniversary', ix, annY, fs(12), ink, 'left', 700, iw);

      // iGくん。**紙面の文字とは重ねない**（横は紙面の外、縦持ちは紙面の右上の空き）
      if(igReady){
        var iy, ix2, ih = Math.round(igW*1.12);
        g.imageSmoothingEnabled = true;
        if(narrow){
          iy  = py + Math.round(14*k);
          ix2 = px + pw - igW - pad*0.5;
        } else {
          igW = Math.min(Math.round(126*k), W - (px+pw) - m*2);
          ih  = Math.round(igW*1.12);
          iy  = py + Math.round(ph*0.22);
          ix2 = px + pw + Math.round(14*k);
        }
        drawCertIg(g, ix2, iy, igW, ih, igFloat||0, k);
      }
    }

    /* =============== 完走証の iGくん（2026-09-15。実機報告2） ===============
       完走証の地は水色のグラデーション。**iGくん本体も水色**なので輪郭が消える。
       走行中は接地影・色調補正・リムライト（popObs）で分離させているが、
       完走証にはその仕組みが無く、宙に浮いた水色の塊に見えていた。

       直し方の選択：**背景のグラデーションには触らない**（9/9 に承認した画）。
       iGくんの側にだけ、3つ足す。
         1. 白の縁（ステッカー）… SNS でそのまま映える。水色の濃い側で効く
         2. 柔らかい落ち影 …… 白の縁が沈む「地の明るい側」でも分離が残る
         3. 接地の楕円 ……… 浮いて見えるのを止める。**浮きに合わせて薄く小さくする**
            （影が本体と一緒に動くと、かえって浮いて見える） */
    var IGST = null;
    function igSticker(w, h, ring){
      var key = w+'/'+h+'/'+ring;
      if(IGST && IGST.key === key) return IGST;
      var pad = Math.ceil(ring) + 2, o = mkc(w + pad*2, h + pad*2, 1), g = o.g, i, a;
      // 12方向にずらして描いた形を、まとめて白で塗りつぶす＝一定の太さの縁になる
      for(i=0;i<12;i++){
        a = i/12*Math.PI*2;
        g.drawImage(igImg, pad + Math.cos(a)*ring, pad + Math.sin(a)*ring, w, h);
      }
      g.globalCompositeOperation = 'source-in';
      g.fillStyle = '#ffffff';
      g.fillRect(0, 0, o.w, o.h);
      g.globalCompositeOperation = 'source-over';
      g.drawImage(igImg, pad, pad, w, h);
      o.key = key; o.pad = pad; IGST = o;
      return o;
    }
    function drawCertIg(g, x, y, w, h, float, k){
      var ring = Math.max(2, Math.round(3*k));
      var footY = y + h - Math.round(2*k);            // 浮きを足さない＝地面は動かない
      var rise  = Math.max(0, -float);                // 上がっているぶん
      // 接地の楕円。上がるほど小さく薄く
      g.save();
      g.globalAlpha = 0.20 * Math.max(0.45, 1 - rise/14);
      g.fillStyle = '#0e2530';
      g.translate(x + w/2, footY);
      g.scale(1, 0.17);
      g.beginPath();
      g.arc(0, 0, w*0.40*Math.max(0.8, 1 - rise/40), 0, Math.PI*2);
      g.fill();
      g.restore();
      // 白の縁＋落ち影。落ち影は縁ごと落とす（輪郭が二重にならない）
      var o = igSticker(w, h, ring);
      g.save();
      g.shadowColor = 'rgba(14,37,48,.26)';
      g.shadowBlur = Math.round(10*k);
      g.shadowOffsetY = Math.round(5*k);
      g.drawImage(o.c, x - o.pad, y + float - o.pad, o.w, o.h);
      g.restore();
    }

    /* =============== ループ =============== */
    var last=0, acc=0, STEP=1000/60, running=false, raf=0;
    /* 端末が追いつかないときの自動的な間引き（art-direction-final.md 4章の
       「60fps を中位 Android で。落ちるなら手前オーバーレイ → 残像 →
       パーティクル数の順で削る」をそのまま実装したもの）。

       1フレームの実時間を指数移動平均で見て、**21ms を 120 フレーム
       （およそ2秒）続けて超えたら lite に落とす。**
       一度落としたらその走りの間は戻さない（軽くなった瞬間に戻すと、
       重い→軽い→重いを往復して、かえって見苦しくなる）。
       最初の30フレームは焼き込みと読み込みで必ず重いので数に入れない。 */
    var frameMS=16.7, slowN=0, warmN=0, lite=false;
    /* worstMS は直近5秒でいちばん遅かった1フレーム。
       **都市の切り替えの引っかかりは平均には出ない**（1フレームだけ跳ねる）ので、
       最悪値を別に持って実機で読めるようにする */
    var worstMS=0, worstAt=0;
    function loop(now){
      if(!running) return;
      if(!last) last=now;
      var dt = now-last;
      acc+=Math.min(120, dt); last=now;
      while(acc>=STEP){ update(); acc-=STEP; }
      render();
      if(warmN<30){ warmN++; }
      else {
        if(dt > worstMS || now-worstAt > 5000){ worstMS = dt; worstAt = now; }
        if(!lite){
          frameMS += (Math.min(80, dt) - frameMS) * 0.08;
          slowN = (frameMS > 21) ? slowN+1 : 0;
          if(slowN > 120){ lite = true; track('igrun_lite', {ms:Math.round(frameMS)}); }
        }
      }
      raf=window.requestAnimationFrame(loop);
    }
    function play(){ if(running) return; running=true; last=0; raf=window.requestAnimationFrame(loop); }
    function halt(){ running=false; last=0; if(raf) window.cancelAnimationFrame(raf); }

    if('IntersectionObserver' in window){
      new IntersectionObserver(function(en){
        if(en[0].isIntersecting) play(); else halt();
      },{threshold:0.15}).observe(stage);
    } else { play(); }
    document.addEventListener('visibilitychange', function(){
      if(document.hidden) halt(); else play();
    });

    city=CITIES[0]; prev=CITIES[0];
    clearField();
    bootNames = namesFor('common-')
      .concat(cityNames(CITIES[0].id))
      .concat(MANIFEST.sprite ? ['sprite'] : []);
    request(bootNames);
    if(!bootNames.length && fontDone) mode='idle';   // 素材が無い環境ではローディングを出さない（フォントだけは待つ）
    render();
  }

  /* ===================================================== */
  function boot(){
    var n=document.querySelectorAll('[data-igrun]');
    for(var i=0;i<n.length;i++){
      if(n[i].getAttribute('data-igrun-ready')) continue;
      n[i].setAttribute('data-igrun-ready','1');
      init(n[i]);
    }
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
